import React from 'react';

const Decor2: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-2 prefix__map-decor"
      transform="translate(0 190)"
    >
      <defs>
        <radialGradient
          id="b0eeb372-f870-4eb5-8ed5-9b0fc7b16082"
          data-name="grad-30"
          cx="209.4"
          cy="103.45"
          r="5.99"
          gradientTransform="translate(-56.96) scale(1.08 1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#3bece3" stopOpacity="0.3" />
          <stop offset="0.31" stopColor="#5defe5" stopOpacity="0.33" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0.5" />
        </radialGradient>
        <linearGradient
          id="af4c84dd-6639-46a0-9c82-ae23c991f3ca"
          data-name="grad-14"
          x1="170.03"
          y1="98.52"
          x2="170.02"
          y2="100.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#2ca3ad" />
          <stop offset="0.82" stopColor="#3ffff1" />
        </linearGradient>
        <linearGradient
          id="affd273b-0722-4f9e-a6db-ce129b630e53"
          x1="170.02"
          y1="98.9"
          x2="170.03"
          y2="100.96"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="e10209bd-b6ae-4b2e-9bd7-8fa5c51f1e37"
          x1="170"
          y1="99.29"
          x2="170.04"
          y2="101.62"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="a155d4f6-ff95-49e7-885a-ee84969b2b72"
          x1="169.97"
          y1="99.69"
          x2="170.05"
          y2="102.22"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="b5a01f61-c81d-4bfa-a2f5-7d9d416dc67f"
          x1="169.94"
          y1="100.09"
          x2="170.05"
          y2="102.74"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="a13a180a-2aa1-4c5c-9a86-75c415e7ae84"
          x1="169.9"
          y1="100.49"
          x2="170.05"
          y2="103.19"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="f84f41b8-750b-4160-b769-1bd5e34c7e3c"
          x1="169.94"
          y1="101.6"
          x2="170.05"
          y2="104.36"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="e0f24d19-a6a9-4ade-852b-3bd59920cdd6"
          x1="169.97"
          y1="102.7"
          x2="170.05"
          y2="105.48"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="f9dc0485-2123-4753-9958-75814ab286f6"
          x1="169.99"
          y1="103.81"
          x2="170.04"
          y2="106.55"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="e7afcbad-df0b-42aa-b0a2-3b8f490ae857"
          x1="170.01"
          y1="104.91"
          x2="170.03"
          y2="107.57"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="a8530771-c3f1-49ff-8868-b908498fd99e"
          x1="170.03"
          y1="106.02"
          x2="170.02"
          y2="108.54"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="af8cc88e-6a01-4684-8c28-db57f65f4b75"
          data-name="grad-190"
          x1="1108.47"
          y1="139.26"
          x2="1108.46"
          y2="141.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
          data-name="grad-198"
          x1="1108.46"
          y1="139.78"
          x2="1108.47"
          y2="142.64"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
          data-name="grad-197"
          x1="1108.43"
          y1="140.33"
          x2="1108.49"
          y2="143.56"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="a58b1564-2560-46ac-9152-d30b38a3d20c"
          data-name="grad-196"
          x1="1108.39"
          y1="140.88"
          x2="1108.5"
          y2="144.38"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
          data-name="grad-195"
          x1="1108.35"
          y1="141.43"
          x2="1108.51"
          y2="145.11"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="f9096152-0410-41ac-9e4b-67854b38b6f4"
          data-name="grad-47"
          x1="1108.3"
          y1="141.99"
          x2="1108.51"
          y2="145.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
          data-name="grad-194"
          x1="1108.35"
          y1="143.52"
          x2="1108.51"
          y2="147.35"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
          data-name="grad-193"
          x1="1108.39"
          y1="145.05"
          x2="1108.5"
          y2="148.89"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
          data-name="grad-192"
          x1="1108.42"
          y1="146.58"
          x2="1108.49"
          y2="150.37"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
          data-name="grad-19"
          x1="1108.45"
          y1="148.11"
          x2="1108.48"
          y2="151.78"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="be198cd7-f47b-4bc8-9024-f1cb90035c2d"
          data-name="grad-126"
          x1="1108.48"
          y1="149.64"
          x2="1108.46"
          y2="153.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="a4f7440e-0a99-4b73-8fba-877268796c2c"
          data-name="grad-210"
          cx="1108.34"
          cy="145.67"
          r="12.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="a22a83b8-0f19-4ba6-b233-6548c13e1771"
          x1="943.47"
          y1="99.26"
          x2="943.46"
          y2="101.63"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="b7f130ff-fffd-4dcb-b4f4-c27278dcbab1"
          x1="943.46"
          y1="99.78"
          x2="943.47"
          y2="102.64"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="e92da4c0-dc4e-4e89-878c-cc9c57897892"
          x1="943.43"
          y1="100.33"
          x2="943.49"
          y2="103.56"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="af3bb75d-bf0c-4e4c-8de0-8b071c4d8c1d"
          x1="943.39"
          y1="100.88"
          x2="943.5"
          y2="104.38"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="b621a4b9-da69-4d47-8ca1-1dce2b900c3d"
          x1="943.35"
          y1="101.43"
          x2="943.51"
          y2="105.11"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="be9095df-8a88-4b4e-83a1-50af4f0a0a11"
          x1="943.3"
          y1="101.99"
          x2="943.51"
          y2="105.73"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="f8465dea-0dcf-479d-82b6-2d6bff55bd92"
          x1="943.35"
          y1="103.52"
          x2="943.51"
          y2="107.35"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="e7f0015f-a176-4b59-8815-2fcbba29f8a7"
          x1="943.39"
          y1="105.05"
          x2="943.5"
          y2="108.89"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="a9e31796-9bb5-4e01-bf19-c01843f47174"
          x1="943.42"
          y1="106.58"
          x2="943.49"
          y2="110.37"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="e7405b36-9a11-439b-bb7a-96e207a44d8a"
          x1="943.45"
          y1="108.11"
          x2="943.48"
          y2="111.78"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="a7ff5db6-05d3-469c-8ba2-506af4402ea4"
          x1="943.48"
          y1="109.64"
          x2="943.46"
          y2="113.13"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="e58d0f6e-b11f-4c6f-8e95-ada9e5dde016"
          cx="943.34"
          cy="105.67"
          r="12.67"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <linearGradient
          id="a93d67bd-1042-4640-a413-8d28303101a8"
          x1="1379.84"
          y1="125.43"
          x2="1379.83"
          y2="128.42"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="bcb12865-68fa-4f98-8301-1597d237fc54"
          x1="1379.82"
          y1="126.1"
          x2="1379.84"
          y2="129.7"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="a70b2ba3-5512-43e1-9f67-c0396d7576a7"
          x1="1379.79"
          y1="126.78"
          x2="1379.86"
          y2="130.86"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="ea7bc7b8-563c-40d3-8ec2-2108674f3256"
          data-name="grad-28"
          x1="1379.74"
          y1="127.47"
          x2="1379.88"
          y2="131.9"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="ea477d7c-f6d6-4c6f-92f8-449c53836dcd"
          data-name="grad-26"
          x1="1379.69"
          y1="128.18"
          x2="1379.89"
          y2="132.82"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="bc525b24-ec10-4a9c-a8d2-19c30d61a89d"
          x1="1379.63"
          y1="128.88"
          x2="1379.88"
          y2="133.6"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="aa1bb739-f1f4-41e1-b647-622a36a9cd56"
          x1="1379.68"
          y1="130.82"
          x2="1379.89"
          y2="135.65"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="bf70dbb5-6208-471a-a9dc-40b1d133f408"
          x1="1379.73"
          y1="132.75"
          x2="1379.88"
          y2="137.6"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="e02afc87-963a-4418-bac0-11e9b5f9566e"
          x1="1379.78"
          y1="134.68"
          x2="1379.87"
          y2="139.47"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="eb34fe2b-da19-4639-b158-efedbcde17d2"
          x1="1379.82"
          y1="136.61"
          x2="1379.85"
          y2="141.25"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="abb486f7-27e2-487f-a74f-c042925b8994"
          x1="1379.85"
          y1="138.55"
          x2="1379.82"
          y2="142.96"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="bc677365-b852-44fe-b235-577ced0fdf9b"
          cx="1379.67"
          cy="133.53"
          r="16"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <linearGradient
          id="e180ec85-e861-4004-9814-1df7c24cbe0d"
          x1="1083.09"
          y1="478.42"
          x2="1083.05"
          y2="485.72"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="ade61729-d9f4-4952-b67e-4b2a71064855"
          x1="1083.04"
          y1="480.04"
          x2="1083.09"
          y2="488.83"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="a8f28611-4fec-44bf-8963-20d84a0f6400"
          x1="1082.96"
          y1="481.71"
          x2="1083.14"
          y2="491.66"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="a987d169-0064-4dcd-99d5-9a581b6d0ca5"
          data-name="grad-28"
          x1="1082.85"
          y1="483.41"
          x2="1083.18"
          y2="494.19"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="ae40de8f-b484-452d-af81-90c66c0a3f60"
          data-name="grad-26"
          x1="1082.72"
          y1="485.12"
          x2="1083.2"
          y2="496.43"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="a8ce02f6-c04d-407f-9dad-ea4a10d6d28d"
          x1="1082.56"
          y1="486.84"
          x2="1083.19"
          y2="498.34"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="eeffe273-7e9f-48c6-9b4a-18a74578dae7"
          x1="1082.7"
          y1="491.55"
          x2="1083.2"
          y2="503.33"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="bef0805b-8e31-4459-a1a2-652b8593eb40"
          x1="1082.83"
          y1="496.25"
          x2="1083.19"
          y2="508.09"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="b2f36ca4-9f7d-4a25-b025-1544824d0b51"
          x1="1082.93"
          y1="500.96"
          x2="1083.15"
          y2="512.64"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="e2d03eb1-dff1-4d96-813c-ed5535ff573b"
          x1="1083.03"
          y1="505.67"
          x2="1083.1"
          y2="516.99"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="bcc9ee63-d0c3-41ef-a3f3-bc59c98ce3af"
          x1="1083.1"
          y1="510.4"
          x2="1083.04"
          y2="521.14"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="ae513ab2-cfe2-4cc1-aca8-46efa3d042c6"
          cx="1082.67"
          cy="498.16"
          r="39"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <linearGradient
          id="ba220288-c5ce-4e37-9266-587804447fc8"
          x1="1096.99"
          y1="183.86"
          x2="1096.96"
          y2="188.73"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="a9479e01-18b7-45ab-82b2-a62e1270907c"
          x1="1096.95"
          y1="184.94"
          x2="1096.99"
          y2="190.81"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="b1a0f2cc-920f-44a5-bb43-0cfc002d00bd"
          x1="1096.9"
          y1="186.06"
          x2="1097.02"
          y2="192.7"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="b2be1248-384f-4ab8-b725-78fbf2cdbf5c"
          x1="1096.83"
          y1="187.19"
          x2="1097.05"
          y2="194.39"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="fe7f83a3-2bba-4fc1-bbf9-8e1fec21322c"
          x1="1096.74"
          y1="188.33"
          x2="1097.06"
          y2="195.88"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="b06fa48d-aef7-4c86-bebb-a622b36bcd8a"
          x1="1096.63"
          y1="189.48"
          x2="1097.05"
          y2="197.16"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="b380ba6c-d88b-4dd8-9b55-6e91961664bb"
          x1="1096.73"
          y1="192.63"
          x2="1097.06"
          y2="200.49"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="ec98ea77-64fb-404d-94fd-4903dae69004"
          x1="1096.81"
          y1="195.77"
          x2="1097.05"
          y2="203.67"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="b8c66959-18ac-401d-aeb4-fff5b08603cb"
          x1="1096.88"
          y1="198.91"
          x2="1097.03"
          y2="206.71"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="b67e68d7-30cf-4110-b047-d2c8d64f8add"
          x1="1096.95"
          y1="202.05"
          x2="1096.99"
          y2="209.61"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="be1190e6-1c8e-4d02-9267-0092f225ee46"
          x1="1097"
          y1="205.21"
          x2="1096.96"
          y2="212.38"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="b445d720-5c75-4bf9-a361-6abd8574e56d"
          cx="1096.71"
          cy="197.04"
          r="26.04"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <radialGradient
          id="a292e7da-2b4f-4270-9870-b395a972825f"
          cx="251.81"
          cy="98.45"
          r="5.99"
          xlinkHref="#b0eeb372-f870-4eb5-8ed5-9b0fc7b16082"
        />
        <linearGradient
          id="e571f8f7-9e24-44a2-93bd-16f18597f311"
          x1="216.03"
          y1="93.52"
          x2="216.02"
          y2="95.23"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="fadb8b41-5f7b-41aa-aff3-b297f7138a23"
          x1="216.02"
          y1="93.9"
          x2="216.03"
          y2="95.96"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="ae54be04-3dec-4271-be20-ec8ee91aec3d"
          x1="216"
          y1="94.29"
          x2="216.04"
          y2="96.62"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="effe6407-f6de-409a-9587-438e60a3f499"
          x1="215.97"
          y1="94.69"
          x2="216.05"
          y2="97.22"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="ebf893cb-300e-45ab-9293-b51d92ff7590"
          x1="215.94"
          y1="95.09"
          x2="216.05"
          y2="97.74"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="b6fa0389-29d5-4bc3-8e44-b5a0ddb5202a"
          x1="215.9"
          y1="95.49"
          x2="216.05"
          y2="98.19"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="a6f0f267-dd63-49ba-938d-19565f6762b5"
          x1="215.94"
          y1="96.6"
          x2="216.05"
          y2="99.36"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="bc10d274-e868-402e-b426-67bb6ff11ffd"
          x1="215.97"
          y1="97.7"
          x2="216.05"
          y2="100.48"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="fe594bc4-2d38-4e7f-912e-8062c39ecf7e"
          x1="215.99"
          y1="98.81"
          x2="216.04"
          y2="101.55"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="eed8da73-0afb-43b0-bf30-1afab0be83e8"
          x1="216.01"
          y1="99.91"
          x2="216.03"
          y2="102.57"
          gradientTransform="translate(0 0)"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="e055dc92-f703-48a7-8ffc-0ad921a884b1"
          x1="216.03"
          y1="101.02"
          x2="216.02"
          y2="103.54"
          xlinkHref="#af4c84dd-6639-46a0-9c82-ae23c991f3ca"
        />
        <linearGradient
          id="bb51daec-2d1c-4186-8ed3-820ddd26374e"
          x1="397.88"
          y1="418.38"
          x2="397.86"
          y2="421.94"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="af17228d-3ce7-4fd8-98b9-d6ef50cb940c"
          x1="397.85"
          y1="419.18"
          x2="397.88"
          y2="423.46"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="ff3485ce-0572-4be1-9003-13828d6dc858"
          x1="397.81"
          y1="419.99"
          x2="397.9"
          y2="424.83"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="ff0b2c7f-4e58-4b5a-a10d-7b5ca9f69024"
          x1="397.76"
          y1="420.81"
          x2="397.92"
          y2="426.07"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="f86f0c2a-e547-4535-8bd8-0ad58b69fd76"
          x1="397.69"
          y1="421.65"
          x2="397.93"
          y2="427.16"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="a5cf90d3-ff06-45f0-9de2-4acd6caded88"
          x1="397.62"
          y1="422.48"
          x2="397.92"
          y2="428.09"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="b8432aea-8d64-447c-919c-1d6f3349aff5"
          x1="397.69"
          y1="424.78"
          x2="397.93"
          y2="430.52"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="f505260b-cbaa-4ce0-921b-03f3b01e1585"
          x1="397.75"
          y1="427.07"
          x2="397.92"
          y2="432.84"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="edf4915a-6e6f-4799-b8f9-448896d4cab2"
          x1="397.8"
          y1="429.36"
          x2="397.9"
          y2="435.06"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="f3466d8e-5a58-46c2-af02-f186783b7058"
          x1="397.84"
          y1="431.66"
          x2="397.88"
          y2="437.17"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="ba6d1fa7-51d9-499f-bd73-f2f345abe976"
          x1="397.88"
          y1="433.96"
          x2="397.85"
          y2="439.2"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="a866a499-21a3-4cd6-a270-e25945a93385"
          cx="397.67"
          cy="428"
          r="19"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <radialGradient
          id="b8128b6f-7c6a-4b15-9a4b-3cabe612b027"
          data-name="grad-7"
          cx="397.55"
          cy="463.07"
          r="10.73"
          gradientTransform="translate(0 -76.74) scale(1 1.17)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.05" stopColor="#eeff5c" stopOpacity="0.51" />
          <stop offset="0.12" stopColor="#f3ff84" stopOpacity="0.37" />
          <stop offset="0.19" stopColor="#f6ffa6" stopOpacity="0.26" />
          <stop offset="0.28" stopColor="#faffc2" stopOpacity="0.16" />
          <stop offset="0.37" stopColor="#fcffd7" stopOpacity="0.09" />
          <stop offset="0.49" stopColor="#feffe6" stopOpacity="0.04" />
          <stop offset="0.63" stopColor="#ffe" stopOpacity="0.01" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="be03678d-295a-4f13-89c6-3a9c3e2b27bd"
          x1="392.88"
          y1="312.38"
          x2="392.86"
          y2="315.94"
          xlinkHref="#af8cc88e-6a01-4684-8c28-db57f65f4b75"
        />
        <linearGradient
          id="b3c1a236-8a79-4e04-b640-73353683d346"
          x1="392.85"
          y1="313.18"
          x2="392.88"
          y2="317.46"
          xlinkHref="#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb"
        />
        <linearGradient
          id="a5d09026-af44-4849-9891-fa1f5a3e80f4"
          x1="392.81"
          y1="313.99"
          x2="392.9"
          y2="318.83"
          xlinkHref="#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f"
        />
        <linearGradient
          id="bffbe26a-01ac-467b-a3f4-bedb7f6a82e5"
          x1="392.76"
          y1="314.81"
          x2="392.92"
          y2="320.07"
          xlinkHref="#a58b1564-2560-46ac-9152-d30b38a3d20c"
        />
        <linearGradient
          id="a1f78bdb-8cce-422e-83c1-9e6711b32ad1"
          x1="392.69"
          y1="315.65"
          x2="392.93"
          y2="321.16"
          xlinkHref="#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4"
        />
        <linearGradient
          id="eaccccad-037b-407f-9b10-a2bb0b34629f"
          x1="392.62"
          y1="316.48"
          x2="392.92"
          y2="322.09"
          xlinkHref="#f9096152-0410-41ac-9e4b-67854b38b6f4"
        />
        <linearGradient
          id="ac97d989-8264-49f9-b1f6-1a57da9534a0"
          x1="392.69"
          y1="318.78"
          x2="392.93"
          y2="324.52"
          xlinkHref="#f972b0ef-6e58-4a46-a4fa-e4d710e17f15"
        />
        <linearGradient
          id="ed4f33a6-7515-485b-a1f5-422a7ae4c71d"
          x1="392.75"
          y1="321.07"
          x2="392.92"
          y2="326.84"
          xlinkHref="#ffe9a791-b24c-436f-a1a1-ff3d2572df9d"
        />
        <linearGradient
          id="f159e18f-a70f-4269-ae4b-183616ca71c1"
          x1="392.8"
          y1="323.36"
          x2="392.9"
          y2="329.06"
          xlinkHref="#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4"
        />
        <linearGradient
          id="bf29695c-7c1a-46f6-90cd-c8aba126d7a5"
          x1="392.84"
          y1="325.66"
          x2="392.88"
          y2="331.17"
          xlinkHref="#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1"
        />
        <linearGradient
          id="e39a3a15-72f8-441a-9c6a-b7aa979b5e9f"
          x1="392.88"
          y1="327.96"
          x2="392.85"
          y2="333.2"
          xlinkHref="#be198cd7-f47b-4bc8-9024-f1cb90035c2d"
        />
        <radialGradient
          id="a8ccf94f-e10f-4ed7-8c49-810d363b466d"
          cx="392.67"
          cy="322"
          r="19"
          xlinkHref="#a4f7440e-0a99-4b73-8fba-877268796c2c"
        />
        <radialGradient
          id="bba1478d-f7c3-45f3-9cbd-d4d77c75c723"
          cx="393.55"
          cy="373.07"
          r="10.73"
          xlinkHref="#b8128b6f-7c6a-4b15-9a4b-3cabe612b027"
        />
        <linearGradient
          id="b3592a21-f7ae-4e46-9437-0def5c4ec9ff"
          data-name="grad-21"
          x1="1452.69"
          y1="225.53"
          x2="1080.2"
          y2="226.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.3" stopColor="#0d2b6c" />
          <stop offset="0.34" stopColor="#303472" />
          <stop offset="0.4" stopColor="#68427c" />
          <stop offset="0.45" stopColor="#8b4b83" />
          <stop offset="0.48" stopColor="#984e85" />
          <stop offset="0.82" stopColor="#ff9683" />
        </linearGradient>
        <linearGradient
          id="e0a0d72b-2788-427c-8012-2effeeb7495c"
          data-name="grad-190"
          x1="358.94"
          y1="65.42"
          x2="358.9"
          y2="72.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#35323c" />
          <stop offset="0.43" stopColor="#7a7a42" />
          <stop offset="0.63" stopColor="#b1b347" />
          <stop offset="0.79" stopColor="#d9dc4a" />
          <stop offset="0.92" stopColor="#f1f64c" />
          <stop offset="1" stopColor="#faff4d" />
        </linearGradient>
        <linearGradient
          id="a2b09e04-4031-40da-aa90-8c00999bfdb5"
          data-name="grad-198"
          x1="358.89"
          y1="67.04"
          x2="358.94"
          y2="75.83"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.27" stopColor="#4b4945" />
          <stop offset="0.47" stopColor="#8d8d51" />
          <stop offset="0.63" stopColor="#bdbf5a" />
          <stop offset="0.75" stopColor="#dadd60" />
          <stop offset="0.82" stopColor="#e5e962" />
          <stop offset="1" stopColor="#faff64" />
        </linearGradient>
        <linearGradient
          id="a9e95210-c213-48bf-82f0-fc39c581116b"
          data-name="grad-197"
          x1="358.8"
          y1="68.71"
          x2="358.99"
          y2="78.66"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.17" stopColor="#272341" />
          <stop offset="0.41" stopColor="#7a7959" />
          <stop offset="0.61" stopColor="#b7b86a" />
          <stop offset="0.75" stopColor="#dddf75" />
          <stop offset="0.82" stopColor="#ebee79" />
          <stop offset="1" stopColor="#fbff7b" />
        </linearGradient>
        <linearGradient
          id="f638875d-a30a-4409-bd8d-c40629cec067"
          data-name="grad-196"
          x1="358.7"
          y1="70.41"
          x2="359.02"
          y2="81.19"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.31" stopColor="#565456" />
          <stop offset="0.56" stopColor="#a8a975" />
          <stop offset="0.74" stopColor="#dcdf89" />
          <stop offset="0.82" stopColor="#f0f491" />
          <stop offset="1" stopColor="#fbff91" />
        </linearGradient>
        <linearGradient
          id="ff47643f-4330-453f-9f75-05d3cbbda61e"
          data-name="grad-195"
          x1="358.57"
          y1="72.12"
          x2="359.05"
          y2="83.43"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.44" stopColor="#818070" />
          <stop offset="0.7" stopColor="#d5d798" />
          <stop offset="0.82" stopColor="#f6f9a8" />
          <stop offset="1" stopColor="#fcffa8" />
        </linearGradient>
        <linearGradient
          id="b84cfbf9-aa7c-4134-ac22-b0907286cf63"
          data-name="grad-47"
          x1="358.41"
          y1="73.84"
          x2="359.04"
          y2="85.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.54" stopColor="#a3a38d" />
          <stop offset="0.82" stopColor="#fcffbf" />
        </linearGradient>
        <linearGradient
          id="aa2d45af-5519-4e48-a105-ab9a892f6588"
          data-name="grad-194"
          x1="358.55"
          y1="78.55"
          x2="359.05"
          y2="90.33"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.2" stopColor="#332f4b" />
          <stop offset="0.43" stopColor="#888773" />
          <stop offset="0.62" stopColor="#c6c891" />
          <stop offset="0.75" stopColor="#ecf0a3" />
          <stop offset="0.82" stopColor="#fbffaa" />
        </linearGradient>
        <linearGradient
          id="bbbe08cd-7b9f-403e-93e4-29bf33e3a5e5"
          data-name="grad-193"
          x1="358.68"
          y1="83.25"
          x2="359.04"
          y2="95.09"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.25" stopColor="#4d4b53" />
          <stop offset="0.4" stopColor="#8a8a6a" />
          <stop offset="0.54" stopColor="#babd7d" />
          <stop offset="0.66" stopColor="#dde18b" />
          <stop offset="0.76" stopColor="#f2f793" />
          <stop offset="0.82" stopColor="#faff96" />
        </linearGradient>
        <linearGradient
          id="f724630b-e6ee-4a91-83ff-1d8a187d6784"
          data-name="grad-192"
          x1="358.78"
          y1="87.96"
          x2="359"
          y2="99.64"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.22" stopColor="#4a484c" />
          <stop offset="0.34" stopColor="#7f805c" />
          <stop offset="0.45" stopColor="#abad69" />
          <stop offset="0.56" stopColor="#cdd174" />
          <stop offset="0.66" stopColor="#e5ea7b" />
          <stop offset="0.75" stopColor="#f4fa7f" />
          <stop offset="0.82" stopColor="#f9ff81" />
        </linearGradient>
        <linearGradient
          id="f1cb2374-018c-4d4a-8001-9a740e028073"
          data-name="grad-191"
          x1="358.88"
          y1="92.67"
          x2="358.95"
          y2="103.99"
          gradientTransform="translate(0 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.18" stopColor="#403d44" />
          <stop offset="0.27" stopColor="#70704f" />
          <stop offset="0.36" stopColor="#9a9c58" />
          <stop offset="0.45" stopColor="#bcc060" />
          <stop offset="0.54" stopColor="#d6db66" />
          <stop offset="0.64" stopColor="#e9ef6a" />
          <stop offset="0.73" stopColor="#f4fb6c" />
          <stop offset="0.82" stopColor="#f8ff6d" />
        </linearGradient>
        <linearGradient
          id="afdc56f3-ec0c-4965-98fb-529caf23792c"
          data-name="grad-126"
          x1="358.95"
          y1="97.4"
          x2="358.89"
          y2="108.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#0c0739" />
          <stop offset="0.14" stopColor="#302d3e" />
          <stop offset="0.21" stopColor="#5e5e44" />
          <stop offset="0.28" stopColor="#878949" />
          <stop offset="0.35" stopColor="#aaae4e" />
          <stop offset="0.43" stopColor="#c6cb52" />
          <stop offset="0.51" stopColor="#dce254" />
          <stop offset="0.6" stopColor="#ebf256" />
          <stop offset="0.69" stopColor="#f4fc58" />
          <stop offset="0.82" stopColor="#f7ff58" />
        </linearGradient>
        <radialGradient
          id="b2dc3688-cc87-43d1-acac-1c8c33b3013e"
          data-name="grad-210"
          cx="358.52"
          cy="85.16"
          r="39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#ebff41" stopOpacity="0.6" />
          <stop offset="0.27" stopColor="#f2ff7d" stopOpacity="0.39" />
          <stop offset="0.58" stopColor="#f9ffbc" stopOpacity="0.18" />
          <stop offset="0.81" stopColor="#fdffe2" stopOpacity="0.05" />
          <stop offset="0.94" stopColor="#fffff1" stopOpacity="0" />
        </radialGradient>
      </defs>
      <g id="a3dc499a-de62-44eb-8e15-23f381f9ee09" data-name="decor_2">
        <g>
          <path
            d="M203.78,146.33s21.34,7.78,39.37-11.17c0,0,5.63-2.71-3.91-9.34s-11.57,2-11.57,2-3.47-8-10.44-3.22,1,8.64-1.31,11-6.69-4.38-10.33-3.86-7.59,6.81-4.7,10.71Z"
            fill="#396039"
          />
          <path
            d="M223.59,140.83c2.93-1.71-2.22-3.84-1.52-5.51s4.6.63,7.3,1.61,3.45-2,4.27-5.76.66-6.24,5.6-5.35,12.1,2,8.74,6.49-9.34,10.3-13.11,9.71-5.83,6.07-7.74,5.24S221,142.31,223.59,140.83Z"
            fill="#426642"
          />
          <path
            d="M221.21,130.88c-3-.79-3-5-.23-5.3s2.87,4.18,5.48,4.07,6.83-.93,3.5,2.59S221.21,130.88,221.21,130.88Z"
            fill="#2f4f2f"
          />
          <path
            d="M210.71,145c-3.89-.11-6.13-2.94-5.59-4.15s1.89-4.74,4.1-2.37,7.46.42,7.81,3.6S210.71,145,210.71,145Z"
            fill="#2f4f2f"
          />
          <path
            d="M216.58,150.26c-5.41-1.16-7.62,1.51-8.48-.73s-2.52-3.92-.37-5.84,3.89.84,6.25.1.81-4.51,4.22-3S223,151.64,216.58,150.26Z"
            fill="#426642"
          />
          <path
            d="M223.56,149.15c-4.81,1.11-4.46-1.55-3.68-3.32s4.8-.39,6.06-2.08,6.09-.9,7-3.13,2.92-6.62,5.88-5,8.44,5.67,2.21,6-10.35,5.19-12.76,6.48A8.94,8.94,0,0,1,223.56,149.15Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M67.58,192.48s-22.3,27.55-57,17.33c0,0-8.83,1-.82-15.44s15.92-6.84,15.92-6.84S25.17,174.22,37,174.82s4.09,12.15,8.5,13.4,5.8-11.18,10.74-13.46S70.09,177.54,68.84,185Z"
            fill="#396039"
          />
          <path
            d="M39,201.35c-4.78.15.44-6.83-1.49-8.46s-5.45,4.56-8.28,8-5.62.22-9-4.08-4.7-7.66-10.44-2.48S-4.38,206.78,2.7,210s18.27,5.94,22.7,2.09,11.17,3.24,13.08.59S43.15,201.23,39,201.35Z"
            fill="#426642"
          />
          <path
            d="M35.85,186.36c3.36-3.5.69-9-3-7.14S31.8,187,28.42,189s-9.27,4.34-2.84,6.25S35.85,186.36,35.85,186.36Z"
            fill="#2f4f2f"
          />
          <path
            d="M58,196.4c4.88-3.31,6-8.84,4.54-10s-5.34-4.68-6.69.23-9.23,6.62-7.69,11.08S58,196.4,58,196.4Z"
            fill="#2f4f2f"
          />
          <path
            d="M53.75,208.05c6.16-5.93,10.63-4.22,10.33-7.87s.77-7.18-3.14-8-4.43,4.27-7.89,5.21-3.83-5.26-7.23-.52S46.48,215.05,53.75,208.05Z"
            fill="#426642"
          />
          <path
            d="M44.19,212.25c6.8-2.44,4.7-5.65,2.63-7.35s-6.35,3.4-9,2.2-8.3,3.77-10.87,1.59-7.81-6.31-10.57-1.78-7.21,14.31.92,9.71,16.38-1.6,20.24-1.86A13.08,13.08,0,0,0,44.19,212.25Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M206.53,145.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11S166,139.81,166,139.81s-.93-12.15,10.51-11.25,4.32,11.21,8.62,12.49,5.24-10,9.95-12,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M179.21,152.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S183.21,152.84,179.21,152.82Z"
            fill="#426642"
          />
          <path
            d="M175.7,139.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S175.7,139.05,175.7,139.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M197.37,148.89c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.75-7.09,9.87S197.37,148.89,197.37,148.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M193.65,159.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.45,4.51-3.87-4.91-7-.7S186.85,165.54,193.65,159.38Z"
            fill="#426642"
          />
          <path
            d="M184.55,162.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.89,3.19-10.44,1.13-7.74-6-10.27-2S151,170,158.72,166.08s15.77-1,19.49-1.08A12.22,12.22,0,0,0,184.55,162.92Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M280.13,120.31s-14.88,17.15-39.85,9.32c0,0-6.22.36-1.1-10.06s11.06-3.9,11.06-3.9-.84-8.67,7.58-7.88,3.31,8,6.49,9,3.73-7.07,7.16-8.38,9.93,2.28,9.3,7.09Z"
            fill="#396039"
          />
          <path
            d="M260.15,125.11c-3.39-.07.07-4.43-1.35-5.56s-3.71,2.78-5.6,5-4,0-6.53-3-3.6-5.15-7.49-2-9.64,7.58-4.5,9.91,13.17,4.48,16.18,2.14,8,2.48,9.31.83S263.09,125.17,260.15,125.11Z"
            fill="#426642"
          />
          <path
            d="M257.4,115.25c2.27-2.16.18-5.81-2.37-4.74s-.48,5-2.82,6.21-6.42,2.5-1.8,4S257.4,115.25,257.4,115.25Z"
            fill="#2f4f2f"
          />
          <path
            d="M273.44,122.54c3.36-2,3.94-5.55,2.88-6.35s-3.95-3.23-4.73-.08-6.33,4-5.09,6.94S273.44,122.54,273.44,122.54Z"
            fill="#2f4f2f"
          />
          <path
            d="M270.85,130c4.16-3.64,7.4-2.37,7.06-4.76s.3-4.64-2.5-5.28-3,2.62-5.42,3.12-2.9-3.55-5.15-.59S265.92,134.26,270.85,130Z"
            fill="#426642"
          />
          <path
            d="M264.2,132.37c4.75-1.36,3.15-3.52,1.62-4.69s-4.39,2-6.32,1.12-5.76,2.16-7.65.66-5.76-4.36-7.57-1.52-4.63,9.06,1,6.35,11.57-.48,14.3-.52A8.9,8.9,0,0,0,264.2,132.37Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M724.78,58.61S737.9,85.26,721.72,100l25.3-.22s-9.3-4.47-10.46-7.39-1.46-21.81-9.51-33Z"
            fill="#6d4c89"
          />
          <path
            d="M728,59.9s1.23-15.46,10-17.54c0,0-3.64,3.16-1.78,5.7,0,0,3.28-7.61,13.54-5.81,0,0-11.79,1.55-13.52,8.7a8.25,8.25,0,0,1,9.07,2.66S728,54.06,728,59.9Z"
            fill="#6d4c89"
          />
          <path
            d="M724.79,59.93s-1.5-15.44-10.34-17.37c0,0,3.69,3.1,1.88,5.67,0,0-3.42-7.55-13.64-5.57,0,0,11.81,1.34,13.67,8.46a8.25,8.25,0,0,0-9,2.82S724.75,54.09,724.79,59.93Z"
            fill="#6d4c89"
          />
          <path
            d="M729.13,62.62S711.87,40.53,692.9,49.25c0,0,10.77-.5,11.68.76,0,0-3.53-.52-3.33,3,0,0,7.3-3.57,9.38-1.85,0,0-4.06.84-3.8,2.56,0,0,6.51-1.62,8.21-.11,0,0-4.21,1-2.51,3,0,0,5.75-2.55,8.55,1.17,0,0-2.42-.8-3.16.09C717.92,57.85,728.68,60.35,729.13,62.62Z"
            fill="#6d4c89"
          />
          <path
            d="M726,62.35S740.41,41.19,760.2,51.7c0,0-10.7-1.41-11.46-.2a3.36,3.36,0,0,1,3.64,3.3s-7.63-4.27-9.48-2.68c0,0,4.11,1.2,4.06,2.94,0,0-6.63-2.2-8.13-.81,0,0,4.28,1.4,2.84,3.31,0,0-6-3.09-8.31.48,0,0,2.29-.61,3.13.36C736.49,58.4,726.15,60.06,726,62.35Z"
            fill="#6d4c89"
          />
          <path
            d="M729.51,61.41S713.2,48.65,700.2,66.3c0,0,8-5.74,8.92-5a3.91,3.91,0,0,0-2.07,4.46s5-7,6.79-6.37c0,0-2.94,2.8-2.48,4.32,0,0,4.67-4.74,6.17-4.12,0,0-3,3-1.44,4.13,0,0,3.95-5.26,6.62-3.06,0,0-1.94.42-2.36,1.63C720.35,62.31,728.83,59.45,729.51,61.41Z"
            fill="#6d4c89"
          />
          <path
            d="M724.8,61.89s19.16-15,34.42,4.33c0,0-9.45-6.14-10.48-5.25a4.22,4.22,0,0,1,2.43,4.94s-5.83-7.68-8-6.89c0,0,3.44,3,2.91,4.75,0,0-5.48-5.14-7.24-4.39,0,0,3.54,3.3,1.69,4.6,0,0-4.65-5.77-7.78-3.18,0,0,2.28.39,2.78,1.74C735.56,62.54,725.6,59.65,724.8,61.89Z"
            fill="#6d4c89"
          />
          <path
            d="M727.63,62.33c-.78-8.93,8.55-19.42,15.33-18.82,0,0-13.4-2.49-15.5,5.55,0,0,2.62-10.64,6.57-10.68,0,0-8.74-2.31-10.25,5.07,0,0-4.79-9.16-.09-10.45,0,0-10.75,3-6.09,10.07,0,0-5-4.07-10.77,1.4,0,0,11.49.12,13.48,4.65,0,0-5.07-3.21-8,.07,0,0,10.12-1.77,12.73,5.68Z"
            fill="#6d4c89"
          />
          <path
            d="M727.08,62.33c-.61-6.89,6.59-15,11.82-14.51,0,0-10.34-1.92-11.95,4.28,0,0,2-8.21,5.06-8.23,0,0-6.74-1.78-7.9,3.91,0,0-3.7-7.07-.07-8.07,0,0-8.29,2.29-4.7,7.77,0,0-3.82-3.14-8.3,1.08,0,0,8.86.09,10.39,3.59,0,0-3.9-2.48-6.18.05,0,0,7.8-1.36,9.81,4.38Z"
            fill="#6d4c89"
          />
          <path
            d="M726.23,65.06s.71-8.94,5.81-10.14c0,0-2.11,1.83-1,3.3,0,0,1.9-4.4,7.83-3.36,0,0-6.81.89-7.81,5a4.75,4.75,0,0,1,5.24,1.54S726.2,61.69,726.23,65.06Z"
            fill="#6d4c89"
          />
          <path
            d="M727.75,63.75s-.87-8.93-6-10c0,0,2.14,1.79,1.09,3.28,0,0-2-4.37-7.88-3.22,0,0,6.82.77,7.89,4.89a4.76,4.76,0,0,0-5.21,1.63S727.72,60.37,727.75,63.75Z"
            fill="#6d4c89"
          />
          <path
            d="M736.56,92.42c-1-2.62-1.39-18.21-7.32-29.42.81,3.1,6.24,24.28,3.59,30.38-1.06,2.43,2.47,4.65,7.34,6.49l6.85-.06S737.72,95.34,736.56,92.42Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M598.88,70.25s8.64,17.94-2.29,27.75h17s-6.21-3-7-5-.85-14.64-6.18-22.16Z"
            fill="#6d4c89"
          />
          <path
            d="M601.05,71.13s.91-10.37,6.84-11.71c0,0-2.47,2.1-1.24,3.81,0,0,2.25-5.08,9.12-3.81,0,0-7.91,1-9.12,5.75A5.53,5.53,0,0,1,612.72,67S601,67.21,601.05,71.13Z"
            fill="#6d4c89"
          />
          <path
            d="M598.88,71.13S598,60.76,592,59.42c0,0,2.46,2.1,1.23,3.81,0,0-2.25-5.08-9.11-3.81,0,0,7.91,1,9.11,5.75A5.52,5.52,0,0,0,587.21,67S598.88,67.21,598.88,71.13Z"
            fill="#6d4c89"
          />
          <path
            d="M601.77,73S590.32,58,577.55,63.78c0,0,7.23-.27,7.83.58,0,0-2.36-.37-2.25,2,0,0,4.92-2.36,6.3-1.19,0,0-2.73.54-2.56,1.69,0,0,4.37-1,5.5,0,0,0-2.82.66-1.7,2,0,0,3.87-1.67,5.73.84,0,0-1.62-.55-2.12,0C594.28,69.69,601.49,71.43,601.77,73Z"
            fill="#6d4c89"
          />
          <path
            d="M599.66,72.75s9.8-14.1,23-6.93c0,0-7.17-1-7.68-.2a2.25,2.25,0,0,1,2.42,2.23s-5.1-2.91-6.34-1.86c0,0,2.75.84,2.7,2,0,0-4.43-1.51-5.44-.59,0,0,2.86,1,1.88,2.24,0,0-4-2.11-5.58.27,0,0,1.55-.4,2.1.26C606.73,70.17,599.79,71.22,599.66,72.75Z"
            fill="#6d4c89"
          />
          <path
            d="M602,72.15s-10.86-8.66-19.68,3.11c0,0,5.42-3.81,6-3.29A2.61,2.61,0,0,0,587,75s3.37-4.67,4.59-4.23c0,0-2,1.86-1.69,2.88,0,0,3.16-3.15,4.16-2.73,0,0-2,2-1,2.76,0,0,2.68-3.5,4.46-2,0,0-1.31.27-1.6,1.08C595.88,72.7,601.59,70.83,602,72.15Z"
            fill="#6d4c89"
          />
          <path
            d="M598.87,72.44s12.93-9.95,23.06,3.11c0,0-6.3-4.18-7-3.59a2.84,2.84,0,0,1,1.6,3.33s-3.86-5.18-5.3-4.67c0,0,2.29,2,1.92,3.21,0,0-3.64-3.48-4.83-3,0,0,2.36,2.23,1.1,3.09,0,0-3.07-3.89-5.19-2.18,0,0,1.53.28,1.85,1.19C606.08,72.94,599.42,71,598.87,72.44Z"
            fill="#6d4c89"
          />
          <path
            d="M600.77,72.75c-.48-6,5.84-13,10.39-12.53,0,0-9-1.74-10.43,3.63,0,0,1.82-7.12,4.47-7.12,0,0-5.85-1.6-6.91,3.34,0,0-3.16-6.17,0-7,0,0-7.22,1.93-4.14,6.72,0,0-3.3-2.76-7.23.87,0,0,7.71.15,9,3.2,0,0-3.37-2.18-5.37,0,0,0,6.79-1.12,8.5,3.89Z"
            fill="#6d4c89"
          />
          <path
            d="M600.4,72.75c-.37-4.62,4.51-10,8-9.66,0,0-6.92-1.35-8,2.8,0,0,1.4-5.49,3.44-5.49,0,0-4.51-1.24-5.32,2.57,0,0-2.44-4.76,0-5.4,0,0-5.57,1.48-3.19,5.18,0,0-2.55-2.13-5.58.67,0,0,5.94.11,6.95,2.47,0,0-2.61-1.68-4.15,0,0,0,5.24-.87,6.56,3Z"
            fill="#6d4c89"
          />
          <path
            d="M599.81,74.58s.53-6,4-6.77c0,0-1.43,1.22-.72,2.2,0,0,1.3-2.93,5.27-2.2,0,0-4.57.56-5.27,3.33a3.19,3.19,0,0,1,3.51,1.06S599.81,72.31,599.81,74.58Z"
            fill="#6d4c89"
          />
          <path
            d="M600.84,73.7s-.53-6-4-6.76c0,0,1.42,1.21.71,2.2,0,0-1.3-2.94-5.27-2.2,0,0,4.57.56,5.27,3.32a3.2,3.2,0,0,0-3.51,1.07S600.84,71.44,600.84,73.7Z"
            fill="#6d4c89"
          />
          <path
            d="M606.58,93c-.69-1.77-.83-12.22-4.74-19.78.53,2.08,4,16.32,2.23,20.39-.72,1.63,1.63,3.14,4.89,4.4h4.59S607.34,95,606.58,93Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M927.78,77.79s-7.37,14.95,1.71,23.24l-14.2-.12s5.23-2.51,5.88-4.15.81-12.24,5.33-18.5Z"
            fill="#6d4c89"
          />
          <path
            d="M926,78.51s-.69-8.68-5.63-9.85c0,0,2,1.78,1,3.2,0,0-1.85-4.27-7.6-3.26,0,0,6.61.87,7.59,4.88a4.62,4.62,0,0,0-5.09,1.5S926,75.23,926,78.51Z"
            fill="#6d4c89"
          />
          <path
            d="M927.77,78.52s.84-8.66,5.81-9.74c0,0-2.08,1.74-1.06,3.18,0,0,1.92-4.24,7.65-3.13,0,0-6.62.75-7.66,4.75a4.62,4.62,0,0,1,5.06,1.58S927.79,75.25,927.77,78.52Z"
            fill="#6d4c89"
          />
          <path
            d="M925.33,80s9.69-12.4,20.34-7.5c0,0-6-.28-6.56.43,0,0,2-.3,1.87,1.65,0,0-4.09-2-5.26-1,0,0,2.28.48,2.13,1.44,0,0-3.65-.91-4.6-.06,0,0,2.36.57,1.4,1.7,0,0-3.22-1.43-4.8.65,0,0,1.36-.44,1.78.06C931.63,77.36,925.59,78.76,925.33,80Z"
            fill="#6d4c89"
          />
          <path
            d="M927.11,79.88S919,68,907.9,73.91c0,0,6-.8,6.43-.12a1.89,1.89,0,0,0-2,1.86s4.28-2.4,5.32-1.51c0,0-2.31.68-2.28,1.65,0,0,3.72-1.23,4.56-.45,0,0-2.4.78-1.59,1.86,0,0,3.36-1.74,4.66.27,0,0-1.29-.35-1.75.2C921.21,77.67,927,78.59,927.11,79.88Z"
            fill="#6d4c89"
          />
          <path
            d="M925.12,79.35s9.16-7.16,16.45,2.75c0,0-4.51-3.22-5-2.8a2.2,2.2,0,0,1,1.16,2.51s-2.79-3.93-3.81-3.58c0,0,1.64,1.57,1.39,2.43,0,0-2.62-2.66-3.46-2.32,0,0,1.69,1.71.8,2.32,0,0-2.21-3-3.71-1.71,0,0,1.09.23,1.33.91C930.27,79.86,925.5,78.25,925.12,79.35Z"
            fill="#6d4c89"
          />
          <path
            d="M927.77,79.62S917,71.2,908.45,82.06c0,0,5.3-3.45,5.88-3A2.36,2.36,0,0,0,913,81.88s3.27-4.31,4.47-3.87c0,0-1.93,1.7-1.64,2.67,0,0,3.08-2.89,4.07-2.46,0,0-2,1.85-1,2.57,0,0,2.61-3.23,4.37-1.78,0,0-1.28.22-1.56,1C921.73,80,927.32,78.37,927.77,79.62Z"
            fill="#6d4c89"
          />
          <path
            d="M926.18,79.87c.44-5-4.8-10.9-8.61-10.56,0,0,7.53-1.4,8.7,3.11,0,0-1.46-6-3.68-6,0,0,4.9-1.29,5.75,2.85,0,0,2.69-5.15,0-5.87,0,0,6,1.66,3.42,5.65,0,0,2.78-2.28,6,.79,0,0-6.45.06-7.56,2.61,0,0,2.84-1.8,4.5,0,0,0-5.68-1-7.15,3.19Z"
            fill="#6d4c89"
          />
          <path
            d="M926.49,79.87c.34-3.86-3.7-8.4-6.64-8.14,0,0,5.8-1.08,6.71,2.4,0,0-1.13-4.61-2.84-4.62,0,0,3.78-1,4.43,2.19,0,0,2.08-4,0-4.52,0,0,4.66,1.28,2.64,4.36,0,0,2.15-1.76,4.66.6,0,0-5,0-5.83,2,0,0,2.19-1.39,3.47,0,0,0-4.38-.77-5.51,2.46Z"
            fill="#6d4c89"
          />
          <path
            d="M927,81.4s-.4-5-3.26-5.69c0,0,1.19,1,.58,1.85,0,0-1.06-2.47-4.39-1.88,0,0,3.82.5,4.39,2.82a2.67,2.67,0,0,0-2.94.87S927,79.51,927,81.4Z"
            fill="#6d4c89"
          />
          <path
            d="M926.11,80.67s.49-5,3.36-5.64c0,0-1.2,1-.61,1.84,0,0,1.1-2.45,4.42-1.8,0,0-3.83.43-4.43,2.74a2.67,2.67,0,0,1,2.92.92S926.12,78.77,926.11,80.67Z"
            fill="#6d4c89"
          />
          <path
            d="M921.17,96.76c.59-1.47.78-10.22,4.11-16.51-.46,1.74-3.51,13.63-2,17,.6,1.36-1.38,2.61-4.12,3.64l-3.85,0S920.52,98.4,921.17,96.76Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M966.42,87.55S969.11,93,965.8,96L971,96s-1.9-.91-2.14-1.51-.3-4.46-1.94-6.74Z"
            fill="#6d4c89"
          />
          <path
            d="M967.09,87.82s.25-3.17,2-3.59c0,0-.74.65-.36,1.16a2.4,2.4,0,0,1,2.77-1.18s-2.41.31-2.77,1.78a1.68,1.68,0,0,1,1.86.54S967.07,86.62,967.09,87.82Z"
            fill="#6d4c89"
          />
          <path
            d="M966.42,87.82s-.3-3.16-2.11-3.55c0,0,.75.63.38,1.16a2.39,2.39,0,0,0-2.79-1.14s2.42.27,2.8,1.73a1.7,1.7,0,0,0-1.85.58S966.42,86.63,966.42,87.82Z"
            fill="#6d4c89"
          />
          <path
            d="M967.31,88.37s-3.53-4.52-7.41-2.73c0,0,2.2-.1,2.39.15,0,0-.72-.1-.68.61,0,0,1.49-.73,1.92-.38,0,0-.83.17-.78.52,0,0,1.33-.33,1.68,0,0,0-.86.21-.51.62,0,0,1.17-.52,1.74.24,0,0-.49-.17-.64,0C965,87.4,967.22,87.91,967.31,88.37Z"
            fill="#6d4c89"
          />
          <path
            d="M966.67,88.32s3-4.33,7-2.18c0,0-2.19-.29-2.34,0a.68.68,0,0,1,.74.67s-1.56-.87-1.94-.55c0,0,.84.25.83.61,0,0-1.36-.45-1.66-.17,0,0,.87.29.58.68,0,0-1.23-.63-1.7.1,0,0,.47-.13.64.07C968.82,87.51,966.7,87.85,966.67,88.32Z"
            fill="#6d4c89"
          />
          <path
            d="M967.39,88.13a4.09,4.09,0,0,0-6,1s1.65-1.18,1.83-1a.81.81,0,0,0-.43.91s1-1.43,1.39-1.3c0,0-.6.57-.5.88,0,0,1-1,1.26-.84,0,0-.62.62-.3.84,0,0,.81-1.07,1.36-.62,0,0-.4.08-.49.33C965.51,88.31,967.25,87.72,967.39,88.13Z"
            fill="#6d4c89"
          />
          <path
            d="M966.43,88.22s3.92-3.07,7,.89c0,0-1.93-1.26-2.14-1.07a.86.86,0,0,1,.49,1s-1.19-1.57-1.63-1.41c0,0,.71.62.6,1,0,0-1.12-1-1.49-.9,0,0,.73.68.35.94,0,0-.95-1.18-1.59-.65,0,0,.47.08.57.36C968.63,88.36,966.59,87.77,966.43,88.22Z"
            fill="#6d4c89"
          />
          <path
            d="M967,88.31c-.16-1.82,1.76-4,3.14-3.85,0,0-2.74-.51-3.17,1.14,0,0,.54-2.18,1.34-2.19,0,0-1.78-.47-2.09,1,0,0-1-1.87,0-2.14,0,0-2.2.61-1.25,2.06a1.63,1.63,0,0,0-2.2.29s2.35,0,2.76,1c0,0-1-.66-1.64,0,0,0,2.07-.37,2.6,1.16Z"
            fill="#6d4c89"
          />
          <path
            d="M966.89,88.31c-.12-1.4,1.35-3.06,2.42-3,0,0-2.11-.39-2.44.88,0,0,.41-1.68,1-1.68,0,0-1.38-.37-1.62.8,0,0-.75-1.45,0-1.65,0,0-1.7.46-1,1.59a1.25,1.25,0,0,0-1.7.22s1.81,0,2.13.73c0,0-.8-.51-1.27,0,0,0,1.6-.28,2,.9Z"
            fill="#6d4c89"
          />
          <path
            d="M966.72,88.87s.14-1.83,1.19-2.07c0,0-.43.37-.21.67a1.37,1.37,0,0,1,1.6-.68s-1.4.18-1.6,1a1,1,0,0,1,1.07.32S966.71,88.18,966.72,88.87Z"
            fill="#6d4c89"
          />
          <path
            d="M967,88.6s-.18-1.82-1.22-2c0,0,.43.37.22.67a1.4,1.4,0,0,0-1.61-.66s1.39.16,1.61,1a1,1,0,0,0-1.06.34S967,87.91,967,88.6Z"
            fill="#6d4c89"
          />
          <path
            d="M968.83,94.47c-.21-.53-.28-3.72-1.5-6,.17.64,1.28,5,.74,6.22-.22.5.5,1,1.5,1.33l1.4,0S969.07,95.07,968.83,94.47Z"
            fill="#6d4c89"
            opacity="0.24"
          />
        </g>
        <g>
          <path
            d="M984.24,103.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S982.12,107.2,984.24,103.71Z"
            fill="#396039"
          />
          <path
            d="M983,96.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S983,96.81,983,96.81Z"
            fill="#447244"
          />
          <path
            d="M987.58,94c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S987.58,94,987.58,94Z"
            fill="#6b996b"
          />
          <path
            d="M980.62,106.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,974,106C975.78,106.73,978.78,105,980.62,106.38Z"
            fill="#447244"
          />
          <path
            d="M987,108c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C991.86,108.38,988.86,106.62,987,108Z"
            fill="#447244"
          />
          <path
            d="M990.87,105.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,990.87,105.21Z"
            fill="#396039"
          />
          <path
            d="M984.5,106.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,984.5,106.7Z"
            fill="#704d3c"
          />
          <path
            d="M987.71,106.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M982.31,105.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,982.31,105.34Z"
            fill="#44322c"
          />
          <path
            d="M987.06,105.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1.05-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,987.06,105.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M982.66,103.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M982.62,103.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C982.91,102.05,982.67,102.84,982.62,103.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M979.44,103.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,979.44,103.32Z"
            fill="#6b996b"
          />
          <path
            d="M980.56,95.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S980.56,95.08,980.56,95.08Z"
            fill="#6b996b"
          />
          <path
            d="M974.78,105.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C974,105.7,974.62,105,974.78,105.23Z"
            fill="#447244"
          />
          <path
            d="M986.7,108.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C986.47,109.14,986.21,108.9,986.7,108.9Z"
            fill="#396039"
          />
          <path
            d="M984.29,101.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S983.88,102.39,984.29,101.48Z"
            fill="#447244"
          />
          <path
            d="M991.75,100.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93S986.47,95,987,94.51s-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S992.45,103.12,991.75,100.92Z"
            fill="#447244"
          />
          <path
            d="M980.71,122.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C980.71,122.32,980.71,122.05,980.71,122.05Z"
            fill="#44322c"
          />
          <path
            d="M983.64,121.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-1.95,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,983.64,121.93Z"
            fill="#44322c"
          />
          <path
            d="M983,114.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,982,118a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C983.1,115.77,982.85,115,983,114.41Z"
            fill="#44322c"
          />
          <path
            d="M983,101.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C983.14,102.68,983,102.31,983,101.93Z"
            fill="#44322c"
          />
        </g>
        <g>
          <g>
            <rect
              x="1107.83"
              y="146.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1108.47"
                cy="140.57"
                rx="2.61"
                ry="0.51"
                fill="url(#af8cc88e-6a01-4684-8c28-db57f65f4b75)"
              />
              <ellipse
                cx="1108.47"
                cy="141.46"
                rx="3.6"
                ry="0.67"
                fill="url(#b80cdb07-3be6-4f95-8e48-ebc0ad63c6cb)"
              />
              <ellipse
                cx="1108.47"
                cy="142.35"
                rx="4.59"
                ry="0.83"
                fill="url(#b5b11025-e2e9-4ac8-8d9d-0d66326bb20f)"
              />
              <ellipse
                cx="1108.47"
                cy="143.24"
                rx="5.57"
                ry="0.99"
                fill="url(#a58b1564-2560-46ac-9152-d30b38a3d20c)"
              />
              <ellipse
                cx="1108.47"
                cy="144.13"
                rx="6.56"
                ry="1.15"
                fill="url(#bc117bed-cc21-4e10-8972-bb4dbc2dd3d4)"
              />
              <ellipse
                cx="1108.47"
                cy="145.03"
                rx="7.55"
                ry="1.31"
                fill="url(#f9096152-0410-41ac-9e4b-67854b38b6f4)"
              />
              <ellipse
                cx="1108.47"
                cy="146.34"
                rx="6.81"
                ry="1.2"
                fill="url(#f972b0ef-6e58-4a46-a4fa-e4d710e17f15)"
              />
              <ellipse
                cx="1108.47"
                cy="147.65"
                rx="6.07"
                ry="1.09"
                fill="url(#ffe9a791-b24c-436f-a1a1-ff3d2572df9d)"
              />
              <ellipse
                cx="1108.47"
                cy="148.96"
                rx="5.32"
                ry="0.98"
                fill="url(#b113aa07-ce44-4ca3-8ef0-cc3f8ad032d4)"
              />
              <ellipse
                cx="1108.47"
                cy="150.27"
                rx="4.58"
                ry="0.86"
                fill="url(#ec5df442-fa3e-4f5f-9c05-6be445dd5ae1)"
              />
              <ellipse
                cx="1108.47"
                cy="151.58"
                rx="3.84"
                ry="0.75"
                fill="url(#be198cd7-f47b-4bc8-9024-f1cb90035c2d)"
              />
            </g>
          </g>
          <circle
            cx="1108.34"
            cy="145.67"
            r="12.67"
            fill="url(#a4f7440e-0a99-4b73-8fba-877268796c2c)"
          />
        </g>
        <g>
          <g>
            <rect
              x="942.83"
              y="106.53"
              width="1.27"
              height="22.47"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="943.47"
                cy="100.57"
                rx="2.61"
                ry="0.51"
                fill="url(#a22a83b8-0f19-4ba6-b233-6548c13e1771)"
              />
              <ellipse
                cx="943.47"
                cy="101.46"
                rx="3.6"
                ry="0.67"
                fill="url(#b7f130ff-fffd-4dcb-b4f4-c27278dcbab1)"
              />
              <ellipse
                cx="943.47"
                cy="102.35"
                rx="4.59"
                ry="0.83"
                fill="url(#e92da4c0-dc4e-4e89-878c-cc9c57897892)"
              />
              <ellipse
                cx="943.47"
                cy="103.24"
                rx="5.57"
                ry="0.99"
                fill="url(#af3bb75d-bf0c-4e4c-8de0-8b071c4d8c1d)"
              />
              <ellipse
                cx="943.47"
                cy="104.13"
                rx="6.56"
                ry="1.15"
                fill="url(#b621a4b9-da69-4d47-8ca1-1dce2b900c3d)"
              />
              <ellipse
                cx="943.47"
                cy="105.03"
                rx="7.55"
                ry="1.31"
                fill="url(#be9095df-8a88-4b4e-83a1-50af4f0a0a11)"
              />
              <ellipse
                cx="943.47"
                cy="106.34"
                rx="6.81"
                ry="1.2"
                fill="url(#f8465dea-0dcf-479d-82b6-2d6bff55bd92)"
              />
              <ellipse
                cx="943.47"
                cy="107.65"
                rx="6.07"
                ry="1.09"
                fill="url(#e7f0015f-a176-4b59-8815-2fcbba29f8a7)"
              />
              <ellipse
                cx="943.47"
                cy="108.96"
                rx="5.32"
                ry="0.98"
                fill="url(#a9e31796-9bb5-4e01-bf19-c01843f47174)"
              />
              <ellipse
                cx="943.47"
                cy="110.27"
                rx="4.58"
                ry="0.86"
                fill="url(#e7405b36-9a11-439b-bb7a-96e207a44d8a)"
              />
              <ellipse
                cx="943.47"
                cy="111.58"
                rx="3.84"
                ry="0.75"
                fill="url(#a7ff5db6-05d3-469c-8ba2-506af4402ea4)"
              />
            </g>
          </g>
          <circle
            cx="943.34"
            cy="105.67"
            r="12.67"
            fill="url(#e58d0f6e-b11f-4c6f-8e95-ada9e5dde016)"
          />
        </g>
        <g>
          <g>
            <rect
              x="1379.03"
              y="134.61"
              width="1.61"
              height="28.39"
              rx="0.64"
              fill="#a39bb2"
            />
            <g>
              <ellipse
                cx="1379.83"
                cy="127.09"
                rx="3.29"
                ry="0.65"
                fill="url(#a93d67bd-1042-4640-a413-8d28303101a8)"
              />
              <ellipse
                cx="1379.83"
                cy="128.22"
                rx="4.54"
                ry="0.85"
                fill="url(#bcb12865-68fa-4f98-8301-1597d237fc54)"
              />
              <ellipse
                cx="1379.83"
                cy="129.34"
                rx="5.79"
                ry="1.05"
                fill="url(#a70b2ba3-5512-43e1-9f67-c0396d7576a7)"
              />
              <ellipse
                cx="1379.83"
                cy="130.47"
                rx="7.04"
                ry="1.25"
                fill="url(#ea7bc7b8-563c-40d3-8ec2-2108674f3256)"
              />
              <ellipse
                cx="1379.83"
                cy="131.59"
                rx="8.29"
                ry="1.45"
                fill="url(#ea477d7c-f6d6-4c6f-92f8-449c53836dcd)"
              />
              <ellipse
                cx="1379.83"
                cy="132.72"
                rx="9.54"
                ry="1.65"
                fill="url(#bc525b24-ec10-4a9c-a8d2-19c30d61a89d)"
              />
              <ellipse
                cx="1379.83"
                cy="134.37"
                rx="8.6"
                ry="1.51"
                fill="url(#aa1bb739-f1f4-41e1-b647-622a36a9cd56)"
              />
              <ellipse
                cx="1379.83"
                cy="136.03"
                rx="7.66"
                ry="1.37"
                fill="url(#bf70dbb5-6208-471a-a9dc-40b1d133f408)"
              />
              <ellipse
                cx="1379.83"
                cy="137.68"
                rx="6.72"
                ry="1.23"
                fill="url(#e02afc87-963a-4418-bac0-11e9b5f9566e)"
              />
              <ellipse
                cx="1379.83"
                cy="139.34"
                rx="5.79"
                ry="1.09"
                fill="url(#eb34fe2b-da19-4639-b158-efedbcde17d2)"
              />
              <ellipse
                cx="1379.83"
                cy="141"
                rx="4.85"
                ry="0.95"
                fill="url(#abb486f7-27e2-487f-a74f-c042925b8994)"
              />
            </g>
          </g>
          <circle
            cx="1379.67"
            cy="133.53"
            r="16"
            fill="url(#bc677365-b852-44fe-b235-577ced0fdf9b)"
          />
        </g>
        <g>
          <path
            d="M911.88,286.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
            fill="#6d3b2f"
          />
          <path
            d="M915.08,287.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S915.07,281.76,915.08,287.51Z"
            fill="#43771c"
          />
          <path
            d="M911.88,287.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S911.89,281.76,911.88,287.51Z"
            fill="#43771c"
          />
          <path
            d="M916.14,290.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C905.14,285.41,915.72,288,916.14,290.2Z"
            fill="#529022"
          />
          <path
            d="M913,289.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C923.42,286.11,913.22,287.65,913,289.91Z"
            fill="#529022"
          />
          <path
            d="M916.52,289s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C907.49,289.82,915.87,287.07,916.52,289Z"
            fill="#426642"
          />
          <path
            d="M911.88,289.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C922.47,290.18,912.68,287.25,911.88,289.44Z"
            fill="#426642"
          />
          <path
            d="M914.66,289.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M914.12,289.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M913.26,292.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1.05,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S913.26,289.26,913.26,292.58Z"
            fill="#659965"
          />
          <path
            d="M914.77,291.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S914.77,288,914.77,291.3Z"
            fill="#659965"
          />
          <path
            d="M923.2,319.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,6,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S924.32,322.52,923.2,319.63Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <ellipse
          cx="1305.17"
          cy="410.5"
          rx="11.5"
          ry="4.5"
          fill="#141c66"
          opacity="0.28"
        />
        <g transform="translate(560 -140)">
          <g>
            <path
              d="M911.88,286.22s12.71,26.37-3.36,40.78h24.93s-9.13-4.48-10.25-7.37-1.25-21.51-9.08-32.56Z"
              fill="#6d3b2f"
            />
            <path
              d="M915.08,287.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S915.07,281.76,915.08,287.51Z"
              fill="#43771c"
            />
            <path
              d="M911.88,287.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S911.89,281.76,911.88,287.51Z"
              fill="#43771c"
            />
            <path
              d="M916.14,290.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C905.14,285.41,915.72,288,916.14,290.2Z"
              fill="#529022"
            />
            <path
              d="M913,289.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C923.42,286.11,913.22,287.65,913,289.91Z"
              fill="#529022"
            />
            <path
              d="M916.52,289s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s4.95-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C907.49,289.82,915.87,287.07,916.52,289Z"
              fill="#426642"
            />
            <path
              d="M911.88,289.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C922.47,290.18,912.68,287.25,911.88,289.44Z"
              fill="#426642"
            />
            <path
              d="M914.66,289.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
              fill="#529022"
            />
            <path
              d="M914.12,289.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-8,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
              fill="#396039"
            />
            <path
              d="M913.26,292.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1.05,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S913.26,289.26,913.26,292.58Z"
              fill="#659965"
            />
            <path
              d="M914.77,291.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S914.77,288,914.77,291.3Z"
              fill="#659965"
            />
            <path
              d="M923.2,319.63c-1-2.59-1.21-17.95-7-29.05.78,3.06,6,24,3.28,30-1.07,2.39,2.39,4.61,7.17,6.46h6.76S924.32,322.52,923.2,319.63Z"
              fill="#17216b"
              opacity="0.24"
            />
          </g>
          <ellipse
            cx="1305.17"
            cy="410.5"
            rx="11.5"
            ry="4.5"
            fill="#141c66"
            opacity="0.28"
          />
        </g>
        <g>
          <path
            d="M1011.53,562.6s-20.69,24.45-54.48,14.07c0,0-8.49.66-1.26-14.11S971,556.81,971,556.81s-.93-12.15,10.51-11.25,4.32,11.21,8.62,12.49,5.24-10,9.95-11.95,13.47,3,12.48,9.73Z"
            fill="#396039"
          />
          <path
            d="M984.21,569.82c-4.62,0,.21-6.22-1.7-7.76s-5.13,4-7.75,7.08-5.41,0-8.81-4-4.78-7.13-10.16-2.58-13.3,10.88-6.37,14,17.83,6,22,2.6,10.89,3.3,12.65.94S988.21,569.84,984.21,569.82Z"
            fill="#426642"
          />
          <path
            d="M980.7,556.05c3.15-3.09.4-8.17-3.1-6.6s-.78,7.09-4,8.79-8.81,3.67-2.55,5.61S980.7,556.05,980.7,556.05Z"
            fill="#2f4f2f"
          />
          <path
            d="M1002.37,565.89c4.61-2.87,5.5-7.88,4.08-9s-5.3-4.44-6.45,0-8.71,5.75-7.09,9.87S1002.37,565.89,1002.37,565.89Z"
            fill="#2f4f2f"
          />
          <path
            d="M998.65,576.38c5.76-5.21,10.14-3.52,9.74-6.86s.52-6.53-3.28-7.35-4.15,3.75-7.45,4.51-3.87-4.91-7-.7S991.85,582.54,998.65,576.38Z"
            fill="#426642"
          />
          <path
            d="M989.55,579.92c6.49-2,4.37-5,2.31-6.62s-6,2.9-8.62,1.72-7.89,3.19-10.44,1.13-7.74-6-10.27-1.95S956,587,963.72,583.08s15.77-1,19.49-1.08A12.22,12.22,0,0,0,989.55,579.92Z"
            fill="#659965"
          />
        </g>
        <g>
          <path
            d="M1388.12,579.07l-2.24-.85a55.91,55.91,0,0,1,4.44,15.78h3.94C1393,588.79,1391.16,583.36,1388.12,579.07Z"
            fill="#6d3b2f"
          />
          <path
            d="M1389.08,579.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1389.07,573.76,1389.08,579.51Z"
            fill="#43771c"
          />
          <path
            d="M1385.88,579.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S1385.89,573.76,1385.88,579.51Z"
            fill="#43771c"
          />
          <path
            d="M1390.14,582.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C1379.14,577.41,1389.72,580,1390.14,582.2Z"
            fill="#529022"
          />
          <path
            d="M1387,581.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C1397.42,578.11,1387.22,579.65,1387,581.91Z"
            fill="#529022"
          />
          <path
            d="M1390.52,581s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s5-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C1381.49,581.82,1389.87,579.07,1390.52,581Z"
            fill="#426642"
          />
          <path
            d="M1385.88,581.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C1396.47,582.18,1386.68,579.25,1385.88,581.44Z"
            fill="#426642"
          />
          <path
            d="M1388.66,581.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1388.12,581.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1387.26,584.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1387.26,581.26,1387.26,584.58Z"
            fill="#659965"
          />
          <path
            d="M1388.77,583.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1388.77,580,1388.77,583.3Z"
            fill="#659965"
          />
          <path
            d="M1390.24,582.58c.34,1.33,1.51,6,2.5,11.42h1.52A50,50,0,0,0,1390.24,582.58Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g transform="translate(60 -400)">
          <path
            d="M1388.12,579.07l-2.24-.85a55.91,55.91,0,0,1,4.44,15.78h3.94C1393,588.79,1391.16,583.36,1388.12,579.07Z"
            fill="#6d3b2f"
          />
          <path
            d="M1389.08,579.51s1.34-15.22,10-17.2c0,0-3.62,3.09-1.81,5.6,0,0,3.31-7.47,13.39-5.6,0,0-11.62,1.42-13.39,8.45a8.13,8.13,0,0,1,8.91,2.71S1389.07,573.76,1389.08,579.51Z"
            fill="#43771c"
          />
          <path
            d="M1385.88,579.51s-1.34-15.22-10-17.2c0,0,3.62,3.09,1.81,5.6,0,0-3.3-7.47-13.39-5.6,0,0,11.62,1.42,13.39,8.45a8.13,8.13,0,0,0-8.91,2.71S1385.89,573.76,1385.88,579.51Z"
            fill="#43771c"
          />
          <path
            d="M1390.14,582.2s-16.82-21.91-35.59-13.48c0,0,10.62-.4,11.51.85,0,0-3.48-.55-3.31,2.88,0,0,7.22-3.46,9.25-1.75,0,0-4,.8-3.76,2.49,0,0,6.43-1.53,8.09,0,0,0-4.15,1-2.5,3,0,0,5.69-2.47,8.42,1.22,0,0-2.38-.81-3.11.07C1379.14,577.41,1389.72,580,1390.14,582.2Z"
            fill="#529022"
          />
          <path
            d="M1387,581.91s14.41-20.73,33.82-10.2c0,0-10.54-1.48-11.29-.29a3.31,3.31,0,0,1,3.56,3.28s-7.49-4.27-9.32-2.73c0,0,4,1.23,4,2.93,0,0-6.51-2.22-8-.86,0,0,4.2,1.42,2.77,3.29,0,0-5.87-3.1-8.2.4,0,0,2.27-.59,3.08.38C1397.42,578.11,1387.22,579.65,1387,581.91Z"
            fill="#529022"
          />
          <path
            d="M1390.52,581s-16-12.71-28.92,4.58c0,0,8-5.6,8.83-4.84a3.86,3.86,0,0,0-2.07,4.38s5-6.86,6.74-6.22c0,0-2.92,2.73-2.48,4.24,0,0,4.64-4.63,6.11-4,0,0-3,3-1.45,4.07,0,0,3.94-5.15,6.55-3,0,0-1.92.39-2.34,1.58C1381.49,581.82,1389.87,579.07,1390.52,581Z"
            fill="#426642"
          />
          <path
            d="M1385.88,581.44s19-14.62,33.87,4.57c0,0-9.25-6.13-10.27-5.27a4.16,4.16,0,0,1,2.35,4.89s-5.68-7.61-7.8-6.86c0,0,3.37,3,2.83,4.72,0,0-5.36-5.12-7.1-4.4,0,0,3.46,3.29,1.62,4.55,0,0-4.52-5.72-7.63-3.2,0,0,2.25.4,2.72,1.74C1396.47,582.18,1386.68,579.25,1385.88,581.44Z"
            fill="#426642"
          />
          <path
            d="M1388.66,581.9c-.69-8.8,8.59-19,15.27-18.41,0,0-13.19-2.56-15.32,5.34,0,0,2.67-10.47,6.56-10.47,0,0-8.59-2.35-10.14,4.91,0,0-4.64-9.07,0-10.3,0,0-10.62,2.83-6.08,9.88,0,0-4.86-4.06-10.63,1.28,0,0,11.32.21,13.24,4.7,0,0-5-3.21-7.9,0,0,0,10-1.66,12.49,5.71Z"
            fill="#529022"
          />
          <path
            d="M1388.12,581.9c-.54-6.79,6.63-14.69,11.77-14.2,0,0-10.17-2-11.81,4.12,0,0,2.05-8.07,5.06-8.07,0,0-6.63-1.81-7.82,3.79,0,0-3.58-7,0-7.95,0,0-8.19,2.18-4.69,7.62,0,0-3.75-3.13-8.2,1,0,0,8.73.17,10.21,3.63,0,0-3.83-2.47-6.09,0,0,0,7.7-1.28,9.63,4.4Z"
            fill="#396039"
          />
          <path
            d="M1387.26,584.58s.78-8.8,5.81-9.94c0,0-2.09,1.79-1,3.24,0,0,1.91-4.32,7.74-3.24,0,0-6.72.82-7.74,4.89a4.69,4.69,0,0,1,5.15,1.56S1387.26,581.26,1387.26,584.58Z"
            fill="#659965"
          />
          <path
            d="M1388.77,583.3s-.78-8.8-5.81-9.94c0,0,2.09,1.79,1,3.24,0,0-1.91-4.32-7.74-3.24,0,0,6.72.82,7.74,4.89a4.69,4.69,0,0,0-5.15,1.56S1388.77,580,1388.77,583.3Z"
            fill="#659965"
          />
          <path
            d="M1390.24,582.58c.34,1.33,1.51,6,2.5,11.42h1.52A50,50,0,0,0,1390.24,582.58Z"
            fill="#17216b"
            opacity="0.24"
          />
        </g>
        <g>
          <g>
            <path
              d="M1443.87,516.91c-.07-.53-.11-1.07-.14-1.59a12.94,12.94,0,0,1,.07-2.33c.1-.69.3-1.36.46-2a6.6,6.6,0,0,0,.2-1.82c0-.67-.22-1.31-.27-2a4.79,4.79,0,0,1,.14-1.51c.13-.34.27-.68.42-1a8.35,8.35,0,0,1,.58-.88.14.14,0,0,0,0-.18,7.07,7.07,0,0,1,7.88-3.4,2,2,0,0,0,.54.55,4.71,4.71,0,0,0,1.63.6,3.15,3.15,0,0,1,1.69.88,15.57,15.57,0,0,1,1.14,1.83,3.39,3.39,0,0,0,.76.8,3.6,3.6,0,0,0,.93.44,2.55,2.55,0,0,1,1,.6,8.19,8.19,0,0,1,.66.89,7.55,7.55,0,0,0,.79.81,6,6,0,0,1,.57.66c.84,1.1.9,2.57,1.21,3.87a5.62,5.62,0,0,0,.91,2.15,10.28,10.28,0,0,0,1.36,1.36,4.51,4.51,0,0,1,1,1.19,5,5,0,0,1,.46,2.16c.09,1.78-.06,3.56.15,5.33a10.85,10.85,0,0,0,.22,1.29c.1.4.24.8.32,1.21a2.72,2.72,0,0,1-.12,1.57,13.18,13.18,0,0,1-.73,1.33,4,4,0,0,0-.67,2.12,3.34,3.34,0,0,1,0,1.18,2.54,2.54,0,0,1-.51.85,10.36,10.36,0,0,0-1.31,1.5.16.16,0,0,0,0,.08,6.91,6.91,0,0,1-1.82,1.1,7.06,7.06,0,0,1-3.06.48,10.56,10.56,0,0,0-2-1.08,23.83,23.83,0,0,1-2.44-1,6.87,6.87,0,0,1-1.08-.7c-.33-.27-.62-.58-1-.84-.66-.49-1.41-.85-2-1.38a3.59,3.59,0,0,1-.87-1.07c-.2-.39-.35-.81-.53-1.22a3.86,3.86,0,0,0-.67-1.1,10.31,10.31,0,0,0-.94-.93c-.43-.39-.88-.76-1.31-1.14a34.21,34.21,0,0,1-1.6-3.27,6.78,6.78,0,0,1,.58-1.35c.35-.65.75-1.26,1.11-1.91a.18.18,0,0,0-.09-.25,17.26,17.26,0,0,1-1.76-.4,2.35,2.35,0,0,1-1.13-.63,2.22,2.22,0,0,1-.44-.78C1444,517.59,1443.94,517.25,1443.87,516.91Z"
              fill="#396039"
            />
            <path
              d="M1449.39,501.82a123,123,0,0,1,8,17.36c2.31,6,4.3,12,6.14,18.13s3.36,12.32,4.83,18.53c.72,3.11,1.36,6.23,2,9.35l1.76,9.41-1.91-9.38c-.71-3.11-1.36-6.23-2.1-9.33-1.5-6.2-3.06-12.39-4.93-18.49s-3.75-12.18-6-18.15l-1.76-4.44c-.62-1.47-1.21-2.95-1.87-4.4A91,91,0,0,0,1449.39,501.82Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1479.36,544.17c0-.77,0-1.53-.09-2.29a50.74,50.74,0,0,1,3.5-11.25c.38-.37.75-.74,1.09-1.14s.78-1,1.16-1.55l1.33-1.82a15.68,15.68,0,0,0,2.14-3.75c.24-.67.33-1.37.51-2.06.12-.46.28-.92.44-1.37,4.36-5.84,8.93-9,11.76-7.68a3.26,3.26,0,0,1,1,.79c.06.2.12.41.17.62a8.8,8.8,0,0,1,.27,2.89,12.63,12.63,0,0,1-.57,2.77,18.92,18.92,0,0,0-.94,3.2,11.91,11.91,0,0,0,.12,3,14.38,14.38,0,0,1,.22,3.07,4.11,4.11,0,0,1-.88,2.53,7.47,7.47,0,0,1-1.62,1.16,8,8,0,0,0-1.72,1.62,2.13,2.13,0,0,0-.6,1.63c.07.63.34,1.23.45,1.86a5.25,5.25,0,0,1-1.31,4.17,20.34,20.34,0,0,1-3.55,3.06c-.67.51-1.33,1-2,1.59-.31.28-.62.58-.91.89s-.62.74-.94,1.11a19,19,0,0,1-4.69,3.61c-.85.52-1.68,1-2.47,1.64-1.43-.72-2.22-2.53-2.4-5.08A12.34,12.34,0,0,0,1479.36,544.17Z"
              fill="#2f4f2f"
            />
            <path
              d="M1502.27,510.81q-2.51,3.69-4.82,7.5t-4.54,7.68q-4.4,7.77-8.14,15.87a172.28,172.28,0,0,0-6.65,16.53c-.86,2.85-1.81,5.67-2.46,8.57-.82,2.86-1.26,5.81-1.82,8.73a104.58,104.58,0,0,1,4.07-17.37,170.32,170.32,0,0,1,6.56-16.6q3.81-8.09,8.25-15.84C1495.68,520.72,1498.83,515.66,1502.27,510.81Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1479.65,548.49c.1-.6.16-1.21.22-1.81a39.67,39.67,0,0,1,4.17-8.37c.34-.24.68-.49,1-.75s.75-.71,1.11-1.08l1.27-1.25a12.34,12.34,0,0,0,2.16-2.67c.27-.5.43-1,.66-1.55a10.88,10.88,0,0,1,.52-1c4.16-4,8.15-6,10.19-4.52a2.51,2.51,0,0,1,.7.75c0,.17,0,.33.07.5a7.11,7.11,0,0,1-.16,2.3,10.45,10.45,0,0,1-.8,2.1,14.53,14.53,0,0,0-1.14,2.39,8.82,8.82,0,0,0-.29,2.4,12.34,12.34,0,0,1-.22,2.43,3.33,3.33,0,0,1-1,1.88,6,6,0,0,1-1.41.7,6.11,6.11,0,0,0-1.56,1.05,1.72,1.72,0,0,0-.68,1.2c0,.51.12,1,.12,1.52a4.2,4.2,0,0,1-1.55,3.1,16.4,16.4,0,0,1-3.18,1.94c-.58.32-1.17.64-1.73,1-.28.19-.56.38-.83.59s-.58.5-.88.75a15.28,15.28,0,0,1-4.13,2.23c-.73.3-1.45.61-2.14,1-1-.75-1.42-2.27-1.24-4.28A10.37,10.37,0,0,0,1479.65,548.49Z"
              fill="#396039"
            />
            <path
              d="M1501.84,525.25q-2.43,2.58-4.72,5.28c-1.55,1.78-3.06,3.6-4.53,5.44q-4.42,5.53-8.39,11.41a137.6,137.6,0,0,0-7.32,12.11c-1,2.11-2.14,4.2-3,6.39s-1.73,4.39-2.55,6.61a83,83,0,0,1,5.38-13.11,136.21,136.21,0,0,1,7.24-12.19q4-5.85,8.49-11.35A141.06,141.06,0,0,1,1501.84,525.25Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1469.55,548.82a.79.79,0,0,0,.34-.56.9.9,0,0,0-.35-.65,6.46,6.46,0,0,0-1-.8v0a5.26,5.26,0,0,0,.62-.63,1,1,0,0,0,.27-.55c0-.4-.41-.59-.72-.71s-.44-.17-.67-.24c-.14-.69-.28-1.41-.4-2.16l.4-.1a6.76,6.76,0,0,0,1-.32,1.73,1.73,0,0,0,.67-.42.18.18,0,0,0,0-.27c-.31-.17-.64-.29-1-.44a2.13,2.13,0,0,1-.84-.54c-.24-.31-.06-.67,0-1a.94.94,0,0,0-.39-.68l-.32-.27c-.1-.89-.18-1.8-.25-2.74l.55-.16a2.94,2.94,0,0,0,1.25-.65,1.06,1.06,0,0,0,.19-1.26,2.45,2.45,0,0,0-1.26-.93,6.61,6.61,0,0,0-.79-.25c0-.32-.11-.64-.16-1,0-.91,0-1.85,0-2.79a.44.44,0,0,1,.08-.11,1.46,1.46,0,0,1,.52-.32,3,3,0,0,0,.78-.59.17.17,0,0,0,0-.24c-.37-.31-1.27-.77-1-1.39.07-.18.36-.2.51-.28a.5.5,0,0,0,.27-.56c-.12-.42-.63-.58-.86-.91s.4-.5.65-.52a7.7,7.7,0,0,0,1.36,0,.17.17,0,0,0,0-.3c-.69-.5-1.39-1-2.12-1.44.13-2,.32-3.83.56-5.58l.31.09a.17.17,0,0,0,.2-.15,6.71,6.71,0,0,1,1.33.69l.72.54c.16.13.39-.09.23-.23a6.94,6.94,0,0,0-.76-.58,13.9,13.9,0,0,0-1.91-1.16c.22-1.53.49-3,.8-4.27a6.93,6.93,0,0,1,1.64.86l.59.54a.17.17,0,0,0,.24-.24,4.68,4.68,0,0,0-.62-.56c-.39-.36-.77-.72-1.18-1.06l-.47-.38a27.15,27.15,0,0,1,1.17-3.65,21.07,21.07,0,0,0,2.2.89.18.18,0,0,0,.21-.16,3.6,3.6,0,0,0-.81-1.81,7.34,7.34,0,0,0-.7-.79c.81-1.36,1.7-2.12,2.63-2.12,1.9,0,3.61,3.1,4.81,8.06-.49.44-1,.91-1.44,1.38a.17.17,0,0,0,.2.26,11.3,11.3,0,0,0,1.39-1c.3,1.31.56,2.73.79,4.26a23.93,23.93,0,0,0-1.47,3,.17.17,0,0,0,0,.23c.62.32,1.27.58,1.9.87.2,2.16.32,4.45.36,6.83a12.79,12.79,0,0,0-1.32,3.09,6.85,6.85,0,0,0-.11,2.47c0,.41.09.82.11,1.23s0,.81.07,1.21c.11.76.4,1.49.53,2.25a1.84,1.84,0,0,1-.5,1.86,4.35,4.35,0,0,1-1.39.53.63.63,0,0,0-.41.35.79.79,0,0,0,.11.63,3.37,3.37,0,0,0,1.43,1.21l.52.29c-1.16,7.32-3.25,12.21-5.63,12.21-1.46,0-2.82-1.86-3.92-5A2.16,2.16,0,0,0,1469.55,548.82Z"
              fill="#659965"
            />
            <path
              d="M1473.14,511.46c.29,10.57.37,21.14.49,31.71V559c-.06,5.29,0,10.59-.48,15.85.26-2.63.2-5.28.24-7.92l0-7.93-.1-15.85Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1462.79,523a2.05,2.05,0,0,1,1.25,0c.23.3.46.6.71.89.36.44.73.88,1.13,1.29a11.66,11.66,0,0,1,1.08,1.25,10.47,10.47,0,0,1,1.25,2.27,10.34,10.34,0,0,0,1.3,2.62c.51.63,1.16,1.1,1.72,1.67l0,0c.14.38.27.77.4,1.16a30.82,30.82,0,0,1,1.55,7.48q0,.3-.06.6a47.47,47.47,0,0,0-1,5.41,2.16,2.16,0,0,1-1,.78c-2.59.85-6.56-4.16-8.87-11.19S1460.2,523.89,1462.79,523Z"
              fill="#3b6818"
            />
            <path
              d="M1462.29,537.3s11.13,5.67,11.51,34.93"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.33"
            />
            <path
              d="M1464.54,525.69a6.31,6.31,0,0,1,1.54,2.91,13.59,13.59,0,0,0,.63,3.08,4.25,4.25,0,0,0,1,1.38c.4.37.83.69,1.22,1.08a3.24,3.24,0,0,1,.89,1.48,2.79,2.79,0,0,1,0,1.32,6.21,6.21,0,0,0-.2,1.37,4.52,4.52,0,0,0,.56,1.85,5.14,5.14,0,0,1,.56,1.9,4,4,0,0,1-.21,1.21,3.62,3.62,0,0,0-.08,1.32,3.47,3.47,0,0,0,.41,1.21,2.56,2.56,0,0,1,.37,1,3.33,3.33,0,0,1-.48,1.55l-.08.16a1.18,1.18,0,0,1-.45.27c-2,.67-5.58-4.48-7.89-11.51s-2.54-13.27-.5-13.94a1.49,1.49,0,0,1,.86,0A13.26,13.26,0,0,0,1464.54,525.69Z"
              fill="#659965"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1464.56,542.86a9,9,0,0,0,.09-1,7.41,7.41,0,0,0,0-1.49c-.06-.45-.19-.88-.29-1.31a4.25,4.25,0,0,1-.13-1.17c0-.43.14-.85.17-1.27a2.94,2.94,0,0,0-.09-1c-.08-.22-.17-.43-.27-.64s-.24-.38-.37-.57a.08.08,0,0,1,0-.12,4.82,4.82,0,0,0-2.28-2,4.71,4.71,0,0,0-2.79-.19,1.5,1.5,0,0,1-.35.36,3.23,3.23,0,0,1-1,.38,2,2,0,0,0-1.09.56,11,11,0,0,0-.73,1.18,2.21,2.21,0,0,1-.49.52,2.53,2.53,0,0,1-.6.28,1.59,1.59,0,0,0-.63.39,6.07,6.07,0,0,0-.43.57,6.14,6.14,0,0,1-.5.52,4.83,4.83,0,0,0-.37.42,6.36,6.36,0,0,0-.78,2.5,3.68,3.68,0,0,1-.59,1.38,6.57,6.57,0,0,1-.87.88,2.83,2.83,0,0,0-.66.76,3.19,3.19,0,0,0-.3,1.39c-.06,1.15,0,2.29-.1,3.43a7.56,7.56,0,0,1-.14.83c-.06.26-.15.51-.2.78a1.74,1.74,0,0,0,.07,1c.13.3.32.57.47.86a2.58,2.58,0,0,1,.44,1.36,2.16,2.16,0,0,0,0,.76,1.79,1.79,0,0,0,.33.55,7,7,0,0,1,.85,1,.13.13,0,0,1,0,.06,4.47,4.47,0,0,0,3.15,1,6.9,6.9,0,0,1,1.32-.69c.52-.22,1.07-.4,1.57-.67a5.1,5.1,0,0,0,.69-.45c.21-.18.4-.38.62-.54.43-.32.91-.55,1.31-.89a2.33,2.33,0,0,0,.56-.69c.13-.25.23-.52.34-.79a2.64,2.64,0,0,1,.43-.7,6.9,6.9,0,0,1,.61-.6l.84-.74a21.54,21.54,0,0,0,1-2.1,4.84,4.84,0,0,0-.37-.87c-.23-.42-.49-.81-.71-1.23a.11.11,0,0,1,0-.16c.38-.08.77-.14,1.14-.25a1.62,1.62,0,0,0,.72-.41,1.46,1.46,0,0,0,.28-.5C1464.47,543.3,1464.52,543.08,1464.56,542.86Z"
              fill="#396039"
            />
            <path
              d="M1461,533.15a58.69,58.69,0,0,0-2.7,5.52c-.84,1.88-1.6,3.78-2.34,5.7-1.46,3.83-2.72,7.74-3.88,11.68s-2.2,7.91-3.17,11.89c-.47,2-.9,4-1.35,6l-1.23,6,1.13-6.06c.44-2,.85-4,1.31-6,1-4,1.93-8,3.11-11.92s2.46-7.84,3.95-11.67A78.54,78.54,0,0,1,1461,533.15Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1441.72,560.4c0-.49,0-1,.06-1.47a32.38,32.38,0,0,0-2.25-7.24c-.24-.24-.48-.48-.7-.73s-.5-.67-.75-1-.57-.78-.85-1.17a10,10,0,0,1-1.38-2.42c-.15-.43-.21-.88-.33-1.32s-.18-.59-.28-.88c-2.81-3.76-5.75-5.82-7.57-4.94a2.14,2.14,0,0,0-.66.5l-.12.4a6.09,6.09,0,0,0-.17,1.86,8.41,8.41,0,0,0,.37,1.78,11.79,11.79,0,0,1,.6,2.06,7.56,7.56,0,0,1-.07,2,8.68,8.68,0,0,0-.14,2,2.69,2.69,0,0,0,.56,1.64,5.45,5.45,0,0,0,1,.74,5.27,5.27,0,0,1,1.12,1,1.43,1.43,0,0,1,.38,1.05c0,.41-.22.79-.29,1.2a3.39,3.39,0,0,0,.84,2.68,13.46,13.46,0,0,0,2.29,2c.43.33.85.66,1.26,1,.2.19.4.38.59.58s.4.48.6.71a12.26,12.26,0,0,0,3,2.33c.54.33,1.08.67,1.59,1,.92-.46,1.43-1.63,1.54-3.27A8.19,8.19,0,0,1,1441.72,560.4Z"
              fill="#2f4f2f"
            />
            <path
              d="M1427,538.93a135,135,0,0,1,11.46,19.89,111.38,111.38,0,0,1,4.22,10.69,68,68,0,0,1,2.62,11.18,77.34,77.34,0,0,0-2.76-11.13,110.07,110.07,0,0,0-4.28-10.65q-2.4-5.2-5.23-10.21C1431.11,545.38,1429.13,542.1,1427,538.93Z"
              fill="#87f139"
            />
          </g>
          <g>
            <path
              d="M1441.54,563.18c-.06-.38-.11-.77-.14-1.16a26.15,26.15,0,0,0-2.68-5.39c-.23-.16-.44-.31-.65-.48s-.47-.46-.71-.69-.55-.54-.82-.81a7.62,7.62,0,0,1-1.38-1.72c-.18-.32-.28-.66-.43-1s-.21-.44-.33-.65c-2.68-2.59-5.25-3.83-6.57-2.91a1.89,1.89,0,0,0-.45.48c0,.11,0,.22,0,.32a4.59,4.59,0,0,0,.11,1.48A6.47,6.47,0,0,0,1428,552a8.78,8.78,0,0,1,.73,1.55,5.7,5.7,0,0,1,.19,1.54,7.42,7.42,0,0,0,.14,1.56,2.17,2.17,0,0,0,.66,1.21,3.79,3.79,0,0,0,.9.45,4.07,4.07,0,0,1,1,.68,1.08,1.08,0,0,1,.43.77c0,.33-.07.65-.07,1a2.66,2.66,0,0,0,1,2,10.15,10.15,0,0,0,2,1.25c.38.21.76.41,1.12.65a6.3,6.3,0,0,1,.53.37c.2.15.38.33.57.49a9.75,9.75,0,0,0,2.66,1.43c.47.19.93.39,1.38.62.66-.47.91-1.45.79-2.75A6.84,6.84,0,0,1,1441.54,563.18Z"
              fill="#396039"
            />
            <path
              d="M1427.26,548.23a104.73,104.73,0,0,1,11.52,14.12,86.05,86.05,0,0,1,4.66,7.84,52.93,52.93,0,0,1,3.47,8.44,61.83,61.83,0,0,0-3.59-8.37,89,89,0,0,0-4.71-7.79q-2.55-3.78-5.4-7.34C1431.3,552.76,1429.34,550.44,1427.26,548.23Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1448,563.4a.55.55,0,0,1-.22-.36.62.62,0,0,1,.22-.43,5.52,5.52,0,0,1,.66-.51v0a3,3,0,0,1-.4-.4.67.67,0,0,1-.17-.36c0-.26.26-.37.46-.45l.43-.16c.1-.44.18-.91.26-1.39l-.25-.06a5.17,5.17,0,0,1-.63-.21,1.16,1.16,0,0,1-.43-.27.11.11,0,0,1,0-.17c.19-.11.41-.19.61-.29a1.38,1.38,0,0,0,.54-.34c.16-.2,0-.43,0-.66a.62.62,0,0,1,.25-.44l.2-.17c.07-.57.12-1.16.16-1.77l-.35-.1a1.87,1.87,0,0,1-.8-.42.67.67,0,0,1-.13-.8,1.57,1.57,0,0,1,.81-.6,5.08,5.08,0,0,1,.51-.17c0-.2.07-.41.11-.61l0-1.8,0-.07a1.08,1.08,0,0,0-.34-.21,1.7,1.7,0,0,1-.5-.38.1.1,0,0,1,0-.15c.24-.2.81-.5.65-.9,0-.11-.23-.12-.33-.18a.32.32,0,0,1-.17-.36c.07-.27.4-.37.55-.58s-.26-.33-.42-.33a6.47,6.47,0,0,1-.88,0c-.09,0-.09-.15,0-.2.45-.32.9-.64,1.37-.92-.09-1.27-.21-2.47-.37-3.59l-.19.05a.1.1,0,0,1-.13-.09,4.65,4.65,0,0,0-.86.44c-.16.11-.31.23-.46.35s-.26-.06-.15-.15a4.49,4.49,0,0,1,.49-.37,9.61,9.61,0,0,1,1.23-.75c-.15-1-.32-1.9-.52-2.74a4,4,0,0,0-1.05.55l-.38.34c-.11.09-.25,0-.16-.15a4.48,4.48,0,0,1,.4-.36c.25-.23.5-.46.76-.68l.3-.25a16.57,16.57,0,0,0-.75-2.34,14.26,14.26,0,0,1-1.41.56.11.11,0,0,1-.14-.1,2.31,2.31,0,0,1,.52-1.16c.14-.17.29-.35.45-.51-.52-.87-1.09-1.36-1.69-1.36-1.22,0-2.32,2-3.1,5.18.32.29.63.59.93.89a.11.11,0,0,1-.13.17,8.14,8.14,0,0,1-.9-.64c-.19.84-.36,1.76-.5,2.74a18.31,18.31,0,0,1,1,1.94.12.12,0,0,1,0,.15c-.4.21-.81.37-1.22.56-.13,1.39-.21,2.86-.23,4.39a8.53,8.53,0,0,1,.85,2,4.73,4.73,0,0,1,.07,1.59c0,.27-.06.53-.07.8s0,.51,0,.77c-.07.49-.25,1-.34,1.45a1.21,1.21,0,0,0,.33,1.2,2.74,2.74,0,0,0,.89.34.38.38,0,0,1,.26.22.54.54,0,0,1-.07.41,2.12,2.12,0,0,1-.92.78l-.34.19c.75,4.71,2.09,7.85,3.63,7.85.94,0,1.81-1.19,2.52-3.22Z"
              fill="#659965"
            />
            <path
              d="M1445.73,539.35l-.1,20.41-.07,10.2,0,5.1c0,1.7,0,3.41.15,5.1-.32-3.39-.27-6.8-.31-10.2v-10.2C1445.49,553,1445.54,546.15,1445.73,539.35Z"
              fill="#78bf3a"
            />
          </g>
          <g>
            <path
              d="M1452.39,546.8a1.36,1.36,0,0,0-.8,0c-.15.2-.3.39-.46.58s-.47.56-.73.82a10.69,10.69,0,0,0-.7.81,7.4,7.4,0,0,0-.8,1.46,6.84,6.84,0,0,1-.84,1.69c-.32.4-.74.7-1.1,1.07l0,0c-.09.25-.18.5-.26.75a20.14,20.14,0,0,0-1,4.82c0,.12,0,.25,0,.38a29.83,29.83,0,0,1,.61,3.48,1.34,1.34,0,0,0,.67.5c1.66.55,4.22-2.67,5.71-7.2S1454.05,547.35,1452.39,546.8Z"
              fill="#3b6818"
            />
            <path
              d="M1452.71,556s-7.16,3.65-7.41,22.49"
              fill="none"
              stroke="#78bf3a"
              strokeMiterlimit="10"
              strokeWidth="0.21"
            />
            <path
              d="M1451.26,548.51a4.13,4.13,0,0,0-1,1.87,8.92,8.92,0,0,1-.4,2,2.81,2.81,0,0,1-.65.89c-.26.24-.54.45-.79.7a2.09,2.09,0,0,0-.57.95,1.62,1.62,0,0,0,0,.85,3.66,3.66,0,0,1,.12.88,2.94,2.94,0,0,1-.36,1.19,3.36,3.36,0,0,0-.36,1.22,2.45,2.45,0,0,0,.14.78,2.45,2.45,0,0,1,0,.86,2.13,2.13,0,0,1-.26.77,1.59,1.59,0,0,0-.24.67,2,2,0,0,0,.31,1,.31.31,0,0,0,0,.1.64.64,0,0,0,.29.18c1.31.43,3.59-2.88,5.08-7.41s1.63-8.54.31-9a.87.87,0,0,0-.55,0A8.68,8.68,0,0,1,1451.26,548.51Z"
              fill="#659965"
            />
          </g>
        </g>
        <g transform="translate(-80 110)">
          <ellipse
            cx="307.2"
            cy="343.5"
            rx="48.15"
            ry="8.5"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M281.94,336.18c-8.27,4.19-10.06,5.09-17.52,2.11s-22.36-20.28-5.66-31.9,33.69,3.87,33.69,10.73c0,0-28.92-30.11,0-37.86s19.37,22.66,17.29,27.13c0,0,10.43-20.57,22.36-14.31s4.26,45-17.7,35c0,0,29.62-14.13,38.86,1.07s-50.38,18.19-60.81,13.12S281.94,336.18,281.94,336.18Z"
            fill="#1f441f"
          />
          <path
            d="M281.26,300.27c7.46,3,4.93-11.77,4.93-11.77s3.28-1.79,3.35-8.32C278.41,284.35,278.25,292.61,281.26,300.27Z"
            fill="#659965"
          />
          <path
            d="M307.06,311.16c-21.17-2.09-21.47-20-9.84-25S307.06,311.16,307.06,311.16Z"
            fill="#245624"
          />
          <path
            d="M297.44,326.82c-34.33,5.59-40.94-18.72-24.21-30.28S297.44,326.82,297.44,326.82Z"
            fill="#245624"
          />
          <path
            d="M311.81,326.09c25.8,15.21,41-4.88,32-20.3S311.81,326.09,311.81,326.09Z"
            fill="#245624"
          />
          <g>
            <path
              d="M309.74,306.39c10.73,7.15,12.82-5.67,12.82-5.67,4.59-.62,6-5.19,6.38-9.71C318.39,289.34,309.74,306.39,309.74,306.39Z"
              fill="#659965"
            />
            <path d="M309.74,306.39c.21-.46.51-1.2.83-2.14Z" fill="#659965" />
          </g>
          <path
            d="M322.22,330.57c14.73,3.87,24.07-5,24.19-15.24q-.82.72-1.62,1.32c-7,5.21-12.69,3.15-12.69,3.15s-.9,11.93-9.54,8.8Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M285.44,339.33s-26.23-9.24-20-24.15,15.2-6.85,20,11.93c0,0-6.26-39.95,16.7-34.59s5.66,33.69,0,34.59c0,0,16.69-22.66,27.42-6.26S312,340.52,304.82,339.33,285.44,339.33,285.44,339.33Z"
              fill="#659965"
            />
            <path
              d="M329.56,320.85a14.83,14.83,0,0,0-3.91-4.2c-3.19,12-15,10.61-15,10.61s.3,11-12.52,8.94l-1.27,2.6a51.86,51.86,0,0,1,8,.53C312,340.52,340.3,337.24,329.56,320.85Z"
              fill="#396039"
            />
            <path
              d="M292.45,324s7.74,3.69,17.13-4.74c4.12-7.15,6.74-17.41,0-23.19-4.62,11.53-12.7,11.53-12.7,11.53S305.56,321.89,292.45,324Z"
              fill="#396039"
            />
            <path
              d="M286.18,339.26c-7-3.76-9.83-11.11-9.83-11.11-7.22.93-10.44-7.42-11.5-11.11-3.47,13.81,20.59,22.29,20.59,22.29Z"
              fill="#396039"
            />
          </g>
          <path
            d="M266.21,332.92A31.8,31.8,0,0,1,256,331.36a23.15,23.15,0,0,0,8.42,6.93c6.93,2.77,9,2.19,15.86-1.28A33.68,33.68,0,0,1,266.21,332.92Z"
            fill="#172d17"
          />
          <path
            d="M353.11,327.91c-3.79,7.91-14,8.76-17.44,7.69,0,0-4.72,6.13-21.82,7.92,20.26-.37,45.68-5,39.41-15.37Z"
            fill="#172d17"
          />
          <path
            d="M286.19,339.18c-8.65-3.58-5.67-12.22,0-11S286.19,339.18,286.19,339.18Z"
            fill="#245624"
          />
          <path
            d="M285.66,338.77c13.72,13.31,27.51.7,20.68-8.95S285.66,338.77,285.66,338.77Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="1239.77"
            cy="184.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1248,181.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1248.18,170.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1249.1,165.06,1249.16,167.74,1248.18,170.22Z"
            fill="#659965"
          />
          <path
            d="M1239.82,173.75c6.86-.67,7-6.47,3.19-8.12S1239.82,173.75,1239.82,173.75Z"
            fill="#245624"
          />
          <path
            d="M1242.93,178.83c11.14,1.82,13.28-6.07,7.86-9.82S1242.93,178.83,1242.93,178.83Z"
            fill="#245624"
          />
          <path
            d="M1238.27,178.6c-8.36,4.93-13.29-1.59-10.37-6.59S1238.27,178.6,1238.27,178.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1238.94,172.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1236.14,166.68,1238.94,172.21,1238.94,172.21Z"
              fill="#659965"
            />
            <path d="M1238.94,172.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1234.9,180.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1246.83,182.89s8.5-3,6.47-7.83-4.93-2.22-6.47,3.87c0,0,2-13-5.42-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.31,31.31,0,0,1,1246.83,182.89Z"
              fill="#659965"
            />
            <path
              d="M1232.52,176.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1238.22,183.28,1229,182.21,1232.52,176.9Z"
              fill="#396039"
            />
            <path
              d="M1244.55,177.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1240.3,177.23,1244.55,177.91Z"
              fill="#396039"
            />
            <path
              d="M1246.58,182.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.67,7.23-6.67,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1253.06,180.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.24.9-2.91.71-5.14-.41A11,11,0,0,0,1253.06,180.81Z"
            fill="#172d17"
          />
          <path
            d="M1224.88,179.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1246.58,182.84c2.81-1.16,1.84-4,0-3.58S1246.58,182.84,1246.58,182.84Z"
            fill="#245624"
          />
          <path
            d="M1246.75,182.71c-4.45,4.31-8.92.23-6.7-2.9S1246.75,182.71,1246.75,182.71Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <ellipse
            cx="1308.77"
            cy="168.24"
            rx="15.62"
            ry="2.76"
            fill="#141c66"
            opacity="0.2"
          />
          <path
            d="M1317,165.87c2.68,1.36,3.26,1.65,5.68.68s7.25-6.57,1.84-10.34-10.93,1.25-10.93,3.48c0,0,9.38-9.77,0-12.28s-6.28,7.35-5.61,8.8c0,0-3.38-6.67-7.25-4.64s-1.38,14.58,5.74,11.35c0,0-9.6-4.59-12.6.34s16.34,5.9,19.72,4.26Z"
            fill="#1f441f"
          />
          <path
            d="M1317.18,154.22c-2.42,1-1.6-3.81-1.6-3.81s-1.06-.58-1.08-2.7C1318.1,149.06,1318.16,151.74,1317.18,154.22Z"
            fill="#659965"
          />
          <path
            d="M1308.82,157.75c6.86-.67,7-6.47,3.19-8.12S1308.82,157.75,1308.82,157.75Z"
            fill="#245624"
          />
          <path
            d="M1311.93,162.83c11.14,1.82,13.28-6.07,7.86-9.82S1311.93,162.83,1311.93,162.83Z"
            fill="#245624"
          />
          <path
            d="M1307.27,162.6c-8.36,4.93-13.29-1.59-10.37-6.59S1307.27,162.6,1307.27,162.6Z"
            fill="#245624"
          />
          <g>
            <path
              d="M1307.94,156.21c-3.48,2.32-4.15-1.84-4.15-1.84-1.49-.2-1.94-1.68-2.07-3.15C1305.14,150.68,1307.94,156.21,1307.94,156.21Z"
              fill="#659965"
            />
            <path d="M1307.94,156.21c-.06-.15-.16-.39-.26-.7Z" fill="#659965" />
          </g>
          <path
            d="M1303.9,164.05c-4.78,1.25-7.81-1.61-7.85-4.94.18.15.36.3.53.42a4.6,4.6,0,0,0,4.11,1s.29,3.87,3.1,2.85Z"
            fill="#172d17"
          />
          <g>
            <path
              d="M1315.83,166.89s8.5-3,6.47-7.83-4.93-2.22-6.47,3.87c0,0,2-13-5.42-11.22s-1.84,10.93,0,11.22c0,0-5.41-7.35-8.89-2s5.7,6.38,8,6A31.31,31.31,0,0,1,1315.83,166.89Z"
              fill="#659965"
            />
            <path
              d="M1301.52,160.9a4.84,4.84,0,0,1,1.26-1.37,4.54,4.54,0,0,0,4.87,3.44s-.09,3.58,4.07,2.91l.41.84a17.24,17.24,0,0,0-2.59.17C1307.22,167.28,1298,166.21,1301.52,160.9Z"
              fill="#396039"
            />
            <path
              d="M1313.55,161.91s-2.51,1.2-5.55-1.54c-1.34-2.31-2.19-5.64,0-7.52,1.5,3.74,4.12,3.74,4.12,3.74S1309.3,161.23,1313.55,161.91Z"
              fill="#396039"
            />
            <path
              d="M1315.58,166.87a7.59,7.59,0,0,0,3.19-3.61c2.35.31,3.39-2.4,3.73-3.6,1.13,4.48-6.67,7.23-6.67,7.23Z"
              fill="#396039"
            />
          </g>
          <path
            d="M1322.06,164.81a10.23,10.23,0,0,0,3.31-.5,7.45,7.45,0,0,1-2.73,2.24c-2.24.9-2.91.71-5.14-.41A11,11,0,0,0,1322.06,164.81Z"
            fill="#172d17"
          />
          <path
            d="M1293.88,163.19c1.23,2.56,4.53,2.84,5.65,2.49,0,0,1.54,2,7.08,2.57-6.57-.12-14.81-1.64-12.78-5Z"
            fill="#172d17"
          />
          <path
            d="M1315.58,166.84c2.81-1.16,1.84-4,0-3.58S1315.58,166.84,1315.58,166.84Z"
            fill="#245624"
          />
          <path
            d="M1315.75,166.71c-4.45,4.31-8.92.23-6.7-2.9S1315.75,166.71,1315.75,166.71Z"
            fill="#1f441f"
          />
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M449.63,240.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33l.45-.12a3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07,0,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,.05.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.11,3.11,0,0,1-.84-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55s-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31-.05.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M456.15,239s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M449.34,259.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,449.34,259.86Z"
                fill="#141c66"
              />
              <path d="M466.48,259.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M448,261.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,448,261.05Z"
                fill="#141c66"
              />
              <path d="M461.46,262.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M445.28,257.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12c.05,0,.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c.05-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26,0c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06,9.83,9.83,0,0,0-.05-1.09c.7-.45,1.39-.86,2-1.22,0,0,0,.09,0,.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22.05-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M458.89,249.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M452.33,248.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S451.39,248.21,452.33,248.88Z"
                fill="#141c66"
              />
              <path d="M447.36,252.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M451.88,250.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,451.88,250.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M419.81,230.23c-.05-.32-.07-.64-.09-1a7.37,7.37,0,0,1,0-1.41c.05-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,2.37,2.37,0,0,0,.46.49,2.27,2.27,0,0,0,.57.26,1.57,1.57,0,0,1,.59.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c.05,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.79,6.79,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,1,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66,7.66,7.66,0,0,0-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0,0,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C419.89,230.64,419.85,230.44,419.81,230.23Z"
                fill="#396039"
              />
              <path
                d="M423.15,221.1A75.1,75.1,0,0,1,428,231.6c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,423.15,221.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M441.28,246.72c0-.46,0-.92,0-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-.95l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,441.28,246.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M455.14,226.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10A127.54,127.54,0,0,1,455.14,226.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M441.45,249.34c.06-.37.1-.73.14-1.1a24.5,24.5,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1.05.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,441.45,249.34Z"
                fill="#396039"
              />
              <path
                d="M454.88,235.28c-1.95,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,454.88,235.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M435.35,249.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56,4.42,4.42,0,0,0-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l.05-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19,0a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.75,4.75,0,0,1,1,.52l.35.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48.05.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M437.52,226.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M431.25,233.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.28,1.28,0,0,1-.62.47c-1.57.51-4-2.52-5.37-6.77S429.69,234.45,431.25,233.94Z"
                fill="#3b6818"
              />
              <path
                d="M431,242.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M432.31,235.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93.47.47,0,0,1-.05.1.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,432.31,235.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M414.63,274.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33l.45-.12a3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07-.05,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,.05.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.11,3.11,0,0,1-.84-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55,0-.34-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31,0,.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M421.15,273s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M414.34,293.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,414.34,293.86Z"
                fill="#141c66"
              />
              <path d="M431.48,293.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M413,295.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,413,295.05Z"
                fill="#141c66"
              />
              <path d="M426.46,296.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M410.28,291.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12c.05,0,.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c.05-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26-.05c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06,9.83,9.83,0,0,0-.05-1.09c.7-.45,1.39-.86,2-1.22,0,0,0,.09,0,.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22.05-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M423.89,283.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M417.33,282.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S416.39,282.21,417.33,282.88Z"
                fill="#141c66"
              />
              <path d="M412.36,286.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M416.88,284.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,416.88,284.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M384.81,264.23c-.05-.32-.07-.64-.09-1a7.37,7.37,0,0,1,0-1.41c.05-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2.05,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,2.37,2.37,0,0,0,.46.49,2.27,2.27,0,0,0,.57.26,1.57,1.57,0,0,1,.59.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c.05,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.79,6.79,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,.95,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66,7.66,7.66,0,0,0-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0-.05,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C384.89,264.64,384.85,264.44,384.81,264.23Z"
                fill="#396039"
              />
              <path
                d="M388.15,255.1A75.1,75.1,0,0,1,393,265.6c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,388.15,255.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M406.28,280.72c0-.46,0-.92,0-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-1l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,406.28,280.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M420.14,260.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10.05A127.54,127.54,0,0,1,420.14,260.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M406.45,283.34c.06-.37.1-.73.14-1.1a24.5,24.5,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1.05.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,406.45,283.34Z"
                fill="#396039"
              />
              <path
                d="M419.88,269.28c-1.95,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,419.88,269.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M400.35,283.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56l-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l.05-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19.05a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.75,4.75,0,0,1,1,.52l.35.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48.05.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M402.52,260.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M396.25,267.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.28,1.28,0,0,1-.62.47c-1.57.51-4-2.52-5.37-6.77S394.69,268.45,396.25,267.94Z"
                fill="#3b6818"
              />
              <path
                d="M396,276.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M397.31,269.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93.47.47,0,0,1-.05.1.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,397.31,269.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g transform="translate(0 -20)">
          <g opacity="0.19">
            <g>
              <path
                d="M412.63,350.9c.16-.16.33-.31.5-.45a6.25,6.25,0,0,1,.81-.57c.26-.14.54-.24.81-.36a2.5,2.5,0,0,0,.67-.39c.22-.18.39-.4.6-.59a1.83,1.83,0,0,1,.55-.33l.45-.12a3.17,3.17,0,0,1,.44,0,.07.07,0,0,0,.07-.05,3.13,3.13,0,0,1,1.94.42,3.06,3.06,0,0,1,1.2,1.4,1.19,1.19,0,0,0-.05.32,2.23,2.23,0,0,0,.21.71,1.3,1.3,0,0,1,.13.8,6.78,6.78,0,0,1-.33.85,1.39,1.39,0,0,0-.08.46,1.56,1.56,0,0,0,.08.43,1.1,1.1,0,0,1,.05.48,3.36,3.36,0,0,1-.14.45,3.81,3.81,0,0,0-.07.47,3.21,3.21,0,0,1-.08.36,4.21,4.21,0,0,1-1,1.39,2.49,2.49,0,0,0-.5.86,4.29,4.29,0,0,0-.12.8,2.1,2.1,0,0,1-.14.66,2.3,2.3,0,0,1-.62.7c-.58.48-1.23.88-1.78,1.4-.13.13-.26.26-.38.4s-.21.28-.33.41a1.16,1.16,0,0,1-.56.36,4.69,4.69,0,0,1-.64.09,1.65,1.65,0,0,0-.89.31,1.68,1.68,0,0,1-.4.3,1.18,1.18,0,0,1-.42,0,4.76,4.76,0,0,0-.84-.07l0,0a3.11,3.11,0,0,1-.84-.35,3,3,0,0,1-.94-.92,4.65,4.65,0,0,0-.15-1,10.16,10.16,0,0,1-.26-1.09,3.27,3.27,0,0,1,0-.54c0-.18,0-.36,0-.55,0-.34-.07-.69,0-1a1.59,1.59,0,0,1,.14-.56c.08-.17.19-.33.28-.49a1.53,1.53,0,0,0,.21-.51,3.45,3.45,0,0,0,.07-.55c0-.25,0-.49.06-.73a15.05,15.05,0,0,1,.71-1.38,3.08,3.08,0,0,1,.6-.14c.31,0,.62-.06.93-.11a.06.06,0,0,0,.06-.09c-.1-.23-.22-.46-.31-.7a.85.85,0,0,1,.09-.89Z"
                fill="#141c66"
              />
              <path d="M419.15,349s-4,10.1-19,26.16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M412.34,369.86c.27-.19.51-.4.76-.61a21.84,21.84,0,0,1,4.71-1.66,5,5,0,0,0,.66.08,7.48,7.48,0,0,0,.82,0h1a6.46,6.46,0,0,0,1.81-.22c.29-.09.55-.23.83-.34a5.66,5.66,0,0,1,.58-.2c3.09,0,5.33.75,5.58,2.06a1.23,1.23,0,0,1,0,.54l-.17.22a3.74,3.74,0,0,1-.91.82,6,6,0,0,1-1.09.51,7.85,7.85,0,0,0-1.33.49,5.15,5.15,0,0,0-1,.81,6.57,6.57,0,0,1-1,.85,1.74,1.74,0,0,1-1.09.34,3.72,3.72,0,0,1-.8-.25,3,3,0,0,0-1-.18.91.91,0,0,0-.71.21c-.19.18-.33.43-.51.62a2.22,2.22,0,0,1-1.75.61,8.51,8.51,0,0,1-1.94-.43c-.34-.1-.69-.19-1-.26l-.54-.09-.62,0a8.18,8.18,0,0,1-2.41-.68c-.39-.15-.78-.3-1.18-.42a2.42,2.42,0,0,1,1.12-2.1A5.18,5.18,0,0,0,412.34,369.86Z"
                fill="#141c66"
              />
              <path d="M429.48,369.2s-17.58.37-29.25,6.75" fill="#141c66" />
            </g>
            <g>
              <path
                d="M411,371.05c.23-.12.45-.25.67-.38a17.21,17.21,0,0,1,3.9-.71l.51.15c.21.05.43.08.64.11l.75.11a5,5,0,0,0,1.45.06c.24,0,.46-.12.7-.17l.47-.08c2.42.4,4.09,1.27,4.12,2.32a1.06,1.06,0,0,1-.08.43l-.15.15a3.11,3.11,0,0,1-.82.53,4.33,4.33,0,0,1-.92.25,6.7,6.7,0,0,0-1.1.22,3.94,3.94,0,0,0-.89.51,4.94,4.94,0,0,1-.88.54,1.4,1.4,0,0,1-.9.13,2.73,2.73,0,0,1-.59-.3,2.93,2.93,0,0,0-.75-.27.73.73,0,0,0-.58.08c-.18.12-.32.29-.49.42a1.77,1.77,0,0,1-1.45.26,6.57,6.57,0,0,1-1.46-.59,7.59,7.59,0,0,0-.78-.33l-.41-.14c-.15-.05-.31-.07-.47-.11a6.09,6.09,0,0,1-1.81-.84,9.17,9.17,0,0,0-.87-.48c0-.54.41-1.06,1.14-1.5A4.23,4.23,0,0,0,411,371.05Z"
                fill="#141c66"
              />
              <path d="M424.46,372.71s-13.82-1.95-23.78,1.58" fill="#141c66" />
            </g>
            <g>
              <path
                d="M408.28,367.7a.39.39,0,0,0,.28,0,.41.41,0,0,0,.13-.29,3.33,3.33,0,0,0,0-.55h0a2.25,2.25,0,0,0,.36.06.45.45,0,0,0,.26-.05c.14-.1.09-.29.06-.43l-.09-.29.63-.68.14.11a2.8,2.8,0,0,0,.35.25.74.74,0,0,0,.31.12c.05,0,.09,0,.08-.08a3.43,3.43,0,0,0-.09-.44,1,1,0,0,1,0-.42c.05-.16.22-.19.34-.27a.4.4,0,0,0,.13-.31,1.09,1.09,0,0,0,0-.18l.87-.78.19.15a1.13,1.13,0,0,0,.54.26.44.44,0,0,0,.47-.25.94.94,0,0,0,0-.66,1.6,1.6,0,0,0-.11-.33l.28-.3.94-.73h.06a.72.72,0,0,1,.24.1,1.08,1.08,0,0,0,.4.11s.07,0,.08-.06c0-.2-.06-.62.22-.69.07,0,.15.07.22.1a.21.21,0,0,0,.26-.05c.11-.15,0-.36.09-.52s.27,0,.34.09a3.09,3.09,0,0,0,.36.45.07.07,0,0,0,.11-.06,9.83,9.83,0,0,0-.05-1.09c.7-.45,1.39-.86,2-1.22,0,0,0,.09,0,.13a.07.07,0,0,0,.1,0,2.59,2.59,0,0,1,.1.62,2.54,2.54,0,0,1,0,.39c0,.09.13.11.14,0a2.81,2.81,0,0,0,0-.41,4.91,4.91,0,0,0-.09-.94c.58-.31,1.13-.58,1.66-.81a3,3,0,0,1,.12.78l0,.33a.07.07,0,0,0,.14,0,2,2,0,0,0,0-.35c0-.22.05-.44.06-.67,0-.08,0-.17,0-.25a11.71,11.71,0,0,1,1.53-.53,6.62,6.62,0,0,0,.26,1,.06.06,0,0,0,.1,0,1.44,1.44,0,0,0,.41-.73,3.12,3.12,0,0,0,.09-.44,1.5,1.5,0,0,1,1.39.36c.48.65-.14,2-1.52,3.68-.28-.06-.56-.1-.84-.14-.08,0-.11.1,0,.13a5.05,5.05,0,0,0,.69.22c-.37.43-.79.88-1.25,1.35a11.12,11.12,0,0,0-1.4.26.06.06,0,0,0-.06.08c0,.29.12.57.18.86-.68.61-1.43,1.24-2.23,1.85a5.45,5.45,0,0,0-1.38.33,3,3,0,0,0-.87.59l-.39.35c-.13.11-.27.21-.39.33s-.41.51-.64.75a.78.78,0,0,1-.76.3,2,2,0,0,1-.53-.34.25.25,0,0,0-.22-.05.35.35,0,0,0-.18.2,1.41,1.41,0,0,0-.06.79c0,.08,0,.17,0,.25-2.78,1.46-5,2-5.57,1.18-.38-.5-.09-1.43.71-2.6Z"
                fill="#141c66"
              />
              <path d="M421.89,359.47s-19.82,15.19-21.55,16" fill="#141c66" />
            </g>
            <g>
              <path
                d="M415.33,358.88a.91.91,0,0,1,.32.42c0,.16-.09.31-.13.47s-.11.47-.15.71a3.93,3.93,0,0,1-.15.68,4.58,4.58,0,0,1-.45,1,4.6,4.6,0,0,0-.57,1.1c-.08.33-.07.67-.13,1h0c-.09.15-.19.29-.29.43a13.4,13.4,0,0,1-2.15,2.42l-.22.13a19.28,19.28,0,0,0-2.08,1.05.94.94,0,0,1-.53-.15c-.94-.67-.24-3.28,1.56-5.85S414.39,358.21,415.33,358.88Z"
                fill="#141c66"
              />
              <path d="M410.36,362.32s.89,5.21-9,12.75" fill="#141c66" />
              <path
                d="M414.88,360.14a2.78,2.78,0,0,1-.6,1.26,5.64,5.64,0,0,0-.89,1,2,2,0,0,0-.22.69c0,.23,0,.46-.06.69a1.38,1.38,0,0,1-.27.68,1.32,1.32,0,0,1-.46.32,2.39,2.39,0,0,0-.52.28,1.84,1.84,0,0,0-.48.65,2.13,2.13,0,0,1-.51.67,1.68,1.68,0,0,1-.46.24,1.42,1.42,0,0,0-.47.31,1.35,1.35,0,0,0-.31.44,1.11,1.11,0,0,1-.26.39,1.42,1.42,0,0,1-.64.23h-.08a.5.5,0,0,1-.21-.09c-.74-.52.12-3,1.92-5.59s3.87-4.22,4.61-3.69a.49.49,0,0,1,.21.29A5.44,5.44,0,0,0,414.88,360.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M382.81,340.23c-.05-.32-.07-.64-.09-1a7.37,7.37,0,0,1,0-1.41c.05-.42.18-.82.27-1.23a4.08,4.08,0,0,0,.12-1.1c0-.41-.13-.79-.16-1.2a2.81,2.81,0,0,1,.08-.91,5.42,5.42,0,0,1,.26-.6,3.84,3.84,0,0,1,.35-.54.09.09,0,0,0,0-.11,4.29,4.29,0,0,1,4.77-2.05,1.26,1.26,0,0,0,.32.33,2.68,2.68,0,0,0,1,.36,2,2,0,0,1,1,.53,8.54,8.54,0,0,1,.69,1.11,2.37,2.37,0,0,0,.46.49,2.27,2.27,0,0,0,.57.26,1.57,1.57,0,0,1,.59.36c.15.17.27.36.4.54a3.7,3.7,0,0,0,.48.49,4.23,4.23,0,0,1,.34.4,5.82,5.82,0,0,1,.73,2.34,3.34,3.34,0,0,0,.55,1.3,6.43,6.43,0,0,0,.82.83,2.56,2.56,0,0,1,.63.72,3.08,3.08,0,0,1,.28,1.31c.05,1.07,0,2.15.09,3.22a7,7,0,0,0,.13.78c.06.24.15.48.19.73a1.54,1.54,0,0,1-.07.95,6.35,6.35,0,0,1-.44.81,2.43,2.43,0,0,0-.41,1.28,1.89,1.89,0,0,1,0,.71,1.46,1.46,0,0,1-.32.52,6.79,6.79,0,0,0-.79.9.13.13,0,0,0,0,.06,4.18,4.18,0,0,1-3,.95,5.63,5.63,0,0,0-1.24-.65c-.49-.21-1-.38-1.48-.63a4.48,4.48,0,0,1-.64-.43c-.21-.16-.38-.35-.59-.51-.4-.29-.86-.51-1.23-.83a2.23,2.23,0,0,1-.53-.65c-.12-.23-.21-.49-.32-.74a2.48,2.48,0,0,0-.4-.66,7.66,7.66,0,0,0-.57-.57l-.8-.68a19.28,19.28,0,0,1-1-2,3.89,3.89,0,0,1,.35-.81c.21-.39.45-.76.67-1.15,0-.05,0-.14-.06-.15-.35-.08-.71-.14-1.06-.25a1.43,1.43,0,0,1-.69-.38,1.45,1.45,0,0,1-.26-.47C382.89,340.64,382.85,340.44,382.81,340.23Z"
                fill="#396039"
              />
              <path
                d="M386.15,331.1A75.1,75.1,0,0,1,391,341.6c1.4,3.61,2.6,7.28,3.72,11s2,7.46,2.92,11.21c.43,1.89.82,3.78,1.23,5.66l1.06,5.7-1.16-5.68-1.26-5.65c-.91-3.74-1.86-7.49-3-11.18s-2.27-7.37-3.64-11c-.7-1.8-1.41-3.59-2.2-5.35A55.51,55.51,0,0,0,386.15,331.1Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M404.28,356.72c0-.46,0-.92,0-1.38a30.78,30.78,0,0,1,2.11-6.81c.23-.22.46-.45.66-.68a10.54,10.54,0,0,0,.7-1l.81-1.1a8.94,8.94,0,0,0,1.29-2.27c.15-.4.2-.83.31-1.24s.17-.56.27-.83c2.64-3.54,5.4-5.47,7.12-4.64a2,2,0,0,1,.62.47l.1.37a5.16,5.16,0,0,1,.16,1.75,7.48,7.48,0,0,1-.34,1.68,11.69,11.69,0,0,0-.57,1.94,7.1,7.1,0,0,0,.08,1.84,9.54,9.54,0,0,1,.13,1.85,2.51,2.51,0,0,1-.54,1.54,4.79,4.79,0,0,1-1,.7,4.65,4.65,0,0,0-1.05,1,1.29,1.29,0,0,0-.36,1c0,.39.21.75.27,1.13a3.16,3.16,0,0,1-.79,2.52,12.65,12.65,0,0,1-2.15,1.85c-.4.31-.8.62-1.18,1l-.56.54c-.2.22-.37.45-.57.68a11.56,11.56,0,0,1-2.83,2.18,16.74,16.74,0,0,0-1.49,1c-.87-.43-1.35-1.53-1.46-3.07A7.29,7.29,0,0,0,404.28,356.72Z"
                fill="#2f4f2f"
              />
              <path
                d="M418.14,336.54c-2,3-3.88,6.06-5.66,9.19s-3.42,6.33-4.93,9.6a105.38,105.38,0,0,0-4,10,72.12,72.12,0,0,0-2.59,10.47,64.16,64.16,0,0,1,2.46-10.51,103.32,103.32,0,0,1,4-10.05A127.54,127.54,0,0,1,418.14,336.54Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M404.45,359.34c.06-.37.1-.73.14-1.1a24.5,24.5,0,0,1,2.52-5.06c.21-.15.41-.3.6-.46s.45-.43.67-.65.52-.5.77-.76a7.28,7.28,0,0,0,1.31-1.61c.16-.3.26-.62.4-.94s.2-.41.31-.61c2.52-2.44,4.93-3.6,6.17-2.74a1.51,1.51,0,0,1,.42.45c0,.1,0,.21,0,.31a4.33,4.33,0,0,1-.1,1.39,5.92,5.92,0,0,1-.48,1.27,8.75,8.75,0,0,0-.69,1.45,5.88,5.88,0,0,0-.18,1.45,7.24,7.24,0,0,1-.13,1.47,2,2,0,0,1-.61,1.13,3.84,3.84,0,0,1-.86.43,3.69,3.69,0,0,0-.94.63,1.05,1.05,0,0,0-.41.73c0,.31.07.61.07.92a2.55,2.55,0,0,1-.94,1.88,10.16,10.16,0,0,1-1.92,1.17c-.36.19-.71.39-1.05.61a5.62,5.62,0,0,0-.5.35c-.19.14-.35.3-.53.45a9.17,9.17,0,0,1-2.5,1.35c-.44.18-.88.37-1.3.59a2.77,2.77,0,0,1-.75-2.59A6.15,6.15,0,0,0,404.45,359.34Z"
                fill="#396039"
              />
              <path
                d="M417.88,345.28c-1.95,2.08-3.8,4.26-5.6,6.49s-3.47,4.53-5.07,6.9a83.75,83.75,0,0,0-4.43,7.32,58.77,58.77,0,0,0-3.37,7.87,49.66,49.66,0,0,1,3.25-7.93q2-3.8,4.38-7.38A100.11,100.11,0,0,1,417.88,345.28Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M398.35,359.54a.52.52,0,0,0,.2-.34.55.55,0,0,0-.21-.4,4.78,4.78,0,0,0-.61-.48v0a2.28,2.28,0,0,0,.38-.38.64.64,0,0,0,.16-.33c0-.24-.25-.35-.44-.43l-.4-.15c-.09-.41-.17-.85-.25-1.3l.25-.06c.19-.06.39-.11.58-.19a1,1,0,0,0,.4-.26.1.1,0,0,0,0-.16,5.14,5.14,0,0,0-.58-.27,1.38,1.38,0,0,1-.5-.32c-.15-.19,0-.41,0-.62a.6.6,0,0,0-.23-.42l-.19-.16c-.06-.53-.11-1.09-.16-1.66l.34-.09a1.82,1.82,0,0,0,.75-.4.62.62,0,0,0,.12-.76,1.52,1.52,0,0,0-.76-.56l-.48-.15c0-.19-.06-.39-.1-.58,0-.56,0-1.12,0-1.69l.05-.07a1,1,0,0,1,.31-.19,1.68,1.68,0,0,0,.48-.36.11.11,0,0,0,0-.14c-.23-.19-.77-.47-.61-.85,0-.1.21-.12.3-.17a.28.28,0,0,0,.17-.33c-.07-.26-.38-.35-.52-.55s.24-.31.39-.32a4.61,4.61,0,0,0,.83,0c.09,0,.09-.14,0-.19-.42-.3-.84-.6-1.29-.87.08-1.18.2-2.31.34-3.37l.19.05a.09.09,0,0,0,.12-.08,3.86,3.86,0,0,1,.81.41c.14.1.29.21.43.33s.24-.06.14-.14a3.1,3.1,0,0,0-.46-.35,8.57,8.57,0,0,0-1.16-.71c.14-.92.31-1.79.49-2.58a4.75,4.75,0,0,1,1,.52l.35.33a.1.1,0,0,0,.14-.15,2.91,2.91,0,0,0-.37-.33l-.71-.65-.29-.23a17.86,17.86,0,0,1,.71-2.2,12.7,12.7,0,0,0,1.33.53.1.1,0,0,0,.13-.1,2.16,2.16,0,0,0-.49-1.09,4.69,4.69,0,0,0-.42-.47c.48-.83,1-1.29,1.59-1.29,1.15,0,2.18,1.88,2.91,4.88-.3.27-.59.55-.87.83a.1.1,0,0,0,.12.16,7.12,7.12,0,0,0,.84-.6c.18.79.34,1.66.47,2.58a17,17,0,0,0-.89,1.82.11.11,0,0,0,0,.14c.37.19.76.35,1.15.52.12,1.31.19,2.7.22,4.14a7.41,7.41,0,0,0-.81,1.87,4.39,4.39,0,0,0-.06,1.49c0,.25.05.5.06.75s0,.48.05.73c.07.46.24.9.32,1.36a1.12,1.12,0,0,1-.31,1.13,2.66,2.66,0,0,1-.84.32.35.35,0,0,0-.25.21.58.58,0,0,0,.07.38,2.07,2.07,0,0,0,.87.73l.31.18c-.7,4.43-2,7.38-3.4,7.38-.89,0-1.71-1.12-2.37-3Z"
                fill="#659965"
              />
              <path
                d="M400.52,336.93c.17,6.4.22,12.79.29,19.19v9.59c0,3.2,0,6.41-.29,9.59.15-1.59.12-3.19.14-4.79v-4.8l-.06-9.59Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M394.25,343.94a1.23,1.23,0,0,1,.76,0l.43.54c.22.27.44.53.68.78a7.7,7.7,0,0,1,.66.75,7.43,7.43,0,0,1,.76,1.38,6.53,6.53,0,0,0,.78,1.59c.31.37.7.66,1,1l0,0,.24.71a18.53,18.53,0,0,1,.94,4.52c0,.12,0,.24,0,.36a28.12,28.12,0,0,0-.57,3.28,1.28,1.28,0,0,1-.62.47c-1.57.51-4-2.52-5.37-6.77S392.69,344.45,394.25,343.94Z"
                fill="#3b6818"
              />
              <path
                d="M394,352.57s6.73,3.43,7,21.14"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.2"
              />
              <path
                d="M395.31,345.54a3.71,3.71,0,0,1,.93,1.76,9.13,9.13,0,0,0,.38,1.87,2.58,2.58,0,0,0,.62.83c.24.23.5.42.73.66a2,2,0,0,1,.55.89,1.65,1.65,0,0,1,0,.8,3.78,3.78,0,0,0-.12.83,2.8,2.8,0,0,0,.34,1.12,3.12,3.12,0,0,1,.34,1.15,2.54,2.54,0,0,1-.13.73,2.37,2.37,0,0,0-.05.8,2.11,2.11,0,0,0,.25.73,1.58,1.58,0,0,1,.22.63,1.82,1.82,0,0,1-.29.93.47.47,0,0,1-.05.1.63.63,0,0,1-.27.16c-1.24.41-3.37-2.71-4.77-7s-1.54-8-.3-8.43a.78.78,0,0,1,.52,0A7.71,7.71,0,0,0,395.31,345.54Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g>
          <g opacity="0.19">
            <g>
              <path
                d="M517.08,212.22c.12-.11.24-.23.37-.33a3.15,3.15,0,0,1,.61-.42,6.46,6.46,0,0,1,.6-.27,2,2,0,0,0,.5-.3c.16-.13.29-.3.45-.44a1.55,1.55,0,0,1,.41-.25l.33-.08a1.94,1.94,0,0,1,.34,0,0,0,0,0,0,0,0,2.41,2.41,0,0,1,1.46.32,2.38,2.38,0,0,1,.9,1.05.61.61,0,0,0,0,.24,1.26,1.26,0,0,0,.16.52,1,1,0,0,1,.09.6,3.75,3.75,0,0,1-.25.63,1.43,1.43,0,0,0-.06.35,1.23,1.23,0,0,0,.07.32.88.88,0,0,1,0,.36,1.91,1.91,0,0,1-.1.34c0,.11,0,.24-.06.35a1.31,1.31,0,0,1-.06.27,3.08,3.08,0,0,1-.75,1,1.65,1.65,0,0,0-.37.64,2.42,2.42,0,0,0-.09.6,1.66,1.66,0,0,1-.11.49,1.53,1.53,0,0,1-.46.52c-.44.36-.92.66-1.33,1a2.68,2.68,0,0,0-.28.3c-.09.1-.16.21-.25.31a1,1,0,0,1-.42.27,3.93,3.93,0,0,1-.48.06,1.31,1.31,0,0,0-.67.23,1.05,1.05,0,0,1-.29.23,1.12,1.12,0,0,1-.32,0,2.64,2.64,0,0,0-.63-.05h0a2.47,2.47,0,0,1-.63-.26,2.19,2.19,0,0,1-.7-.69,3,3,0,0,0-.11-.72,7.54,7.54,0,0,1-.2-.82,1.79,1.79,0,0,1,0-.4c0-.14,0-.27,0-.41s0-.52,0-.78a1.24,1.24,0,0,1,.11-.42c.06-.13.14-.24.21-.36a1.12,1.12,0,0,0,.15-.38,3,3,0,0,0,.06-.42c0-.18,0-.36,0-.55.16-.34.33-.68.53-1a1.92,1.92,0,0,1,.46-.11l.69-.08a.05.05,0,0,0,0-.07c-.08-.17-.17-.34-.24-.52a.82.82,0,0,1,0-.41.68.68,0,0,1,.12-.26Z"
                fill="#141c66"
              />
              <path d="M522,210.77s-3,7.56-14.18,19.56" fill="#141c66" />
            </g>
            <g>
              <path
                d="M516.86,226.4c.2-.15.38-.3.57-.46A16,16,0,0,1,521,224.7a4.1,4.1,0,0,0,.49.06,4.28,4.28,0,0,0,.62,0h.71a4.83,4.83,0,0,0,1.36-.17,5.45,5.45,0,0,0,.62-.26l.43-.14c2.31,0,4,.56,4.17,1.53a1,1,0,0,1,0,.41,1,1,0,0,1-.13.16,2.87,2.87,0,0,1-.68.62,4,4,0,0,1-.81.38,4.91,4.91,0,0,0-1,.37,3.35,3.35,0,0,0-.75.6,5,5,0,0,1-.74.64,1.32,1.32,0,0,1-.81.25,2.47,2.47,0,0,1-.6-.19,2.35,2.35,0,0,0-.74-.13.72.72,0,0,0-.53.15c-.14.14-.25.32-.38.47a1.71,1.71,0,0,1-1.31.46,6.49,6.49,0,0,1-1.45-.33c-.26-.07-.51-.14-.77-.19l-.4-.07-.46,0a5.69,5.69,0,0,1-1.81-.51c-.29-.11-.58-.22-.88-.31a1.81,1.81,0,0,1,.83-1.57A3.9,3.9,0,0,0,516.86,226.4Z"
                fill="#141c66"
              />
              <path d="M529.67,225.91s-13.14.27-21.86,5" fill="#141c66" />
            </g>
            <g>
              <path
                d="M515.82,227.29l.5-.29a12.42,12.42,0,0,1,2.92-.52l.37.11.49.08.56.08a3.9,3.9,0,0,0,1.08,0,4.37,4.37,0,0,0,.52-.12,2.25,2.25,0,0,1,.36-.06c1.81.29,3,.94,3.07,1.73a.7.7,0,0,1-.05.32l-.12.11a2.22,2.22,0,0,1-.61.4,3.2,3.2,0,0,1-.69.19,4.59,4.59,0,0,0-.82.17,3.36,3.36,0,0,0-.67.37,3.73,3.73,0,0,1-.65.41,1.12,1.12,0,0,1-.67.1,2.38,2.38,0,0,1-.45-.23,1.88,1.88,0,0,0-.56-.2.54.54,0,0,0-.43.06c-.14.09-.24.22-.37.31a1.29,1.29,0,0,1-1.08.2,6.06,6.06,0,0,1-1.09-.44c-.19-.09-.39-.18-.58-.25a2.22,2.22,0,0,0-.31-.1l-.36-.09a4.86,4.86,0,0,1-1.35-.62,5.13,5.13,0,0,0-.65-.36c0-.41.31-.79.86-1.13A3.6,3.6,0,0,0,515.82,227.29Z"
                fill="#141c66"
              />
              <path d="M525.92,228.53s-10.33-1.46-17.78,1.18" fill="#141c66" />
            </g>
            <g>
              <path
                d="M513.82,224.79a.23.23,0,0,0,.31-.24,1.86,1.86,0,0,0,0-.41h0l.27,0a.34.34,0,0,0,.2,0c.1-.07.07-.22,0-.32l-.06-.21c.14-.17.3-.34.47-.51l.1.08a2.4,2.4,0,0,0,.26.18.42.42,0,0,0,.24.09.06.06,0,0,0,.06-.06c0-.11-.05-.21-.07-.32a.7.7,0,0,1,0-.32c0-.12.16-.14.24-.2a.27.27,0,0,0,.1-.23.62.62,0,0,0,0-.13l.65-.59.15.11a.84.84,0,0,0,.4.2.32.32,0,0,0,.35-.19.78.78,0,0,0,0-.5,2.25,2.25,0,0,0-.08-.24l.21-.23.7-.54h0a.36.36,0,0,1,.18.07.86.86,0,0,0,.3.09s.06,0,.06,0,0-.47.16-.53.12.06.17.08a.15.15,0,0,0,.19,0c.09-.11,0-.26.07-.39s.21,0,.26.07a3,3,0,0,0,.26.34.06.06,0,0,0,.09-.05c0-.27,0-.54,0-.81.53-.34,1-.64,1.53-.91l0,.09a.06.06,0,0,0,.08,0,1.77,1.77,0,0,1,.07.46,1.41,1.41,0,0,1,0,.29c0,.06.1.08.11,0v-.3a5.69,5.69,0,0,0-.07-.71c.43-.23.85-.43,1.24-.6a2.33,2.33,0,0,1,.09.58,2.29,2.29,0,0,0,0,.25.05.05,0,1,0,.1,0,2.6,2.6,0,0,0,0-.26c0-.17,0-.34,0-.51a1.15,1.15,0,0,0,0-.19,9.21,9.21,0,0,1,1.15-.39,6.54,6.54,0,0,0,.19.73.05.05,0,0,0,.08,0,1.07,1.07,0,0,0,.3-.55,1.65,1.65,0,0,0,.07-.32,1.08,1.08,0,0,1,1,.27c.36.48-.11,1.5-1.14,2.74l-.62-.1a.05.05,0,0,0,0,.1,4.48,4.48,0,0,0,.52.16c-.28.32-.59.66-.94,1a7.32,7.32,0,0,0-1,.19.06.06,0,0,0,0,.06c0,.22.09.43.14.65-.51.46-1.07.92-1.67,1.38a3.69,3.69,0,0,0-1,.25,2.07,2.07,0,0,0-.65.44l-.29.26a3.5,3.5,0,0,0-.3.24c-.17.18-.3.39-.47.57a.6.6,0,0,1-.57.22,1.24,1.24,0,0,1-.39-.25.21.21,0,0,0-.17,0,.26.26,0,0,0-.14.15,1.07,1.07,0,0,0,0,.59l0,.19c-2.08,1.09-3.72,1.48-4.17.88-.28-.38-.06-1.07.53-1.95Z"
                fill="#141c66"
              />
              <path d="M524,218.63s-14.82,11.36-16.11,12" fill="#141c66" />
            </g>
            <g>
              <path
                d="M519.1,218.19a.65.65,0,0,1,.23.32l-.09.35a4.52,4.52,0,0,0-.11.53,4.7,4.7,0,0,1-.12.51,3.6,3.6,0,0,1-.34.75,3.53,3.53,0,0,0-.42.82c-.06.25-.06.5-.1.75v0l-.22.32a9.7,9.7,0,0,1-1.61,1.81l-.16.1a13.22,13.22,0,0,0-1.55.78.62.62,0,0,1-.39-.12c-.71-.49-.19-2.45,1.16-4.37S518.39,217.69,519.1,218.19Z"
                fill="#141c66"
              />
              <path d="M515.38,220.76s.66,3.9-6.7,9.53" fill="#141c66" />
              <path
                d="M518.75,219.14a2,2,0,0,1-.44.94,4.27,4.27,0,0,0-.67.74,1.37,1.37,0,0,0-.16.52c0,.17,0,.34,0,.51a1.09,1.09,0,0,1-.21.51.88.88,0,0,1-.34.24,1.2,1.2,0,0,0-.75.7,1.7,1.7,0,0,1-.38.5,1.29,1.29,0,0,1-.35.18,1.06,1.06,0,0,0-.35.23,1,1,0,0,0-.23.33.91.91,0,0,1-.19.29,1.11,1.11,0,0,1-.48.17h-.06a.26.26,0,0,1-.15-.07c-.56-.39.08-2.26,1.43-4.18s2.89-3.15,3.45-2.76a.44.44,0,0,1,.15.22A5,5,0,0,0,518.75,219.14Z"
                fill="#141c66"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M494.78,204.25q0-.36-.06-.72a5.27,5.27,0,0,1,0-1.05c0-.31.14-.62.21-.92a3.27,3.27,0,0,0,.09-.82c0-.31-.1-.6-.12-.9a1.94,1.94,0,0,1,.06-.68,4.68,4.68,0,0,1,.19-.45,3.42,3.42,0,0,1,.26-.4s0-.06,0-.09a3.36,3.36,0,0,1,1.6-1.39,3.29,3.29,0,0,1,2-.14.82.82,0,0,0,.24.25,2.12,2.12,0,0,0,.74.27,1.41,1.41,0,0,1,.76.4,8.73,8.73,0,0,1,.52.82,1.5,1.5,0,0,0,.34.37,1.75,1.75,0,0,0,.42.19,1.18,1.18,0,0,1,.44.28,3,3,0,0,1,.31.4,3.06,3.06,0,0,0,.35.37,3.58,3.58,0,0,1,.26.29,4.48,4.48,0,0,1,.55,1.75,2.5,2.5,0,0,0,.41,1,4.4,4.4,0,0,0,.61.61,2.2,2.2,0,0,1,.47.54,2.37,2.37,0,0,1,.21,1c0,.8,0,1.61.06,2.41a5.4,5.4,0,0,0,.11.58c0,.18.1.36.14.55a1.23,1.23,0,0,1-.06.71,5,5,0,0,1-.33.6,1.84,1.84,0,0,0-.3,1,1.57,1.57,0,0,1,0,.53,1,1,0,0,1-.23.39,3.84,3.84,0,0,0-.59.68,0,0,0,0,0,0,0,3.06,3.06,0,0,1-.83.5,3.23,3.23,0,0,1-1.38.22,4.59,4.59,0,0,0-.93-.49,10.69,10.69,0,0,1-1.1-.47,2.76,2.76,0,0,1-.49-.32c-.15-.12-.28-.26-.44-.38s-.64-.38-.92-.62a1.79,1.79,0,0,1-.39-.48,5.55,5.55,0,0,1-.24-.56,2,2,0,0,0-.3-.5c-.14-.15-.28-.28-.43-.42l-.59-.51a14.47,14.47,0,0,1-.72-1.48,2.2,2.2,0,0,1,.26-.61c.15-.3.34-.57.5-.86,0,0,0-.11,0-.12a7.13,7.13,0,0,1-.8-.18,1.08,1.08,0,0,1-.51-.29,1.1,1.1,0,0,1-.2-.35C494.85,204.56,494.81,204.4,494.78,204.25Z"
                fill="#396039"
              />
              <path
                d="M497.28,197.43a55.91,55.91,0,0,1,3.64,7.85c1,2.69,1.94,5.43,2.77,8.2s1.52,5.57,2.19,8.38l.92,4.23.79,4.25c-.56-2.83-1.15-5.65-1.81-8.46s-1.39-5.6-2.23-8.36-1.7-5.51-2.73-8.21c-.52-1.34-1.05-2.68-1.64-4A39.78,39.78,0,0,0,497.28,197.43Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M510.83,216.58a9,9,0,0,0,0-1,23.21,23.21,0,0,1,1.59-5.08c.17-.17.33-.34.49-.52s.35-.46.52-.7.41-.55.6-.82a7,7,0,0,0,1-1.7c.11-.3.15-.62.23-.93s.13-.42.2-.62c2-2.64,4-4.09,5.32-3.47a1.45,1.45,0,0,1,.47.35,2.29,2.29,0,0,0,.08.28,4.14,4.14,0,0,1,.12,1.31,6.61,6.61,0,0,1-.26,1.25,8.27,8.27,0,0,0-.42,1.45,5.32,5.32,0,0,0,0,1.38,7.13,7.13,0,0,1,.1,1.38,1.89,1.89,0,0,1-.4,1.15,3.45,3.45,0,0,1-.73.52,3.65,3.65,0,0,0-.78.74.92.92,0,0,0-.27.73c0,.29.15.56.2.84a2.38,2.38,0,0,1-.59,1.89,9.18,9.18,0,0,1-1.61,1.38c-.3.23-.6.47-.88.72s-.28.27-.42.41-.28.33-.42.5a8.63,8.63,0,0,1-2.12,1.63c-.38.23-.76.47-1.12.74a2.57,2.57,0,0,1-1.08-2.29A5.68,5.68,0,0,0,510.83,216.58Z"
                fill="#2f4f2f"
              />
              <path
                d="M521.2,201.49c-1.51,2.23-2.91,4.53-4.24,6.87s-2.55,4.73-3.68,7.17a77.85,77.85,0,0,0-3,7.48,54,54,0,0,0-1.94,7.83,48.25,48.25,0,0,1,1.85-7.86,78,78,0,0,1,3-7.51A95.12,95.12,0,0,1,521.2,201.49Z"
                fill="#87f139"
              />
            </g>
            <g>
              <path
                d="M511,218.53a7.46,7.46,0,0,0,.1-.81,18,18,0,0,1,1.89-3.79c.15-.11.31-.22.45-.34a5.78,5.78,0,0,0,.5-.49l.58-.56a5.93,5.93,0,0,0,1-1.21c.12-.23.19-.47.3-.7s.15-.31.23-.46c1.89-1.82,3.69-2.69,4.62-2a1.13,1.13,0,0,1,.31.34l0,.23a3.3,3.3,0,0,1-.07,1,4.76,4.76,0,0,1-.36,1,6.31,6.31,0,0,0-.52,1.08,4.4,4.4,0,0,0-.13,1.09,5.74,5.74,0,0,1-.1,1.09,1.46,1.46,0,0,1-.46.85,3,3,0,0,1-.64.32,2.81,2.81,0,0,0-.7.48.74.74,0,0,0-.31.54c0,.23.05.46.05.68a1.86,1.86,0,0,1-.7,1.41,7.74,7.74,0,0,1-1.43.88c-.27.14-.53.29-.79.45s-.25.17-.37.26l-.4.34a6.64,6.64,0,0,1-1.87,1c-.33.14-.66.28-1,.44a2.06,2.06,0,0,1-.56-1.94A4,4,0,0,0,511,218.53Z"
                fill="#396039"
              />
              <path
                d="M521,208c-1.46,1.56-2.84,3.19-4.18,4.85s-2.6,3.39-3.8,5.16-2.3,3.6-3.31,5.48a44.27,44.27,0,0,0-2.52,5.88,36.8,36.8,0,0,1,2.44-5.93A60,60,0,0,1,512.9,218,74.23,74.23,0,0,1,521,208Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M506.4,218.68a.35.35,0,0,0,.15-.25.41.41,0,0,0-.16-.3,3.23,3.23,0,0,0-.45-.36h0a2.47,2.47,0,0,0,.28-.28.42.42,0,0,0,.12-.25c0-.18-.18-.27-.32-.32l-.3-.11c-.07-.32-.13-.64-.19-1l.18,0a3.26,3.26,0,0,0,.44-.15.73.73,0,0,0,.3-.19.08.08,0,0,0,0-.12c-.14-.08-.29-.13-.44-.2a1.17,1.17,0,0,1-.38-.24c-.11-.14,0-.31,0-.46a.42.42,0,0,0-.18-.31.53.53,0,0,0-.14-.12c0-.41-.08-.82-.11-1.25l.24-.07a1.34,1.34,0,0,0,.57-.29.49.49,0,0,0,.09-.57,1.14,1.14,0,0,0-.57-.42,2.47,2.47,0,0,0-.36-.11c0-.15-.05-.29-.07-.44,0-.41,0-.83,0-1.26l0-.05a.65.65,0,0,1,.24-.15,1.1,1.1,0,0,0,.35-.26.09.09,0,0,0,0-.11c-.17-.14-.57-.35-.46-.63,0-.08.16-.09.23-.13a.22.22,0,0,0,.12-.25c-.05-.19-.28-.26-.38-.41s.18-.23.29-.24a4.28,4.28,0,0,0,.62,0,.08.08,0,0,0,0-.14c-.31-.23-.63-.45-1-.65.06-.89.15-1.74.26-2.53l.14,0c.05,0,.08,0,.09-.06a2.85,2.85,0,0,1,.6.31l.32.24c.08.06.18,0,.11-.1a3.85,3.85,0,0,0-.34-.26,6.52,6.52,0,0,0-.87-.53c.1-.69.23-1.34.36-1.93a3,3,0,0,1,.75.39l.26.24c.08.07.18,0,.11-.1a2.27,2.27,0,0,0-.28-.26l-.53-.48-.21-.17a12,12,0,0,1,.52-1.65,7.72,7.72,0,0,0,1,.4.07.07,0,0,0,.09-.07,1.69,1.69,0,0,0-.36-.82,3.49,3.49,0,0,0-.32-.35c.37-.62.77-1,1.19-1,.86,0,1.63,1.4,2.18,3.64-.23.2-.44.42-.65.63s0,.16.09.12a7.17,7.17,0,0,0,.63-.45c.13.59.25,1.23.35,1.92a13.2,13.2,0,0,0-.67,1.36s0,.09,0,.11c.28.14.57.26.86.39.09,1,.14,2,.16,3.09a5.8,5.8,0,0,0-.6,1.4,3.19,3.19,0,0,0,0,1.11c0,.19,0,.38,0,.56s0,.37,0,.55c.06.34.18.67.24,1a.84.84,0,0,1-.22.84,2.1,2.1,0,0,1-.63.24.28.28,0,0,0-.19.16.36.36,0,0,0,.06.28,1.49,1.49,0,0,0,.64.55l.24.13c-.53,3.31-1.47,5.52-2.55,5.52-.66,0-1.28-.84-1.77-2.26Z"
                fill="#659965"
              />
              <path
                d="M508,201.79c.13,4.78.17,9.56.22,14.34v7.17c0,2.39,0,4.78-.22,7.17.12-1.19.09-2.39.11-3.59V223.3l-.05-7.17Z"
                fill="#78bf3a"
              />
            </g>
            <g>
              <path
                d="M503.34,207a1,1,0,0,1,.56,0l.32.41c.17.2.34.39.52.58a6.55,6.55,0,0,1,.49.56,5.14,5.14,0,0,1,.56,1,4.72,4.72,0,0,0,.59,1.19c.23.28.52.49.78.75h0l.18.53a14.13,14.13,0,0,1,.7,3.39,2.46,2.46,0,0,1,0,.26,19.06,19.06,0,0,0-.43,2.45,1,1,0,0,1-.47.35c-1.17.39-3-1.88-4-5.05S502.17,207.41,503.34,207Z"
                fill="#3b6818"
              />
              <path
                d="M503.11,213.47s5,2.57,5.21,15.8"
                fill="none"
                stroke="#78bf3a"
                strokeMiterlimit="10"
                strokeWidth="0.15"
              />
              <path
                d="M504.13,208.22a2.91,2.91,0,0,1,.7,1.32,6.12,6.12,0,0,0,.28,1.39,2.09,2.09,0,0,0,.46.63c.18.16.37.31.55.49a1.4,1.4,0,0,1,.4.66,1.11,1.11,0,0,1,0,.6,3.09,3.09,0,0,0-.09.62,2.28,2.28,0,0,0,.26.84,2.37,2.37,0,0,1,.25.85,1.92,1.92,0,0,1-.09.55,1.72,1.72,0,0,0,0,.6,1.55,1.55,0,0,0,.18.55,1.12,1.12,0,0,1,.17.46,1.44,1.44,0,0,1-.21.7l0,.08a.55.55,0,0,1-.21.12c-.92.3-2.52-2-3.56-5.2s-1.15-6-.23-6.31a.58.58,0,0,1,.39,0A6.21,6.21,0,0,0,504.13,208.22Z"
                fill="#659965"
              />
            </g>
          </g>
        </g>
        <g transform="translate(-10 -12)">
          <polygon
            points="357.67 394 371.67 401 401.67 384 387.67 373.49 357.67 394"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="380.46 360.86 380.46 378.42 382.5 377.83 382.46 360.28 380.46 360.86"
                fill="#54392e"
              />
              <polygon
                points="379.37 378.1 380.46 378.42 380.46 360.86 379.67 361 379.37 378.1"
                fill="#96695c"
              />
              <polyline
                points="380.46 360.86 382.46 360.28 381.37 360"
                fill="#704d3c"
              />
            </g>
            <line
              x1="355.25"
              y1="381.31"
              x2="387.59"
              y2="362.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="360.28"
              y1="384.21"
              x2="392.63"
              y2="365.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="375.4 381.31 360.28 372.58 360.29 375.61 375.4 384.21 375.4 381.31"
                fill="#96695c"
              />
              <polygon
                points="360.28 372.58 362.32 371.41 377.51 380.1 375.4 381.31 360.28 372.58"
                fill="#704d3c"
              />
              <polygon
                points="375.4 381.31 377.51 380.1 377.51 382.88 375.4 384.21 375.4 381.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="380.44 378.41 365.32 369.68 365.32 372.71 380.44 381.31 380.44 378.41"
                fill="#96695c"
              />
              <polygon
                points="365.32 369.68 367.36 368.51 382.55 377.2 380.44 378.41 365.32 369.68"
                fill="#704d3c"
              />
              <polygon
                points="380.44 378.41 382.55 377.2 382.55 379.97 380.44 381.31 380.44 378.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="385.48 375.49 370.36 366.77 370.36 369.8 385.48 378.4 385.48 375.49"
                fill="#96695c"
              />
              <polygon
                points="370.36 366.77 372.4 365.59 387.59 374.29 385.48 375.49 370.36 366.77"
                fill="#704d3c"
              />
              <polygon
                points="385.48 375.49 387.59 374.29 387.59 377.06 385.48 378.4 385.48 375.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="390.52 372.59 375.4 363.86 375.4 366.89 390.52 375.49 390.52 372.59"
                fill="#96695c"
              />
              <polygon
                points="375.4 363.86 377.44 362.69 392.63 371.38 390.52 372.59 375.4 363.86"
                fill="#704d3c"
              />
              <polygon
                points="390.52 372.59 392.63 371.38 392.63 374.16 390.52 375.49 390.52 372.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="395.46 369.52 379.67 360.25 379.67 363.47 395.46 372.61 395.46 369.52"
                fill="#96695c"
              />
              <polygon
                points="379.67 360.25 381.8 359 397.67 368.24 395.46 369.52 379.67 360.25"
                fill="#704d3c"
              />
              <polygon
                points="395.46 369.52 397.67 368.24 397.67 371.19 395.46 372.61 395.46 369.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="370.36 384.22 355.24 375.49 355.25 378.52 370.36 387.12 370.36 384.22"
                fill="#96695c"
              />
              <polygon
                points="355.24 375.49 357.28 374.32 372.47 383.01 370.36 384.22 355.24 375.49"
                fill="#704d3c"
              />
              <polygon
                points="370.36 384.22 372.47 383.01 372.47 385.79 370.36 387.12 370.36 384.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="351.21 378.83 351.2 395.86 353.24 395.28 353.21 378.27 351.21 378.83"
              fill="#54392e"
            />
            <polygon
              points="350.12 395.55 351.2 395.86 351.21 378.83 350.12 378.52 350.12 395.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="365.32 387.12 350.2 378.4 350.21 381.43 365.32 390.03 365.32 387.12"
                fill="#96695c"
              />
              <polygon
                points="350.2 378.4 352.24 377.22 367.43 385.92 365.32 387.12 350.2 378.4"
                fill="#704d3c"
              />
              <polygon
                points="365.32 387.12 367.43 385.92 367.43 388.69 365.32 390.03 365.32 387.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="365.32 404.59 365.32 387.12 363.22 385.92 363.22 403.37 365.32 404.59"
              fill="#96695c"
            />
            <polygon
              points="365.32 404.59 367.43 403.37 367.43 385.92 365.32 387.12 365.32 404.59"
              fill="#54392e"
            />
            <polygon
              points="395.57 387.12 395.56 369.71 397.67 368.5 397.67 385.91 395.57 387.12"
              fill="#54392e"
            />
            <polygon
              points="394 368.81 394 386.23 395.57 387.12 395.56 369.71 394 368.81"
              fill="#96695c"
            />
          </g>
        </g>
        <g>
          <polygon
            points="449.67 233 463.67 240 493.67 223 479.67 212.49 449.67 233"
            fill="#141c66"
            opacity="0.2"
          />
          <g>
            <g>
              <polygon
                points="472.46 199.86 472.46 217.42 474.5 216.83 474.46 199.28 472.46 199.86"
                fill="#54392e"
              />
              <polygon
                points="471.37 217.1 472.46 217.42 472.46 199.86 471.67 200 471.37 217.1"
                fill="#96695c"
              />
              <polyline
                points="472.46 199.86 474.46 199.28 473.37 199"
                fill="#704d3c"
              />
            </g>
            <line
              x1="447.25"
              y1="220.31"
              x2="479.59"
              y2="201.73"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <line
              x1="452.28"
              y1="223.21"
              x2="484.63"
              y2="204.64"
              fill="none"
              stroke="#54392e"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="467.4 220.31 452.28 211.58 452.29 214.61 467.4 223.21 467.4 220.31"
                fill="#96695c"
              />
              <polygon
                points="452.28 211.58 454.32 210.41 469.51 219.1 467.4 220.31 452.28 211.58"
                fill="#704d3c"
              />
              <polygon
                points="467.4 220.31 469.51 219.1 469.51 221.88 467.4 223.21 467.4 220.31"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="472.44 217.41 457.32 208.68 457.32 211.71 472.44 220.31 472.44 217.41"
                fill="#96695c"
              />
              <polygon
                points="457.32 208.68 459.36 207.51 474.55 216.2 472.44 217.41 457.32 208.68"
                fill="#704d3c"
              />
              <polygon
                points="472.44 217.41 474.55 216.2 474.55 218.97 472.44 220.31 472.44 217.41"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="477.48 214.49 462.36 205.77 462.36 208.8 477.48 217.4 477.48 214.49"
                fill="#96695c"
              />
              <polygon
                points="462.36 205.77 464.4 204.59 479.59 213.29 477.48 214.49 462.36 205.77"
                fill="#704d3c"
              />
              <polygon
                points="477.48 214.49 479.59 213.29 479.59 216.06 477.48 217.4 477.48 214.49"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="482.52 211.59 467.4 202.86 467.4 205.89 482.52 214.49 482.52 211.59"
                fill="#96695c"
              />
              <polygon
                points="467.4 202.86 469.44 201.69 484.63 210.38 482.52 211.59 467.4 202.86"
                fill="#704d3c"
              />
              <polygon
                points="482.52 211.59 484.63 210.38 484.63 213.16 482.52 214.49 482.52 211.59"
                fill="#54392e"
              />
            </g>
            <g>
              <polygon
                points="487.46 208.52 471.67 199.25 471.67 202.47 487.46 211.61 487.46 208.52"
                fill="#96695c"
              />
              <polygon
                points="471.67 199.25 473.8 198 489.67 207.24 487.46 208.52 471.67 199.25"
                fill="#704d3c"
              />
              <polygon
                points="487.46 208.52 489.67 207.24 489.67 210.19 487.46 211.61 487.46 208.52"
                fill="#a06338"
              />
            </g>
            <g>
              <polygon
                points="462.36 223.22 447.24 214.49 447.25 217.52 462.36 226.12 462.36 223.22"
                fill="#96695c"
              />
              <polygon
                points="447.24 214.49 449.28 213.32 464.47 222.01 462.36 223.22 447.24 214.49"
                fill="#704d3c"
              />
              <polygon
                points="462.36 223.22 464.47 222.01 464.47 224.79 462.36 226.12 462.36 223.22"
                fill="#54392e"
              />
            </g>
            <polygon
              points="443.21 217.83 443.2 234.86 445.24 234.28 445.21 217.27 443.21 217.83"
              fill="#54392e"
            />
            <polygon
              points="442.12 234.55 443.2 234.86 443.21 217.83 442.12 217.52 442.12 234.55"
              fill="#96695c"
            />
            <g>
              <polygon
                points="457.32 226.12 442.2 217.4 442.21 220.43 457.32 229.03 457.32 226.12"
                fill="#96695c"
              />
              <polygon
                points="442.2 217.4 444.24 216.22 459.43 224.92 457.32 226.12 442.2 217.4"
                fill="#704d3c"
              />
              <polygon
                points="457.32 226.12 459.43 224.92 459.43 227.69 457.32 229.03 457.32 226.12"
                fill="#a06338"
              />
            </g>
            <polygon
              points="457.32 243.59 457.32 226.12 455.22 224.92 455.22 242.37 457.32 243.59"
              fill="#96695c"
            />
            <polygon
              points="457.32 243.59 459.43 242.37 459.43 224.92 457.32 226.12 457.32 243.59"
              fill="#54392e"
            />
            <polygon
              points="487.57 226.12 487.56 208.71 489.67 207.5 489.67 224.91 487.57 226.12"
              fill="#54392e"
            />
            <polygon
              points="486 207.81 486 225.23 487.57 226.12 487.56 208.71 486 207.81"
              fill="#96695c"
            />
          </g>
        </g>
        <g
          id="a98c581a-aa2c-4687-baf0-c65510ad6ef9"
          data-name="decor"
          transform="translate(912 180)"
        >
          <g transform="translate(-15 10)">
            <g opacity="0.19">
              <g>
                <path
                  d="M305.83,65.86c.27-.27.56-.52.85-.76a8.7,8.7,0,0,1,1.36-.95c.43-.24.9-.4,1.35-.6a4.85,4.85,0,0,0,1.12-.66c.37-.3.66-.68,1-1a3.23,3.23,0,0,1,.92-.57l.75-.18a3.74,3.74,0,0,1,.75,0,.1.1,0,0,0,.1-.09,5.07,5.07,0,0,1,5.29,3.06,1.47,1.47,0,0,0-.08.55,3.34,3.34,0,0,0,.35,1.18,2.22,2.22,0,0,1,.21,1.34,9.63,9.63,0,0,1-.56,1.43,2.54,2.54,0,0,0-.13.77,2.5,2.5,0,0,0,.15.72,2,2,0,0,1,.07.81,6.65,6.65,0,0,1-.23.76,5.34,5.34,0,0,0-.13.8,4.29,4.29,0,0,1-.13.6,6.84,6.84,0,0,1-1.7,2.34,4,4,0,0,0-.83,1.43,6.88,6.88,0,0,0-.21,1.36,3.13,3.13,0,0,1-.23,1.09,3.6,3.6,0,0,1-1.05,1.18c-1,.81-2.06,1.48-3,2.35-.22.22-.44.44-.64.68s-.35.47-.55.69a1.93,1.93,0,0,1-.95.61c-.35.08-.71.09-1.07.14a2.88,2.88,0,0,0-1.5.52,2.3,2.3,0,0,1-.67.5,1.84,1.84,0,0,1-.7.07,7.45,7.45,0,0,0-1.41-.11.08.08,0,0,0-.06,0,4.75,4.75,0,0,1-3-2.12,7.59,7.59,0,0,0-.26-1.63c-.15-.61-.35-1.21-.44-1.83a4.64,4.64,0,0,1-.06-.91c0-.31.07-.61.07-.92,0-.58-.12-1.16-.08-1.74a2.62,2.62,0,0,1,.25-1,8.28,8.28,0,0,1,.47-.82,2.67,2.67,0,0,0,.34-.86,7.18,7.18,0,0,0,.13-.93c0-.41.06-.82.1-1.23a21.87,21.87,0,0,1,1.19-2.3,4.52,4.52,0,0,1,1-.25c.52-.08,1-.11,1.56-.18.07,0,.14-.08.11-.15-.18-.39-.38-.77-.53-1.18a1.77,1.77,0,0,1-.11-.91,1.44,1.44,0,0,1,.26-.58C305.5,66.23,305.66,66,305.83,65.86Z"
                  fill="#141c66"
                />
                <path d="M316.79,62.59s-6.75,17-31.87,44" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M305.35,97.71c.44-.32.85-.67,1.27-1a36,36,0,0,1,7.91-2.79c.37.06.74.11,1.11.14s.92,0,1.38,0h1.6a10.77,10.77,0,0,0,3.05-.38,14.23,14.23,0,0,0,1.4-.58c.31-.12.64-.23,1-.33,5.19,0,9,1.26,9.38,3.46a2.33,2.33,0,0,1,0,.91c-.09.13-.18.25-.28.37a6.15,6.15,0,0,1-1.54,1.38,9.42,9.42,0,0,1-1.82.85,12.72,12.72,0,0,0-2.23.83,8.14,8.14,0,0,0-1.68,1.36,10.8,10.8,0,0,1-1.66,1.43,3,3,0,0,1-1.83.57,5.82,5.82,0,0,1-1.34-.43,5.53,5.53,0,0,0-1.66-.3,1.59,1.59,0,0,0-1.19.35c-.32.32-.55.72-.87,1a3.72,3.72,0,0,1-2.93,1,14.52,14.52,0,0,1-3.26-.73c-.58-.17-1.15-.32-1.74-.44-.3-.06-.6-.11-.9-.14s-.69,0-1-.07a13.74,13.74,0,0,1-4.06-1.14,20.39,20.39,0,0,0-2-.72c-.2-1.12.5-2.34,1.88-3.52A9.19,9.19,0,0,0,305.35,97.71Z"
                  fill="#141c66"
                />
                <path d="M334.14,96.61S304.6,97.23,285,108" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M303,99.71c.39-.2.76-.42,1.13-.64a28,28,0,0,1,6.55-1.18c.29.09.57.18.85.25s.73.12,1.09.18l1.26.19a8.62,8.62,0,0,0,2.43.09,11.71,11.71,0,0,0,1.17-.28c.26,0,.53-.1.8-.13,4.07.66,6.86,2.12,6.92,3.9a1.75,1.75,0,0,1-.13.71,3.07,3.07,0,0,1-.26.25,4.94,4.94,0,0,1-1.38.89,6.92,6.92,0,0,1-1.54.43,11.43,11.43,0,0,0-1.85.37,6.15,6.15,0,0,0-1.49.86,8.68,8.68,0,0,1-1.49.9,2.29,2.29,0,0,1-1.5.22,4.11,4.11,0,0,1-1-.51,4.29,4.29,0,0,0-1.26-.44,1.24,1.24,0,0,0-1,.12c-.29.21-.52.5-.81.71a3,3,0,0,1-2.43.44,11.41,11.41,0,0,1-2.46-1c-.43-.2-.87-.4-1.31-.56a6.2,6.2,0,0,0-.69-.23c-.26-.08-.53-.12-.8-.18a11,11,0,0,1-3-1.41c-.48-.29-1-.57-1.46-.82,0-.9.69-1.77,1.91-2.52A7,7,0,0,0,303,99.71Z"
                  fill="#141c66"
                />
                <path d="M325.71,102.5s-23.23-3.27-40,2.65" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M298.52,94.09a.61.61,0,0,0,.46,0,.65.65,0,0,0,.23-.48,5.7,5.7,0,0,0,0-.92v0a4.21,4.21,0,0,0,.62.09.79.79,0,0,0,.43-.08c.24-.16.16-.49.1-.71l-.15-.49c.34-.38.69-.76,1.06-1.15l.23.19a4.78,4.78,0,0,0,.59.41,1.15,1.15,0,0,0,.53.2.12.12,0,0,0,.13-.13,5.9,5.9,0,0,0-.15-.73,1.56,1.56,0,0,1-.05-.71c.07-.27.36-.32.56-.46a.68.68,0,0,0,.23-.52,2.81,2.81,0,0,0,0-.29c.47-.44,1-.87,1.46-1.31l.33.24a2,2,0,0,0,.9.44.74.74,0,0,0,.8-.42,1.66,1.66,0,0,0,0-1.12,2.76,2.76,0,0,0-.19-.55c.17-.17.32-.34.48-.51.51-.4,1-.81,1.58-1.21a.27.27,0,0,1,.09,0,.9.9,0,0,1,.41.16,1.92,1.92,0,0,0,.66.19.12.12,0,0,0,.14-.1c0-.34-.1-1,.37-1.17.13,0,.26.12.37.17a.35.35,0,0,0,.44-.08c.19-.24.06-.6.15-.88s.46,0,.57.16a6.34,6.34,0,0,0,.61.76c.08.07.19,0,.19-.11,0-.61,0-1.22-.09-1.83,1.18-.75,2.33-1.44,3.43-2a1.43,1.43,0,0,0,.08.22.12.12,0,0,0,.17,0,5.35,5.35,0,0,1,.17,1c0,.21,0,.43,0,.64s.22.19.23,0a5.17,5.17,0,0,0,0-.68,10.44,10.44,0,0,0-.15-1.59c1-.52,1.9-1,2.77-1.35a4.77,4.77,0,0,1,.21,1.3c0,.19,0,.38-.05.56a.12.12,0,0,0,.23,0,3,3,0,0,0,.06-.59c0-.38.08-.75.1-1.13,0-.14,0-.28,0-.43a20.82,20.82,0,0,1,2.58-.88,13,13,0,0,0,.43,1.63.12.12,0,0,0,.18,0,2.42,2.42,0,0,0,.68-1.23A4.3,4.3,0,0,0,324,76a2.48,2.48,0,0,1,2.33.6c.81,1.08-.24,3.38-2.56,6.17-.46-.09-.93-.16-1.4-.23a.11.11,0,0,0-.06.22,7.86,7.86,0,0,0,1.16.38c-.62.72-1.33,1.48-2.1,2.25a20.7,20.7,0,0,0-2.35.44.12.12,0,0,0-.1.13c.07.49.2,1,.31,1.46-1.15,1-2.41,2.07-3.75,3.11a9.41,9.41,0,0,0-2.33.55,5,5,0,0,0-1.45,1l-.66.59c-.22.18-.46.35-.66.55-.39.39-.68.86-1.06,1.26A1.32,1.32,0,0,1,308,95a3.22,3.22,0,0,1-.89-.57.45.45,0,0,0-.37-.09.56.56,0,0,0-.31.33,2.44,2.44,0,0,0-.09,1.34l.06.42c-4.68,2.45-8.35,3.33-9.37,2-.62-.84-.13-2.4,1.2-4.36Z"
                  fill="#141c66"
                />
                <path
                  d="M321.38,80.26s-33.3,25.52-36.21,26.95"
                  fill="#141c66"
                />
              </g>
              <g>
                <path
                  d="M310.37,79.26a1.52,1.52,0,0,1,.53.72c-.07.26-.15.52-.21.78a12.16,12.16,0,0,0-.25,1.2,7.93,7.93,0,0,1-.26,1.15,7.68,7.68,0,0,1-.76,1.68,7.37,7.37,0,0,0-.95,1.85c-.14.56-.13,1.13-.22,1.69v0l-.49.73a22.63,22.63,0,0,1-3.62,4.06l-.36.22a31.8,31.8,0,0,0-3.5,1.76,1.52,1.52,0,0,1-.88-.26c-1.59-1.11-.42-5.51,2.61-9.82S308.78,78.15,310.37,79.26Z"
                  fill="#141c66"
                />
                <path d="M302,85s1.49,8.76-15.06,21.43" fill="#141c66" />
                <path
                  d="M309.6,81.39a4.4,4.4,0,0,1-1,2.12,9.13,9.13,0,0,0-1.49,1.67,3.32,3.32,0,0,0-.36,1.16c0,.39,0,.77-.1,1.16a2.4,2.4,0,0,1-.46,1.14,2,2,0,0,1-.78.53,5.16,5.16,0,0,0-.86.47,3.24,3.24,0,0,0-.82,1.11,3.47,3.47,0,0,1-.85,1.12,2.75,2.75,0,0,1-.78.4,2.64,2.64,0,0,0-.79.52,2.51,2.51,0,0,0-.51.74,1.94,1.94,0,0,1-.43.65,2.4,2.4,0,0,1-1.09.39l-.13,0a.94.94,0,0,1-.34-.14c-1.26-.88.18-5.09,3.21-9.4s6.5-7.09,7.75-6.21a1,1,0,0,1,.36.5A9,9,0,0,0,309.6,81.39Z"
                  fill="#141c66"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M255.73,47.93c-.08-.53-.12-1.08-.15-1.61a13.39,13.39,0,0,1,.07-2.37c.1-.7.31-1.38.47-2.06a6.82,6.82,0,0,0,.2-1.85c0-.68-.22-1.34-.27-2a4.44,4.44,0,0,1,.14-1.54c.13-.35.27-.69.42-1a7.41,7.41,0,0,1,.6-.9.14.14,0,0,0,0-.19,7.6,7.6,0,0,1,3.59-3.14,7.48,7.48,0,0,1,4.43-.31,2.22,2.22,0,0,0,.54.56,4.68,4.68,0,0,0,1.66.61,3.21,3.21,0,0,1,1.72.89,18.67,18.67,0,0,1,1.16,1.86,3.53,3.53,0,0,0,.77.82,3.58,3.58,0,0,0,.95.44,2.63,2.63,0,0,1,1,.62,8.49,8.49,0,0,1,.68.9,7.81,7.81,0,0,0,.8.83c.2.21.4.43.58.66.84,1.12.91,2.61,1.23,3.94a5.55,5.55,0,0,0,.92,2.18,10.07,10.07,0,0,0,1.38,1.39,4.31,4.31,0,0,1,1,1.2,5.22,5.22,0,0,1,.47,2.21c.09,1.8-.06,3.61.15,5.41a11.58,11.58,0,0,0,.23,1.31c.1.41.24.81.32,1.23a2.82,2.82,0,0,1-.12,1.6A13.65,13.65,0,0,1,280,61a4.08,4.08,0,0,0-.68,2.16,3.45,3.45,0,0,1,0,1.2,2.54,2.54,0,0,1-.52.86,11.32,11.32,0,0,0-1.33,1.52.29.29,0,0,0,0,.09,7,7,0,0,1-1.86,1.11,7.12,7.12,0,0,1-3.11.49,10.6,10.6,0,0,0-2.08-1.1,24.57,24.57,0,0,1-2.48-1,8,8,0,0,1-1.1-.72c-.34-.27-.63-.59-1-.85-.66-.5-1.43-.86-2.06-1.4a3.58,3.58,0,0,1-.88-1.09c-.21-.4-.36-.83-.54-1.25a4.09,4.09,0,0,0-.68-1.11,12.28,12.28,0,0,0-1-1l-1.33-1.15a34.22,34.22,0,0,1-1.62-3.33,6.63,6.63,0,0,1,.58-1.37c.36-.66.77-1.29,1.13-1.94,0-.08,0-.23-.09-.25-.6-.13-1.21-.23-1.79-.41a2.47,2.47,0,0,1-1.15-.64A2.2,2.2,0,0,1,256,49C255.87,48.63,255.79,48.28,255.73,47.93Z"
                  fill="#396039"
                />
                <path
                  d="M261.33,32.6a124.89,124.89,0,0,1,8.18,17.64c2.34,6,4.37,12.22,6.24,18.43s3.41,12.53,4.91,18.84c.72,3.16,1.38,6.34,2.07,9.5l1.78,9.57-1.95-9.53c-.71-3.16-1.38-6.34-2.12-9.49-1.53-6.3-3.12-12.59-5-18.79s-3.83-12.39-6.13-18.45l-1.78-4.52c-.64-1.49-1.23-3-1.91-4.47A91.56,91.56,0,0,0,261.33,32.6Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M291.8,75.65c0-.78,0-1.56-.09-2.33a52.19,52.19,0,0,1,3.55-11.44,15,15,0,0,0,1.11-1.15c.43-.5.8-1,1.18-1.58s.91-1.23,1.35-1.85a16.21,16.21,0,0,0,2.18-3.81c.24-.69.33-1.4.52-2.1.12-.47.28-.93.44-1.39,4.44-5.94,9.09-9.19,12-7.8a3.22,3.22,0,0,1,1,.8,6.32,6.32,0,0,1,.18.62,8.83,8.83,0,0,1,.27,2.94,13,13,0,0,1-.58,2.82,18.45,18.45,0,0,0-1,3.26,11.36,11.36,0,0,0,.13,3.08,15.55,15.55,0,0,1,.22,3.12,4.25,4.25,0,0,1-.9,2.58,8.33,8.33,0,0,1-1.64,1.18A7.66,7.66,0,0,0,310,64.25a2.21,2.21,0,0,0-.61,1.65c.08.64.35,1.25.46,1.89A5.33,5.33,0,0,1,308.53,72a21,21,0,0,1-3.61,3.11c-.68.52-1.35,1-2,1.62q-.48.43-.93.9c-.34.36-.63.76-.95,1.13a19.16,19.16,0,0,1-4.77,3.67c-.86.52-1.71,1.06-2.51,1.66-1.46-.73-2.26-2.57-2.44-5.15A12.44,12.44,0,0,0,291.8,75.65Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M315.09,41.74c-1.71,2.49-3.33,5-4.9,7.62s-3.13,5.18-4.62,7.81q-4.45,7.89-8.27,16.13a171.92,171.92,0,0,0-6.76,16.81c-.88,2.89-1.84,5.75-2.5,8.7-.83,2.91-1.28,5.91-1.86,8.88A108,108,0,0,1,290.32,90,176.29,176.29,0,0,1,297,73.15q3.87-8.2,8.39-16.09C308.39,51.81,311.59,46.67,315.09,41.74Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M292.09,80c.1-.61.17-1.23.22-1.84a41.26,41.26,0,0,1,4.24-8.51c.35-.25.69-.5,1-.77a14.54,14.54,0,0,0,1.13-1.09c.43-.43.87-.84,1.29-1.27a12.4,12.4,0,0,0,2.19-2.71c.28-.51.44-1.05.68-1.58.16-.35.34-.69.52-1,4.23-4.1,8.29-6.05,10.37-4.6a2.59,2.59,0,0,1,.71.76,4.43,4.43,0,0,1,.06.51,6.82,6.82,0,0,1-.16,2.34,10.16,10.16,0,0,1-.81,2.13,16,16,0,0,0-1.16,2.44,9.46,9.46,0,0,0-.3,2.43,11.35,11.35,0,0,1-.22,2.47,3.28,3.28,0,0,1-1,1.91,6,6,0,0,1-1.43.71,6.34,6.34,0,0,0-1.59,1.07,1.76,1.76,0,0,0-.69,1.22c0,.52.12,1,.12,1.54a4.25,4.25,0,0,1-1.58,3.16,17.16,17.16,0,0,1-3.23,2c-.59.31-1.19.64-1.76,1-.29.19-.57.38-.84.59s-.59.51-.89.77a15.28,15.28,0,0,1-4.21,2.26c-.74.31-1.47.62-2.17,1-1.05-.76-1.45-2.3-1.26-4.35A10.26,10.26,0,0,0,292.09,80Z"
                  fill="#396039"
                />
                <path
                  d="M314.65,56.42q-2.47,2.61-4.8,5.36c-1.57,1.82-3.11,3.66-4.6,5.54q-4.5,5.63-8.53,11.59a139.71,139.71,0,0,0-7.44,12.31c-1,2.15-2.18,4.27-3.07,6.5s-1.76,4.46-2.6,6.71a85.72,85.72,0,0,1,5.47-13.32,141.73,141.73,0,0,1,7.36-12.39q4.08-5.94,8.63-11.54C308.1,63.45,311.27,59.83,314.65,56.42Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M281.83,80.38a.83.83,0,0,0,.34-.57.91.91,0,0,0-.35-.67,7.35,7.35,0,0,0-1-.81v0a4.23,4.23,0,0,0,.63-.64,1,1,0,0,0,.27-.56c0-.41-.41-.59-.73-.72l-.68-.25c-.14-.7-.28-1.43-.41-2.19l.41-.1a8.62,8.62,0,0,0,1-.32,1.9,1.9,0,0,0,.68-.44.17.17,0,0,0,0-.26c-.31-.18-.65-.31-1-.46a2.1,2.1,0,0,1-.85-.54c-.25-.31-.06-.68-.06-1a1,1,0,0,0-.39-.69l-.33-.27c-.1-.91-.18-1.84-.25-2.79l.56-.16a3.12,3.12,0,0,0,1.27-.67,1.06,1.06,0,0,0,.19-1.27,2.45,2.45,0,0,0-1.28-1,6.8,6.8,0,0,0-.8-.26c-.05-.32-.11-.64-.17-1,0-.93,0-1.88,0-2.84l.07-.11a1.63,1.63,0,0,1,.53-.33,2.76,2.76,0,0,0,.8-.6.16.16,0,0,0,0-.23c-.38-.32-1.29-.8-1-1.42.07-.18.37-.21.52-.29a.49.49,0,0,0,.27-.57c-.11-.42-.63-.58-.87-.92s.41-.51.66-.53a8,8,0,0,0,1.39,0,.17.17,0,0,0,0-.31c-.71-.5-1.42-1-2.16-1.46.13-2,.32-3.9.57-5.67l.31.09a.18.18,0,0,0,.21-.15,7.21,7.21,0,0,1,1.35.7c.25.17.49.36.73.55s.4-.09.24-.24a8.87,8.87,0,0,0-.78-.59,15.45,15.45,0,0,0-1.94-1.18c.23-1.55.5-3,.81-4.33a6.63,6.63,0,0,1,1.67.87l.6.55a.17.17,0,0,0,.24-.24,3.78,3.78,0,0,0-.63-.57c-.39-.37-.78-.74-1.2-1.09l-.47-.38a29.69,29.69,0,0,1,1.18-3.71,20.53,20.53,0,0,0,2.24.9.16.16,0,0,0,.21-.16,3.59,3.59,0,0,0-.82-1.83,6.75,6.75,0,0,0-.71-.81c.82-1.38,1.73-2.15,2.68-2.15,1.93,0,3.66,3.15,4.89,8.19-.51.45-1,.93-1.47,1.4a.17.17,0,0,0,.21.27,11.67,11.67,0,0,0,1.41-1c.3,1.33.57,2.78.8,4.33a25.48,25.48,0,0,0-1.5,3.06.17.17,0,0,0,.06.23c.63.33,1.29.6,1.93.89.2,2.19.33,4.52.37,6.94a12.31,12.31,0,0,0-1.35,3.14,7.07,7.07,0,0,0-.11,2.51c0,.42.09.83.11,1.25s0,.82.07,1.23c.12.78.41,1.52.54,2.29a1.87,1.87,0,0,1-.51,1.89,4.17,4.17,0,0,1-1.41.54.62.62,0,0,0-.42.35.85.85,0,0,0,.12.64A3.37,3.37,0,0,0,290.67,73l.53.29c-1.18,7.45-3.3,12.41-5.72,12.41-1.49,0-2.87-1.89-4-5.09Z"
                  fill="#659965"
                />
                <path
                  d="M285.48,42.4c.29,10.74.37,21.48.49,32.23V90.75c-.06,5.37,0,10.75-.48,16.11.25-2.68.2-5.37.24-8l0-8.06-.1-16.12Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M275,54.17a2.11,2.11,0,0,1,1.27,0l.72.91c.37.45.75.89,1.16,1.3a13.35,13.35,0,0,1,1.1,1.27A11.36,11.36,0,0,1,280.47,60a10.65,10.65,0,0,0,1.32,2.66c.51.63,1.18,1.11,1.74,1.69l0,0c.15.39.28.78.41,1.18a32,32,0,0,1,1.58,7.61q0,.3-.06.6c-.25,1.83-.93,3.65-1,5.5a2.19,2.19,0,0,1-1,.8c-2.63.86-6.66-4.23-9-11.37S272.32,55,275,54.17Z"
                  fill="#3b6818"
                />
                <path
                  d="M274.45,68.66s11.31,5.76,11.7,35.52"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.34"
                />
                <path
                  d="M276.74,56.86a6.42,6.42,0,0,1,1.56,3,13.39,13.39,0,0,0,.64,3.13,4.28,4.28,0,0,0,1,1.4c.4.38.84.71,1.23,1.1a3.38,3.38,0,0,1,.91,1.51,2.75,2.75,0,0,1,0,1.34,5.84,5.84,0,0,0-.2,1.4,4.52,4.52,0,0,0,.57,1.87A5.1,5.1,0,0,1,283,73.5a4.12,4.12,0,0,1-.2,1.23,3.57,3.57,0,0,0-.09,1.35,3.28,3.28,0,0,0,.42,1.22,2.7,2.7,0,0,1,.37,1,3.26,3.26,0,0,1-.48,1.57l-.09.17a1.21,1.21,0,0,1-.46.28c-2.07.68-5.66-4.56-8-11.7s-2.57-13.49-.5-14.17a1.37,1.37,0,0,1,.87,0A13.23,13.23,0,0,0,276.74,56.86Z"
                  fill="#659965"
                />
              </g>
            </g>
          </g>
          <g transform="translate(280 70)">
            <g opacity="0.19">
              <g>
                <path
                  d="M305.83,65.86c.27-.27.56-.52.85-.76a8.7,8.7,0,0,1,1.36-.95c.43-.24.9-.4,1.35-.6a4.85,4.85,0,0,0,1.12-.66c.37-.3.66-.68,1-1a3.23,3.23,0,0,1,.92-.57l.75-.18a3.74,3.74,0,0,1,.75,0,.1.1,0,0,0,.1-.09,5.07,5.07,0,0,1,5.29,3.06,1.47,1.47,0,0,0-.08.55,3.34,3.34,0,0,0,.35,1.18,2.22,2.22,0,0,1,.21,1.34,9.63,9.63,0,0,1-.56,1.43,2.54,2.54,0,0,0-.13.77,2.5,2.5,0,0,0,.15.72,2,2,0,0,1,.07.81,6.65,6.65,0,0,1-.23.76,5.34,5.34,0,0,0-.13.8,4.29,4.29,0,0,1-.13.6,6.84,6.84,0,0,1-1.7,2.34,4,4,0,0,0-.83,1.43,6.88,6.88,0,0,0-.21,1.36,3.13,3.13,0,0,1-.23,1.09,3.6,3.6,0,0,1-1.05,1.18c-1,.81-2.06,1.48-3,2.35-.22.22-.44.44-.64.68s-.35.47-.55.69a1.93,1.93,0,0,1-.95.61c-.35.08-.71.09-1.07.14a2.88,2.88,0,0,0-1.5.52,2.3,2.3,0,0,1-.67.5,1.84,1.84,0,0,1-.7.07,7.45,7.45,0,0,0-1.41-.11.08.08,0,0,0-.06,0,4.75,4.75,0,0,1-3-2.12,7.59,7.59,0,0,0-.26-1.63c-.15-.61-.35-1.21-.44-1.83a4.64,4.64,0,0,1-.06-.91c0-.31.07-.61.07-.92,0-.58-.12-1.16-.08-1.74a2.62,2.62,0,0,1,.25-1,8.28,8.28,0,0,1,.47-.82,2.67,2.67,0,0,0,.34-.86,7.18,7.18,0,0,0,.13-.93c0-.41.06-.82.1-1.23a21.87,21.87,0,0,1,1.19-2.3,4.52,4.52,0,0,1,1-.25c.52-.08,1-.11,1.56-.18.07,0,.14-.08.11-.15-.18-.39-.38-.77-.53-1.18a1.77,1.77,0,0,1-.11-.91,1.44,1.44,0,0,1,.26-.58C305.5,66.23,305.66,66,305.83,65.86Z"
                  fill="#141c66"
                />
                <path d="M316.79,62.59s-6.75,17-31.87,44" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M305.35,97.71c.44-.32.85-.67,1.27-1a36,36,0,0,1,7.91-2.79c.37.06.74.11,1.11.14s.92,0,1.38,0h1.6a10.77,10.77,0,0,0,3.05-.38,14.23,14.23,0,0,0,1.4-.58c.31-.12.64-.23,1-.33,5.19,0,9,1.26,9.38,3.46a2.33,2.33,0,0,1,0,.91c-.09.13-.18.25-.28.37a6.15,6.15,0,0,1-1.54,1.38,9.42,9.42,0,0,1-1.82.85,12.72,12.72,0,0,0-2.23.83,8.14,8.14,0,0,0-1.68,1.36,10.8,10.8,0,0,1-1.66,1.43,3,3,0,0,1-1.83.57,5.82,5.82,0,0,1-1.34-.43,5.53,5.53,0,0,0-1.66-.3,1.59,1.59,0,0,0-1.19.35c-.32.32-.55.72-.87,1a3.72,3.72,0,0,1-2.93,1,14.52,14.52,0,0,1-3.26-.73c-.58-.17-1.15-.32-1.74-.44-.3-.06-.6-.11-.9-.14s-.69,0-1-.07a13.74,13.74,0,0,1-4.06-1.14,20.39,20.39,0,0,0-2-.72c-.2-1.12.5-2.34,1.88-3.52A9.19,9.19,0,0,0,305.35,97.71Z"
                  fill="#141c66"
                />
                <path d="M334.14,96.61S304.6,97.23,285,108" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M303,99.71c.39-.2.76-.42,1.13-.64a28,28,0,0,1,6.55-1.18c.29.09.57.18.85.25s.73.12,1.09.18l1.26.19a8.62,8.62,0,0,0,2.43.09,11.71,11.71,0,0,0,1.17-.28c.26,0,.53-.1.8-.13,4.07.66,6.86,2.12,6.92,3.9a1.75,1.75,0,0,1-.13.71,3.07,3.07,0,0,1-.26.25,4.94,4.94,0,0,1-1.38.89,6.92,6.92,0,0,1-1.54.43,11.43,11.43,0,0,0-1.85.37,6.15,6.15,0,0,0-1.49.86,8.68,8.68,0,0,1-1.49.9,2.29,2.29,0,0,1-1.5.22,4.11,4.11,0,0,1-1-.51,4.29,4.29,0,0,0-1.26-.44,1.24,1.24,0,0,0-1,.12c-.29.21-.52.5-.81.71a3,3,0,0,1-2.43.44,11.41,11.41,0,0,1-2.46-1c-.43-.2-.87-.4-1.31-.56a6.2,6.2,0,0,0-.69-.23c-.26-.08-.53-.12-.8-.18a11,11,0,0,1-3-1.41c-.48-.29-1-.57-1.46-.82,0-.9.69-1.77,1.91-2.52A7,7,0,0,0,303,99.71Z"
                  fill="#141c66"
                />
                <path d="M325.71,102.5s-23.23-3.27-40,2.65" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M298.52,94.09a.61.61,0,0,0,.46,0,.65.65,0,0,0,.23-.48,5.7,5.7,0,0,0,0-.92v0a4.21,4.21,0,0,0,.62.09.79.79,0,0,0,.43-.08c.24-.16.16-.49.1-.71l-.15-.49c.34-.38.69-.76,1.06-1.15l.23.19a4.78,4.78,0,0,0,.59.41,1.15,1.15,0,0,0,.53.2.12.12,0,0,0,.13-.13,5.9,5.9,0,0,0-.15-.73,1.56,1.56,0,0,1-.05-.71c.07-.27.36-.32.56-.46a.68.68,0,0,0,.23-.52,2.81,2.81,0,0,0,0-.29c.47-.44,1-.87,1.46-1.31l.33.24a2,2,0,0,0,.9.44.74.74,0,0,0,.8-.42,1.66,1.66,0,0,0,0-1.12,2.76,2.76,0,0,0-.19-.55c.17-.17.32-.34.48-.51.51-.4,1-.81,1.58-1.21a.27.27,0,0,1,.09,0,.9.9,0,0,1,.41.16,1.92,1.92,0,0,0,.66.19.12.12,0,0,0,.14-.1c0-.34-.1-1,.37-1.17.13,0,.26.12.37.17a.35.35,0,0,0,.44-.08c.19-.24.06-.6.15-.88s.46,0,.57.16a6.34,6.34,0,0,0,.61.76c.08.07.19,0,.19-.11,0-.61,0-1.22-.09-1.83,1.18-.75,2.33-1.44,3.43-2a1.43,1.43,0,0,0,.08.22.12.12,0,0,0,.17,0,5.35,5.35,0,0,1,.17,1c0,.21,0,.43,0,.64s.22.19.23,0a5.17,5.17,0,0,0,0-.68,10.44,10.44,0,0,0-.15-1.59c1-.52,1.9-1,2.77-1.35a4.77,4.77,0,0,1,.21,1.3c0,.19,0,.38-.05.56a.12.12,0,0,0,.23,0,3,3,0,0,0,.06-.59c0-.38.08-.75.1-1.13,0-.14,0-.28,0-.43a20.82,20.82,0,0,1,2.58-.88,13,13,0,0,0,.43,1.63.12.12,0,0,0,.18,0,2.42,2.42,0,0,0,.68-1.23A4.3,4.3,0,0,0,324,76a2.48,2.48,0,0,1,2.33.6c.81,1.08-.24,3.38-2.56,6.17-.46-.09-.93-.16-1.4-.23a.11.11,0,0,0-.06.22,7.86,7.86,0,0,0,1.16.38c-.62.72-1.33,1.48-2.1,2.25a20.7,20.7,0,0,0-2.35.44.12.12,0,0,0-.1.13c.07.49.2,1,.31,1.46-1.15,1-2.41,2.07-3.75,3.11a9.41,9.41,0,0,0-2.33.55,5,5,0,0,0-1.45,1l-.66.59c-.22.18-.46.35-.66.55-.39.39-.68.86-1.06,1.26A1.32,1.32,0,0,1,308,95a3.22,3.22,0,0,1-.89-.57.45.45,0,0,0-.37-.09.56.56,0,0,0-.31.33,2.44,2.44,0,0,0-.09,1.34l.06.42c-4.68,2.45-8.35,3.33-9.37,2-.62-.84-.13-2.4,1.2-4.36Z"
                  fill="#141c66"
                />
                <path
                  d="M321.38,80.26s-33.3,25.52-36.21,26.95"
                  fill="#141c66"
                />
              </g>
              <g>
                <path
                  d="M310.37,79.26a1.52,1.52,0,0,1,.53.72c-.07.26-.15.52-.21.78a12.16,12.16,0,0,0-.25,1.2,7.93,7.93,0,0,1-.26,1.15,7.68,7.68,0,0,1-.76,1.68,7.37,7.37,0,0,0-.95,1.85c-.14.56-.13,1.13-.22,1.69v0l-.49.73a22.63,22.63,0,0,1-3.62,4.06l-.36.22a31.8,31.8,0,0,0-3.5,1.76,1.52,1.52,0,0,1-.88-.26c-1.59-1.11-.42-5.51,2.61-9.82S308.78,78.15,310.37,79.26Z"
                  fill="#141c66"
                />
                <path d="M302,85s1.49,8.76-15.06,21.43" fill="#141c66" />
                <path
                  d="M309.6,81.39a4.4,4.4,0,0,1-1,2.12,9.13,9.13,0,0,0-1.49,1.67,3.32,3.32,0,0,0-.36,1.16c0,.39,0,.77-.1,1.16a2.4,2.4,0,0,1-.46,1.14,2,2,0,0,1-.78.53,5.16,5.16,0,0,0-.86.47,3.24,3.24,0,0,0-.82,1.11,3.47,3.47,0,0,1-.85,1.12,2.75,2.75,0,0,1-.78.4,2.64,2.64,0,0,0-.79.52,2.51,2.51,0,0,0-.51.74,1.94,1.94,0,0,1-.43.65,2.4,2.4,0,0,1-1.09.39l-.13,0a.94.94,0,0,1-.34-.14c-1.26-.88.18-5.09,3.21-9.4s6.5-7.09,7.75-6.21a1,1,0,0,1,.36.5A9,9,0,0,0,309.6,81.39Z"
                  fill="#141c66"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M255.73,47.93c-.08-.53-.12-1.08-.15-1.61a13.39,13.39,0,0,1,.07-2.37c.1-.7.31-1.38.47-2.06a6.82,6.82,0,0,0,.2-1.85c0-.68-.22-1.34-.27-2a4.44,4.44,0,0,1,.14-1.54c.13-.35.27-.69.42-1a7.41,7.41,0,0,1,.6-.9.14.14,0,0,0,0-.19,7.6,7.6,0,0,1,3.59-3.14,7.48,7.48,0,0,1,4.43-.31,2.22,2.22,0,0,0,.54.56,4.68,4.68,0,0,0,1.66.61,3.21,3.21,0,0,1,1.72.89,18.67,18.67,0,0,1,1.16,1.86,3.53,3.53,0,0,0,.77.82,3.58,3.58,0,0,0,.95.44,2.63,2.63,0,0,1,1,.62,8.49,8.49,0,0,1,.68.9,7.81,7.81,0,0,0,.8.83c.2.21.4.43.58.66.84,1.12.91,2.61,1.23,3.94a5.55,5.55,0,0,0,.92,2.18,10.07,10.07,0,0,0,1.38,1.39,4.31,4.31,0,0,1,1,1.2,5.22,5.22,0,0,1,.47,2.21c.09,1.8-.06,3.61.15,5.41a11.58,11.58,0,0,0,.23,1.31c.1.41.24.81.32,1.23a2.82,2.82,0,0,1-.12,1.6A13.65,13.65,0,0,1,280,61a4.08,4.08,0,0,0-.68,2.16,3.45,3.45,0,0,1,0,1.2,2.54,2.54,0,0,1-.52.86,11.32,11.32,0,0,0-1.33,1.52.29.29,0,0,0,0,.09,7,7,0,0,1-1.86,1.11,7.12,7.12,0,0,1-3.11.49,10.6,10.6,0,0,0-2.08-1.1,24.57,24.57,0,0,1-2.48-1,8,8,0,0,1-1.1-.72c-.34-.27-.63-.59-1-.85-.66-.5-1.43-.86-2.06-1.4a3.58,3.58,0,0,1-.88-1.09c-.21-.4-.36-.83-.54-1.25a4.09,4.09,0,0,0-.68-1.11,12.28,12.28,0,0,0-1-1l-1.33-1.15a34.22,34.22,0,0,1-1.62-3.33,6.63,6.63,0,0,1,.58-1.37c.36-.66.77-1.29,1.13-1.94,0-.08,0-.23-.09-.25-.6-.13-1.21-.23-1.79-.41a2.47,2.47,0,0,1-1.15-.64A2.2,2.2,0,0,1,256,49C255.87,48.63,255.79,48.28,255.73,47.93Z"
                  fill="#396039"
                />
                <path
                  d="M261.33,32.6a124.89,124.89,0,0,1,8.18,17.64c2.34,6,4.37,12.22,6.24,18.43s3.41,12.53,4.91,18.84c.72,3.16,1.38,6.34,2.07,9.5l1.78,9.57-1.95-9.53c-.71-3.16-1.38-6.34-2.12-9.49-1.53-6.3-3.12-12.59-5-18.79s-3.83-12.39-6.13-18.45l-1.78-4.52c-.64-1.49-1.23-3-1.91-4.47A91.56,91.56,0,0,0,261.33,32.6Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M291.8,75.65c0-.78,0-1.56-.09-2.33a52.19,52.19,0,0,1,3.55-11.44,15,15,0,0,0,1.11-1.15c.43-.5.8-1,1.18-1.58s.91-1.23,1.35-1.85a16.21,16.21,0,0,0,2.18-3.81c.24-.69.33-1.4.52-2.1.12-.47.28-.93.44-1.39,4.44-5.94,9.09-9.19,12-7.8a3.22,3.22,0,0,1,1,.8,6.32,6.32,0,0,1,.18.62,8.83,8.83,0,0,1,.27,2.94,13,13,0,0,1-.58,2.82,18.45,18.45,0,0,0-1,3.26,11.36,11.36,0,0,0,.13,3.08,15.55,15.55,0,0,1,.22,3.12,4.25,4.25,0,0,1-.9,2.58,8.33,8.33,0,0,1-1.64,1.18A7.66,7.66,0,0,0,310,64.25a2.21,2.21,0,0,0-.61,1.65c.08.64.35,1.25.46,1.89A5.33,5.33,0,0,1,308.53,72a21,21,0,0,1-3.61,3.11c-.68.52-1.35,1-2,1.62q-.48.43-.93.9c-.34.36-.63.76-.95,1.13a19.16,19.16,0,0,1-4.77,3.67c-.86.52-1.71,1.06-2.51,1.66-1.46-.73-2.26-2.57-2.44-5.15A12.44,12.44,0,0,0,291.8,75.65Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M315.09,41.74c-1.71,2.49-3.33,5-4.9,7.62s-3.13,5.18-4.62,7.81q-4.45,7.89-8.27,16.13a171.92,171.92,0,0,0-6.76,16.81c-.88,2.89-1.84,5.75-2.5,8.7-.83,2.91-1.28,5.91-1.86,8.88A108,108,0,0,1,290.32,90,176.29,176.29,0,0,1,297,73.15q3.87-8.2,8.39-16.09C308.39,51.81,311.59,46.67,315.09,41.74Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M292.09,80c.1-.61.17-1.23.22-1.84a41.26,41.26,0,0,1,4.24-8.51c.35-.25.69-.5,1-.77a14.54,14.54,0,0,0,1.13-1.09c.43-.43.87-.84,1.29-1.27a12.4,12.4,0,0,0,2.19-2.71c.28-.51.44-1.05.68-1.58.16-.35.34-.69.52-1,4.23-4.1,8.29-6.05,10.37-4.6a2.59,2.59,0,0,1,.71.76,4.43,4.43,0,0,1,.06.51,6.82,6.82,0,0,1-.16,2.34,10.16,10.16,0,0,1-.81,2.13,16,16,0,0,0-1.16,2.44,9.46,9.46,0,0,0-.3,2.43,11.35,11.35,0,0,1-.22,2.47,3.28,3.28,0,0,1-1,1.91,6,6,0,0,1-1.43.71,6.34,6.34,0,0,0-1.59,1.07,1.76,1.76,0,0,0-.69,1.22c0,.52.12,1,.12,1.54a4.25,4.25,0,0,1-1.58,3.16,17.16,17.16,0,0,1-3.23,2c-.59.31-1.19.64-1.76,1-.29.19-.57.38-.84.59s-.59.51-.89.77a15.28,15.28,0,0,1-4.21,2.26c-.74.31-1.47.62-2.17,1-1.05-.76-1.45-2.3-1.26-4.35A10.26,10.26,0,0,0,292.09,80Z"
                  fill="#396039"
                />
                <path
                  d="M314.65,56.42q-2.47,2.61-4.8,5.36c-1.57,1.82-3.11,3.66-4.6,5.54q-4.5,5.63-8.53,11.59a139.71,139.71,0,0,0-7.44,12.31c-1,2.15-2.18,4.27-3.07,6.5s-1.76,4.46-2.6,6.71a85.72,85.72,0,0,1,5.47-13.32,141.73,141.73,0,0,1,7.36-12.39q4.08-5.94,8.63-11.54C308.1,63.45,311.27,59.83,314.65,56.42Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M281.83,80.38a.83.83,0,0,0,.34-.57.91.91,0,0,0-.35-.67,7.35,7.35,0,0,0-1-.81v0a4.23,4.23,0,0,0,.63-.64,1,1,0,0,0,.27-.56c0-.41-.41-.59-.73-.72l-.68-.25c-.14-.7-.28-1.43-.41-2.19l.41-.1a8.62,8.62,0,0,0,1-.32,1.9,1.9,0,0,0,.68-.44.17.17,0,0,0,0-.26c-.31-.18-.65-.31-1-.46a2.1,2.1,0,0,1-.85-.54c-.25-.31-.06-.68-.06-1a1,1,0,0,0-.39-.69l-.33-.27c-.1-.91-.18-1.84-.25-2.79l.56-.16a3.12,3.12,0,0,0,1.27-.67,1.06,1.06,0,0,0,.19-1.27,2.45,2.45,0,0,0-1.28-1,6.8,6.8,0,0,0-.8-.26c-.05-.32-.11-.64-.17-1,0-.93,0-1.88,0-2.84l.07-.11a1.63,1.63,0,0,1,.53-.33,2.76,2.76,0,0,0,.8-.6.16.16,0,0,0,0-.23c-.38-.32-1.29-.8-1-1.42.07-.18.37-.21.52-.29a.49.49,0,0,0,.27-.57c-.11-.42-.63-.58-.87-.92s.41-.51.66-.53a8,8,0,0,0,1.39,0,.17.17,0,0,0,0-.31c-.71-.5-1.42-1-2.16-1.46.13-2,.32-3.9.57-5.67l.31.09a.18.18,0,0,0,.21-.15,7.21,7.21,0,0,1,1.35.7c.25.17.49.36.73.55s.4-.09.24-.24a8.87,8.87,0,0,0-.78-.59,15.45,15.45,0,0,0-1.94-1.18c.23-1.55.5-3,.81-4.33a6.63,6.63,0,0,1,1.67.87l.6.55a.17.17,0,0,0,.24-.24,3.78,3.78,0,0,0-.63-.57c-.39-.37-.78-.74-1.2-1.09l-.47-.38a29.69,29.69,0,0,1,1.18-3.71,20.53,20.53,0,0,0,2.24.9.16.16,0,0,0,.21-.16,3.59,3.59,0,0,0-.82-1.83,6.75,6.75,0,0,0-.71-.81c.82-1.38,1.73-2.15,2.68-2.15,1.93,0,3.66,3.15,4.89,8.19-.51.45-1,.93-1.47,1.4a.17.17,0,0,0,.21.27,11.67,11.67,0,0,0,1.41-1c.3,1.33.57,2.78.8,4.33a25.48,25.48,0,0,0-1.5,3.06.17.17,0,0,0,.06.23c.63.33,1.29.6,1.93.89.2,2.19.33,4.52.37,6.94a12.31,12.31,0,0,0-1.35,3.14,7.07,7.07,0,0,0-.11,2.51c0,.42.09.83.11,1.25s0,.82.07,1.23c.12.78.41,1.52.54,2.29a1.87,1.87,0,0,1-.51,1.89,4.17,4.17,0,0,1-1.41.54.62.62,0,0,0-.42.35.85.85,0,0,0,.12.64A3.37,3.37,0,0,0,290.67,73l.53.29c-1.18,7.45-3.3,12.41-5.72,12.41-1.49,0-2.87-1.89-4-5.09Z"
                  fill="#659965"
                />
                <path
                  d="M285.48,42.4c.29,10.74.37,21.48.49,32.23V90.75c-.06,5.37,0,10.75-.48,16.11.25-2.68.2-5.37.24-8l0-8.06-.1-16.12Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M275,54.17a2.11,2.11,0,0,1,1.27,0l.72.91c.37.45.75.89,1.16,1.3a13.35,13.35,0,0,1,1.1,1.27A11.36,11.36,0,0,1,280.47,60a10.65,10.65,0,0,0,1.32,2.66c.51.63,1.18,1.11,1.74,1.69l0,0c.15.39.28.78.41,1.18a32,32,0,0,1,1.58,7.61q0,.3-.06.6c-.25,1.83-.93,3.65-1,5.5a2.19,2.19,0,0,1-1,.8c-2.63.86-6.66-4.23-9-11.37S272.32,55,275,54.17Z"
                  fill="#3b6818"
                />
                <path
                  d="M274.45,68.66s11.31,5.76,11.7,35.52"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.34"
                />
                <path
                  d="M276.74,56.86a6.42,6.42,0,0,1,1.56,3,13.39,13.39,0,0,0,.64,3.13,4.28,4.28,0,0,0,1,1.4c.4.38.84.71,1.23,1.1a3.38,3.38,0,0,1,.91,1.51,2.75,2.75,0,0,1,0,1.34,5.84,5.84,0,0,0-.2,1.4,4.52,4.52,0,0,0,.57,1.87A5.1,5.1,0,0,1,283,73.5a4.12,4.12,0,0,1-.2,1.23,3.57,3.57,0,0,0-.09,1.35,3.28,3.28,0,0,0,.42,1.22,2.7,2.7,0,0,1,.37,1,3.26,3.26,0,0,1-.48,1.57l-.09.17a1.21,1.21,0,0,1-.46.28c-2.07.68-5.66-4.56-8-11.7s-2.57-13.49-.5-14.17a1.37,1.37,0,0,1,.87,0A13.23,13.23,0,0,0,276.74,56.86Z"
                  fill="#659965"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <rect
                x="356.96"
                y="87.8"
                width="3.91"
                height="69.2"
                rx="0.64"
                fill="#a39bb2"
              />
              <g>
                <ellipse
                  cx="358.92"
                  cy="69.47"
                  rx="8.03"
                  ry="1.58"
                  fill="url(#e0a0d72b-2788-427c-8012-2effeeb7495c)"
                />
                <ellipse
                  cx="358.92"
                  cy="72.22"
                  rx="11.07"
                  ry="2.07"
                  fill="url(#a2b09e04-4031-40da-aa90-8c00999bfdb5)"
                />
                <ellipse
                  cx="358.92"
                  cy="74.96"
                  rx="14.12"
                  ry="2.56"
                  fill="url(#a9e95210-c213-48bf-82f0-fc39c581116b)"
                />
                <ellipse
                  cx="358.92"
                  cy="77.7"
                  rx="17.16"
                  ry="3.05"
                  fill="url(#f638875d-a30a-4409-bd8d-c40629cec067)"
                />
                <ellipse
                  cx="358.92"
                  cy="80.44"
                  rx="20.2"
                  ry="3.54"
                  fill="url(#ff47643f-4330-453f-9f75-05d3cbbda61e)"
                />
                <ellipse
                  cx="358.92"
                  cy="83.18"
                  rx="23.25"
                  ry="4.03"
                  fill="url(#b84cfbf9-aa7c-4134-ac22-b0907286cf63)"
                />
                <ellipse
                  cx="358.92"
                  cy="87.22"
                  rx="20.96"
                  ry="3.69"
                  fill="url(#aa2d45af-5519-4e48-a105-ab9a892f6588)"
                />
                <ellipse
                  cx="358.92"
                  cy="91.26"
                  rx="18.68"
                  ry="3.35"
                  fill="url(#bbbe08cd-7b9f-403e-93e4-29bf33e3a5e5)"
                />
                <ellipse
                  cx="358.92"
                  cy="95.29"
                  rx="16.39"
                  ry="3"
                  fill="url(#f724630b-e6ee-4a91-83ff-1d8a187d6784)"
                />
                <ellipse
                  cx="358.92"
                  cy="99.33"
                  rx="14.11"
                  ry="2.66"
                  fill="url(#f1cb2374-018c-4d4a-8001-9a740e028073)"
                />
                <ellipse
                  cx="358.92"
                  cy="103.37"
                  rx="11.82"
                  ry="2.32"
                  fill="url(#afdc56f3-ec0c-4965-98fb-529caf23792c)"
                />
              </g>
            </g>
            <circle
              cx="358.52"
              cy="85.16"
              r="39"
              fill="url(#b2dc3688-cc87-43d1-acac-1c8c33b3013e)"
            />
          </g>
          <g>
            <ellipse
              cx="381.86"
              cy="191"
              rx="7.67"
              ry="3"
              fill="#141c66"
              opacity="0.28"
            />
            <g>
              <path d="M370.52,181.53h0Z" fill="#ef6291" />
              <path
                d="M388.6,177.85v0c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85Z"
                fill="#ef6291"
              />
              <path
                d="M385,189.2h0v.05c0,.6-2.34,1.09-5.23,1.09s-5.23-.49-5.23-1.09a.11.11,0,0,1,0-.05h-.05l-3.94-7.72H388.6Z"
                fill="#c1567f"
              />
              <path
                d="M388.6,177.87c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85,4-1.84,8.89-1.84,9.15.83,9.19,1.84Z"
                fill="#c16f86"
              />
              <path
                d="M387.58,177.86c0,.91-3.79,1.63-8.15,1.63s-7.89-.73-7.89-1.64,3.53-1.64,7.89-1.64S387.58,177,387.58,177.86Z"
                fill="#513126"
              />
              <path
                d="M384.85,189.48c-6.28.31-6.07-7.4-6.07-7.4l-8.1-.29,3.78,7.41h.05a.11.11,0,0,0,0,.05c0,.6,2.34,1.09,5.23,1.09C382.25,190.34,384.36,190,384.85,189.48Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M388.6,177.87v3.66h0c0,1-4.13,1.85-9,1.85s-9-.83-9.05-1.85h0v-3.68c0,1,4,1.85,8.89,1.85S388.6,178.89,388.6,177.87Z"
                fill="#ef6291"
              />
              <path
                d="M375.31,179.49h0c-2.85-.31-4.79-.93-4.79-1.64v3.68h0c0,.87,3.06,1.61,7,1.8C374.59,182.67,375.31,179.49,375.31,179.49Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <g>
                <path
                  d="M373.28,176.12c-1.44.28-2.77-3.05-3.73-4.56a10.16,10.16,0,0,1,3.76.95C374.55,173.31,375.23,175.74,373.28,176.12Z"
                  fill="#1c7f19"
                />
                <path
                  d="M369.55,171.56a24.32,24.32,0,0,1,2.59,1.79,10.74,10.74,0,0,1,1.16,1.07,2.25,2.25,0,0,1,.76,1.35,2.59,2.59,0,0,0-.81-1.3,11.6,11.6,0,0,0-1.18-1C371.27,172.77,370.41,172.17,369.55,171.56Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M381.81,174.64c-1.44.28-2.77-3-3.72-4.56a10,10,0,0,1,3.75,1C383.08,171.84,383.76,174.26,381.81,174.64Z"
                  fill="#1c7f19"
                />
                <path
                  d="M378.09,170.08a25.38,25.38,0,0,1,2.59,1.79,13,13,0,0,1,1.15,1.07,2.31,2.31,0,0,1,.76,1.35,2.57,2.57,0,0,0-.81-1.29,12.79,12.79,0,0,0-1.17-1C379.8,171.29,378.94,170.69,378.09,170.08Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M378.33,179.18c-1.44.28-2.78-3.05-3.73-4.55a9.87,9.87,0,0,1,3.75,1C379.59,176.38,380.27,178.8,378.33,179.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M374.6,174.63a23.79,23.79,0,0,1,2.59,1.78,13.13,13.13,0,0,1,1.16,1.08,2.36,2.36,0,0,1,.76,1.35,2.61,2.61,0,0,0-.82-1.3,11.58,11.58,0,0,0-1.17-1C376.32,175.83,375.45,175.23,374.6,174.63Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M374.56,179.18c-1,.2-2-2.19-2.68-3.28a7.1,7.1,0,0,1,2.7.69C375.47,177.16,376,178.9,374.56,179.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M371.88,175.9a18.14,18.14,0,0,1,1.86,1.29,7.57,7.57,0,0,1,.83.77,1.65,1.65,0,0,1,.55,1,1.82,1.82,0,0,0-.59-.93,10,10,0,0,0-.84-.75C373.11,176.77,372.49,176.34,371.88,175.9Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M374.4,172.33c-1,.21-2-2.21-2.71-3.31a7.33,7.33,0,0,1,2.73.7C375.32,170.3,375.81,172.06,374.4,172.33Z"
                  fill="#1c7f19"
                />
                <path
                  d="M371.69,169a19,19,0,0,1,1.88,1.3,10.34,10.34,0,0,1,.84.78,1.7,1.7,0,0,1,.55,1,1.84,1.84,0,0,0-.59-.94,7.6,7.6,0,0,0-.85-.75C372.94,169.9,372.31,169.47,371.69,169Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M375.58,177.38c1.44.28,2.77-3,3.73-4.56a10,10,0,0,0-3.76,1C374.31,174.57,373.63,177,375.58,177.38Z"
                  fill="#1c7f19"
                />
                <path
                  d="M379.31,172.82c-.86.61-1.72,1.2-2.52,1.88a12.8,12.8,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.36,2.36,0,0,1,.76-1.35,11.76,11.76,0,0,1,1.16-1.07A24.32,24.32,0,0,1,379.31,172.82Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M383,172.94c1.44.29,2.77-3.05,3.73-4.55a10,10,0,0,0-3.76,1C381.77,170.14,381.09,172.56,383,172.94Z"
                  fill="#1c7f19"
                />
                <path
                  d="M386.77,168.39c-.86.61-1.72,1.2-2.52,1.87a11.7,11.7,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.25,2.25,0,0,1,.76-1.35,9.81,9.81,0,0,1,1.16-1.07A22.94,22.94,0,0,1,386.77,168.39Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M375.59,173.59c1.05.21,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C374.67,171.55,374.18,173.31,375.59,173.59Z"
                  fill="#1b6817"
                />
                <path
                  d="M378.3,170.28c-.62.44-1.25.88-1.83,1.36a7.68,7.68,0,0,0-.85.76,1.93,1.93,0,0,0-.6.94,1.72,1.72,0,0,1,.56-1,10.34,10.34,0,0,1,.84-.78A17.45,17.45,0,0,1,378.3,170.28Z"
                  fill="#30562e"
                />
              </g>
              <path
                d="M375.48,178.77a6,6,0,0,1-1.09-2,3.13,3.13,0,0,1,.15-2.33,8.22,8.22,0,0,0,.36-2.18c.05-.75.05-1.51.05-2.27a10.86,10.86,0,0,1,.28,2.28,7.28,7.28,0,0,1-.28,2.31,3.1,3.1,0,0,0-.32,1,4.33,4.33,0,0,0,.08,1.07A9.92,9.92,0,0,0,375.48,178.77Z"
                fill="#30562e"
              />
              <path
                d="M379.56,172.09c-.06.28-.23.56-.3.8s.15.48.24.74a6.33,6.33,0,0,1,.48,1.69,7.88,7.88,0,0,1-.42,3.45c0-.58.06-1.15.07-1.72a10.45,10.45,0,0,0-.08-1.68,8.77,8.77,0,0,0-.36-1.64,1.85,1.85,0,0,1-.13-.91C379.23,172.54,379.4,172.35,379.56,172.09Z"
                fill="#30562e"
              />
              <path
                d="M383.1,169.08a4.53,4.53,0,0,1-.68,1c-.26.3-.51.61-.4.93a2.42,2.42,0,0,0,.57.93,3.78,3.78,0,0,1,.63,1.1,7,7,0,0,1,.29,2.43,9.06,9.06,0,0,1-.41,2.38,21.11,21.11,0,0,0,.08-2.38,7.51,7.51,0,0,0-.37-2.28,3,3,0,0,0-.52-1,2.57,2.57,0,0,1-.6-1.13.93.93,0,0,1,.16-.67,2.39,2.39,0,0,1,.42-.47A5.56,5.56,0,0,0,383.1,169.08Z"
                fill="#30562e"
              />
              <g>
                <path
                  d="M383.84,177.09c1.05.21,2-2.21,2.71-3.31a7.33,7.33,0,0,0-2.73.7C382.92,175.06,382.43,176.82,383.84,177.09Z"
                  fill="#1b6817"
                />
                <path
                  d="M382.88,178.68c1,.2,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C382,176.64,381.46,178.4,382.88,178.68Z"
                  fill="#1b6817"
                />
                <path
                  d="M386.55,173.78c-.62.45-1.25.88-1.83,1.37a7.6,7.6,0,0,0-.85.75,1.84,1.84,0,0,0-.59.94,1.65,1.65,0,0,1,.55-1,10.34,10.34,0,0,1,.84-.78A19,19,0,0,1,386.55,173.78Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M380.57,178.47c1.44.28,2.77-3.05,3.73-4.56a10,10,0,0,0-3.76,1C379.3,175.67,378.62,178.09,380.57,178.47Z"
                  fill="#1c7f19"
                />
                <path
                  d="M384.3,173.91c-.86.61-1.72,1.21-2.52,1.88a12.91,12.91,0,0,0-1.18,1,2.57,2.57,0,0,0-.81,1.29,2.42,2.42,0,0,1,.76-1.35,13.13,13.13,0,0,1,1.16-1.07A24.32,24.32,0,0,1,384.3,173.91Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M378.69,174c-1.05.2-2-2.22-2.71-3.31a7.24,7.24,0,0,1,2.73.69C379.61,172,380.1,173.75,378.69,174Z"
                  fill="#1c7f19"
                />
                <path
                  d="M376,170.72a16.12,16.12,0,0,1,1.88,1.3,7.86,7.86,0,0,1,.85.78,1.73,1.73,0,0,1,.55,1,1.87,1.87,0,0,0-.59-.95,10.26,10.26,0,0,0-.86-.75C377.23,171.59,376.6,171.16,376,170.72Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M383.16,170.68c-1.14-.43-.17-2.27-.3-3s1-1.27,1.92-.82.38,1.23,1.13,1.7S384.09,171,383.16,170.68Z"
                  fill="#bc784a"
                />
                <path
                  d="M382.66,170.77c-1.21-.13-.72-2.15-1-2.86s.67-1.48,1.66-1.28.67,1.1,1.51,1.36S383.65,170.87,382.66,170.77Z"
                  fill="#ed863a"
                />
                <path
                  d="M382.61,170.93c-1.22-.13-.16-1.82-.48-2.52s.06-1.36,1.05-1.16.63.58,1.46.85S383.59,171,382.61,170.93Z"
                  fill="#bc784a"
                />
                <path
                  d="M382.77,171.27c-1.08-.32-.29-1.87-.46-2.5s.86-1.08,1.72-.74.43,1,1.14,1.37S383.64,171.53,382.77,171.27Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M379.32,171.29c-1.2-.23-.55-2.21-.81-2.93s.78-1.43,1.75-1.15.59,1.15,1.4,1.48S380.3,171.47,379.32,171.29Z"
                  fill="#bc784a"
                />
                <path
                  d="M378.84,171.47c-1.21.08-1.07-2-1.5-2.64s.41-1.57,1.42-1.55.85,1,1.72,1.08S379.83,171.4,378.84,171.47Z"
                  fill="#ed863a"
                />
                <path
                  d="M378.82,171.64c-1.22.08-.47-1.77-.89-2.41s-.18-1.34.83-1.32.72.46,1.59.58S379.81,171.57,378.82,171.64Z"
                  fill="#bc784a"
                />
                <path
                  d="M379,171.94c-1.11-.12-.6-1.79-.87-2.38s.66-1.22,1.57-1,.59.91,1.35,1.15S379.94,172.05,379,171.94Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M375.67,170.14c1.2-.23.55-2.2.81-2.93s-.78-1.43-1.76-1.15-.58,1.15-1.39,1.48S374.69,170.32,375.67,170.14Z"
                  fill="#bc784a"
                />
                <path
                  d="M376.14,170.32c1.22.09,1.08-2,1.51-2.64s-.41-1.57-1.42-1.55-.85,1-1.72,1.08S375.16,170.25,376.14,170.32Z"
                  fill="#ed863a"
                />
                <path
                  d="M376.17,170.49c1.22.08.46-1.76.89-2.4s.18-1.35-.83-1.33-.72.46-1.59.58S375.18,170.42,376.17,170.49Z"
                  fill="#bc784a"
                />
                <path
                  d="M376,170.8c1.12-.13.61-1.8.88-2.39s-.66-1.22-1.57-1-.59.92-1.35,1.15S375.05,170.9,376,170.8Z"
                  fill="#ed863a"
                />
              </g>
              <ellipse
                cx="384.42"
                cy="176.2"
                rx="0.77"
                ry="0.23"
                transform="translate(2.59 357.95) rotate(-50.08)"
                fill="#b2eff9"
                opacity="0.25"
              />
            </g>
          </g>
          <g>
            <ellipse
              cx="405.86"
              cy="183"
              rx="7.67"
              ry="3"
              fill="#141c66"
              opacity="0.28"
            />
            <g>
              <path d="M394.52,173.53h0Z" fill="#ef6291" />
              <path
                d="M412.6,169.85v0c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85Z"
                fill="#ef6291"
              />
              <path
                d="M409,181.2h0v.05c0,.6-2.34,1.09-5.23,1.09s-5.23-.49-5.23-1.09a.11.11,0,0,1,0-.05h-.05l-3.94-7.72H412.6Z"
                fill="#c1567f"
              />
              <path
                d="M412.6,169.87c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85,4-1.84,8.89-1.84,9.15.83,9.19,1.84Z"
                fill="#c16f86"
              />
              <path
                d="M411.58,169.86c0,.91-3.79,1.63-8.15,1.63s-7.89-.73-7.89-1.64,3.53-1.64,7.89-1.64S411.58,169,411.58,169.86Z"
                fill="#513126"
              />
              <path
                d="M408.85,181.48c-6.28.31-6.07-7.4-6.07-7.4l-8.1-.29,3.78,7.41h.05a.11.11,0,0,0,0,.05c0,.6,2.34,1.09,5.23,1.09C406.25,182.34,408.36,182,408.85,181.48Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M412.6,169.87v3.66h0c0,1-4.13,1.85-9,1.85s-9-.83-9.05-1.85h0v-3.68c0,1,4,1.85,8.89,1.85S412.6,170.89,412.6,169.87Z"
                fill="#ef6291"
              />
              <path
                d="M399.31,171.49h0c-2.85-.31-4.79-.93-4.79-1.64v3.68h0c0,.87,3.06,1.61,7,1.8C398.59,174.67,399.31,171.49,399.31,171.49Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <g>
                <path
                  d="M397.28,168.12c-1.44.28-2.77-3.05-3.73-4.56a10.16,10.16,0,0,1,3.76.95C398.55,165.31,399.23,167.74,397.28,168.12Z"
                  fill="#1c7f19"
                />
                <path
                  d="M393.55,163.56a24.32,24.32,0,0,1,2.59,1.79,10.74,10.74,0,0,1,1.16,1.07,2.25,2.25,0,0,1,.76,1.35,2.59,2.59,0,0,0-.81-1.3,11.6,11.6,0,0,0-1.18-1C395.27,164.77,394.41,164.17,393.55,163.56Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M405.81,166.64c-1.44.28-2.77-3-3.72-4.56a10,10,0,0,1,3.75,1C407.08,163.84,407.76,166.26,405.81,166.64Z"
                  fill="#1c7f19"
                />
                <path
                  d="M402.09,162.08a25.38,25.38,0,0,1,2.59,1.79,13,13,0,0,1,1.15,1.07,2.31,2.31,0,0,1,.76,1.35,2.57,2.57,0,0,0-.81-1.29,12.79,12.79,0,0,0-1.17-1C403.8,163.29,402.94,162.69,402.09,162.08Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M402.33,171.18c-1.44.28-2.78-3.05-3.73-4.55a9.87,9.87,0,0,1,3.75,1C403.59,168.38,404.27,170.8,402.33,171.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M398.6,166.63a23.79,23.79,0,0,1,2.59,1.78,13.13,13.13,0,0,1,1.16,1.08,2.36,2.36,0,0,1,.76,1.35,2.61,2.61,0,0,0-.82-1.3,11.58,11.58,0,0,0-1.17-1C400.32,167.83,399.45,167.23,398.6,166.63Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M398.56,171.18c-1,.2-2-2.19-2.68-3.28a7.1,7.1,0,0,1,2.7.69C399.47,169.16,400,170.9,398.56,171.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M395.88,167.9a18.14,18.14,0,0,1,1.86,1.29,7.57,7.57,0,0,1,.83.77,1.65,1.65,0,0,1,.55,1,1.82,1.82,0,0,0-.59-.93,10,10,0,0,0-.84-.75C397.11,168.77,396.49,168.34,395.88,167.9Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M398.4,164.33c-1,.21-2-2.21-2.71-3.31a7.33,7.33,0,0,1,2.73.7C399.32,162.3,399.81,164.06,398.4,164.33Z"
                  fill="#1c7f19"
                />
                <path
                  d="M395.69,161a19,19,0,0,1,1.88,1.3,10.34,10.34,0,0,1,.84.78,1.7,1.7,0,0,1,.55,1,1.84,1.84,0,0,0-.59-.94,7.6,7.6,0,0,0-.85-.75C396.94,161.9,396.31,161.47,395.69,161Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M399.58,169.38c1.44.28,2.77-3,3.73-4.56a10,10,0,0,0-3.76,1C398.31,166.57,397.63,169,399.58,169.38Z"
                  fill="#1c7f19"
                />
                <path
                  d="M403.31,164.82c-.86.61-1.72,1.2-2.52,1.88a12.8,12.8,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.36,2.36,0,0,1,.76-1.35,11.76,11.76,0,0,1,1.16-1.07A24.32,24.32,0,0,1,403.31,164.82Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M407,164.94c1.44.29,2.77-3.05,3.73-4.55a10,10,0,0,0-3.76,1C405.77,162.14,405.09,164.56,407,164.94Z"
                  fill="#1c7f19"
                />
                <path
                  d="M410.77,160.39c-.86.61-1.72,1.2-2.52,1.87a11.7,11.7,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.25,2.25,0,0,1,.76-1.35,9.81,9.81,0,0,1,1.16-1.07A22.94,22.94,0,0,1,410.77,160.39Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M399.59,165.59c1.05.21,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C398.67,163.55,398.18,165.31,399.59,165.59Z"
                  fill="#1b6817"
                />
                <path
                  d="M402.3,162.28c-.62.44-1.25.88-1.83,1.36a7.68,7.68,0,0,0-.85.76,1.93,1.93,0,0,0-.6.94,1.72,1.72,0,0,1,.56-1,10.34,10.34,0,0,1,.84-.78A17.45,17.45,0,0,1,402.3,162.28Z"
                  fill="#30562e"
                />
              </g>
              <path
                d="M399.48,170.77a6,6,0,0,1-1.09-2,3.13,3.13,0,0,1,.15-2.33,8.22,8.22,0,0,0,.36-2.18c.05-.75.05-1.51.05-2.27a10.86,10.86,0,0,1,.28,2.28,7.28,7.28,0,0,1-.28,2.31,3.1,3.1,0,0,0-.32,1,4.33,4.33,0,0,0,.08,1.07A9.92,9.92,0,0,0,399.48,170.77Z"
                fill="#30562e"
              />
              <path
                d="M403.56,164.09c-.06.28-.23.56-.3.8s.15.48.24.74a6.33,6.33,0,0,1,.48,1.69,7.88,7.88,0,0,1-.42,3.45c0-.58.06-1.15.07-1.72a10.45,10.45,0,0,0-.08-1.68,8.77,8.77,0,0,0-.36-1.64,1.85,1.85,0,0,1-.13-.91C403.23,164.54,403.4,164.35,403.56,164.09Z"
                fill="#30562e"
              />
              <path
                d="M407.1,161.08a4.53,4.53,0,0,1-.68,1c-.26.3-.51.61-.4.93a2.42,2.42,0,0,0,.57.93,3.78,3.78,0,0,1,.63,1.1,7,7,0,0,1,.29,2.43,9.06,9.06,0,0,1-.41,2.38,21.11,21.11,0,0,0,.08-2.38,7.51,7.51,0,0,0-.37-2.28,3,3,0,0,0-.52-1,2.57,2.57,0,0,1-.6-1.13.93.93,0,0,1,.16-.67,2.39,2.39,0,0,1,.42-.47A5.56,5.56,0,0,0,407.1,161.08Z"
                fill="#30562e"
              />
              <g>
                <path
                  d="M407.84,169.09c1.05.21,2-2.21,2.71-3.31a7.33,7.33,0,0,0-2.73.7C406.92,167.06,406.43,168.82,407.84,169.09Z"
                  fill="#1b6817"
                />
                <path
                  d="M406.88,170.68c1,.2,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C406,168.64,405.46,170.4,406.88,170.68Z"
                  fill="#1b6817"
                />
                <path
                  d="M410.55,165.78c-.62.45-1.25.88-1.83,1.37a7.6,7.6,0,0,0-.85.75,1.84,1.84,0,0,0-.59.94,1.65,1.65,0,0,1,.55-1,10.34,10.34,0,0,1,.84-.78A19,19,0,0,1,410.55,165.78Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M404.57,170.47c1.44.28,2.77-3.05,3.73-4.56a10,10,0,0,0-3.76,1C403.3,167.67,402.62,170.09,404.57,170.47Z"
                  fill="#1c7f19"
                />
                <path
                  d="M408.3,165.91c-.86.61-1.72,1.21-2.52,1.88a12.91,12.91,0,0,0-1.18,1,2.57,2.57,0,0,0-.81,1.29,2.42,2.42,0,0,1,.76-1.35,13.13,13.13,0,0,1,1.16-1.07A24.32,24.32,0,0,1,408.3,165.91Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M402.69,166c-1.05.2-2-2.22-2.71-3.31a7.24,7.24,0,0,1,2.73.69C403.61,164,404.1,165.75,402.69,166Z"
                  fill="#1c7f19"
                />
                <path
                  d="M400,162.72a16.12,16.12,0,0,1,1.88,1.3,7.86,7.86,0,0,1,.85.78,1.73,1.73,0,0,1,.55,1,1.87,1.87,0,0,0-.59-.95,10.26,10.26,0,0,0-.86-.75C401.23,163.59,400.6,163.16,400,162.72Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M407.16,162.68c-1.14-.43-.17-2.27-.3-3s1-1.27,1.92-.82.38,1.23,1.13,1.7S408.09,163,407.16,162.68Z"
                  fill="#bc784a"
                />
                <path
                  d="M406.66,162.77c-1.21-.13-.72-2.15-1-2.86s.67-1.48,1.66-1.28.67,1.1,1.51,1.36S407.65,162.87,406.66,162.77Z"
                  fill="#ed863a"
                />
                <path
                  d="M406.61,162.93c-1.22-.13-.16-1.82-.48-2.52s.06-1.36,1.05-1.16.63.58,1.46.85S407.59,163,406.61,162.93Z"
                  fill="#bc784a"
                />
                <path
                  d="M406.77,163.27c-1.08-.32-.29-1.87-.46-2.5s.86-1.08,1.72-.74.43,1,1.14,1.37S407.64,163.53,406.77,163.27Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M403.32,163.29c-1.2-.23-.55-2.21-.81-2.93s.78-1.43,1.75-1.15.59,1.15,1.4,1.48S404.3,163.47,403.32,163.29Z"
                  fill="#bc784a"
                />
                <path
                  d="M402.84,163.47c-1.21.08-1.07-2-1.5-2.64s.41-1.57,1.42-1.55.85,1,1.72,1.08S403.83,163.4,402.84,163.47Z"
                  fill="#ed863a"
                />
                <path
                  d="M402.82,163.64c-1.22.08-.47-1.77-.89-2.41s-.18-1.34.83-1.32.72.46,1.59.58S403.81,163.57,402.82,163.64Z"
                  fill="#bc784a"
                />
                <path
                  d="M403,163.94c-1.11-.12-.6-1.79-.87-2.38s.66-1.22,1.57-1,.59.91,1.35,1.15S403.94,164.05,403,163.94Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M399.67,162.14c1.2-.23.55-2.2.81-2.93s-.78-1.43-1.76-1.15-.58,1.15-1.39,1.48S398.69,162.32,399.67,162.14Z"
                  fill="#bc784a"
                />
                <path
                  d="M400.14,162.32c1.22.09,1.08-2,1.51-2.64s-.41-1.57-1.42-1.55-.85,1-1.72,1.08S399.16,162.25,400.14,162.32Z"
                  fill="#ed863a"
                />
                <path
                  d="M400.17,162.49c1.22.08.46-1.76.89-2.4s.18-1.35-.83-1.33-.72.46-1.59.58S399.18,162.42,400.17,162.49Z"
                  fill="#bc784a"
                />
                <path
                  d="M400,162.8c1.12-.13.61-1.8.88-2.39s-.66-1.22-1.57-1-.59.92-1.35,1.15S399.05,162.9,400,162.8Z"
                  fill="#ed863a"
                />
              </g>
              <ellipse
                cx="408.42"
                cy="168.2"
                rx="0.77"
                ry="0.23"
                transform="translate(17.32 373.49) rotate(-50.08)"
                fill="#b2eff9"
                opacity="0.25"
              />
            </g>
          </g>
          <g>
            <ellipse
              cx="430.86"
              cy="173"
              rx="7.67"
              ry="3"
              fill="#141c66"
              opacity="0.28"
            />
            <g>
              <path d="M419.52,163.53h0Z" fill="#ef6291" />
              <path
                d="M437.6,159.85v0c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85Z"
                fill="#ef6291"
              />
              <path
                d="M434,171.2h0v.05c0,.6-2.34,1.09-5.23,1.09s-5.23-.49-5.23-1.09a.11.11,0,0,1,0-.05h-.05l-3.94-7.72H437.6Z"
                fill="#c1567f"
              />
              <path
                d="M437.6,159.87c0,1-4.28,1.83-9.19,1.83s-8.89-.83-8.89-1.85,4-1.84,8.89-1.84,9.15.83,9.19,1.84Z"
                fill="#c16f86"
              />
              <path
                d="M436.58,159.86c0,.91-3.79,1.63-8.15,1.63s-7.89-.73-7.89-1.64,3.53-1.64,7.89-1.64S436.58,159,436.58,159.86Z"
                fill="#513126"
              />
              <path
                d="M433.85,171.48c-6.28.31-6.07-7.4-6.07-7.4l-8.1-.29,3.78,7.41h.05a.11.11,0,0,0,0,.05c0,.6,2.34,1.09,5.23,1.09C431.25,172.34,433.36,172,433.85,171.48Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <path
                d="M437.6,159.87v3.66h0c0,1-4.13,1.85-9,1.85s-9-.83-9.05-1.85h0v-3.68c0,1,4,1.85,8.89,1.85S437.6,160.89,437.6,159.87Z"
                fill="#ef6291"
              />
              <path
                d="M424.31,161.49h0c-2.85-.31-4.79-.93-4.79-1.64v3.68h0c0,.87,3.06,1.61,7,1.8C423.59,164.67,424.31,161.49,424.31,161.49Z"
                fill="#602b8e"
                opacity="0.35"
              />
              <g>
                <path
                  d="M422.28,158.12c-1.44.28-2.77-3.05-3.73-4.56a10.16,10.16,0,0,1,3.76.95C423.55,155.31,424.23,157.74,422.28,158.12Z"
                  fill="#1c7f19"
                />
                <path
                  d="M418.55,153.56a24.32,24.32,0,0,1,2.59,1.79,10.74,10.74,0,0,1,1.16,1.07,2.25,2.25,0,0,1,.76,1.35,2.59,2.59,0,0,0-.81-1.3,11.6,11.6,0,0,0-1.18-1C420.27,154.77,419.41,154.17,418.55,153.56Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M430.81,156.64c-1.44.28-2.77-3-3.72-4.56a10,10,0,0,1,3.75,1C432.08,153.84,432.76,156.26,430.81,156.64Z"
                  fill="#1c7f19"
                />
                <path
                  d="M427.09,152.08a25.38,25.38,0,0,1,2.59,1.79,13,13,0,0,1,1.15,1.07,2.31,2.31,0,0,1,.76,1.35,2.57,2.57,0,0,0-.81-1.29,12.79,12.79,0,0,0-1.17-1C428.8,153.29,427.94,152.69,427.09,152.08Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M427.33,161.18c-1.44.28-2.78-3.05-3.73-4.55a9.87,9.87,0,0,1,3.75,1C428.59,158.38,429.27,160.8,427.33,161.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M423.6,156.63a23.79,23.79,0,0,1,2.59,1.78,13.13,13.13,0,0,1,1.16,1.08,2.36,2.36,0,0,1,.76,1.35,2.61,2.61,0,0,0-.82-1.3,11.58,11.58,0,0,0-1.17-1C425.32,157.83,424.45,157.23,423.6,156.63Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M423.56,161.18c-1,.2-2-2.19-2.68-3.28a7.1,7.1,0,0,1,2.7.69C424.47,159.16,425,160.9,423.56,161.18Z"
                  fill="#1b6817"
                />
                <path
                  d="M420.88,157.9a18.14,18.14,0,0,1,1.86,1.29,7.57,7.57,0,0,1,.83.77,1.65,1.65,0,0,1,.55,1,1.82,1.82,0,0,0-.59-.93,10,10,0,0,0-.84-.75C422.11,158.77,421.49,158.34,420.88,157.9Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M423.4,154.33c-1,.21-2-2.21-2.71-3.31a7.33,7.33,0,0,1,2.73.7C424.32,152.3,424.81,154.06,423.4,154.33Z"
                  fill="#1c7f19"
                />
                <path
                  d="M420.69,151a19,19,0,0,1,1.88,1.3,10.34,10.34,0,0,1,.84.78,1.7,1.7,0,0,1,.55,1,1.84,1.84,0,0,0-.59-.94,7.6,7.6,0,0,0-.85-.75C421.94,151.9,421.31,151.47,420.69,151Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M424.58,159.38c1.44.28,2.77-3,3.73-4.56a10,10,0,0,0-3.76,1C423.31,156.57,422.63,159,424.58,159.38Z"
                  fill="#1c7f19"
                />
                <path
                  d="M428.31,154.82c-.86.61-1.72,1.2-2.52,1.88a12.8,12.8,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.36,2.36,0,0,1,.76-1.35,11.76,11.76,0,0,1,1.16-1.07A24.32,24.32,0,0,1,428.31,154.82Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M432,154.94c1.44.29,2.77-3.05,3.73-4.55a10,10,0,0,0-3.76,1C430.77,152.14,430.09,154.56,432,154.94Z"
                  fill="#1c7f19"
                />
                <path
                  d="M435.77,150.39c-.86.61-1.72,1.2-2.52,1.87a11.7,11.7,0,0,0-1.18,1,2.59,2.59,0,0,0-.81,1.3,2.25,2.25,0,0,1,.76-1.35,9.81,9.81,0,0,1,1.16-1.07A22.94,22.94,0,0,1,435.77,150.39Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M424.59,155.59c1.05.21,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C423.67,153.55,423.18,155.31,424.59,155.59Z"
                  fill="#1b6817"
                />
                <path
                  d="M427.3,152.28c-.62.44-1.25.88-1.83,1.36a7.68,7.68,0,0,0-.85.76,1.93,1.93,0,0,0-.6.94,1.72,1.72,0,0,1,.56-1,10.34,10.34,0,0,1,.84-.78A17.45,17.45,0,0,1,427.3,152.28Z"
                  fill="#30562e"
                />
              </g>
              <path
                d="M424.48,160.77a6,6,0,0,1-1.09-2,3.13,3.13,0,0,1,.15-2.33,8.22,8.22,0,0,0,.36-2.18c.05-.75.05-1.51.05-2.27a10.86,10.86,0,0,1,.28,2.28,7.28,7.28,0,0,1-.28,2.31,3.1,3.1,0,0,0-.32,1,4.33,4.33,0,0,0,.08,1.07A9.92,9.92,0,0,0,424.48,160.77Z"
                fill="#30562e"
              />
              <path
                d="M428.56,154.09c-.06.28-.23.56-.3.8s.15.48.24.74a6.33,6.33,0,0,1,.48,1.69,7.88,7.88,0,0,1-.42,3.45c0-.58.06-1.15.07-1.72a10.45,10.45,0,0,0-.08-1.68,8.77,8.77,0,0,0-.36-1.64,1.85,1.85,0,0,1-.13-.91C428.23,154.54,428.4,154.35,428.56,154.09Z"
                fill="#30562e"
              />
              <path
                d="M432.1,151.08a4.53,4.53,0,0,1-.68,1c-.26.3-.51.61-.4.93a2.42,2.42,0,0,0,.57.93,3.78,3.78,0,0,1,.63,1.1,7,7,0,0,1,.29,2.43,9.06,9.06,0,0,1-.41,2.38,21.11,21.11,0,0,0,.08-2.38,7.51,7.51,0,0,0-.37-2.28,3,3,0,0,0-.52-1,2.57,2.57,0,0,1-.6-1.13.93.93,0,0,1,.16-.67,2.39,2.39,0,0,1,.42-.47A5.56,5.56,0,0,0,432.1,151.08Z"
                fill="#30562e"
              />
              <g>
                <path
                  d="M432.84,159.09c1.05.21,2-2.21,2.71-3.31a7.33,7.33,0,0,0-2.73.7C431.92,157.06,431.43,158.82,432.84,159.09Z"
                  fill="#1b6817"
                />
                <path
                  d="M431.88,160.68c1,.2,2-2.22,2.71-3.31a7.24,7.24,0,0,0-2.73.69C431,158.64,430.46,160.4,431.88,160.68Z"
                  fill="#1b6817"
                />
                <path
                  d="M435.55,155.78c-.62.45-1.25.88-1.83,1.37a7.6,7.6,0,0,0-.85.75,1.84,1.84,0,0,0-.59.94,1.65,1.65,0,0,1,.55-1,10.34,10.34,0,0,1,.84-.78A19,19,0,0,1,435.55,155.78Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M429.57,160.47c1.44.28,2.77-3.05,3.73-4.56a10,10,0,0,0-3.76,1C428.3,157.67,427.62,160.09,429.57,160.47Z"
                  fill="#1c7f19"
                />
                <path
                  d="M433.3,155.91c-.86.61-1.72,1.21-2.52,1.88a12.91,12.91,0,0,0-1.18,1,2.57,2.57,0,0,0-.81,1.29,2.42,2.42,0,0,1,.76-1.35,13.13,13.13,0,0,1,1.16-1.07A24.32,24.32,0,0,1,433.3,155.91Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M427.69,156c-1.05.2-2-2.22-2.71-3.31a7.24,7.24,0,0,1,2.73.69C428.61,154,429.1,155.75,427.69,156Z"
                  fill="#1c7f19"
                />
                <path
                  d="M425,152.72a16.12,16.12,0,0,1,1.88,1.3,7.86,7.86,0,0,1,.85.78,1.73,1.73,0,0,1,.55,1,1.87,1.87,0,0,0-.59-.95,10.26,10.26,0,0,0-.86-.75C426.23,153.59,425.6,153.16,425,152.72Z"
                  fill="#30562e"
                />
              </g>
              <g>
                <path
                  d="M432.16,152.68c-1.14-.43-.17-2.27-.3-3s1-1.27,1.92-.82.38,1.23,1.13,1.7S433.09,153,432.16,152.68Z"
                  fill="#bc784a"
                />
                <path
                  d="M431.66,152.77c-1.21-.13-.72-2.15-1-2.86s.67-1.48,1.66-1.28.67,1.1,1.51,1.36S432.65,152.87,431.66,152.77Z"
                  fill="#ed863a"
                />
                <path
                  d="M431.61,152.93c-1.22-.13-.16-1.82-.48-2.52s.06-1.36,1.05-1.16.63.58,1.46.85S432.59,153,431.61,152.93Z"
                  fill="#bc784a"
                />
                <path
                  d="M431.77,153.27c-1.08-.32-.29-1.87-.46-2.5s.86-1.08,1.72-.74.43,1,1.14,1.37S432.64,153.53,431.77,153.27Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M428.32,153.29c-1.2-.23-.55-2.21-.81-2.93s.78-1.43,1.75-1.15.59,1.15,1.4,1.48S429.3,153.47,428.32,153.29Z"
                  fill="#bc784a"
                />
                <path
                  d="M427.84,153.47c-1.21.08-1.07-2-1.5-2.64s.41-1.57,1.42-1.55.85,1,1.72,1.08S428.83,153.4,427.84,153.47Z"
                  fill="#ed863a"
                />
                <path
                  d="M427.82,153.64c-1.22.08-.47-1.77-.89-2.41s-.18-1.34.83-1.32.72.46,1.59.58S428.81,153.57,427.82,153.64Z"
                  fill="#bc784a"
                />
                <path
                  d="M428,153.94c-1.11-.12-.6-1.79-.87-2.38s.66-1.22,1.57-1,.59.91,1.35,1.15S428.94,154.05,428,153.94Z"
                  fill="#ed863a"
                />
              </g>
              <g>
                <path
                  d="M424.67,152.14c1.2-.23.55-2.2.81-2.93s-.78-1.43-1.76-1.15-.58,1.15-1.39,1.48S423.69,152.32,424.67,152.14Z"
                  fill="#bc784a"
                />
                <path
                  d="M425.14,152.32c1.22.09,1.08-2,1.51-2.64s-.41-1.57-1.42-1.55-.85,1-1.72,1.08S424.16,152.25,425.14,152.32Z"
                  fill="#ed863a"
                />
                <path
                  d="M425.17,152.49c1.22.08.46-1.76.89-2.4s.18-1.35-.83-1.33-.72.46-1.59.58S424.18,152.42,425.17,152.49Z"
                  fill="#bc784a"
                />
                <path
                  d="M425,152.8c1.12-.13.61-1.8.88-2.39s-.66-1.22-1.57-1-.59.92-1.35,1.15S424.05,152.9,425,152.8Z"
                  fill="#ed863a"
                />
              </g>
              <ellipse
                cx="433.42"
                cy="158.2"
                rx="0.77"
                ry="0.23"
                transform="translate(33.95 389.08) rotate(-50.08)"
                fill="#b2eff9"
                opacity="0.25"
              />
            </g>
          </g>
          <g>
            <g opacity="0.2">
              <path
                d="M214.83,80.67c4.79-.49,6-.37,7.63-2.89s-.93-1.9,3.88-4.2,3.61-6.45,2.67-8-10.24-5.46-11.57-2.62-7.24,8.08-8.71,7.22S209.19,81.25,214.83,80.67Z"
                fill="#141c66"
              />
              <path
                d="M221.48,73.57c1.74-1.42,4.49.74,4.64-.75s1.49-4.13-.26-4.14-3.86.56-3.44-.78-.09-2.08-1.35-1.79-2.17,1.53-2.64.3-1.27-1.34-2.14-.47.07,1.32-.61,2.85,1.69,4.35,2,3.37S221.48,73.57,221.48,73.57Z"
                fill="#141c66"
              />
              <path
                d="M228.37,76.28c3.42-.28,7.09.18,6.65,3.73s-6.57,2.81-6.94,5.23-4.14,4.81-5.08,3.83-4.8-6.09-6.42-7-.65-4.31,1.54-6S228.37,76.28,228.37,76.28Z"
                fill="#141c66"
              />
              <path
                d="M208.85,78.9c0,5.4,9.25-1.21,5.7-4.3s-4.24-4.46-3.5-6.86-4.33-3.17-5.21-2.66-2.92,3.52-2.18,6.13S208.86,75.67,208.85,78.9Z"
                fill="#141c66"
              />
              <path
                d="M212.37,87.36c-5.2-1.46,3.7-8.56,5.7-4.29s3.13,5.3,5.64,5.24,1.85,5,1.11,5.75-4.19,1.83-6.49.4S215.48,88.24,212.37,87.36Z"
                fill="#141c66"
              />
              <path
                d="M218.72,89.28c1.34-.24.53,2.61.53,2.61s1.2-1,2.25-.62.14,1.68.14,1.68c1-.62,1.51,1.88,0,2.17h0a5.45,5.45,0,0,1-3.34-.66,4.45,4.45,0,0,1-1.28-1.31l-.88-2.09A5.29,5.29,0,0,1,218.72,89.28Z"
                fill="#141c66"
              />
              <path
                d="M211.73,83.47c-1.72.22-12.86,8-17,12.84,0,0-1.81-3.55-3.06-4.13-.4.15-.11-.07-.11-.07s18.34-7,19.92-14.15-5.94-7.89-5.94-7.89,3.44-.85,5.48,1.44,1.41,8,.91,8.66c0,0,4.85-3.45,5.36-6.23s3.18-1.74,3.18-1.74-2.14-1.55-3.91,4.89c-.93,3.35-5.92,5.23-5.92,5.23s4-1.36,5.26,1.76-.57,7,1.46,9.26A16,16,0,0,1,215,87,3.77,3.77,0,0,0,211.73,83.47Z"
                fill="#141c66"
              />
              <path
                d="M214.93,86.65a3.74,3.74,0,0,0-3.2-3.18A18.86,18.86,0,0,0,207.27,86c2.11-2.81,6.36-3.83,7-3.6a3.09,3.09,0,0,1,1.62,1.72,7.16,7.16,0,0,1,.47,2.33Z"
                fill="#141c66"
              />
              <path
                d="M211.41,79.9a10.1,10.1,0,0,1-4.2,3.65h0c2.18-1.77,3.82-3.68,4.24-5.59a8.15,8.15,0,0,0,.19-1.21l.34-.5A7.18,7.18,0,0,1,211.41,79.9Z"
                fill="#141c66"
              />
              <path
                d="M214.89,85.54c1,.72,2.38-.22,3.15.95S217.3,89,217,90.73s.46,2.3.66,3.31-5.87,1.24-6.37-2.42-.56-3.23-.65-4.56S212.62,84,214.89,85.54Z"
                fill="#141c66"
              />
              <g>
                <path
                  d="M213.25,79.12c-.05.06-.06.06,0,0l0,0Z"
                  fill="#141c66"
                />
                <path
                  d="M213.79,78.64c1.43-1.26,3.18-3.09,3.47-4.7a2.4,2.4,0,0,1,.74-1.47l.42.38a11.15,11.15,0,0,0-1.89,4.24c0,.06,0,.11-.05.16C215.56,77.81,214.48,78.21,213.79,78.64Z"
                  fill="#141c66"
                />
              </g>
              <path
                d="M211.25,75c.31-1.2,2-1.38,1.78-2.77s-2.2-1.44-3.58-2.52-1.14-2-1.65-2.94-5.27,2.87-3.27,6,1.67,2.82,2.47,3.89S210.56,77.71,211.25,75Z"
                fill="#141c66"
              />
              <path
                d="M221.33,69.38c1.49-.12,3.1.08,2.9,1.63s-2.87,1.23-3,2.29S219.39,75.4,219,75s-2.1-2.66-2.81-3-.29-1.89.67-2.63S221.33,69.38,221.33,69.38Z"
                fill="#141c66"
              />
              <path
                d="M205.23,71.46c-.14.39.32.9.69,1.11s1.46-.32,1.67.31-.1,1.26.49,1.7,1-.26,1.56.45.75,1.54.39,1.84l-.09.07h0l-.1,0a2.3,2.3,0,0,1-2.84-.32c-.8-1.07-.47-.78-2.47-3.89a3,3,0,0,1-.47-1.34C204,71,205.37,71.06,205.23,71.46Z"
                fill="#141c66"
              />
              <path
                d="M211.13,87.75c.54.72.84,2.74,1.7,2.4s2.11,1,1.9,1.37a1.79,1.79,0,0,0,.67,1.9c.63.29.35,1.27-.08,1.24-1.71-.13-3.8-1-4.08-3-.35-2.54-.49-3.11-.56-3.67C210.67,87.69,210.71,87.2,211.13,87.75Z"
                fill="#141c66"
              />
              <path
                d="M217.35,78.87c1.36-.3,2,.95,2.46,1.83s-.76,1.44.2,1.69.81,2.5-.43,2.62h0a15.3,15.3,0,0,0-3-2.9c-1-.54-1-2.06-.36-3.55l.37-.71h0S216,79.18,217.35,78.87Z"
                fill="#141c66"
              />
              <path
                d="M224.21,86.68c.69-1,2.45-.27,1.69-1.28s-3-1.91-1.43-2.85,2-2,1.09-3,.81-3.67,1.81-3.46-3.63-2.68-3.81.26.8,3.23,0,3.71-2.22,1.67-1.42,3.21-2.37,1.18-2,2.52S222.35,89.3,224.21,86.68Z"
                fill="#141c66"
              />
              <path
                d="M191.53,92.11s1.14-.44,2.87-1.2c3.45,1.66,8.14-1.57,8.27-1.66a57.46,57.46,0,0,0-8,7.06s-1.81-3.55-3.06-4.13C191.24,92.33,191.53,92.11,191.53,92.11Z"
                fill="#141c66"
              />
              <path
                d="M194.11,95.25a13.77,13.77,0,0,0,2.07-2A23.46,23.46,0,0,1,200,90.3c1.27-.81,6.06-3.81,6.56-4.44s1.75-2.34,3-2.57,2.58-.57,3.58,0a5.48,5.48,0,0,1,1.69,2.25"
                fill="#141c66"
              />
              <path
                d="M201.94,88.27c-1.33.74-1.32,1.3-2.63,1.11a4.75,4.75,0,0,0-3.88,2.11,11.66,11.66,0,0,1-2.21,2.35"
                fill="#141c66"
              />
              <path
                d="M215.78,77.83c-.73.66-.85,1.11-1.59,1.35s-1.47,2.39-3.55,3.15-4.21,3.42-4.21,3.42"
                fill="#141c66"
              />
            </g>
            <g>
              <path
                d="M198.38,53.46c4.34-7.18,5.83-8.81,4-13.65s-3.63-.71-1.78-9.81-5.19-11.8-8.39-12.15-18.34,8.53-15.78,13.36,3.65,18.55.9,19.69S193.26,61.93,198.38,53.46Z"
                fill="#396039"
              />
              <path
                d="M195.46,36.76c-.14-3.91,5.76-5.48,3.84-7.25s-4.19-6.4-6-4-3.27,6-4.7,4-3-2.07-3.91,0-.14,4.62-2.34,4-3.2.35-2.92,2.49,1.92,1.27,3.34,3.83,7.83,2.21,6.76.79S195.46,36.76,195.46,36.76Z"
                fill="#447244"
              />
              <path
                d="M206.48,30c3.2-5,7.68-9.67,12.16-5.33s-3,12.09,0,15.14,2.34,10.81,0,11.1-13.51.28-16.42,1.63-6.69-3.63-6.76-8.46S206.48,30,206.48,30Z"
                fill="#6b996b"
              />
              <path
                d="M189.63,59.93c7.49,5.71,8-14.14,0-12.44S179,48.7,176.41,45.15s-9,2.7-9.17,4.48,1.84,7.74,6.25,9.45S185.15,56.52,189.63,59.93Z"
                fill="#447244"
              />
              <path
                d="M205.11,63.92c-7.49,5.7-8-14.15,0-12.45s10.66,1.21,13.22-2.34,9,2.7,9.17,4.48-1.84,7.75-6.25,9.45S209.59,60.5,205.11,63.92Z"
                fill="#447244"
              />
              <path
                d="M214.44,57.09c1.07-2.13,4.2,2,4.2,2s-.22-2.77,1.49-3.77,2.49,1.57,2.49,1.57c.14-2,4.19-.14,3.06,2.22h0a9.44,9.44,0,0,1-4.43,4,7.8,7.8,0,0,1-3.18.41l-3.81-1S213.38,59.22,214.44,57.09Z"
                fill="#396039"
              />
              <path
                d="M199,60.72c-1.5,2.63-2.35,26.3,0,37.18,0,0-6.83-1.21-9-.07-.22.71-.22.07-.22.07S199.3,65,191.05,55.31s-17.2,0-17.2,0,2.42-5.68,7.75-6.11,12.65,6.47,13,7.82c0,0,.28-10.38-3.06-14s.92-6.25.92-6.25-4.4,1.35,2.71,10.59c3.68,4.79,1.06,13.72,1.06,13.72s2.28-7,8-5.47,9.1,8.1,14.43,7.68a28,28,0,0,1-11.23-3.35A6.58,6.58,0,0,0,199,60.72Z"
                fill="#704d3c"
              />
              <path
                d="M206.8,59.6A6.51,6.51,0,0,0,199,60.72c-.52.9-1,4.31-1.21,8.82-1.71-5.89,1.35-12.88,2.32-13.5a5.36,5.36,0,0,1,4.08-.44A12.68,12.68,0,0,1,208,57.38Z"
                fill="#634b42"
              />
              <path
                d="M193.72,57.41c.78,1.78,1.63,7,.67,9.68h0c-.18-4.88-1.12-9.17-3.34-11.78a16.49,16.49,0,0,0-1.47-1.52l-.34-1A12.69,12.69,0,0,1,193.72,57.41Z"
                fill="#44322c"
              />
              <path
                d="M205.22,58.5c2.06-.67,2.19-3.56,4.63-3.39s2.73,3.68,4.75,6,3.68,1.78,5.3,2.57-4.43,9.46-10.05,6.32-5.09-2.6-7-3.88S200.63,60,205.22,58.5Z"
                fill="#6b996b"
              />
              <g>
                <path d="M194.55,54c0,.13,0,.15,0,.07V54Z" fill="#7f2c03" />
                <path
                  d="M194.47,52.78c-.27-3.3-1-7.67-2.92-9.77a4.27,4.27,0,0,1-1.27-2.57l1-.19c.34,1.58,1.42,3.86,3.92,7.1l.16.22C195.17,49.44,194.58,51.36,194.47,52.78Z"
                  fill="#634b42"
                />
              </g>
              <path
                d="M186.77,52.52c-1.35-1.69.13-4.17-2-5.38s-4.31,1.56-7.26,2.34-4.05-.55-5.82-.78S170.16,59,176.58,59.52s5.68.63,8,.64S189.77,56.3,186.77,52.52Z"
                fill="#6b996b"
              />
              <path
                d="M189.48,32.57c1.4-2.21,3.36-4.23,5.32-2.34s-1.31,5.29,0,6.63,1,4.73,0,4.85-5.91.13-7.19.72-2.92-1.59-3-3.7S189.48,32.57,189.48,32.57Z"
                fill="#6b996b"
              />
              <path
                d="M175.48,57.16c.4.61,1.58.5,2.27.22s1.08-2.38,2.19-2,1.64,1.46,2.87,1.1.7-1.68,2.27-1.7,2.92.57,3,1.38c0,.07,0,.14,0,.21h0a1,1,0,0,0,0,.18c-.29,2.09-2,3.62-3.43,3.62-2.33,0-1.58-.16-8-.64a5.22,5.22,0,0,1-2.36-.75C173.51,58.3,175.07,56.54,175.48,57.16Z"
                fill="#447244"
              />
              <path
                d="M204.35,66.05c1.56,0,4.69,1.7,5.12.14S213,64.27,213.38,65s2.27,1.64,3.34,1.07,2.13.85,1.65,1.41c-2,2.24-5.32,4.28-8.52,2.49-3.91-2.18-4.84-2.59-5.7-3.06C203.79,66.62,203.15,66.05,204.35,66.05Z"
                fill="#396039"
              />
              <path
                d="M198.52,48.06c1-2.2,3.41-1.78,5.12-1.49s1.21,2.56,2.56,1.49,4.33,1.49,3.21,3.34h0c-3,.21-5.91.55-7.19,1.14-1.81.84-3.94-.75-5.32-3.23l-.6-1.26h0S197.52,50.27,198.52,48.06Z"
                fill="#447244"
              />
              <path
                d="M216.58,46.71c-.64-2,2.2-3.7,0-3.7s-5.83,2.21-5.48-1-.64-4.91-3.06-4.69-4.26-5-2.91-6.15-7.54,2.24-3.63,5.58,5.34,2.27,5.19,3.84,0,4.83,3,5.33-.85,4.55,1.39,5.47S218.28,52,216.58,46.71Z"
                fill="#447244"
              />
              <path
                d="M189.84,97.9s.59-2,1.34-5.26c5.94-3,6.37-13,6.38-13.25,0,6.74.44,13.82,1.46,18.51,0,0-6.83-1.21-9-.07C189.84,98.54,189.84,97.9,189.84,97.9Z"
                fill="#44322c"
              />
              <path
                d="M196.93,97.6c0-1.92-.63-3.74-.87-5.64a37.82,37.82,0,0,1-.12-5.73c.21-3.81.6-7.6.78-11.4.05-1,.1-1.9.11-2.85a10.64,10.64,0,0,0-.05-1.39c-.07-.43-.23-.91-.33-1.37a17,17,0,0,1-.49-2.84,5.75,5.75,0,0,1,.39-2.89c.43-.86.84-1.71,1.34-2.54a6.59,6.59,0,0,1,1.9-2.17,4.79,4.79,0,0,1,2.78-.67,12.79,12.79,0,0,1,2.83.4,12.25,12.25,0,0,0-2.83-.29,4.62,4.62,0,0,0-2.66.73c-1.53,1.12-2.23,3-3.06,4.68a5.66,5.66,0,0,0-.32,2.72,16.7,16.7,0,0,0,.49,2.78c.11.47.26.89.36,1.4a10.31,10.31,0,0,1,.06,1.46c0,1-.05,1.91-.1,2.86-.21,3.81-.59,7.61-.87,11.4a38.6,38.6,0,0,0,0,5.69C196.44,93.82,197,95.68,196.93,97.6Z"
                fill="#44322c"
              />
              <path
                d="M195.43,79.38a15.36,15.36,0,0,0,0,2.35,3.52,3.52,0,0,1-.14,1.2,3.43,3.43,0,0,1-.63,1.06,6.32,6.32,0,0,0-1.75,4.13,9.32,9.32,0,0,0,0,2.3,16.66,16.66,0,0,0,.61,2.24,19.17,19.17,0,0,1,.5,4.7,25.44,25.44,0,0,0-.82-4.61,12.57,12.57,0,0,1-.67-2.28,9.64,9.64,0,0,1-.07-2.4,9,9,0,0,1,.57-2.33,5.3,5.3,0,0,1,1.37-2,3,3,0,0,0,.62-.93,3.36,3.36,0,0,0,.18-1.11A15.44,15.44,0,0,1,195.43,79.38Z"
                fill="#44322c"
              />
              <path
                d="M195.43,49.16c.08.91.43,1.74.48,2.68a3.17,3.17,0,0,1-.07.69,2.24,2.24,0,0,0-.12.64,5.39,5.39,0,0,0,.26,1.28,12.9,12.9,0,0,1,.77,5.39c-.11.94-.49,1.76-.58,2.64a18.17,18.17,0,0,0-.14,2.66,32.22,32.22,0,0,0,.6,5.35,24.57,24.57,0,0,1-.92-5.34,14.68,14.68,0,0,1,.07-2.73c.1-.92.46-1.78.55-2.64a13.18,13.18,0,0,0-.67-5.25,6.12,6.12,0,0,1-.21-1.37,2.62,2.62,0,0,1,.15-.68,2.84,2.84,0,0,0,.1-.65C195.72,51,195.44,50.06,195.43,49.16Z"
                fill="#44322c"
              />
            </g>
          </g>
          <g>
            <g opacity="0.19">
              <g>
                <path
                  d="M429.84,128a4.48,4.48,0,0,1,.4-.36,3.59,3.59,0,0,1,.65-.45,4.63,4.63,0,0,1,.64-.29,2.17,2.17,0,0,0,.53-.31c.18-.15.31-.33.48-.47a1.34,1.34,0,0,1,.44-.27l.35-.09a2.17,2.17,0,0,1,.36,0,0,0,0,0,0,.05,0,2.42,2.42,0,0,1,2.51,1.45.78.78,0,0,0,0,.26,1.4,1.4,0,0,0,.17.56,1.17,1.17,0,0,1,.1.64,5.66,5.66,0,0,1-.27.68,1.09,1.09,0,0,0-.06.36,1.28,1.28,0,0,0,.07.34.86.86,0,0,1,0,.39c0,.12-.07.24-.1.36a2.32,2.32,0,0,0-.07.38,1.4,1.4,0,0,1-.06.28,3.25,3.25,0,0,1-.8,1.11,1.8,1.8,0,0,0-.4.68,3.55,3.55,0,0,0-.1.64,1.31,1.31,0,0,1-.11.52,1.66,1.66,0,0,1-.49.56c-.47.39-1,.71-1.42,1.12a3,3,0,0,0-.3.32l-.26.33a1,1,0,0,1-.46.28,2.74,2.74,0,0,1-.5.07,1.38,1.38,0,0,0-.71.25,1.49,1.49,0,0,1-.32.24.74.74,0,0,1-.33,0,3.07,3.07,0,0,0-.67,0h0a2.32,2.32,0,0,1-.67-.28,2.24,2.24,0,0,1-.74-.73,3.35,3.35,0,0,0-.13-.77c-.07-.29-.16-.57-.21-.87a2.07,2.07,0,0,1,0-.43c0-.15,0-.29,0-.44s-.06-.55,0-.83a1.16,1.16,0,0,1,.12-.44c.06-.14.15-.26.22-.39a1.21,1.21,0,0,0,.16-.41c0-.14.05-.29.07-.44s0-.39,0-.59a9.49,9.49,0,0,1,.57-1.09,2,2,0,0,1,.48-.11c.24,0,.49-.05.74-.09a.06.06,0,0,0,.05-.07c-.09-.19-.18-.37-.25-.56a.81.81,0,0,1-.06-.43.72.72,0,0,1,.13-.28A2.85,2.85,0,0,1,429.84,128Z"
                  fill="#141c66"
                />
                <path d="M435,126.44s-3.2,8.05-15.12,20.85" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M429.61,143.1c.21-.16.41-.32.6-.49a17.31,17.31,0,0,1,3.76-1.32,4.6,4.6,0,0,0,.52.06,4.85,4.85,0,0,0,.66,0h.76a5.1,5.1,0,0,0,1.45-.18c.23-.07.43-.19.66-.27a3.57,3.57,0,0,1,.46-.16c2.46,0,4.25.59,4.45,1.64a1,1,0,0,1,0,.43,1.09,1.09,0,0,1-.13.17,3.06,3.06,0,0,1-.73.66,4,4,0,0,1-.86.4,6.42,6.42,0,0,0-1.06.4,3.81,3.81,0,0,0-.8.64,4.65,4.65,0,0,1-.79.68,1.4,1.4,0,0,1-.86.27,2.8,2.8,0,0,1-.64-.2,2.35,2.35,0,0,0-.79-.14.75.75,0,0,0-.56.16c-.16.15-.26.34-.41.5a1.83,1.83,0,0,1-1.4.49,6.75,6.75,0,0,1-1.54-.35c-.27-.08-.55-.15-.83-.21l-.42-.07c-.17,0-.33,0-.49,0a6.25,6.25,0,0,1-1.93-.54c-.31-.12-.62-.24-.94-.34a2,2,0,0,1,.89-1.67A4.41,4.41,0,0,0,429.61,143.1Z"
                  fill="#141c66"
                />
                <path d="M443.27,142.57s-14,.3-23.31,5.38" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M428.5,144a5.54,5.54,0,0,0,.53-.3,13.31,13.31,0,0,1,3.11-.56c.14,0,.27.09.41.12a4.5,4.5,0,0,0,.51.08l.6.09a4,4,0,0,0,1.15.05c.19,0,.37-.09.56-.13l.38-.07c1.93.32,3.25,1,3.28,1.85a1,1,0,0,1-.06.34l-.13.12a2.34,2.34,0,0,1-.65.42,3.79,3.79,0,0,1-.73.21,5.07,5.07,0,0,0-.88.17,3.13,3.13,0,0,0-.71.41,4.53,4.53,0,0,1-.7.43,1.16,1.16,0,0,1-.71.1,2.16,2.16,0,0,1-.48-.24,1.79,1.79,0,0,0-.6-.21.53.53,0,0,0-.46.06c-.14.09-.25.23-.39.33a1.38,1.38,0,0,1-1.15.21,5.61,5.61,0,0,1-1.17-.47c-.2-.09-.41-.19-.62-.27l-.32-.1-.38-.09a5,5,0,0,1-1.44-.67,6.8,6.8,0,0,0-.7-.38,1.55,1.55,0,0,1,.91-1.2A3.66,3.66,0,0,0,428.5,144Z"
                  fill="#141c66"
                />
                <path d="M439.27,145.37s-11-1.55-18.95,1.25" fill="#141c66" />
              </g>
              <g>
                <path
                  d="M426.37,141.38a.33.33,0,0,0,.22,0,.34.34,0,0,0,.11-.23,2.14,2.14,0,0,0,0-.44h0l.29,0a.38.38,0,0,0,.21,0c.11-.08.07-.23,0-.34a2,2,0,0,0-.07-.23q.24-.27.51-.54l.1.08.29.2a.55.55,0,0,0,.25.1.07.07,0,0,0,.06-.07c0-.11,0-.23-.07-.35a.61.61,0,0,1,0-.33c0-.13.17-.15.27-.22a.32.32,0,0,0,.11-.24v-.14l.7-.63.15.12a1,1,0,0,0,.43.21.36.36,0,0,0,.38-.2.87.87,0,0,0,0-.53l-.09-.26.22-.24c.24-.2.49-.39.75-.58h0a.5.5,0,0,1,.2.08,1.11,1.11,0,0,0,.31.09.08.08,0,0,0,.07,0c0-.16,0-.5.17-.55.06,0,.13.05.18.08a.19.19,0,0,0,.21,0c.09-.12,0-.29.07-.42s.22,0,.27.07a2.08,2.08,0,0,0,.29.36s.09,0,.09-.05c0-.28,0-.57,0-.86.56-.36,1.1-.69,1.62-1a1,1,0,0,1,0,.1.05.05,0,0,0,.08,0,2.09,2.09,0,0,1,.08.5v.3c0,.08.1.09.11,0a1.71,1.71,0,0,0,0-.32,3.91,3.91,0,0,0-.07-.76c.46-.24.9-.46,1.32-.64a2.23,2.23,0,0,1,.1.62l0,.27c0,.07.1.09.11,0a1.41,1.41,0,0,0,0-.28c0-.18,0-.36,0-.54s0-.13,0-.2a7.72,7.72,0,0,1,1.22-.42,6.73,6.73,0,0,0,.21.77.06.06,0,0,0,.08,0,1.19,1.19,0,0,0,.33-.59,2.05,2.05,0,0,0,.07-.34,1.18,1.18,0,0,1,1.11.28c.38.52-.12,1.6-1.22,2.93-.22,0-.44-.08-.66-.11a.05.05,0,0,0,0,.1,3.54,3.54,0,0,0,.55.18c-.3.35-.63.7-1,1.07a10.34,10.34,0,0,0-1.11.21s-.06,0-.05.06c0,.24.1.46.15.69-.55.49-1.14,1-1.78,1.48a4.27,4.27,0,0,0-1.11.26,2.48,2.48,0,0,0-.69.47l-.31.28c-.1.09-.21.16-.31.26s-.32.41-.5.6a.63.63,0,0,1-.61.24,1.68,1.68,0,0,1-.42-.27.2.2,0,0,0-.18,0,.28.28,0,0,0-.15.15,1.26,1.26,0,0,0,0,.64l0,.2c-2.22,1.16-4,1.58-4.44.93-.3-.39-.07-1.14.56-2.07Z"
                  fill="#141c66"
                />
                <path
                  d="M437.22,134.82s-15.8,12.1-17.18,12.78"
                  fill="#141c66"
                />
              </g>
              <g>
                <path
                  d="M432,134.35a.6.6,0,0,1,.25.33c0,.13-.06.25-.1.38s-.08.37-.11.56a4.88,4.88,0,0,1-.12.55,4.13,4.13,0,0,1-.37.8,3.48,3.48,0,0,0-.45.88c-.06.26-.06.53-.1.8h0l-.24.34a10.33,10.33,0,0,1-1.71,1.93l-.17.11a14.28,14.28,0,0,0-1.66.83.74.74,0,0,1-.42-.12c-.75-.53-.2-2.62,1.24-4.66S431.24,133.82,432,134.35Z"
                  fill="#141c66"
                />
                <path d="M428,137.09s.71,4.15-7.14,10.16" fill="#141c66" />
                <path
                  d="M431.63,135.35a2.2,2.2,0,0,1-.48,1,4.45,4.45,0,0,0-.71.79,1.66,1.66,0,0,0-.17.55c0,.19,0,.37,0,.55a1.09,1.09,0,0,1-.21.54,1,1,0,0,1-.37.26,1.81,1.81,0,0,0-.41.22,1.55,1.55,0,0,0-.39.52,1.81,1.81,0,0,1-.4.54,2.16,2.16,0,0,1-.37.19,1.11,1.11,0,0,0-.38.24,1.21,1.21,0,0,0-.24.35.85.85,0,0,1-.21.31,1.12,1.12,0,0,1-.51.18h-.06a.49.49,0,0,1-.17-.06c-.59-.42.09-2.42,1.53-4.46s3.08-3.36,3.68-3a.51.51,0,0,1,.16.24A4.91,4.91,0,0,0,431.63,135.35Z"
                  fill="#141c66"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M404.65,117.31c0-.29-.06-.58-.08-.87a7,7,0,0,1,0-1.29,11.07,11.07,0,0,1,.25-1.11,3.44,3.44,0,0,0,.11-1c0-.36-.12-.72-.15-1.09a2.33,2.33,0,0,1,.08-.83c.07-.19.15-.37.23-.55a3.08,3.08,0,0,1,.32-.48.09.09,0,0,0,0-.11,4.13,4.13,0,0,1,1.94-1.7,4.07,4.07,0,0,1,2.4-.16,1.22,1.22,0,0,0,.3.3,2.59,2.59,0,0,0,.89.33,1.71,1.71,0,0,1,.93.48,8.11,8.11,0,0,1,.63,1,2,2,0,0,0,.42.44,1.7,1.7,0,0,0,.51.24,1.48,1.48,0,0,1,.54.33,5.72,5.72,0,0,1,.37.49,4.57,4.57,0,0,0,.43.45c.11.12.22.23.32.36a5.46,5.46,0,0,1,.66,2.14,3,3,0,0,0,.51,1.18,5.25,5.25,0,0,0,.74.75,2.36,2.36,0,0,1,.57.65,2.91,2.91,0,0,1,.26,1.2c0,1,0,2,.08,2.93a4.21,4.21,0,0,0,.12.71c.05.22.13.44.17.66a1.51,1.51,0,0,1-.06.87c-.11.26-.27.49-.4.73a2.1,2.1,0,0,0-.37,1.17,2,2,0,0,1,0,.65,1.42,1.42,0,0,1-.29.47,7,7,0,0,0-.72.82.11.11,0,0,0,0,0,3.83,3.83,0,0,1-1,.61,4,4,0,0,1-1.68.26,6.41,6.41,0,0,0-1.13-.6,11.22,11.22,0,0,1-1.34-.57,4.67,4.67,0,0,1-.6-.38c-.18-.15-.34-.33-.53-.47-.36-.27-.78-.46-1.12-.75a2.08,2.08,0,0,1-.48-.59c-.11-.22-.19-.45-.29-.68a2.07,2.07,0,0,0-.37-.6,6.38,6.38,0,0,0-.52-.52c-.23-.21-.48-.41-.72-.62a19,19,0,0,1-.88-1.81,3.76,3.76,0,0,1,.32-.74c.19-.36.41-.69.61-1a.11.11,0,0,0,0-.14,8.46,8.46,0,0,1-1-.22,1.24,1.24,0,0,1-.62-.35,1.18,1.18,0,0,1-.24-.42Z"
                  fill="#396039"
                />
                <path
                  d="M407.69,109a68.47,68.47,0,0,1,4.43,9.56c1.27,3.28,2.36,6.62,3.38,10s1.85,6.78,2.66,10.2l1.12,5.15,1,5.19-1.05-5.17L418,138.78c-.83-3.41-1.69-6.82-2.72-10.18s-2.07-6.71-3.32-10c-.63-1.64-1.28-3.27-2-4.88A49.2,49.2,0,0,0,407.69,109Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M424.19,132.33c0-.42,0-.84,0-1.26a27.29,27.29,0,0,1,1.92-6.2q.31-.3.6-.63c.23-.27.43-.56.64-.85s.49-.67.73-1a8.86,8.86,0,0,0,1.18-2.07c.13-.37.18-.76.28-1.13s.15-.51.24-.76c2.41-3.22,4.92-5,6.48-4.23a1.86,1.86,0,0,1,.57.44c0,.11.07.22.1.34a5,5,0,0,1,.14,1.59,7.07,7.07,0,0,1-.31,1.52,10.22,10.22,0,0,0-.52,1.77,6.22,6.22,0,0,0,.07,1.67,8,8,0,0,1,.12,1.69,2.33,2.33,0,0,1-.49,1.4,4.38,4.38,0,0,1-.89.64,4.22,4.22,0,0,0-.95.89,1.2,1.2,0,0,0-.33.9c0,.34.19.67.25,1a2.9,2.9,0,0,1-.72,2.3,11.67,11.67,0,0,1-2,1.68c-.37.28-.73.57-1.07.88-.18.16-.35.32-.51.49s-.34.41-.52.61a10.23,10.23,0,0,1-2.58,2c-.46.28-.92.58-1.36.9-.79-.4-1.22-1.39-1.32-2.79A6.86,6.86,0,0,0,424.19,132.33Z"
                  fill="#2f4f2f"
                />
                <path
                  d="M436.81,114c-1.84,2.72-3.53,5.52-5.15,8.37s-3.11,5.76-4.49,8.73a93.09,93.09,0,0,0-3.66,9.11,66.33,66.33,0,0,0-2.36,9.53,59.36,59.36,0,0,1,2.24-9.57A93.34,93.34,0,0,1,427,131,115.48,115.48,0,0,1,436.81,114Z"
                  fill="#87f139"
                />
              </g>
              <g>
                <path
                  d="M424.35,134.7c.06-.32.09-.66.12-1a22.45,22.45,0,0,1,2.3-4.61c.19-.13.37-.27.55-.42s.41-.39.61-.59l.7-.69a6.46,6.46,0,0,0,1.18-1.47c.15-.27.24-.57.37-.85s.18-.38.28-.56c2.3-2.22,4.49-3.28,5.62-2.49a1.53,1.53,0,0,1,.39.41l0,.28a3.82,3.82,0,0,1-.09,1.26,4.78,4.78,0,0,1-.44,1.16,8.39,8.39,0,0,0-.63,1.32,5.3,5.3,0,0,0-.16,1.32,6,6,0,0,1-.12,1.34,1.78,1.78,0,0,1-.56,1,3.48,3.48,0,0,1-.77.39,3.34,3.34,0,0,0-.86.58.91.91,0,0,0-.37.66c0,.28.06.55.06.83a2.27,2.27,0,0,1-.86,1.71,8.84,8.84,0,0,1-1.74,1.07c-.33.18-.65.35-1,.55s-.31.21-.46.32-.32.28-.48.42a8.52,8.52,0,0,1-2.28,1.23c-.4.16-.79.33-1.18.53a2.51,2.51,0,0,1-.68-2.36A5.53,5.53,0,0,0,424.35,134.7Z"
                  fill="#396039"
                />
                <path
                  d="M436.57,121.91c-1.78,1.9-3.46,3.88-5.09,5.9s-3.16,4.13-4.62,6.29a75.07,75.07,0,0,0-4,6.66,53.75,53.75,0,0,0-3.07,7.16,46.1,46.1,0,0,1,3-7.21,73.33,73.33,0,0,1,4-6.72A90.73,90.73,0,0,1,436.57,121.91Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M418.79,134.89a.48.48,0,0,0,.19-.31.58.58,0,0,0-.19-.36,3.87,3.87,0,0,0-.56-.44v0a2.24,2.24,0,0,0,.35-.34.59.59,0,0,0,.14-.31c0-.22-.22-.32-.39-.38l-.37-.14c-.08-.38-.16-.78-.23-1.19l.22-.05a3.8,3.8,0,0,0,.54-.18.86.86,0,0,0,.36-.23.1.1,0,0,0,0-.15c-.17-.09-.36-.16-.53-.24a1.19,1.19,0,0,1-.46-.3c-.14-.17,0-.37,0-.56a.56.56,0,0,0-.22-.38l-.17-.14c-.06-.49-.1-1-.14-1.51l.3-.09a1.64,1.64,0,0,0,.69-.36.58.58,0,0,0,.1-.69,1.26,1.26,0,0,0-.69-.51,2.16,2.16,0,0,0-.43-.14l-.09-.53c0-.5,0-1,0-1.54l0-.06a.88.88,0,0,1,.29-.18,1.51,1.51,0,0,0,.43-.32.09.09,0,0,0,0-.13c-.2-.17-.7-.43-.56-.77,0-.1.2-.11.29-.15a.26.26,0,0,0,.14-.31c-.06-.23-.34-.32-.47-.5s.22-.28.36-.29a3.74,3.74,0,0,0,.75,0,.1.1,0,0,0,0-.17c-.38-.27-.77-.55-1.17-.79.07-1.08.18-2.11.31-3.07l.17,0a.09.09,0,0,0,.11-.08,3.85,3.85,0,0,1,.73.37l.4.3c.09.08.22-.05.13-.13s-.28-.22-.42-.31a7.66,7.66,0,0,0-1.06-.64c.13-.85.28-1.63.45-2.35a3.67,3.67,0,0,1,.9.47l.33.3c.09.07.21,0,.13-.13a2.45,2.45,0,0,0-.34-.31l-.65-.59-.26-.21a16,16,0,0,1,.64-2,11.35,11.35,0,0,0,1.21.49.09.09,0,0,0,.12-.09,2,2,0,0,0-.45-1,3.08,3.08,0,0,0-.38-.43c.44-.76.93-1.17,1.45-1.17,1,0,2,1.7,2.65,4.43-.28.25-.54.51-.8.77-.07.07,0,.19.11.14a5.36,5.36,0,0,0,.77-.55c.16.72.31,1.51.43,2.35a14.15,14.15,0,0,0-.81,1.66.09.09,0,0,0,0,.12c.34.18.7.32,1.05.48.11,1.19.18,2.45.2,3.76a6.63,6.63,0,0,0-.73,1.71,3.62,3.62,0,0,0-.06,1.35c0,.23.05.46.06.68a4.92,4.92,0,0,0,0,.67c.06.42.22.82.29,1.24a1,1,0,0,1-.28,1,2.49,2.49,0,0,1-.76.29.34.34,0,0,0-.23.19.45.45,0,0,0,.06.34,1.84,1.84,0,0,0,.79.67l.29.16c-.64,4-1.79,6.73-3.1,6.73-.81,0-1.56-1-2.16-2.76Z"
                  fill="#659965"
                />
                <path
                  d="M420.77,114.31c.16,5.82.2,11.64.27,17.47v8.73c0,2.91,0,5.83-.26,8.73.14-1.45.11-2.91.13-4.36v-4.37l-.05-8.73Z"
                  fill="#78bf3a"
                />
              </g>
              <g>
                <path
                  d="M415.07,120.69a1.13,1.13,0,0,1,.68,0l.39.49c.2.25.41.48.63.71a6.5,6.5,0,0,1,.59.69,5.45,5.45,0,0,1,.69,1.25,5.88,5.88,0,0,0,.72,1.44,11.76,11.76,0,0,0,1,.92v0c.08.21.15.42.22.64a17.35,17.35,0,0,1,.86,4.12c0,.11,0,.22,0,.33a27.3,27.3,0,0,0-.52,3,1.24,1.24,0,0,1-.57.43c-1.42.46-3.61-2.29-4.89-6.16S413.64,121.16,415.07,120.69Z"
                  fill="#3b6818"
                />
                <path
                  d="M414.79,128.54s6.13,3.12,6.34,19.25"
                  fill="none"
                  stroke="#78bf3a"
                  strokeMiterlimit="10"
                  strokeWidth="0.18"
                />
                <path
                  d="M416,122.15a3.45,3.45,0,0,1,.85,1.6,7.65,7.65,0,0,0,.34,1.7,2.54,2.54,0,0,0,.56.76c.22.2.46.38.67.59a1.92,1.92,0,0,1,.5.82,1.63,1.63,0,0,1,0,.73,3.67,3.67,0,0,0-.11.75,2.52,2.52,0,0,0,.31,1,3,3,0,0,1,.31,1,2,2,0,0,1-.12.67,2.21,2.21,0,0,0,0,.73,2,2,0,0,0,.22.67,1.32,1.32,0,0,1,.21.56,1.81,1.81,0,0,1-.26.85l-.05.09a.73.73,0,0,1-.25.15c-1.12.37-3.07-2.46-4.35-6.33s-1.39-7.31-.27-7.68a.79.79,0,0,1,.48,0A7.06,7.06,0,0,0,416,122.15Z"
                  fill="#659965"
                />
              </g>
            </g>
          </g>
          <g>
            <g opacity="0.2">
              <path
                d="M118.14,128.41c5.36.32,6.73.67,8.91-1.82s-.68-2.26,5-3.93,5.12-6.45,4.37-8.36-10.29-7.83-12.26-4.94-9.41,7.59-10.87,6.38S111.83,128,118.14,128.41Z"
                fill="#141c66"
              />
              <path
                d="M126.72,121.78c2.17-1.24,4.82,1.63,5.25,0s2.36-4.28.45-4.6-4.36-.07-3.65-1.47.27-2.3-1.17-2.21-2.65,1.3-2.95-.14-1.16-1.7-2.28-.9-.15,1.46-1.17,3,1.08,5.08,1.57,4S126.72,121.78,126.72,121.78Z"
                fill="#141c66"
              />
              <path
                d="M133.83,126c3.81.3,7.75,1.46,6.64,5.28s-7.73,1.92-8.56,4.52-5.42,4.55-6.28,3.31-4.18-7.56-5.82-8.8.06-4.86,2.77-6.34S133.83,126,133.83,126Z"
                fill="#141c66"
              />
              <path
                d="M111.88,125.4c-1,5.94,10.39.32,7-3.71s-3.86-5.67-2.61-8.18-4.2-4.26-5.27-3.85S107.2,113,107.55,116,112.47,121.85,111.88,125.4Z"
                fill="#141c66"
              />
              <path
                d="M114.24,135.34c-5.46-2.54,5.61-8.76,7-3.71s2.49,6.39,5.27,6.77,1.14,5.88.2,6.53-4.93,1.26-7.21-.72S117.51,136.85,114.24,135.34Z"
                fill="#141c66"
              />
              <path
                d="M120.89,138.58c1.52,0,.12,3,.12,3s1.51-1,2.58-.28-.15,1.87-.15,1.87c1.17-.51,1.34,2.33-.34,2.39h0a6.07,6.07,0,0,1-3.56-1.32,5.18,5.18,0,0,1-1.18-1.67l-.59-2.45A5.84,5.84,0,0,1,120.89,138.58Z"
                fill="#141c66"
              />
              <path
                d="M114.23,130.94c-1.93-.06-15.57,6.52-21,11.09,0,0-1.35-4.22-2.63-5.09-.47.09-.1-.1-.1-.1s21.43-4.47,24.44-12-5.13-9.72-5.13-9.72,3.93-.33,5.76,2.55.12,9.09-.54,9.69c0,0,6-2.93,7-5.9s3.81-1.34,3.81-1.34-2.08-2.09-5.18,4.68c-1.61,3.51-7.44,4.7-7.44,4.7s4.62-.8,5.47,2.87-1.87,7.56,0,10.45a17.82,17.82,0,0,1-1.46-7.35A4.2,4.2,0,0,0,114.23,130.94Z"
                fill="#141c66"
              />
              <path
                d="M117.19,135a4.17,4.17,0,0,0-3-4.07,20.57,20.57,0,0,0-5.35,1.95c2.83-2.73,7.69-3.08,8.33-2.72a3.45,3.45,0,0,1,1.47,2.18,8.12,8.12,0,0,1,.11,2.65Z"
                fill="#141c66"
              />
              <path
                d="M114.52,127c-.77,1-3.46,3-5.27,3.27h0c2.71-1.56,4.86-3.37,5.67-5.41a12.07,12.07,0,0,0,.42-1.29l.46-.48A8,8,0,0,1,114.52,127Z"
                fill="#141c66"
              />
              <path
                d="M117.34,133.78c1,1,2.66.18,3.3,1.61s-1.27,2.64-2,4.46.09,2.62.13,3.76-6.68.32-6.58-3.79,0-3.66.1-5.14S115.13,131.63,117.34,133.78Z"
                fill="#141c66"
              />
              <g>
                <path
                  d="M116.68,126.42c-.06.06-.07.07,0,0l0,0Z"
                  fill="#141c66"
                />
                <path
                  d="M117.37,126c1.79-1.13,4-2.84,4.65-4.56a2.75,2.75,0,0,1,1.07-1.49l.4.5a12.46,12.46,0,0,0-2.84,4.33l-.08.16C119.46,125.4,118.2,125.64,117.37,126Z"
                  fill="#141c66"
                />
              </g>
              <path
                d="M115.21,121.57c.56-1.27,2.41-1.17,2.46-2.73s-2.17-2-3.49-3.41-.9-2.45-1.29-3.52-6.31,2.21-4.67,6,1.34,3.4,2,4.71S114,124.39,115.21,121.57Z"
                fill="#141c66"
              />
              <path
                d="M127.31,117.15c1.66.13,3.39.64,2.9,2.31s-3.38.84-3.74,2-2.37,2-2.75,1.45-1.83-3.31-2.55-3.85,0-2.13,1.22-2.78S127.31,117.15,127.31,117.15Z"
                fill="#141c66"
              />
              <path
                d="M109.23,116.57c-.23.41.19,1,.55,1.35s1.67-.1,1.79.64-.33,1.36.23,2,1.16-.11,1.64.77.55,1.83.11,2.1l-.12.05h0l-.11,0a2.57,2.57,0,0,1-3.07-.87c-.69-1.31-.39-.94-2-4.71a3.41,3.41,0,0,1-.28-1.56C108,115.79,109.45,116.16,109.23,116.57Z"
                fill="#141c66"
              />
              <path
                d="M112.81,135.54c.47.89.43,3.17,1.45,2.94s2.14,1.44,1.85,1.85a2,2,0,0,0,.39,2.21c.64.43.15,1.46-.31,1.35-1.85-.45-4-1.73-4-4.07.07-2.86,0-3.51,0-4.14C112.32,135.4,112.45,134.86,112.81,135.54Z"
                fill="#141c66"
              />
              <path
                d="M121.24,126.88c1.55-.09,2,1.4,2.37,2.45s-1.08,1.45-.08,1.89.45,2.9-.93,2.82h0a16.86,16.86,0,0,0-2.79-3.73c-1-.77-.75-2.45.25-4l.52-.71h0S119.7,127,121.24,126.88Z"
                fill="#141c66"
              />
              <path
                d="M127.39,136.69c.94-1,2.75.14,2.09-1.1s-3-2.64-1.07-3.39,2.58-1.83,1.74-3.13,1.55-3.89,2.61-3.48-3.51-3.6-4.24-.39.31,3.69-.62,4.08-2.73,1.44-2.12,3.28-2.83.88-2.68,2.42S124.88,139.25,127.39,136.69Z"
                fill="#141c66"
              />
              <path
                d="M90.48,136.84s1.32-.28,3.37-.81c3.49,2.45,9.23-.27,9.39-.35a63.79,63.79,0,0,0-10,6.35s-1.35-4.22-2.63-5.09C90.11,137,90.48,136.84,90.48,136.84Z"
                fill="#141c66"
              />
              <path
                d="M92.76,140.76a16.28,16.28,0,0,0,2.64-1.89,26,26,0,0,1,4.74-2.5c1.55-.67,7.36-3.11,8-3.71s2.35-2.27,3.78-2.3,2.94-.17,3.93.64a6.16,6.16,0,0,1,1.47,2.78"
                fill="#141c66"
              />
              <path
                d="M102.61,134.47c-1.59.59-1.68,1.2-3.09.76s-3.65.49-4.64,1.63A12.84,12.84,0,0,1,92,139"
                fill="#141c66"
              />
              <path
                d="M119.7,125.46c-.93.59-1.14,1.06-2,1.2s-2,2.37-4.47,2.83-5.24,3-5.24,3"
                fill="#141c66"
              />
            </g>
            <g>
              <path
                d="M99.06,89.31c5.14-8.49,6.89-10.42,4.71-16.14s-4.29-.84-2.1-11.6-6.14-14-9.92-14.38S70.06,57.28,73.08,63s4.32,21.93,1.07,23.28S93,99.31,99.06,89.31Z"
                fill="#396039"
              />
              <path
                d="M95.61,69.55c-.17-4.62,6.81-6.47,4.54-8.57s-5-7.57-7.14-4.71S89.14,63.33,87.46,61s-3.53-2.44-4.63,0-.16,5.46-2.77,4.71-3.78.42-3.45,2.94,2.27,1.51,4,4.54,9.24,2.61,8,.92S95.61,69.55,95.61,69.55Z"
                fill="#447244"
              />
              <path
                d="M108.64,61.57c3.79-6,9.08-11.43,14.38-6.31s-3.53,14.29,0,17.91,2.77,12.78,0,13.11-16,.34-19.42,1.94-7.9-4.29-8-10S108.64,61.57,108.64,61.57Z"
                fill="#6b996b"
              />
              <path
                d="M88.72,97c8.86,6.75,9.5-16.73,0-14.71s-12.61,1.43-15.64-2.78-10.59,3.2-10.84,5.3,2.18,9.16,7.4,11.18S83.42,92.93,88.72,97Z"
                fill="#447244"
              />
              <path
                d="M107,101.67c-8.86,6.75-9.5-16.73,0-14.71s12.61,1.43,15.64-2.78,10.59,3.2,10.84,5.3-2.18,9.16-7.4,11.18S112.32,97.63,107,101.67Z"
                fill="#447244"
              />
              <path
                d="M118.06,93.6c1.26-2.52,5,2.35,5,2.35s-.25-3.28,1.76-4.45,3,1.85,3,1.85c.16-2.36,5-.17,3.61,2.63h0a11.21,11.21,0,0,1-5.24,4.68,9.29,9.29,0,0,1-3.75.48L117.84,100S116.8,96.12,118.06,93.6Z"
                fill="#396039"
              />
              <path
                d="M99.82,97.89c-1.77,3.11-2.78,31.1,0,44,0,0-8.07-1.43-10.6-.08-.25.84-.25.08-.25.08s11.18-38.92,1.43-50.35-20.34,0-20.34,0,2.86-6.73,9.16-7.23,15,7.65,15.38,9.24c0,0,.34-12.27-3.61-16.56s1.09-7.4,1.09-7.4-5.21,1.6,3.2,12.53c4.35,5.66,1.26,16.23,1.26,16.23s2.69-8.24,9.41-6.48,10.76,9.59,17.07,9.08c0,0-7.4-.42-13.28-4S99.82,97.89,99.82,97.89Z"
                fill="#704d3c"
              />
              <path
                d="M109,96.56a7.71,7.71,0,0,0-9.2,1.33c-.61,1.07-1.13,5.09-1.44,10.43-2-7,1.6-15.23,2.75-16a6.37,6.37,0,0,1,4.82-.52,14.87,14.87,0,0,1,4.44,2.11Z"
                fill="#634b42"
              />
              <path
                d="M93.55,94c.93,2.1,1.94,8.26.8,11.44h0C94.13,99.65,93,94.58,90.4,91.5a19,19,0,0,0-1.75-1.81l-.39-1.18A15,15,0,0,1,93.55,94Z"
                fill="#44322c"
              />
              <path
                d="M107.15,95.26c2.43-.79,2.59-4.2,5.47-4s3.23,4.35,5.63,7,4.35,2.11,6.25,3-5.23,11.2-11.88,7.49-6-3.08-8.31-4.6S101.72,97,107.15,95.26Z"
                fill="#6b996b"
              />
              <g>
                <path d="M94.54,90c0,.16,0,.18,0,.08V90Z" fill="#7f2c03" />
                <path
                  d="M94.44,88.5C94.13,84.6,93.28,79.44,91,77a5,5,0,0,1-1.5-3l1.15-.22c.41,1.87,1.69,4.55,4.64,8.39l.19.26C95.26,84.55,94.57,86.83,94.44,88.5Z"
                  fill="#634b42"
                />
              </g>
              <path
                d="M85.33,88.2c-1.59-2,.16-4.94-2.35-6.37s-5.09,1.85-8.58,2.77-4.79-.65-6.89-.93-1.82,12.23,5.78,12.8,6.71.75,9.47.75S88.89,92.66,85.33,88.2Z"
                fill="#6b996b"
              />
              <path
                d="M88.54,64.6c1.65-2.61,4-5,6.29-2.76s-1.55,6.26,0,7.84,1.21,5.59,0,5.74-7,.14-8.5.84-3.46-1.87-3.5-4.38S88.54,64.6,88.54,64.6Z"
                fill="#6b996b"
              />
              <path
                d="M72,93.68c.47.72,1.87.59,2.68.26s1.28-2.81,2.59-2.38,1.94,1.72,3.4,1.3.82-2,2.68-2,3.46.68,3.52,1.64c0,.08,0,.16,0,.24h0a1.46,1.46,0,0,0,0,.22c-.33,2.46-2.32,4.28-4,4.27-2.76,0-1.87-.18-9.47-.75a6.17,6.17,0,0,1-2.8-.89C69.66,95,71.51,93,72,93.68Z"
                fill="#447244"
              />
              <path
                d="M106.12,104.19c1.85,0,5.55,2,6,.17s4.21-2.27,4.63-1.43,2.69,1.93,4,1.26,2.52,1,2,1.67c-2.35,2.64-6.29,5.06-10.08,3-4.61-2.58-5.72-3.07-6.73-3.63C105.46,104.87,104.7,104.19,106.12,104.19Z"
                fill="#396039"
              />
              <path
                d="M99.23,82.92c1.17-2.6,4-2.1,6-1.76s1.43,3,3,1.76,5.12,1.77,3.79,4h0c-3.58.25-7,.64-8.5,1.35-2.14,1-4.66-.89-6.29-3.83l-.71-1.48h0S98.05,85.53,99.23,82.92Z"
                fill="#447244"
              />
              <path
                d="M120.58,81.32c-.76-2.36,2.61-4.37,0-4.37s-6.89,2.61-6.47-1.17-.76-5.8-3.62-5.55-5-5.88-3.44-7.27-8.92,2.64-4.29,6.59,6.3,2.7,6.14,4.54,0,5.72,3.53,6.31-1,5.38,1.64,6.47S122.6,87.63,120.58,81.32Z"
                fill="#447244"
              />
              <path
                d="M89,141.85s.69-2.41,1.59-6.21c7-3.61,7.52-15.33,7.53-15.68,0,8,.53,16.34,1.73,21.89,0,0-8.07-1.43-10.6-.08C89,142.61,89,141.85,89,141.85Z"
                fill="#44322c"
              />
              <path
                d="M97.35,141.5c.05-2.28-.74-4.42-1-6.67a45.16,45.16,0,0,1-.14-6.78c.25-4.51.71-9,.92-13.48.06-1.12.12-2.24.14-3.36a12.74,12.74,0,0,0-.06-1.65c-.09-.51-.28-1.07-.4-1.62a20,20,0,0,1-.57-3.36,6.94,6.94,0,0,1,.45-3.42c.51-1,1-2,1.58-3a7.9,7.9,0,0,1,2.25-2.56,5.65,5.65,0,0,1,3.29-.79,14.47,14.47,0,0,1,3.35.47,14.56,14.56,0,0,0-3.35-.35,5.49,5.49,0,0,0-3.15.87,7.69,7.69,0,0,0-2.11,2.52c-.55,1-1,2-1.51,3a6.83,6.83,0,0,0-.37,3.22,19.47,19.47,0,0,0,.59,3.28c.12.55.3,1.06.41,1.65a12.82,12.82,0,0,1,.08,1.73c0,1.14-.06,2.26-.12,3.39-.25,4.5-.7,9-1,13.47a45.81,45.81,0,0,0,0,6.73C96.77,137,97.48,139.23,97.35,141.5Z"
                fill="#44322c"
              />
              <path
                d="M95.57,120a21.49,21.49,0,0,0,0,2.78,4.38,4.38,0,0,1-.17,1.43,4.09,4.09,0,0,1-.74,1.24,7.52,7.52,0,0,0-2.08,4.88,11.25,11.25,0,0,0,0,2.72,7.42,7.42,0,0,0,.3,1.32c.14.42.31.89.42,1.34a22.63,22.63,0,0,1,.59,5.55,31.1,31.1,0,0,0-1-5.45,16.16,16.16,0,0,1-.8-2.69,11.73,11.73,0,0,1-.07-2.84,10.22,10.22,0,0,1,.67-2.76,6.66,6.66,0,0,1,.68-1.26,7,7,0,0,1,.94-1.06,3.77,3.77,0,0,0,.73-1.1,4.11,4.11,0,0,0,.22-1.32A16.24,16.24,0,0,1,95.57,120Z"
                fill="#44322c"
              />
              <path
                d="M95.57,84.22c.1,1.07.51,2.06.57,3.17a3.26,3.26,0,0,1-.08.82,2.73,2.73,0,0,0-.14.75,6.39,6.39,0,0,0,.3,1.52,15.19,15.19,0,0,1,.92,6.36,12,12,0,0,1-.36,1.6,13,13,0,0,0-.33,1.53,20.65,20.65,0,0,0-.16,3.15,38.58,38.58,0,0,0,.71,6.32,28.57,28.57,0,0,1-1.1-6.31A17.47,17.47,0,0,1,96,99.9a13,13,0,0,1,.33-1.6,11.41,11.41,0,0,0,.32-1.52,10.47,10.47,0,0,0-.07-3.11c-.17-1-.47-2-.72-3.1A6.6,6.6,0,0,1,95.61,89a2.84,2.84,0,0,1,.17-.81,3.88,3.88,0,0,0,.12-.76C95.92,86.35,95.58,85.29,95.57,84.22Z"
                fill="#44322c"
              />
            </g>
          </g>
          <g>
            <ellipse
              cx="295.27"
              cy="195.08"
              rx="44.89"
              ry="7.92"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M271.71,188.25c-7.72,3.91-9.39,4.74-16.33,2s-20.85-18.9-5.29-29.74,31.42,3.61,31.42,10c0,0-27-28.08,0-35.31s18.06,21.13,16.12,25.3c0,0,9.73-19.18,20.85-13.34s4,41.92-16.5,32.63c0,0,27.62-13.18,36.23,1s-47,17-56.7,12.23S271.71,188.25,271.71,188.25Z"
              fill="#1f441f"
            />
            <path
              d="M271.08,154.76c6.95,2.8,4.59-11,4.59-11s3.06-1.67,3.12-7.75C268.42,139.92,268.26,147.62,271.08,154.76Z"
              fill="#659965"
            />
            <path
              d="M295.13,164.92c-19.74-1.95-20-18.63-9.18-23.35S295.13,164.92,295.13,164.92Z"
              fill="#245624"
            />
            <path
              d="M286.16,179.52c-32,5.21-38.17-17.46-22.58-28.23S286.16,179.52,286.16,179.52Z"
              fill="#245624"
            />
            <path
              d="M299.56,178.84c24.06,14.18,38.23-4.55,29.83-18.93S299.56,178.84,299.56,178.84Z"
              fill="#245624"
            />
            <g>
              <path
                d="M297.63,160.47c10,6.67,11.95-5.28,11.95-5.28,4.28-.59,5.56-4.84,5.95-9.06C305.69,144.57,297.63,160.47,297.63,160.47Z"
                fill="#659965"
              />
              <path d="M297.63,160.47c.2-.43.47-1.12.77-2Z" fill="#659965" />
            </g>
            <path
              d="M309.27,183c13.73,3.61,22.44-4.63,22.55-14.21-.51.45-1,.86-1.51,1.23-6.55,4.86-11.83,2.94-11.83,2.94s-.84,11.12-8.9,8.2Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M275,191.19s-24.46-8.62-18.62-22.52,14.18-6.39,18.62,11.12c0,0-5.83-37.25,15.57-32.25s5.28,31.41,0,32.25c0,0,15.57-21.13,25.57-5.84S299.71,192.3,293,191.19,275,191.19,275,191.19Z"
                fill="#659965"
              />
              <path
                d="M316.11,174a14.22,14.22,0,0,0-3.64-3.92c-3,11.17-14,9.9-14,9.9s.28,10.28-11.67,8.34l-1.19,2.42a48.84,48.84,0,0,1,7.44.5C299.71,192.3,326.12,189.24,316.11,174Z"
                fill="#396039"
              />
              <path
                d="M281.51,176.87s7.22,3.44,16-4.42c3.84-6.66,6.28-16.23,0-21.62-4.31,10.75-11.85,10.75-11.85,10.75S293.74,174.92,281.51,176.87Z"
                fill="#396039"
              />
              <path
                d="M275.66,191.12a21.94,21.94,0,0,1-9.17-10.36c-6.73.87-9.73-6.92-10.72-10.36-3.24,12.88,19.2,20.79,19.2,20.79Z"
                fill="#396039"
              />
            </g>
            <path
              d="M257,185.21a29.74,29.74,0,0,1-9.52-1.45,21.49,21.49,0,0,0,7.86,6.45c6.45,2.59,8.35,2,14.78-1.18A31.5,31.5,0,0,1,257,185.21Z"
              fill="#172d17"
            />
            <path
              d="M338.07,180.54c-3.54,7.37-13,8.17-16.26,7.17,0,0-4.41,5.71-20.35,7.38,18.89-.34,42.6-4.71,36.75-14.33Z"
              fill="#172d17"
            />
            <path
              d="M275.67,191.05c-8.06-3.34-5.28-11.4,0-10.29S275.67,191.05,275.67,191.05Z"
              fill="#245624"
            />
            <path
              d="M275.17,190.66c12.8,12.41,25.66.66,19.29-8.34S275.17,190.66,275.17,190.66Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <path
              d="M62.48,139c16.92-1.62-7.78,60.59,38.88,66.18s62.21,14.91,57.35,26.1-53.46,16.78-71,8.39-71-34.49-58.32-67.11S52.76,140,62.48,139Z"
              fill="#396039"
            />
            <path
              d="M64.32,144.6c13.57-1.36-6.24,50.67,31.18,55.34s49.89,12.48,46,21.83-42.88,14-56.91,7-56.91-28.85-46.78-56.13S56.52,145.38,64.32,144.6Z"
              fill="#493b1b"
            />
            <g>
              <path
                d="M122.73,211.81a9.7,9.7,0,0,1-.61-1.66,11.06,11.06,0,0,1-.36-1.73,8.05,8.05,0,0,1-.07-1.77,3.31,3.31,0,0,1,.5-1.71,5.47,5.47,0,0,0-.08,1.71c0,.57.1,1.13.18,1.7C122.44,209.49,122.63,210.63,122.73,211.81Z"
                fill="#396039"
              />
              <path
                d="M122.55,204.58c-3.79-1.09-2.17-5.79,2.72-5.07S122.55,204.58,122.55,204.58Z"
                fill="#a04d90"
              />
              <path
                d="M122.55,204.58s3.62-3.08,5.61-2-.18,4.16-2.89,3.43S122.55,204.58,122.55,204.58Z"
                fill="#a04d90"
              />
              <path
                d="M122,204.58a3.18,3.18,0,0,0-2.89-2.17c-2.35-.18-3.26,3.79-.91,3.79A5.45,5.45,0,0,0,122,204.58Z"
                fill="#a04d90"
              />
              <path
                d="M122.19,204.21s4.34,1.27,1.63,2.72S118.94,206.2,122.19,204.21Z"
                fill="#a04d90"
              />
              <path
                d="M116.9,205.24a1.24,1.24,0,0,0,1.31,1,5.45,5.45,0,0,0,3.8-1.62C120.93,205,118.14,205.63,116.9,205.24Z"
                fill="#7f3374"
              />
              <path d="M119.12,203.85a3,3,0,0,1,2.89.73" fill="#7f3374" />
              <path d="M122.92,200.78s-2.17,1.45-.91,3.43" fill="#7f3374" />
              <path d="M126,200.6s-3.62,1.45-3.8,3.61" fill="#7f3374" />
              <path d="M122.55,204.58a4.76,4.76,0,0,1,3.8-.91" fill="#7f3374" />
              <path d="M122.73,204.88s3.44-1,5.43-.67" fill="#7f3374" />
              <path
                d="M128.55,204.88s-3.66.81-5.63.17a6.61,6.61,0,0,0,2.35,1A3,3,0,0,0,128.55,204.88Z"
                fill="#7f3374"
              />
              <path
                d="M124.65,206.2a4.93,4.93,0,0,1-4.09.11c.06,1,1.55,1.53,3.26.62A1.8,1.8,0,0,0,124.65,206.2Z"
                fill="#7f3374"
              />
              <path
                d="M122.19,204.94a1.06,1.06,0,0,0-.36,1.26"
                fill="#7f3374"
              />
              <path d="M122.19,204.58s.36,1.62,1.45,1.62" fill="#7f3374" />
              <ellipse
                cx="122.28"
                cy="204.4"
                rx="0.99"
                ry="0.54"
                fill="#b7b720"
              />
              <path
                d="M122.63,211.44s-1.07-1.71,1.1-3.16C123.73,208.28,124.43,211,122.63,211.44Z"
                fill="#396039"
              />
              <path
                d="M121.83,208.92s.54-.55-1.63-1.45C120.2,207.47,120,208.74,121.83,208.92Z"
                fill="#396039"
              />
              <path
                d="M123.73,208.28c-.17.54-.41,1-.57,1.58-.1.25-.2.51-.28.78a2.76,2.76,0,0,0-.15.81,1.71,1.71,0,0,1,0-.84c.06-.28.15-.55.23-.82A11.1,11.1,0,0,1,123.73,208.28Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M106.32,224c.05-.65.17-1.27.24-1.9,0-.31.08-.63.1-.94a2.72,2.72,0,0,0,0-.94,1.84,1.84,0,0,1,.28.94,5.32,5.32,0,0,1,0,1A6.71,6.71,0,0,1,106.32,224Z"
                fill="#396039"
              />
              <path
                d="M106.42,220.06c2.08-.59,1.19-3.17-1.49-2.78S106.42,220.06,106.42,220.06Z"
                fill="#a04d90"
              />
              <path
                d="M106.42,220.06s-2-1.68-3.08-1.09.1,2.29,1.59,1.89S106.42,220.06,106.42,220.06Z"
                fill="#a04d90"
              />
              <path
                d="M106.71,220.06a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.09.5,2.09A3,3,0,0,1,106.71,220.06Z"
                fill="#a04d90"
              />
              <path
                d="M106.61,219.87s-2.38.69-.89,1.49S108.4,221,106.61,219.87Z"
                fill="#a04d90"
              />
              <path
                d="M109.52,220.43a.69.69,0,0,1-.72.53,3,3,0,0,1-2.09-.9A5.71,5.71,0,0,0,109.52,220.43Z"
                fill="#7f3374"
              />
              <path d="M108.3,219.67a1.63,1.63,0,0,0-1.59.39" fill="#7f3374" />
              <path d="M106.22,218a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
              <path d="M104.53,217.88s2,.79,2.08,2" fill="#7f3374" />
              <path
                d="M106.42,220.06a2.63,2.63,0,0,0-2.09-.49"
                fill="#7f3374"
              />
              <path d="M106.32,220.23a8.55,8.55,0,0,0-3-.36" fill="#7f3374" />
              <path
                d="M103.12,220.23a7.57,7.57,0,0,0,3.1.09,3.74,3.74,0,0,1-1.29.54A1.68,1.68,0,0,1,103.12,220.23Z"
                fill="#7f3374"
              />
              <path
                d="M105.26,221a2.76,2.76,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,105.26,221Z"
                fill="#7f3374"
              />
              <path d="M106.61,220.26a.59.59,0,0,1,.2.7" fill="#7f3374" />
              <path d="M106.61,220.06s-.19.9-.79.9" fill="#7f3374" />
              <ellipse
                cx="106.56"
                cy="219.97"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M106.37,223.83s.59-.94-.6-1.73C105.77,222.1,105.38,223.58,106.37,223.83Z"
                fill="#396039"
              />
              <path
                d="M106.81,222.45s-.29-.3.9-.8C107.71,221.65,107.81,222.35,106.81,222.45Z"
                fill="#396039"
              />
              <path
                d="M105.77,222.1a6.4,6.4,0,0,1,.41.83,2,2,0,0,1,.14.91,2.23,2.23,0,0,0-.08-.45c0-.14-.1-.28-.16-.43S105.86,222.4,105.77,222.1Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M109.71,211.81c.05-.65.18-1.27.25-1.9.05-.31.07-.62.1-.93a3,3,0,0,0,0-.94,1.81,1.81,0,0,1,.28.93,6.38,6.38,0,0,1,0,1A6.73,6.73,0,0,1,109.71,211.81Z"
                fill="#396039"
              />
              <path
                d="M109.81,207.84c2.09-.6,1.19-3.18-1.49-2.78S109.81,207.84,109.81,207.84Z"
                fill="#a04d90"
              />
              <path
                d="M109.81,207.84s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S109.81,207.84,109.81,207.84Z"
                fill="#a04d90"
              />
              <path
                d="M110.11,207.84a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,110.11,207.84Z"
                fill="#a04d90"
              />
              <path
                d="M110,207.64s-2.38.69-.89,1.49S111.8,208.73,110,207.64Z"
                fill="#a04d90"
              />
              <path
                d="M112.92,208.2a.69.69,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.68,5.68,0,0,0,112.92,208.2Z"
                fill="#7f3374"
              />
              <path d="M111.7,207.44a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M109.61,205.75s1.2.8.5,1.89" fill="#7f3374" />
              <path d="M107.93,205.65s2,.8,2.08,2" fill="#7f3374" />
              <path d="M109.81,207.84a2.58,2.58,0,0,0-2.08-.5" fill="#7f3374" />
              <path d="M109.72,208a8.58,8.58,0,0,0-3-.36" fill="#7f3374" />
              <path
                d="M106.52,208a7.65,7.65,0,0,0,3.09.1,3.8,3.8,0,0,1-1.29.53A1.66,1.66,0,0,1,106.52,208Z"
                fill="#7f3374"
              />
              <path
                d="M108.66,208.73a2.72,2.72,0,0,0,2.25.06c0,.55-.86.84-1.79.34A1,1,0,0,1,108.66,208.73Z"
                fill="#7f3374"
              />
              <path d="M110,208a.57.57,0,0,1,.2.69" fill="#7f3374" />
              <path d="M110,207.84s-.2.89-.79.89" fill="#7f3374" />
              <ellipse
                cx="109.96"
                cy="207.74"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M109.77,211.61s.59-.94-.6-1.74C109.17,209.87,108.78,211.35,109.77,211.61Z"
                fill="#396039"
              />
              <path
                d="M110.21,210.22s-.3-.3.89-.79C111.1,209.43,111.2,210.12,110.21,210.22Z"
                fill="#396039"
              />
              <path
                d="M109.17,209.87a5.28,5.28,0,0,1,.4.83,1.78,1.78,0,0,1,.14.91,1.32,1.32,0,0,0-.08-.44c0-.15-.1-.29-.15-.43C109.39,210.44,109.26,210.17,109.17,209.87Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M120.08,221.32a6.05,6.05,0,0,1-.58-2.84,1.81,1.81,0,0,1,.28-.93,2.7,2.7,0,0,0,0,.94c0,.31,0,.62.1.93C119.9,220.05,120,220.67,120.08,221.32Z"
                fill="#396039"
              />
              <path
                d="M120,217.35c-2.09-.6-1.19-3.18,1.49-2.78S120,217.35,120,217.35Z"
                fill="#a04d90"
              />
              <path
                d="M120,217.35s2-1.69,3.07-1.09-.09,2.28-1.58,1.88S120,217.35,120,217.35Z"
                fill="#a04d90"
              />
              <path
                d="M119.68,217.35a1.75,1.75,0,0,0-1.59-1.19c-1.29-.1-1.79,2.08-.5,2.08A3,3,0,0,0,119.68,217.35Z"
                fill="#a04d90"
              />
              <path
                d="M119.78,217.15s2.38.69.89,1.49S118,218.24,119.78,217.15Z"
                fill="#a04d90"
              />
              <path
                d="M116.87,217.71a.69.69,0,0,0,.72.53,3,3,0,0,0,2.09-.89A5.69,5.69,0,0,1,116.87,217.71Z"
                fill="#7f3374"
              />
              <path d="M118.09,217a1.62,1.62,0,0,1,1.59.4" fill="#7f3374" />
              <path d="M120.18,215.26s-1.2.8-.5,1.89" fill="#7f3374" />
              <path d="M121.86,215.16s-2,.8-2.08,2" fill="#7f3374" />
              <path d="M120,217.35a2.58,2.58,0,0,1,2.08-.5" fill="#7f3374" />
              <path d="M120.07,217.51a8.55,8.55,0,0,1,3-.36" fill="#7f3374" />
              <path
                d="M123.27,217.51a7.65,7.65,0,0,1-3.09.1,3.8,3.8,0,0,0,1.29.53A1.66,1.66,0,0,0,123.27,217.51Z"
                fill="#7f3374"
              />
              <path
                d="M121.13,218.24a2.71,2.71,0,0,1-2.25.06c0,.55.86.84,1.79.34A1,1,0,0,0,121.13,218.24Z"
                fill="#7f3374"
              />
              <path d="M119.78,217.55a.57.57,0,0,0-.2.69" fill="#7f3374" />
              <path d="M119.78,217.35s.2.89.79.89" fill="#7f3374" />
              <ellipse
                cx="119.83"
                cy="217.25"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M120,221.12s-.59-.94.6-1.74C120.62,219.38,121,220.86,120,221.12Z"
                fill="#396039"
              />
              <path
                d="M119.58,219.73s.3-.3-.89-.79C118.69,218.94,118.59,219.63,119.58,219.73Z"
                fill="#396039"
              />
              <path
                d="M120.62,219.38c-.09.3-.22.57-.31.87a3.12,3.12,0,0,0-.15.43,1.32,1.32,0,0,0-.08.44,1.78,1.78,0,0,1,.14-.91A5.28,5.28,0,0,1,120.62,219.38Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M97.83,211.13c0-.65.17-1.27.24-1.9.05-.31.08-.62.1-.93a2.7,2.7,0,0,0,0-.94,1.81,1.81,0,0,1,.28.93,6.38,6.38,0,0,1,0,1A6.71,6.71,0,0,1,97.83,211.13Z"
                fill="#396039"
              />
              <path
                d="M97.92,207.16c2.09-.6,1.2-3.18-1.48-2.78S97.92,207.16,97.92,207.16Z"
                fill="#a04d90"
              />
              <path
                d="M97.92,207.16s-2-1.69-3.07-1.09.1,2.28,1.59,1.88S97.92,207.16,97.92,207.16Z"
                fill="#a04d90"
              />
              <path
                d="M98.22,207.16A1.75,1.75,0,0,1,99.81,206c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,98.22,207.16Z"
                fill="#a04d90"
              />
              <path
                d="M98.12,207s-2.38.69-.89,1.49S99.91,208.05,98.12,207Z"
                fill="#a04d90"
              />
              <path
                d="M101,207.52a.69.69,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.71,5.71,0,0,0,101,207.52Z"
                fill="#7f3374"
              />
              <path d="M99.81,206.76a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M97.73,205.07a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
              <path d="M96,205s2,.8,2.08,2" fill="#7f3374" />
              <path d="M97.92,207.16a2.58,2.58,0,0,0-2.08-.5" fill="#7f3374" />
              <path d="M97.83,207.33a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M94.63,207.33a8,8,0,0,0,3.1.09,3.9,3.9,0,0,1-1.29.53A1.69,1.69,0,0,1,94.63,207.33Z"
                fill="#7f3374"
              />
              <path
                d="M96.77,208.05a2.71,2.71,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,96.77,208.05Z"
                fill="#7f3374"
              />
              <path d="M98.12,207.36a.57.57,0,0,1,.2.69" fill="#7f3374" />
              <path d="M98.12,207.16s-.2.89-.79.89" fill="#7f3374" />
              <ellipse
                cx="98.07"
                cy="207.06"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M97.88,210.93s.59-.94-.6-1.74C97.28,209.19,96.89,210.67,97.88,210.93Z"
                fill="#396039"
              />
              <path
                d="M98.32,209.54s-.3-.3.9-.79C99.22,208.75,99.31,209.44,98.32,209.54Z"
                fill="#396039"
              />
              <path
                d="M97.28,209.19a5.28,5.28,0,0,1,.4.83,1.9,1.9,0,0,1,.15.91,2.14,2.14,0,0,0-.08-.44c0-.15-.1-.29-.16-.43C97.5,209.77,97.37,209.49,97.28,209.19Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M72,191.77c0-.65.18-1.27.24-1.9.06-.31.08-.62.11-.93a3,3,0,0,0,0-.94,1.81,1.81,0,0,1,.28.94,6.3,6.3,0,0,1,0,1A6.73,6.73,0,0,1,72,191.77Z"
                fill="#396039"
              />
              <path
                d="M72.11,187.8c2.09-.6,1.19-3.18-1.49-2.78S72.11,187.8,72.11,187.8Z"
                fill="#a04d90"
              />
              <path
                d="M72.11,187.8s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S72.11,187.8,72.11,187.8Z"
                fill="#a04d90"
              />
              <path
                d="M72.41,187.8A1.75,1.75,0,0,1,74,186.61c1.29-.1,1.79,2.08.49,2.08A3,3,0,0,1,72.41,187.8Z"
                fill="#a04d90"
              />
              <path
                d="M72.31,187.6s-2.38.69-.89,1.49S74.1,188.69,72.31,187.6Z"
                fill="#a04d90"
              />
              <path
                d="M75.22,188.16a.69.69,0,0,1-.73.53,3,3,0,0,1-2.08-.89A5.68,5.68,0,0,0,75.22,188.16Z"
                fill="#7f3374"
              />
              <path d="M74,187.4a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M71.91,185.71a1.41,1.41,0,0,1,.5,1.89" fill="#7f3374" />
              <path d="M70.23,185.61s2,.8,2.08,2" fill="#7f3374" />
              <path d="M72.11,187.8a2.58,2.58,0,0,0-2.08-.5" fill="#7f3374" />
              <path d="M72,188a8.43,8.43,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M68.82,188a7.91,7.91,0,0,0,3.09.09,3.8,3.8,0,0,1-1.29.53A1.68,1.68,0,0,1,68.82,188Z"
                fill="#7f3374"
              />
              <path
                d="M71,188.69a2.72,2.72,0,0,0,2.25.06c0,.55-.86.84-1.79.34A1,1,0,0,1,71,188.69Z"
                fill="#7f3374"
              />
              <path d="M72.31,188a.57.57,0,0,1,.2.69" fill="#7f3374" />
              <path d="M72.31,187.8s-.2.89-.79.89" fill="#7f3374" />
              <ellipse
                cx="72.26"
                cy="187.7"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M72.07,191.57s.59-.94-.6-1.74C71.47,189.83,71.08,191.31,72.07,191.57Z"
                fill="#396039"
              />
              <path
                d="M72.51,190.18s-.3-.3.89-.79C73.4,189.39,73.5,190.08,72.51,190.18Z"
                fill="#396039"
              />
              <path
                d="M71.47,189.83a5.28,5.28,0,0,1,.4.83,1.8,1.8,0,0,1,.14.91,1.32,1.32,0,0,0-.08-.44c0-.15-.1-.29-.15-.43S71.56,190.13,71.47,189.83Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M50.61,180.9c.06-.65.18-1.27.25-1.9,0-.31.07-.62.1-.93a2.71,2.71,0,0,0-.05-.94,1.81,1.81,0,0,1,.28.94,6,6,0,0,1-.58,2.83Z"
                fill="#396039"
              />
              <path
                d="M50.71,176.93c2.09-.6,1.2-3.18-1.49-2.78S50.71,176.93,50.71,176.93Z"
                fill="#a04d90"
              />
              <path
                d="M50.71,176.93s-2-1.69-3.07-1.09.1,2.28,1.58,1.88S50.71,176.93,50.71,176.93Z"
                fill="#a04d90"
              />
              <path
                d="M51,176.93a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,51,176.93Z"
                fill="#a04d90"
              />
              <path
                d="M50.91,176.73s-2.38.7-.89,1.49S52.7,177.82,50.91,176.73Z"
                fill="#a04d90"
              />
              <path
                d="M53.82,177.29a.68.68,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.69,5.69,0,0,0,53.82,177.29Z"
                fill="#7f3374"
              />
              <path d="M52.6,176.53a1.62,1.62,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M50.52,174.84a1.4,1.4,0,0,1,.49,1.89" fill="#7f3374" />
              <path d="M48.83,174.75s2,.79,2.08,2" fill="#7f3374" />
              <path d="M50.71,176.93a2.63,2.63,0,0,0-2.08-.5" fill="#7f3374" />
              <path d="M50.62,177.1a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M47.42,177.1a8,8,0,0,0,3.1.09,3.68,3.68,0,0,1-1.3.53A1.68,1.68,0,0,1,47.42,177.1Z"
                fill="#7f3374"
              />
              <path
                d="M49.56,177.82a2.71,2.71,0,0,0,2.25.06c0,.55-.85.84-1.79.34A1,1,0,0,1,49.56,177.82Z"
                fill="#7f3374"
              />
              <path d="M50.91,177.13a.58.58,0,0,1,.2.69" fill="#7f3374" />
              <path d="M50.91,176.93s-.2.89-.79.89" fill="#7f3374" />
              <ellipse
                cx="50.86"
                cy="176.83"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M50.67,180.7s.59-.94-.6-1.73C50.07,179,49.68,180.44,50.67,180.7Z"
                fill="#396039"
              />
              <path
                d="M51.11,179.31s-.3-.3.89-.79C52,178.52,52.1,179.21,51.11,179.31Z"
                fill="#396039"
              />
              <path
                d="M50.07,179a4.79,4.79,0,0,1,.4.82,1.8,1.8,0,0,1,.14.91,1.62,1.62,0,0,0-.07-.44c0-.15-.1-.29-.16-.43C50.29,179.54,50.16,179.26,50.07,179Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M61.82,160.18c0-.64.18-1.27.25-1.89,0-.32.07-.63.1-.94a3,3,0,0,0-.05-.94,1.81,1.81,0,0,1,.28.94,6.25,6.25,0,0,1,0,1A6.63,6.63,0,0,1,61.82,160.18Z"
                fill="#396039"
              />
              <path
                d="M61.92,156.21c2.09-.59,1.19-3.18-1.49-2.78S61.92,156.21,61.92,156.21Z"
                fill="#a04d90"
              />
              <path
                d="M61.92,156.21s-2-1.69-3.08-1.09.1,2.28,1.59,1.89S61.92,156.21,61.92,156.21Z"
                fill="#a04d90"
              />
              <path
                d="M62.22,156.21A1.75,1.75,0,0,1,63.81,155c1.29-.1,1.79,2.09.5,2.09A3,3,0,0,1,62.22,156.21Z"
                fill="#a04d90"
              />
              <path
                d="M62.12,156s-2.38.7-.89,1.49S63.91,157.11,62.12,156Z"
                fill="#a04d90"
              />
              <path
                d="M65,156.57a.69.69,0,0,1-.72.54,3,3,0,0,1-2.09-.9A5.56,5.56,0,0,0,65,156.57Z"
                fill="#7f3374"
              />
              <path d="M63.81,155.81a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M61.72,154.13a1.39,1.39,0,0,1,.5,1.88" fill="#7f3374" />
              <path d="M60,154s2,.79,2.08,2" fill="#7f3374" />
              <path d="M61.92,156.21a2.6,2.6,0,0,0-2.08-.49" fill="#7f3374" />
              <path d="M61.83,156.38a8.5,8.5,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M58.63,156.38a7.91,7.91,0,0,0,3.09.09,3.74,3.74,0,0,1-1.29.54A1.7,1.7,0,0,1,58.63,156.38Z"
                fill="#7f3374"
              />
              <path
                d="M60.77,157.11a2.7,2.7,0,0,0,2.25,0c0,.56-.86.84-1.79.34A1,1,0,0,1,60.77,157.11Z"
                fill="#7f3374"
              />
              <path d="M62.12,156.41a.59.59,0,0,1,.2.7" fill="#7f3374" />
              <path d="M62.12,156.21s-.2.9-.79.9" fill="#7f3374" />
              <ellipse
                cx="62.07"
                cy="156.11"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M61.88,160s.59-.94-.6-1.73C61.28,158.25,60.89,159.73,61.88,160Z"
                fill="#396039"
              />
              <path
                d="M62.32,158.59s-.3-.29.89-.79C63.21,157.8,63.31,158.5,62.32,158.59Z"
                fill="#396039"
              />
              <path
                d="M61.28,158.25a4.88,4.88,0,0,1,.4.83,1.75,1.75,0,0,1,.14.9,1.36,1.36,0,0,0-.08-.44,3.12,3.12,0,0,0-.15-.43C61.5,158.82,61.37,158.54,61.28,158.25Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M64.88,151.35c.05-.65.17-1.27.24-1.9a7.34,7.34,0,0,0,.1-.93,3,3,0,0,0,0-.94,1.81,1.81,0,0,1,.27.94,5.22,5.22,0,0,1,0,1A6.63,6.63,0,0,1,64.88,151.35Z"
                fill="#396039"
              />
              <path
                d="M65,147.38c2.08-.6,1.19-3.18-1.49-2.78S65,147.38,65,147.38Z"
                fill="#a04d90"
              />
              <path
                d="M65,147.38s-2-1.69-3.08-1.09.1,2.28,1.59,1.89S65,147.38,65,147.38Z"
                fill="#a04d90"
              />
              <path
                d="M65.28,147.38a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.78,2.08.49,2.08A3,3,0,0,1,65.28,147.38Z"
                fill="#a04d90"
              />
              <path
                d="M65.18,147.18s-2.39.7-.9,1.49S67,148.27,65.18,147.18Z"
                fill="#a04d90"
              />
              <path
                d="M68.09,147.74a.68.68,0,0,1-.73.53,3,3,0,0,1-2.08-.89A5.68,5.68,0,0,0,68.09,147.74Z"
                fill="#7f3374"
              />
              <path d="M66.87,147a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M64.78,145.3a1.4,1.4,0,0,1,.5,1.88" fill="#7f3374" />
              <path d="M63.09,145.2s2,.79,2.09,2" fill="#7f3374" />
              <path d="M65,147.38a2.64,2.64,0,0,0-2.09-.5" fill="#7f3374" />
              <path d="M64.88,147.55a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M61.69,147.55a7.89,7.89,0,0,0,3.09.09,3.74,3.74,0,0,1-1.29.54A1.69,1.69,0,0,1,61.69,147.55Z"
                fill="#7f3374"
              />
              <path
                d="M63.83,148.27a2.65,2.65,0,0,0,2.24.06c0,.55-.85.84-1.79.34A1,1,0,0,1,63.83,148.27Z"
                fill="#7f3374"
              />
              <path d="M65.18,147.58a.58.58,0,0,1,.2.69" fill="#7f3374" />
              <path d="M65.18,147.38s-.2.89-.8.89" fill="#7f3374" />
              <ellipse
                cx="65.13"
                cy="147.28"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M64.93,151.15s.6-.94-.6-1.73C64.33,149.42,64,150.89,64.93,151.15Z"
                fill="#396039"
              />
              <path
                d="M65.38,149.76s-.3-.29.89-.79C66.27,149,66.37,149.66,65.38,149.76Z"
                fill="#396039"
              />
              <path
                d="M64.33,149.42a5.82,5.82,0,0,1,.41.83,1.75,1.75,0,0,1,.14.9,1.32,1.32,0,0,0-.08-.44c0-.15-.1-.29-.15-.43C64.56,150,64.43,149.71,64.33,149.42Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M46.88,173.43c0-.65.17-1.27.24-1.9a7.34,7.34,0,0,0,.1-.93,3,3,0,0,0,0-.94,1.9,1.9,0,0,1,.27.93,5.33,5.33,0,0,1,0,1A6.73,6.73,0,0,1,46.88,173.43Z"
                fill="#396039"
              />
              <path
                d="M47,169.46c2.08-.6,1.19-3.18-1.49-2.78S47,169.46,47,169.46Z"
                fill="#a04d90"
              />
              <path
                d="M47,169.46s-2-1.69-3.08-1.09.1,2.28,1.59,1.88S47,169.46,47,169.46Z"
                fill="#a04d90"
              />
              <path
                d="M47.28,169.46a1.73,1.73,0,0,1,1.58-1.19c1.3-.1,1.79,2.08.5,2.08A3,3,0,0,1,47.28,169.46Z"
                fill="#a04d90"
              />
              <path
                d="M47.18,169.26s-2.39.69-.9,1.49S49,170.35,47.18,169.26Z"
                fill="#a04d90"
              />
              <path
                d="M50.08,169.82a.67.67,0,0,1-.72.53,3,3,0,0,1-2.08-.89A5.65,5.65,0,0,0,50.08,169.82Z"
                fill="#7f3374"
              />
              <path d="M48.86,169.06a1.61,1.61,0,0,0-1.58.4" fill="#7f3374" />
              <path d="M46.78,167.37a1.41,1.41,0,0,1,.5,1.89" fill="#7f3374" />
              <path d="M45.09,167.27s2,.8,2.09,2" fill="#7f3374" />
              <path d="M47,169.46a2.6,2.6,0,0,0-2.09-.5" fill="#7f3374" />
              <path d="M46.88,169.62a8.55,8.55,0,0,0-3-.36" fill="#7f3374" />
              <path
                d="M43.69,169.62a7.63,7.63,0,0,0,3.09.1,3.8,3.8,0,0,1-1.29.53A1.66,1.66,0,0,1,43.69,169.62Z"
                fill="#7f3374"
              />
              <path
                d="M45.83,170.35a2.69,2.69,0,0,0,2.24.06c0,.55-.85.84-1.79.34A1,1,0,0,1,45.83,170.35Z"
                fill="#7f3374"
              />
              <path d="M47.18,169.66a.58.58,0,0,1,.2.69" fill="#7f3374" />
              <path d="M47.18,169.46s-.2.89-.8.89" fill="#7f3374" />
              <ellipse
                cx="47.13"
                cy="169.36"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M46.93,173.23s.59-.94-.6-1.74C46.33,171.49,46,173,46.93,173.23Z"
                fill="#396039"
              />
              <path
                d="M47.38,171.84s-.3-.3.89-.79C48.27,171.05,48.37,171.74,47.38,171.84Z"
                fill="#396039"
              />
              <path
                d="M46.33,171.49a6.4,6.4,0,0,1,.41.83,1.9,1.9,0,0,1,.14.91,1.32,1.32,0,0,0-.08-.44,3.16,3.16,0,0,0-.16-.43C46.55,172.06,46.42,171.79,46.33,171.49Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M39.75,179.88c0-.65.17-1.27.24-1.9,0-.31.08-.62.1-.93a2.71,2.71,0,0,0-.05-.94,1.81,1.81,0,0,1,.28.94,5.22,5.22,0,0,1,0,1A6.61,6.61,0,0,1,39.75,179.88Z"
                fill="#396039"
              />
              <path
                d="M39.85,175.91c2.08-.59,1.19-3.18-1.49-2.78S39.85,175.91,39.85,175.91Z"
                fill="#a04d90"
              />
              <path
                d="M39.85,175.91s-2-1.69-3.08-1.09.1,2.28,1.59,1.89S39.85,175.91,39.85,175.91Z"
                fill="#a04d90"
              />
              <path
                d="M40.14,175.91a1.75,1.75,0,0,1,1.59-1.19c1.29-.1,1.79,2.08.5,2.08A3,3,0,0,1,40.14,175.91Z"
                fill="#a04d90"
              />
              <path
                d="M40,175.71s-2.38.7-.89,1.49S41.83,176.8,40,175.71Z"
                fill="#a04d90"
              />
              <path
                d="M43,176.27a.68.68,0,0,1-.72.53,3,3,0,0,1-2.09-.89A5.59,5.59,0,0,0,43,176.27Z"
                fill="#7f3374"
              />
              <path d="M41.73,175.51a1.65,1.65,0,0,0-1.59.4" fill="#7f3374" />
              <path d="M39.65,173.83a1.39,1.39,0,0,1,.49,1.88" fill="#7f3374" />
              <path d="M38,173.73s2,.79,2.08,2" fill="#7f3374" />
              <path d="M39.85,175.91a2.66,2.66,0,0,0-2.09-.5" fill="#7f3374" />
              <path d="M39.75,176.08a8.47,8.47,0,0,0-3-.37" fill="#7f3374" />
              <path
                d="M36.55,176.08a8,8,0,0,0,3.1.09,3.74,3.74,0,0,1-1.29.54A1.71,1.71,0,0,1,36.55,176.08Z"
                fill="#7f3374"
              />
              <path
                d="M38.69,176.8a2.67,2.67,0,0,0,2.25.06c0,.55-.85.84-1.79.34A.94.94,0,0,1,38.69,176.8Z"
                fill="#7f3374"
              />
              <path d="M40,176.11a.58.58,0,0,1,.2.69" fill="#7f3374" />
              <path d="M40,175.91s-.19.89-.79.89" fill="#7f3374" />
              <ellipse
                cx="39.99"
                cy="175.81"
                rx="0.55"
                ry="0.3"
                fill="#b7b720"
              />
              <path
                d="M39.8,179.68s.59-.94-.6-1.73C39.2,178,38.81,179.42,39.8,179.68Z"
                fill="#396039"
              />
              <path
                d="M40.24,178.29s-.3-.29.9-.79C41.14,177.5,41.24,178.19,40.24,178.29Z"
                fill="#396039"
              />
              <path
                d="M39.2,178a4.88,4.88,0,0,1,.4.83,1.86,1.86,0,0,1,.15.9,2.14,2.14,0,0,0-.08-.44c-.05-.15-.1-.29-.16-.43C39.42,178.52,39.29,178.24,39.2,178Z"
                fill="#204220"
              />
            </g>
            <path
              d="M133.91,209.07h0c3.68,10,1.64,15.48-5.49,15.48s-28.87,4.75-39.06-1.7-50.63-19-53-43.81c-2.07,24.27,35.31,43.29,48.23,49.75,14,7,53,2.34,56.91-7C143.45,217.08,141.28,212.78,133.91,209.07Z"
              fill="#35280f"
            />
            <g>
              <path
                d="M84,224.38a10.37,10.37,0,0,1-.61-1.66A11.06,11.06,0,0,1,83,221a8.12,8.12,0,0,1-.07-1.78,3.28,3.28,0,0,1,.5-1.7,5.47,5.47,0,0,0-.08,1.71c0,.56.1,1.13.18,1.7C83.72,222.06,83.91,223.2,84,224.38Z"
                fill="#396039"
              />
              <path
                d="M83.83,217.14c-3.79-1.08-2.17-5.78,2.72-5.06S83.83,217.14,83.83,217.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M83.83,217.14s3.62-3.07,5.61-2-.18,4.16-2.89,3.44S83.83,217.14,83.83,217.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M83.29,217.14A3.18,3.18,0,0,0,80.4,215c-2.35-.18-3.26,3.8-.91,3.8A5.44,5.44,0,0,0,83.29,217.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M83.47,216.78s4.34,1.27,1.63,2.71S80.22,218.77,83.47,216.78Z"
                fill="#4d4d9e"
              />
              <path
                d="M78.18,217.8a1.24,1.24,0,0,0,1.31,1,5.44,5.44,0,0,0,3.8-1.63C82.21,217.61,79.42,218.2,78.18,217.8Z"
                fill="#36367a"
              />
              <path d="M80.4,216.42a3,3,0,0,1,2.89.72" fill="#36367a" />
              <path d="M84.2,213.35s-2.17,1.44-.91,3.43" fill="#36367a" />
              <path d="M87.27,213.17s-3.62,1.44-3.8,3.61" fill="#36367a" />
              <path d="M83.83,217.14a4.77,4.77,0,0,1,3.8-.9" fill="#36367a" />
              <path d="M84,217.45s3.44-1,5.43-.67" fill="#36367a" />
              <path
                d="M89.83,217.45s-3.66.81-5.63.16a6.56,6.56,0,0,0,2.35,1A3.06,3.06,0,0,0,89.83,217.45Z"
                fill="#36367a"
              />
              <path
                d="M85.93,218.77a4.93,4.93,0,0,1-4.09.11c.06,1,1.55,1.52,3.26.61A1.8,1.8,0,0,0,85.93,218.77Z"
                fill="#36367a"
              />
              <path d="M83.47,217.51a1.06,1.06,0,0,0-.36,1.26" fill="#36367a" />
              <path d="M83.47,217.14s.36,1.63,1.45,1.63" fill="#36367a" />
              <ellipse
                cx="83.56"
                cy="216.96"
                rx="0.99"
                ry="0.54"
                fill="#b7b720"
              />
              <path
                d="M83.91,224s-1.07-1.7,1.1-3.15C85,220.85,85.71,223.54,83.91,224Z"
                fill="#396039"
              />
              <path
                d="M83.11,221.48s.54-.54-1.63-1.44C81.48,220,81.3,221.3,83.11,221.48Z"
                fill="#396039"
              />
              <path
                d="M85,220.85c-.17.54-.4,1-.57,1.57-.1.26-.2.52-.28.78A2.83,2.83,0,0,0,84,224a1.71,1.71,0,0,1,0-.84c.06-.27.15-.54.23-.81A10.56,10.56,0,0,1,85,220.85Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M72.13,217.92a10,10,0,0,1-.62-1.65,14.76,14.76,0,0,1-.36-1.73,8.82,8.82,0,0,1-.07-1.78,3.41,3.41,0,0,1,.5-1.71,5.48,5.48,0,0,0-.08,1.71c0,.57.1,1.14.19,1.71C71.83,215.61,72,216.74,72.13,217.92Z"
                fill="#396039"
              />
              <path
                d="M72,210.69c-3.8-1.08-2.17-5.79,2.71-5.06S72,210.69,72,210.69Z"
                fill="#4d4d9e"
              />
              <path
                d="M72,210.69s3.61-3.07,5.6-2-.18,4.16-2.89,3.44S72,210.69,72,210.69Z"
                fill="#4d4d9e"
              />
              <path
                d="M71.4,210.69a3.18,3.18,0,0,0-2.89-2.17c-2.35-.18-3.25,3.8-.9,3.8A5.4,5.4,0,0,0,71.4,210.69Z"
                fill="#4d4d9e"
              />
              <path
                d="M71.58,210.33s4.34,1.26,1.63,2.71S68.33,212.32,71.58,210.33Z"
                fill="#4d4d9e"
              />
              <path
                d="M66.29,211.35a1.25,1.25,0,0,0,1.32,1,5.4,5.4,0,0,0,3.79-1.63C70.32,211.15,67.54,211.75,66.29,211.35Z"
                fill="#36367a"
              />
              <path d="M68.51,210a2.94,2.94,0,0,1,2.89.72" fill="#36367a" />
              <path d="M72.31,206.89s-2.17,1.45-.91,3.44" fill="#36367a" />
              <path d="M75.38,206.71s-3.61,1.45-3.8,3.62" fill="#36367a" />
              <path d="M72,210.69a4.7,4.7,0,0,1,3.79-.9" fill="#36367a" />
              <path d="M72.12,211s3.44-1,5.43-.66" fill="#36367a" />
              <path
                d="M77.94,211s-3.65.82-5.63.17a6.75,6.75,0,0,0,2.35,1A3.06,3.06,0,0,0,77.94,211Z"
                fill="#36367a"
              />
              <path
                d="M74,212.32a4.87,4.87,0,0,1-4.09.1c.07,1,1.56,1.53,3.26.62A1.75,1.75,0,0,0,74,212.32Z"
                fill="#36367a"
              />
              <path d="M71.58,211.05a1.07,1.07,0,0,0-.36,1.27" fill="#36367a" />
              <path d="M71.58,210.69s.37,1.63,1.45,1.63" fill="#36367a" />
              <ellipse
                cx="71.68"
                cy="210.51"
                rx="0.99"
                ry="0.54"
                fill="#b7b720"
              />
              <path
                d="M72,217.55s-1.08-1.71,1.09-3.15C73.12,214.4,73.83,217.09,72,217.55Z"
                fill="#396039"
              />
              <path
                d="M71.22,215s.55-.54-1.62-1.45C69.6,213.58,69.41,214.85,71.22,215Z"
                fill="#396039"
              />
              <path
                d="M73.12,214.4c-.17.53-.4,1-.57,1.57-.1.26-.2.52-.28.78a3.2,3.2,0,0,0-.14.81,1.5,1.5,0,0,1,0-.84c.06-.28.14-.55.22-.81A10.06,10.06,0,0,1,73.12,214.4Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M49.92,161.54a9,9,0,0,1-.73-2.53,7.37,7.37,0,0,1,0-1.33,2.44,2.44,0,0,1,.37-1.27,4.24,4.24,0,0,0-.06,1.28c0,.42.07.85.14,1.27C49.68,159.81,49.85,160.66,49.92,161.54Z"
                fill="#396039"
              />
              <path
                d="M49.78,156.14c-2.83-.81-1.62-4.33,2-3.79S49.78,156.14,49.78,156.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M49.78,156.14s2.71-2.3,4.19-1.49-.13,3.11-2.16,2.57S49.78,156.14,49.78,156.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M49.38,156.14a2.38,2.38,0,0,0-2.16-1.62c-1.76-.14-2.44,2.83-.68,2.83A4.07,4.07,0,0,0,49.38,156.14Z"
                fill="#4d4d9e"
              />
              <path
                d="M49.51,155.87s3.25.94,1.22,2S47.08,157.35,49.51,155.87Z"
                fill="#4d4d9e"
              />
              <path
                d="M45.56,156.63a.92.92,0,0,0,1,.72,4.07,4.07,0,0,0,2.84-1.21A7.73,7.73,0,0,1,45.56,156.63Z"
                fill="#36367a"
              />
              <path d="M47.22,155.6a2.2,2.2,0,0,1,2.16.54" fill="#36367a" />
              <path d="M50.05,153.3a1.9,1.9,0,0,0-.67,2.57" fill="#36367a" />
              <path d="M52.35,153.17s-2.7,1.08-2.84,2.7" fill="#36367a" />
              <path d="M49.78,156.14a3.57,3.57,0,0,1,2.84-.68" fill="#36367a" />
              <path d="M49.92,156.36a11.67,11.67,0,0,1,4-.49" fill="#36367a" />
              <path
                d="M54.26,156.36a10.46,10.46,0,0,1-4.21.13,5.25,5.25,0,0,0,1.76.73A2.27,2.27,0,0,0,54.26,156.36Z"
                fill="#36367a"
              />
              <path
                d="M51.35,157.35a3.69,3.69,0,0,1-3.06.08c.05.75,1.16,1.14,2.44.46A1.26,1.26,0,0,0,51.35,157.35Z"
                fill="#36367a"
              />
              <path d="M49.51,156.41a.78.78,0,0,0-.27.94" fill="#36367a" />
              <path d="M49.51,156.14s.27,1.21,1.08,1.21" fill="#36367a" />
              <ellipse cx="49.58" cy="156" rx="0.74" ry="0.41" fill="#b7b720" />
              <path
                d="M49.84,161.26s-.8-1.27.82-2.35C50.66,158.91,51.19,160.92,49.84,161.26Z"
                fill="#396039"
              />
              <path
                d="M49.24,159.38s.41-.41-1.21-1.08C48,158.3,47.89,159.24,49.24,159.38Z"
                fill="#396039"
              />
              <path
                d="M50.66,158.91c-.12.4-.3.77-.42,1.17a5.89,5.89,0,0,0-.21.59,2,2,0,0,0-.11.6,2.47,2.47,0,0,1,.19-1.23A7.38,7.38,0,0,1,50.66,158.91Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M60.79,171.39a9,9,0,0,1-.73-2.53,7.37,7.37,0,0,1-.05-1.33,2.44,2.44,0,0,1,.37-1.27,4.24,4.24,0,0,0-.06,1.28,11,11,0,0,0,.14,1.27C60.55,169.66,60.72,170.51,60.79,171.39Z"
                fill="#396039"
              />
              <path
                d="M60.65,166c-2.84-.81-1.62-4.33,2-3.79S60.65,166,60.65,166Z"
                fill="#4d4d9e"
              />
              <path
                d="M60.65,166s2.7-2.3,4.19-1.49-.13,3.11-2.16,2.57S60.65,166,60.65,166Z"
                fill="#4d4d9e"
              />
              <path
                d="M60.25,166a2.38,2.38,0,0,0-2.16-1.62c-1.76-.14-2.44,2.83-.68,2.83A4.07,4.07,0,0,0,60.25,166Z"
                fill="#4d4d9e"
              />
              <path
                d="M60.38,165.72s3.24.94,1.22,2S58,167.2,60.38,165.72Z"
                fill="#4d4d9e"
              />
              <path
                d="M56.43,166.48a.92.92,0,0,0,1,.72A4.07,4.07,0,0,0,60.25,166,7.73,7.73,0,0,1,56.43,166.48Z"
                fill="#36367a"
              />
              <path d="M58.09,165.45a2.2,2.2,0,0,1,2.16.54" fill="#36367a" />
              <path d="M60.92,163.15a1.9,1.9,0,0,0-.67,2.57" fill="#36367a" />
              <path d="M63.22,163s-2.7,1.09-2.84,2.71" fill="#36367a" />
              <path d="M60.65,166a3.57,3.57,0,0,1,2.84-.68" fill="#36367a" />
              <path d="M60.78,166.21a11.7,11.7,0,0,1,4.06-.49" fill="#36367a" />
              <path
                d="M65.13,166.21a10.46,10.46,0,0,1-4.21.13,5.25,5.25,0,0,0,1.76.73A2.28,2.28,0,0,0,65.13,166.21Z"
                fill="#36367a"
              />
              <path
                d="M62.22,167.2a3.69,3.69,0,0,1-3.06.08c.05.75,1.16,1.14,2.44.46A1.26,1.26,0,0,0,62.22,167.2Z"
                fill="#36367a"
              />
              <path d="M60.38,166.26a.78.78,0,0,0-.27.94" fill="#36367a" />
              <path d="M60.38,166s.27,1.21,1.08,1.21" fill="#36367a" />
              <ellipse
                cx="60.45"
                cy="165.85"
                rx="0.74"
                ry="0.41"
                fill="#b7b720"
              />
              <path
                d="M60.71,171.11s-.8-1.27.82-2.35C61.53,168.76,62.06,170.77,60.71,171.11Z"
                fill="#396039"
              />
              <path
                d="M60.11,169.23s.41-.41-1.21-1.08C58.9,168.15,58.76,169.09,60.11,169.23Z"
                fill="#396039"
              />
              <path
                d="M61.53,168.76c-.13.4-.3.77-.42,1.17a4.14,4.14,0,0,0-.21.59,2,2,0,0,0-.11.6,2.37,2.37,0,0,1,.19-1.23A7.38,7.38,0,0,1,61.53,168.76Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M45.84,193.13a9.29,9.29,0,0,1-.73-2.53,8.41,8.41,0,0,1,0-1.33,2.42,2.42,0,0,1,.38-1.28,4,4,0,0,0-.07,1.28c0,.43.07.85.14,1.28C45.61,191.4,45.78,192.25,45.84,193.13Z"
                fill="#396039"
              />
              <path
                d="M45.71,187.72c-2.84-.81-1.62-4.32,2-3.78S45.71,187.72,45.71,187.72Z"
                fill="#4d4d9e"
              />
              <path
                d="M45.71,187.72s2.7-2.29,4.19-1.48-.14,3.11-2.17,2.57S45.71,187.72,45.71,187.72Z"
                fill="#4d4d9e"
              />
              <path
                d="M45.3,187.72a2.38,2.38,0,0,0-2.16-1.62c-1.76-.13-2.43,2.84-.67,2.84A4,4,0,0,0,45.3,187.72Z"
                fill="#4d4d9e"
              />
              <path
                d="M45.44,187.45s3.24,1,1.21,2S43,188.94,45.44,187.45Z"
                fill="#4d4d9e"
              />
              <path
                d="M41.48,188.22a.94.94,0,0,0,1,.72,4,4,0,0,0,2.83-1.22A7.72,7.72,0,0,1,41.48,188.22Z"
                fill="#36367a"
              />
              <path d="M43.14,187.18a2.23,2.23,0,0,1,2.16.54" fill="#36367a" />
              <path d="M46,184.89s-1.62,1.08-.68,2.56" fill="#36367a" />
              <path d="M48.27,184.75s-2.7,1.08-2.83,2.7" fill="#36367a" />
              <path d="M45.71,187.72a3.53,3.53,0,0,1,2.83-.67" fill="#36367a" />
              <path d="M45.84,188a11.62,11.62,0,0,1,4.06-.5" fill="#36367a" />
              <path
                d="M50.19,188a10.47,10.47,0,0,1-4.21.13,5.16,5.16,0,0,0,1.75.73A2.3,2.3,0,0,0,50.19,188Z"
                fill="#36367a"
              />
              <path
                d="M47.27,188.94a3.67,3.67,0,0,1-3.05.08c0,.75,1.16,1.14,2.43.46A1.31,1.31,0,0,0,47.27,188.94Z"
                fill="#36367a"
              />
              <path d="M45.44,188a.8.8,0,0,0-.27.95" fill="#36367a" />
              <path d="M45.44,187.72s.27,1.22,1.08,1.22" fill="#36367a" />
              <ellipse
                cx="45.5"
                cy="187.59"
                rx="0.74"
                ry="0.41"
                fill="#b7b720"
              />
              <path
                d="M45.77,192.85s-.81-1.28.82-2.36C46.59,190.49,47.11,192.51,45.77,192.85Z"
                fill="#396039"
              />
              <path
                d="M45.17,191s.4-.41-1.22-1.08C44,189.89,43.82,190.83,45.17,191Z"
                fill="#396039"
              />
              <path
                d="M46.59,190.49c-.13.41-.31.78-.43,1.18-.07.19-.15.38-.21.58a2.12,2.12,0,0,0-.11.61,2.52,2.52,0,0,1,.2-1.24A6.54,6.54,0,0,1,46.59,190.49Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M113,217.92c.07-.88.23-1.72.33-2.58.07-.42.1-.85.14-1.27a3.94,3.94,0,0,0-.07-1.28,2.42,2.42,0,0,1,.38,1.28,8.28,8.28,0,0,1-.05,1.32A8.86,8.86,0,0,1,113,217.92Z"
                fill="#396039"
              />
              <path
                d="M113.11,212.52c2.84-.81,1.63-4.32-2-3.78S113.11,212.52,113.11,212.52Z"
                fill="#4d4d9e"
              />
              <path
                d="M113.11,212.52s-2.7-2.3-4.18-1.49.13,3.11,2.16,2.57S113.11,212.52,113.11,212.52Z"
                fill="#4d4d9e"
              />
              <path
                d="M113.52,212.52a2.36,2.36,0,0,1,2.16-1.62c1.76-.14,2.43,2.83.68,2.83A4.07,4.07,0,0,1,113.52,212.52Z"
                fill="#4d4d9e"
              />
              <path
                d="M113.38,212.25s-3.24.94-1.21,2S115.82,213.73,113.38,212.25Z"
                fill="#4d4d9e"
              />
              <path
                d="M117.34,213a.93.93,0,0,1-1,.72,4.07,4.07,0,0,1-2.84-1.21A7.73,7.73,0,0,0,117.34,213Z"
                fill="#36367a"
              />
              <path d="M115.68,212a2.2,2.2,0,0,0-2.16.54" fill="#36367a" />
              <path
                d="M112.84,209.68a1.91,1.91,0,0,1,.68,2.57"
                fill="#36367a"
              />
              <path d="M110.55,209.55s2.7,1.08,2.83,2.7" fill="#36367a" />
              <path
                d="M113.11,212.52a3.56,3.56,0,0,0-2.83-.68"
                fill="#36367a"
              />
              <path d="M113,212.75a11.59,11.59,0,0,0-4-.5" fill="#36367a" />
              <path
                d="M108.63,212.75a10.75,10.75,0,0,0,4.21.12,5.16,5.16,0,0,1-1.75.73A2.31,2.31,0,0,1,108.63,212.75Z"
                fill="#36367a"
              />
              <path
                d="M111.55,213.73a3.67,3.67,0,0,0,3,.08c0,.76-1.16,1.14-2.43.46A1.26,1.26,0,0,1,111.55,213.73Z"
                fill="#36367a"
              />
              <path d="M113.38,212.79a.78.78,0,0,1,.27.94" fill="#36367a" />
              <path d="M113.38,212.52s-.27,1.21-1.08,1.21" fill="#36367a" />
              <ellipse
                cx="113.32"
                cy="212.38"
                rx="0.74"
                ry="0.41"
                fill="#b7b720"
              />
              <path
                d="M113.05,217.65s.81-1.28-.81-2.36C112.24,215.29,111.71,217.3,113.05,217.65Z"
                fill="#396039"
              />
              <path
                d="M113.65,215.76s-.4-.4,1.22-1.08C114.87,214.68,115,215.63,113.65,215.76Z"
                fill="#396039"
              />
              <path
                d="M112.24,215.29a7.38,7.38,0,0,1,.55,1.13,2.59,2.59,0,0,1,.19,1.23,2.05,2.05,0,0,0-.11-.6c-.06-.2-.13-.39-.21-.59C112.54,216.07,112.36,215.69,112.24,215.29Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M130.86,220.64c.11-1.24.31-2.45.46-3.65.09-.6.15-1.2.2-1.8a5.82,5.82,0,0,0-.09-1.81,3.6,3.6,0,0,1,.53,1.81,9.08,9.08,0,0,1-.07,1.88,12.83,12.83,0,0,1-.39,1.82A10.77,10.77,0,0,1,130.86,220.64Z"
                fill="#396039"
              />
              <path
                d="M131.05,213c4-1.14,2.29-6.11-2.87-5.35S131.05,213,131.05,213Z"
                fill="#4d4d9e"
              />
              <path
                d="M131.05,213s-3.82-3.25-5.92-2.1.19,4.39,3.05,3.63S131.05,213,131.05,213Z"
                fill="#4d4d9e"
              />
              <path
                d="M131.62,213a3.36,3.36,0,0,1,3.06-2.29c2.48-.19,3.43,4,.95,4A5.74,5.74,0,0,1,131.62,213Z"
                fill="#4d4d9e"
              />
              <path
                d="M131.43,212.62s-4.58,1.34-1.72,2.86S134.87,214.72,131.43,212.62Z"
                fill="#4d4d9e"
              />
              <path
                d="M137,213.7a1.32,1.32,0,0,1-1.39,1,5.74,5.74,0,0,1-4-1.72C132.76,213.49,135.71,214.12,137,213.7Z"
                fill="#36367a"
              />
              <path d="M134.68,212.24a3.13,3.13,0,0,0-3.06.76" fill="#36367a" />
              <path d="M130.67,209s2.29,1.53,1,3.63" fill="#36367a" />
              <path d="M127.42,208.8s3.82,1.53,4,3.82" fill="#36367a" />
              <path d="M131.05,213a5,5,0,0,0-4-.95" fill="#36367a" />
              <path d="M130.86,213.32s-3.63-1.08-5.73-.7" fill="#36367a" />
              <path
                d="M124.72,213.32s3.86.86,5.95.18a7.39,7.39,0,0,1-2.49,1A3.21,3.21,0,0,1,124.72,213.32Z"
                fill="#36367a"
              />
              <path
                d="M128.83,214.72a5.16,5.16,0,0,0,4.32.11c-.06,1.06-1.64,1.61-3.44.65A2,2,0,0,1,128.83,214.72Z"
                fill="#36367a"
              />
              <path
                d="M131.43,213.38a1.13,1.13,0,0,1,.38,1.34"
                fill="#36367a"
              />
              <path d="M131.43,213s-.38,1.72-1.53,1.72" fill="#36367a" />
              <ellipse
                cx="131.33"
                cy="212.81"
                rx="1.05"
                ry="0.57"
                fill="#b7b720"
              />
              <path
                d="M131,220.25s1.14-1.81-1.15-3.33C129.81,216.92,129.06,219.76,131,220.25Z"
                fill="#396039"
              />
              <path
                d="M131.81,217.58s-.57-.57,1.72-1.52C133.53,216.06,133.72,217.39,131.81,217.58Z"
                fill="#396039"
              />
              <path
                d="M129.81,216.92a8.64,8.64,0,0,1,.77,1.59,6.11,6.11,0,0,1,.26.86,2.06,2.06,0,0,1,0,.89,2.8,2.8,0,0,0-.17-.86c-.08-.27-.18-.55-.28-.82C130.21,218,130,217.48,129.81,216.92Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M95.53,227.09c.1-1.17.29-2.31.44-3.45.08-.57.13-1.14.18-1.71a5.48,5.48,0,0,0-.08-1.71,3.31,3.31,0,0,1,.5,1.71,8.14,8.14,0,0,1-.07,1.78,11.56,11.56,0,0,1-.36,1.73A10.9,10.9,0,0,1,95.53,227.09Z"
                fill="#396039"
              />
              <path
                d="M95.71,219.86c3.79-1.08,2.17-5.79-2.72-5.06S95.71,219.86,95.71,219.86Z"
                fill="#a04d90"
              />
              <path
                d="M95.71,219.86s-3.62-3.07-5.61-2,.18,4.16,2.89,3.44S95.71,219.86,95.71,219.86Z"
                fill="#a04d90"
              />
              <path
                d="M96.25,219.86a3.18,3.18,0,0,1,2.89-2.17c2.35-.18,3.26,3.8.91,3.8A5.41,5.41,0,0,1,96.25,219.86Z"
                fill="#a04d90"
              />
              <path
                d="M96.07,219.5s-4.34,1.26-1.63,2.71S99.32,221.49,96.07,219.5Z"
                fill="#a04d90"
              />
              <path
                d="M101.36,220.52a1.25,1.25,0,0,1-1.31,1,5.41,5.41,0,0,1-3.8-1.63C97.33,220.32,100.12,220.92,101.36,220.52Z"
                fill="#7f3374"
              />
              <path d="M99.14,219.14a2.94,2.94,0,0,0-2.89.72" fill="#7f3374" />
              <path d="M95.34,216.06s2.17,1.45.91,3.44" fill="#7f3374" />
              <path d="M92.27,215.88s3.62,1.45,3.8,3.62" fill="#7f3374" />
              <path d="M95.71,219.86a4.73,4.73,0,0,0-3.8-.9" fill="#7f3374" />
              <path d="M95.53,220.16s-3.44-1-5.43-.66" fill="#7f3374" />
              <path
                d="M89.71,220.16s3.66.82,5.63.17a6.75,6.75,0,0,1-2.35,1A3.06,3.06,0,0,1,89.71,220.16Z"
                fill="#7f3374"
              />
              <path
                d="M93.61,221.49a4.87,4.87,0,0,0,4.09.1c-.06,1-1.55,1.53-3.26.62A1.8,1.8,0,0,1,93.61,221.49Z"
                fill="#7f3374"
              />
              <path d="M96.07,220.22a1.07,1.07,0,0,1,.36,1.27" fill="#7f3374" />
              <path d="M96.07,219.86s-.36,1.63-1.45,1.63" fill="#7f3374" />
              <ellipse
                cx="95.98"
                cy="219.68"
                rx="0.99"
                ry="0.54"
                fill="#b7b720"
              />
              <path
                d="M95.62,226.72s1.08-1.71-1.09-3.15C94.53,223.57,93.83,226.26,95.62,226.72Z"
                fill="#396039"
              />
              <path
                d="M96.43,224.2s-.54-.54,1.63-1.45C98.06,222.75,98.24,224,96.43,224.2Z"
                fill="#396039"
              />
              <path
                d="M94.53,223.57a10.06,10.06,0,0,1,.74,1.51c.08.27.16.53.23.81a1.71,1.71,0,0,1,0,.84,2.83,2.83,0,0,0-.15-.81c-.08-.26-.18-.52-.28-.78C94.93,224.61,94.7,224.1,94.53,223.57Z"
                fill="#204220"
              />
            </g>
            <path
              d="M52.17,168.67c3.43-2.86-6.79,21.4,16.3,30.91s31.25,15.29,35,13.93c0,0-9.51,2.71-27.17-8.49s-19.7-6.12-23.78-13.25S50.13,170.37,52.17,168.67Z"
              fill="#35280f"
            />
            <path
              d="M66.44,184.3c-1.36,3.39,2.71,7.47,6.45,8.83S84.44,200.6,85.8,202s6.45-1,8.49.68c0,0-9.85,3.06-12.91-.68s-14.26-6.45-16.3-9.17-3.4-10.19-2.38-14.61S67.8,180.9,66.44,184.3Z"
              fill="#35280f"
            />
            <path d="M94.29,228.11c1.36-1,1-1.36,3-1" fill="#493b1b" />
            <path d="M83.42,225.06c1.36-1.7,3.73-.68,3.73-.68" fill="#493b1b" />
            <path d="M70.51,218.6c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
            <path d="M59.64,211.47c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
            <path d="M53.19,205.7c1.36-1.7,3.74-.68,3.74-.68" fill="#493b1b" />
            <path d="M47.42,200.26c1.36-1.7,3.73-.68,3.73-.68" fill="#493b1b" />
            <g>
              <path
                d="M62.25,203.32c.11-1.25.31-2.45.46-3.65.09-.6.15-1.2.2-1.8a5.82,5.82,0,0,0-.09-1.81,3.48,3.48,0,0,1,.53,1.81,9,9,0,0,1-.07,1.87,14.15,14.15,0,0,1-.38,1.83A10.81,10.81,0,0,1,62.25,203.32Z"
                fill="#396039"
              />
              <path
                d="M62.44,195.68c4-1.15,2.29-6.11-2.87-5.35S62.44,195.68,62.44,195.68Z"
                fill="#4d4d9e"
              />
              <path
                d="M62.44,195.68s-3.82-3.25-5.92-2.1.19,4.39,3,3.63S62.44,195.68,62.44,195.68Z"
                fill="#4d4d9e"
              />
              <path
                d="M63,195.68a3.37,3.37,0,0,1,3.06-2.29c2.48-.19,3.44,4,1,4A5.74,5.74,0,0,1,63,195.68Z"
                fill="#4d4d9e"
              />
              <path
                d="M62.82,195.3s-4.58,1.33-1.72,2.86S66.26,197.4,62.82,195.3Z"
                fill="#4d4d9e"
              />
              <path
                d="M68.41,196.38a1.32,1.32,0,0,1-1.39,1,5.74,5.74,0,0,1-4-1.72C64.15,196.17,67.1,196.79,68.41,196.38Z"
                fill="#36367a"
              />
              <path d="M66.07,194.92a3.13,3.13,0,0,0-3.06.76" fill="#36367a" />
              <path d="M62.06,191.67s2.29,1.53.95,3.63" fill="#36367a" />
              <path d="M58.81,191.48s3.82,1.53,4,3.82" fill="#36367a" />
              <path d="M62.44,195.68a5,5,0,0,0-4-1" fill="#36367a" />
              <path d="M62.25,196s-3.63-1.08-5.73-.7" fill="#36367a" />
              <path
                d="M56.11,196s3.86.86,6,.18a7.39,7.39,0,0,1-2.49,1A3.24,3.24,0,0,1,56.11,196Z"
                fill="#36367a"
              />
              <path
                d="M60.23,197.4a5.23,5.23,0,0,0,4.31.11c-.06,1.06-1.64,1.61-3.44.65A1.87,1.87,0,0,1,60.23,197.4Z"
                fill="#36367a"
              />
              <path d="M62.82,196.06a1.11,1.11,0,0,1,.38,1.34" fill="#36367a" />
              <path d="M62.82,195.68s-.38,1.72-1.53,1.72" fill="#36367a" />
              <ellipse
                cx="62.73"
                cy="195.49"
                rx="1.05"
                ry="0.57"
                fill="#b7b720"
              />
              <path
                d="M62.35,202.93s1.14-1.81-1.15-3.34C61.2,199.59,60.45,202.44,62.35,202.93Z"
                fill="#396039"
              />
              <path
                d="M63.2,200.26s-.57-.57,1.72-1.53C64.92,198.73,65.11,200.07,63.2,200.26Z"
                fill="#396039"
              />
              <path
                d="M61.2,199.59a9.47,9.47,0,0,1,.78,1.6,7.78,7.78,0,0,1,.25.86,2.05,2.05,0,0,1,0,.89,2.79,2.79,0,0,0-.16-.86c-.09-.28-.19-.55-.29-.82C61.6,200.7,61.38,200.16,61.2,199.59Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M80.5,206c0-.59.16-1.15.22-1.71a8.17,8.17,0,0,0,.09-.85,2.38,2.38,0,0,0,0-.84,2.69,2.69,0,0,1,.22,1.72A6.12,6.12,0,0,1,80.5,206Z"
                fill="#396039"
              />
              <path
                d="M80.59,202.46c1.88-.54,1.08-2.86-1.34-2.5S80.59,202.46,80.59,202.46Z"
                fill="#4d4d9e"
              />
              <path
                d="M80.59,202.46s-1.78-1.52-2.77-1,.09,2.05,1.43,1.69S80.59,202.46,80.59,202.46Z"
                fill="#4d4d9e"
              />
              <path
                d="M80.86,202.46a1.58,1.58,0,0,1,1.43-1.07c1.16-.09,1.61,1.87.45,1.87A2.71,2.71,0,0,1,80.86,202.46Z"
                fill="#4d4d9e"
              />
              <path
                d="M80.77,202.28s-2.14.63-.8,1.34S82.38,203.26,80.77,202.28Z"
                fill="#4d4d9e"
              />
              <path
                d="M83.39,202.79a.61.61,0,0,1-.65.47,2.71,2.71,0,0,1-1.88-.8A5.16,5.16,0,0,0,83.39,202.79Z"
                fill="#36367a"
              />
              <path d="M82.29,202.1a1.46,1.46,0,0,0-1.43.36" fill="#36367a" />
              <path d="M80.41,200.58s1.08.72.45,1.7" fill="#36367a" />
              <path d="M78.9,200.49s1.78.72,1.87,1.79" fill="#36367a" />
              <path d="M80.59,202.46a2.32,2.32,0,0,0-1.87-.45" fill="#36367a" />
              <path d="M80.51,202.61a7.67,7.67,0,0,0-2.69-.33" fill="#36367a" />
              <path
                d="M77.63,202.61a7,7,0,0,0,2.78.08,3.25,3.25,0,0,1-1.16.48A1.49,1.49,0,0,1,77.63,202.61Z"
                fill="#36367a"
              />
              <path
                d="M79.56,203.26a2.44,2.44,0,0,0,2,.06c0,.49-.77.75-1.61.3A.83.83,0,0,1,79.56,203.26Z"
                fill="#36367a"
              />
              <path d="M80.77,202.64a.52.52,0,0,1,.18.62" fill="#36367a" />
              <path d="M80.77,202.46s-.18.8-.71.8" fill="#36367a" />
              <ellipse
                cx="80.73"
                cy="202.37"
                rx="0.49"
                ry="0.27"
                fill="#b7b720"
              />
              <path
                d="M80.55,205.85s.54-.84-.54-1.56C80,204.29,79.66,205.62,80.55,205.85Z"
                fill="#396039"
              />
              <path
                d="M81,204.6s-.27-.26.81-.71C81.76,203.89,81.85,204.52,81,204.6Z"
                fill="#396039"
              />
              <path
                d="M80,204.29a4.35,4.35,0,0,1,.37.75,1.65,1.65,0,0,1,.12.82,2.15,2.15,0,0,0-.21-.79C80.21,204.81,80.1,204.56,80,204.29Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M91.37,203c0-.59.16-1.14.22-1.71a8,8,0,0,0,.09-.84,2.44,2.44,0,0,0,0-.85,2.72,2.72,0,0,1,.22,1.73A6.16,6.16,0,0,1,91.37,203Z"
                fill="#396039"
              />
              <path
                d="M91.46,199.4c1.88-.53,1.08-2.86-1.34-2.5S91.46,199.4,91.46,199.4Z"
                fill="#4d4d9e"
              />
              <path
                d="M91.46,199.4s-1.79-1.52-2.77-1,.09,2.06,1.43,1.7S91.46,199.4,91.46,199.4Z"
                fill="#4d4d9e"
              />
              <path
                d="M91.73,199.4a1.58,1.58,0,0,1,1.43-1.07c1.16-.09,1.61,1.88.45,1.88A2.7,2.7,0,0,1,91.73,199.4Z"
                fill="#4d4d9e"
              />
              <path
                d="M91.64,199.22s-2.14.63-.8,1.34S93.25,200.21,91.64,199.22Z"
                fill="#4d4d9e"
              />
              <path
                d="M94.26,199.73a.62.62,0,0,1-.65.48,2.7,2.7,0,0,1-1.88-.81A5.15,5.15,0,0,0,94.26,199.73Z"
                fill="#36367a"
              />
              <path d="M93.16,199a1.49,1.49,0,0,0-1.43.36" fill="#36367a" />
              <path d="M91.28,197.53a1.25,1.25,0,0,1,.45,1.69" fill="#36367a" />
              <path d="M89.76,197.44s1.79.71,1.88,1.78" fill="#36367a" />
              <path d="M91.46,199.4a2.33,2.33,0,0,0-1.87-.44" fill="#36367a" />
              <path d="M91.38,199.55a7.71,7.71,0,0,0-2.69-.33" fill="#36367a" />
              <path
                d="M88.5,199.55a6.83,6.83,0,0,0,2.78.08,3.2,3.2,0,0,1-1.16.49A1.51,1.51,0,0,1,88.5,199.55Z"
                fill="#36367a"
              />
              <path
                d="M90.43,200.21a2.42,2.42,0,0,0,2,0c0,.5-.77.75-1.61.3A.87.87,0,0,1,90.43,200.21Z"
                fill="#36367a"
              />
              <path d="M91.64,199.58a.53.53,0,0,1,.18.63" fill="#36367a" />
              <path d="M91.64,199.4s-.18.81-.71.81" fill="#36367a" />
              <ellipse
                cx="91.6"
                cy="199.31"
                rx="0.49"
                ry="0.27"
                fill="#b7b720"
              />
              <path
                d="M91.42,202.79s.53-.84-.54-1.55C90.88,201.24,90.53,202.57,91.42,202.79Z"
                fill="#396039"
              />
              <path
                d="M91.82,201.55s-.27-.27.8-.72C92.62,200.83,92.71,201.46,91.82,201.55Z"
                fill="#396039"
              />
              <path
                d="M90.88,201.24a6.38,6.38,0,0,1,.37.74,1.65,1.65,0,0,1,.12.82,2.5,2.5,0,0,0-.21-.79C91.08,201.75,91,201.5,90.88,201.24Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M55,204.34c0-.59.16-1.15.22-1.71a8,8,0,0,0,.09-.84,2.69,2.69,0,0,0,0-.85,2.68,2.68,0,0,1,.21,1.72A5.78,5.78,0,0,1,55,204.34Z"
                fill="#396039"
              />
              <path
                d="M55.12,200.76c1.88-.54,1.07-2.86-1.34-2.5S55.12,200.76,55.12,200.76Z"
                fill="#4d4d9e"
              />
              <path
                d="M55.12,200.76s-1.79-1.52-2.77-1,.09,2.05,1.43,1.7S55.12,200.76,55.12,200.76Z"
                fill="#4d4d9e"
              />
              <path
                d="M55.39,200.76a1.58,1.58,0,0,1,1.43-1.07c1.16-.09,1.61,1.88.45,1.88A2.67,2.67,0,0,1,55.39,200.76Z"
                fill="#4d4d9e"
              />
              <path
                d="M55.3,200.58s-2.15.63-.81,1.34S56.91,201.57,55.3,200.58Z"
                fill="#4d4d9e"
              />
              <path
                d="M57.92,201.09a.62.62,0,0,1-.65.48,2.67,2.67,0,0,1-1.88-.81A5.15,5.15,0,0,0,57.92,201.09Z"
                fill="#36367a"
              />
              <path d="M56.82,200.4a1.49,1.49,0,0,0-1.43.36" fill="#36367a" />
              <path d="M54.94,198.88a1.27,1.27,0,0,1,.45,1.7" fill="#36367a" />
              <path d="M53.42,198.79s1.79.72,1.88,1.79" fill="#36367a" />
              <path d="M55.12,200.76a2.38,2.38,0,0,0-1.88-.45" fill="#36367a" />
              <path d="M55,200.91a7.64,7.64,0,0,0-2.68-.33" fill="#36367a" />
              <path
                d="M52.16,200.91a6.82,6.82,0,0,0,2.78.08,3.2,3.2,0,0,1-1.16.49A1.51,1.51,0,0,1,52.16,200.91Z"
                fill="#36367a"
              />
              <path
                d="M54.08,201.57a2.49,2.49,0,0,0,2,.05c0,.5-.77.75-1.62.3A.93.93,0,0,1,54.08,201.57Z"
                fill="#36367a"
              />
              <path d="M55.3,200.94a.53.53,0,0,1,.18.63" fill="#36367a" />
              <path d="M55.3,200.76s-.18.81-.72.81" fill="#36367a" />
              <ellipse
                cx="55.25"
                cy="200.67"
                rx="0.49"
                ry="0.27"
                fill="#b7b720"
              />
              <path
                d="M55.08,204.15s.53-.84-.54-1.56C54.54,202.59,54.19,203.93,55.08,204.15Z"
                fill="#396039"
              />
              <path
                d="M55.48,202.91s-.27-.27.8-.72C56.28,202.19,56.37,202.82,55.48,202.91Z"
                fill="#396039"
              />
              <path
                d="M54.54,202.59a5.72,5.72,0,0,1,.36.75,1.65,1.65,0,0,1,.13.82,2.44,2.44,0,0,0-.21-.79C54.74,203.11,54.62,202.86,54.54,202.59Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M103.1,199.42s-3.4,11.44.41,15.79"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.17"
              />
              <path
                d="M103.19,198.46c-3-1.48-6.14.64-5.93,2.44s3,4.55,3,4.55,1.27-1.8,2-3.18A12.28,12.28,0,0,0,103.19,198.46Z"
                fill="#ba8419"
              />
              <path
                d="M103.3,198.46s-2.4-1.27-1.94-1.7-.18.11.46-.42,3.92.64,3.7,1.59S103.3,198.46,103.3,198.46Z"
                fill="#ba8419"
              />
              <path
                d="M103.4,199a2.62,2.62,0,0,1,3,.74c1.17,1.49-.85,2.76-.85,2.76"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.11"
              />
              <path
                d="M101.4,196.72l.18.6a10.18,10.18,0,0,0,1.72,1.14s2,.42,2.22-.53a.49.49,0,0,0-.11-.42l-.36-.16a3.7,3.7,0,0,1-2.81-1l-.12-.12a.59.59,0,0,0-.3.12C101.2,196.85,101.77,196.37,101.4,196.72Z"
                fill="#a06f18"
              />
              <path
                d="M102.24,198.46s2.75,2.44,2,5.3c-.1.21,4.14-1.7,3.5-3.92S102.24,198.46,102.24,198.46Z"
                fill="#ba8419"
              />
              <path
                d="M100.22,198.24c-2.33-.31-2.75.43-4.23,1.49,0,0,3.07-6.46,7.2-1.27Z"
                fill="#ba8419"
              />
              <path
                d="M102.88,198.57l.22.85a5.15,5.15,0,0,1,1.15,4.34A3.7,3.7,0,0,0,102.88,198.57Z"
                fill="#a06f18"
              />
              <path
                d="M107.78,200.65s-1.26,2.15-3,.51l-.48,1a4,4,0,0,1-.08,1.64C104.16,203.94,107.4,202.5,107.78,200.65Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M100.22,198.24l2.43.18.36-.12a4.78,4.78,0,0,0-3.1-1c-1.8.11-3.92,2.44-3.92,2.44C97.47,198.67,97.89,197.93,100.22,198.24Z"
                fill="#a06f18"
              />
              <path
                d="M103.19,198.46c-3-1.48-6.14.64-5.93,2.44s3,4.55,3,4.55,1.27-1.8,2-3.18A12.28,12.28,0,0,0,103.19,198.46Z"
                fill="#ba8419"
              />
              <path
                d="M101.71,198.57A2.76,2.76,0,0,0,99,200.9"
                fill="#a06f18"
              />
              <path d="M102.24,199a2.79,2.79,0,0,0-1.91,2.76" fill="#a06f18" />
              <path
                d="M97.49,201.71a14.82,14.82,0,0,0,2.74,3.74s1.27-1.8,2-3.18l.11-.22C99.9,203.38,98.33,202.54,97.49,201.71Z"
                fill="#a06f18"
              />
              <path d="M103.83,198.78s1.69,0,2.22,1.16" fill="#a06f18" />
              <path
                d="M102.06,212.13s0-4.56,5.69-4.77"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.17"
              />
              <path
                d="M106.37,204.5s-2.28,1.27-1.3,3.39A3.74,3.74,0,0,0,106.37,204.5Z"
                fill="#396039"
              />
              <path
                d="M102.24,211a2.57,2.57,0,0,1,2.54-1.62S103.94,211.25,102.24,211Z"
                fill="#396039"
              />
              <path
                d="M106.74,207.45a3.42,3.42,0,0,1,4.19-2S109.22,208,106.74,207.45Z"
                fill="#396039"
              />
              <path
                d="M103.4,209s-1.27-.46-.52-2.26C102.88,206.73,104,207.87,103.4,209Z"
                fill="#396039"
              />
              <path
                d="M104.78,208a1.54,1.54,0,0,1,1.91.93A2.23,2.23,0,0,1,104.78,208Z"
                fill="#396039"
              />
              <path
                d="M101.71,209.75a9.6,9.6,0,0,0-3.5-3.87A4.68,4.68,0,0,0,101.71,209.75Z"
                fill="#396039"
              />
              <path
                d="M110.93,205.45l-.32-.08c-.66.66-2.21,2.08-3.48,2.14C109.4,207.7,110.93,205.45,110.93,205.45Z"
                fill="#204220"
              />
              <path
                d="M104.76,209.37h-.4a3.38,3.38,0,0,1-2,1.66,2.7,2.7,0,0,0,2.38-1.62Z"
                fill="#204220"
              />
              <g>
                <path d="M105.05,207.85l0,0,0,0Z" fill="#204220" />
                <path
                  d="M105.08,207.83c.14-.1.27-.21.39-.31a3.93,3.93,0,0,0,.9-3l-.06,0C106.15,205.35,105.71,207.29,105.08,207.83Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M104.81,208h0l0,.09a2.26,2.26,0,0,0,1.85.84,1.87,1.87,0,0,0-.32-.5A2.83,2.83,0,0,1,104.81,208Z"
                fill="#204220"
              />
              <path
                d="M98.21,205.88a4.67,4.67,0,0,0,3.42,3.84l.06,0v0c-1.65-.47-2.61-2.43-3-3.51A5,5,0,0,0,98.21,205.88Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M84.65,196.16s-2.87,9.62.34,13.27"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M84.72,195.35c-2.49-1.25-5.16.53-5,2.05s2.5,3.83,2.5,3.83a31.16,31.16,0,0,0,1.69-2.67A10.18,10.18,0,0,0,84.72,195.35Z"
                fill="#ba8419"
              />
              <path
                d="M84.81,195.35s-2-1.07-1.63-1.43-.15.09.39-.35,3.29.53,3.12,1.33S84.81,195.35,84.81,195.35Z"
                fill="#ba8419"
              />
              <path
                d="M84.9,195.8a2.2,2.2,0,0,1,2.5.62c1,1.25-.71,2.32-.71,2.32"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.09"
              />
              <path
                d="M83.22,193.89l.15.5a8.36,8.36,0,0,0,1.44,1s1.7.36,1.88-.45a.49.49,0,0,0-.1-.35l-.31-.14a3.08,3.08,0,0,1-2.35-.84l-.11-.1a.52.52,0,0,0-.25.1C83.05,194,83.53,193.6,83.22,193.89Z"
                fill="#a06f18"
              />
              <path
                d="M83.92,195.35s2.32,2.05,1.7,4.46c-.09.17,3.47-1.43,2.94-3.3S83.92,195.35,83.92,195.35Z"
                fill="#ba8419"
              />
              <path
                d="M82.22,195.17c-2-.27-2.31.36-3.56,1.25,0,0,2.59-5.44,6.06-1.07Z"
                fill="#ba8419"
              />
              <path
                d="M84.46,195.44l.19.72a4.36,4.36,0,0,1,1,3.65A3.12,3.12,0,0,0,84.46,195.44Z"
                fill="#a06f18"
              />
              <path
                d="M88.58,197.19s-1,1.81-2.5.43l-.4.81a3.42,3.42,0,0,1-.06,1.38C85.54,200,88.27,198.75,88.58,197.19Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M82.22,195.17l2,.15.3-.1a4,4,0,0,0-2.61-.85c-1.51.09-3.3,2-3.3,2C79.91,195.53,80.27,194.9,82.22,195.17Z"
                fill="#a06f18"
              />
              <path
                d="M84.72,195.35c-2.49-1.25-5.16.53-5,2.05s2.5,3.83,2.5,3.83a31.16,31.16,0,0,0,1.69-2.67A10.18,10.18,0,0,0,84.72,195.35Z"
                fill="#ba8419"
              />
              <path d="M83.48,195.44a2.33,2.33,0,0,0-2.32,2" fill="#a06f18" />
              <path d="M83.92,195.8a2.33,2.33,0,0,0-1.6,2.31" fill="#a06f18" />
              <path
                d="M79.93,198.08a12.54,12.54,0,0,0,2.3,3.15,31.16,31.16,0,0,0,1.69-2.67c0-.06.07-.12.1-.19C82,199.48,80.63,198.78,79.93,198.08Z"
                fill="#a06f18"
              />
              <path d="M85.26,195.62s1.43,0,1.87,1" fill="#a06f18" />
              <path
                d="M83.77,206.85s0-3.84,4.79-4"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M87.4,200.43s-1.92,1.07-1.1,2.85A3.13,3.13,0,0,0,87.4,200.43Z"
                fill="#396039"
              />
              <path
                d="M83.93,205.9a2.17,2.17,0,0,1,2.13-1.37S85.35,206.11,83.93,205.9Z"
                fill="#396039"
              />
              <path
                d="M87.7,202.91a2.89,2.89,0,0,1,3.53-1.68S89.79,203.34,87.7,202.91Z"
                fill="#396039"
              />
              <path
                d="M84.9,204.21s-1.07-.39-.44-1.91C84.46,202.3,85.44,203.26,84.9,204.21Z"
                fill="#396039"
              />
              <path
                d="M86.06,203.39a1.3,1.3,0,0,1,1.61.78A1.89,1.89,0,0,1,86.06,203.39Z"
                fill="#396039"
              />
              <path
                d="M83.48,204.84a8.11,8.11,0,0,0-2.94-3.25A3.92,3.92,0,0,0,83.48,204.84Z"
                fill="#396039"
              />
              <path
                d="M91.23,201.23l-.27-.07c-.55.56-1.86,1.75-2.93,1.8A4,4,0,0,0,91.23,201.23Z"
                fill="#204220"
              />
              <path
                d="M86,204.53a1.93,1.93,0,0,0-.34,0,2.83,2.83,0,0,1-1.65,1.39,2.26,2.26,0,0,0,2-1.36Z"
                fill="#204220"
              />
              <g>
                <path d="M86.29,203.25l0,0,0,0Z" fill="#204220" />
                <path
                  d="M86.31,203.23c.12-.09.23-.17.33-.26a3.29,3.29,0,0,0,.76-2.54l-.06,0A6.48,6.48,0,0,1,86.31,203.23Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M86.08,203.38h0l0,.08a1.92,1.92,0,0,0,1.56.7,1.69,1.69,0,0,0-.27-.42A2.39,2.39,0,0,1,86.08,203.38Z"
                fill="#204220"
              />
              <path
                d="M80.54,201.59a3.92,3.92,0,0,0,2.87,3.23l0,0h0c-1.39-.4-2.19-2-2.53-2.95Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M71.32,188s2.87,9.62-.34,13.27"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M71.24,187.2c2.5-1.25,5.17.53,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.31,10.31,0,0,1,71.24,187.2Z"
                fill="#ba8419"
              />
              <path
                d="M71.16,187.2s2-1.07,1.63-1.43.15.09-.39-.35-3.29.53-3.12,1.33S71.16,187.2,71.16,187.2Z"
                fill="#ba8419"
              />
              <path
                d="M71.07,187.64a2.21,2.21,0,0,0-2.5.63c-1,1.25.71,2.31.71,2.31"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.09"
              />
              <path
                d="M72.75,185.74l-.15.5a8.36,8.36,0,0,1-1.44,1s-1.7.35-1.88-.45a.49.49,0,0,1,.1-.35l.3-.14a3.09,3.09,0,0,0,2.36-.84l.11-.1a.52.52,0,0,1,.25.1C72.92,185.85,72.44,185.44,72.75,185.74Z"
                fill="#a06f18"
              />
              <path
                d="M72.05,187.2s-2.32,2.05-1.7,4.45c.09.18-3.47-1.42-2.94-3.29S72.05,187.2,72.05,187.2Z"
                fill="#ba8419"
              />
              <path
                d="M73.74,187c2-.27,2.32.36,3.57,1.25,0,0-2.59-5.44-6.07-1.07Z"
                fill="#ba8419"
              />
              <path
                d="M71.51,187.29l-.19.72a4.34,4.34,0,0,0-1,3.64A3.11,3.11,0,0,1,71.51,187.29Z"
                fill="#a06f18"
              />
              <path
                d="M67.39,189s1,1.81,2.5.43l.4.81a3.37,3.37,0,0,0,.06,1.37C70.43,191.81,67.7,190.6,67.39,189Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M73.74,187l-2,.14-.3-.1a4,4,0,0,1,2.61-.84c1.51.09,3.3,2.05,3.3,2.05C76.06,187.38,75.7,186.75,73.74,187Z"
                fill="#a06f18"
              />
              <path
                d="M71.24,187.2c2.5-1.25,5.17.53,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.31,10.31,0,0,1,71.24,187.2Z"
                fill="#ba8419"
              />
              <path d="M72.49,187.29a2.33,2.33,0,0,1,2.32,2" fill="#a06f18" />
              <path d="M72.05,187.64a2.35,2.35,0,0,1,1.6,2.32" fill="#a06f18" />
              <path
                d="M76,189.93a12.54,12.54,0,0,1-2.3,3.15,31.16,31.16,0,0,1-1.69-2.67,1.74,1.74,0,0,1-.1-.19C74,191.33,75.34,190.63,76,189.93Z"
                fill="#a06f18"
              />
              <path d="M70.71,187.47s-1.43,0-1.87,1" fill="#a06f18" />
              <path
                d="M72.2,198.7s0-3.84-4.79-4"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M68.57,192.28s1.92,1.07,1.1,2.85A3.13,3.13,0,0,1,68.57,192.28Z"
                fill="#396039"
              />
              <path
                d="M72,197.75a2.17,2.17,0,0,0-2.13-1.37S70.61,198,72,197.75Z"
                fill="#396039"
              />
              <path
                d="M68.27,194.76a2.89,2.89,0,0,0-3.53-1.68S66.18,195.19,68.27,194.76Z"
                fill="#396039"
              />
              <path
                d="M71.07,196.06s1.07-.39.44-1.91C71.51,194.15,70.53,195.11,71.07,196.06Z"
                fill="#396039"
              />
              <path
                d="M69.91,195.24a1.3,1.3,0,0,0-1.61.78A1.89,1.89,0,0,0,69.91,195.24Z"
                fill="#396039"
              />
              <path
                d="M72.49,196.69a8,8,0,0,1,2.94-3.25A3.92,3.92,0,0,1,72.49,196.69Z"
                fill="#396039"
              />
              <path
                d="M64.74,193.08,65,193c.55.56,1.86,1.75,2.93,1.8A4,4,0,0,1,64.74,193.08Z"
                fill="#204220"
              />
              <path
                d="M69.92,196.38a1.38,1.38,0,0,1,.35,0,2.83,2.83,0,0,0,1.65,1.39,2.26,2.26,0,0,1-2-1.36Z"
                fill="#204220"
              />
              <g>
                <path d="M69.68,195.1l0,0h0Z" fill="#204220" />
                <path
                  d="M69.66,195.08l-.33-.26a3.3,3.3,0,0,1-.76-2.54l.06,0A6.48,6.48,0,0,0,69.66,195.08Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M69.89,195.23h0a.25.25,0,0,1,0,.07,1.91,1.91,0,0,1-1.56.71,1.69,1.69,0,0,1,.27-.42A2.39,2.39,0,0,0,69.89,195.23Z"
                fill="#204220"
              />
              <path
                d="M75.43,193.44a3.92,3.92,0,0,1-2.87,3.23l0,0h0c1.39-.4,2.19-2,2.53-2.95Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M61.18,202.9s1.7,5.72-.2,7.89"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M61.13,202.42c1.49-.74,3.08.32,3,1.22s-1.48,2.27-1.48,2.27a18.54,18.54,0,0,1-1-1.59A6.16,6.16,0,0,1,61.13,202.42Z"
                fill="#ba8419"
              />
              <path
                d="M61.08,202.42s1.2-.64,1-.85.09.05-.23-.21-2,.32-1.85.79S61.08,202.42,61.08,202.42Z"
                fill="#ba8419"
              />
              <path
                d="M61,202.68a1.32,1.32,0,0,0-1.49.37c-.58.74.43,1.38.43,1.38"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.05"
              />
              <path
                d="M62,201.55l-.09.3a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.27a.28.28,0,0,1,.05-.21l.19-.08a1.82,1.82,0,0,0,1.4-.5l.06-.06a.26.26,0,0,1,.15.06C62.13,201.61,61.84,201.37,62,201.55Z"
                fill="#a06f18"
              />
              <path
                d="M61.61,202.42a3,3,0,0,0-1,2.65c.06.1-2.06-.85-1.74-2S61.61,202.42,61.61,202.42Z"
                fill="#ba8419"
              />
              <path
                d="M62.62,202.31c1.16-.16,1.38.21,2.12.74,0,0-1.54-3.23-3.61-.63Z"
                fill="#ba8419"
              />
              <path
                d="M61.29,202.47l-.11.43a2.6,2.6,0,0,0-.58,2.17A1.86,1.86,0,0,1,61.29,202.47Z"
                fill="#a06f18"
              />
              <path
                d="M58.84,203.51s.63,1.08,1.49.26l.24.48a2.08,2.08,0,0,0,0,.82C60.65,205.16,59,204.44,58.84,203.51Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M62.62,202.31l-1.21.09-.19-.06a2.42,2.42,0,0,1,1.56-.51,4,4,0,0,1,2,1.22C64,202.52,63.78,202.15,62.62,202.31Z"
                fill="#a06f18"
              />
              <path
                d="M61.13,202.42c1.49-.74,3.08.32,3,1.22s-1.48,2.27-1.48,2.27a18.54,18.54,0,0,1-1-1.59A6.16,6.16,0,0,1,61.13,202.42Z"
                fill="#ba8419"
              />
              <path
                d="M61.88,202.47a1.38,1.38,0,0,1,1.37,1.17"
                fill="#a06f18"
              />
              <path d="M61.61,202.68a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
              <path
                d="M64,204a7.56,7.56,0,0,1-1.37,1.87,18.54,18.54,0,0,1-1-1.59.37.37,0,0,1,0-.11A1.88,1.88,0,0,0,64,204Z"
                fill="#a06f18"
              />
              <path d="M60.82,202.58s-.85,0-1.12.58" fill="#a06f18" />
              <path
                d="M61.7,209.25s0-2.28-2.84-2.38"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M59.54,205.44s1.15.63.66,1.69A1.87,1.87,0,0,1,59.54,205.44Z"
                fill="#396039"
              />
              <path
                d="M61.61,208.69a1.29,1.29,0,0,0-1.27-.81S60.76,208.81,61.61,208.69Z"
                fill="#396039"
              />
              <path
                d="M59.36,206.91a1.71,1.71,0,0,0-2.09-1A2.25,2.25,0,0,0,59.36,206.91Z"
                fill="#396039"
              />
              <path
                d="M61,207.68s.63-.23.26-1.13C61.29,206.55,60.71,207.12,61,207.68Z"
                fill="#396039"
              />
              <path
                d="M60.34,207.2a.76.76,0,0,0-1,.46A1.1,1.1,0,0,0,60.34,207.2Z"
                fill="#396039"
              />
              <path
                d="M61.88,208.06a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,61.88,208.06Z"
                fill="#396039"
              />
              <path
                d="M57.27,205.91l.16,0a3.36,3.36,0,0,0,1.74,1.07A2.34,2.34,0,0,1,57.27,205.91Z"
                fill="#204220"
              />
              <path
                d="M60.35,207.87h.2a1.72,1.72,0,0,0,1,.83,1.39,1.39,0,0,1-1.2-.81Z"
                fill="#204220"
              />
              <g>
                <path d="M60.21,207.11h0Z" fill="#204220" />
                <path
                  d="M60.19,207.1,60,207a2,2,0,0,1-.46-1.51l0,0A4,4,0,0,0,60.19,207.1Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M60.33,207.19h0l0,0a1.11,1.11,0,0,1-.92.42.89.89,0,0,1,.16-.25A1.35,1.35,0,0,0,60.33,207.19Z"
                fill="#204220"
              />
              <path
                d="M63.63,206.13a2.35,2.35,0,0,1-1.71,1.92h0c.83-.24,1.3-1.22,1.51-1.76Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M113.83,221.58s1.7,5.72-.21,7.89"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M113.78,221.1c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.91-1-1.59A6.26,6.26,0,0,1,113.78,221.1Z"
                fill="#ba8419"
              />
              <path
                d="M113.73,221.1s1.2-.64,1-.85.09.05-.23-.21-2,.32-1.86.79S113.73,221.1,113.73,221.1Z"
                fill="#ba8419"
              />
              <path
                d="M113.67,221.36a1.3,1.3,0,0,0-1.48.37c-.58.75.42,1.38.42,1.38"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.05"
              />
              <path
                d="M114.68,220.23l-.09.3a5.3,5.3,0,0,1-.86.57s-1,.21-1.12-.27a.29.29,0,0,1,.06-.21l.18-.08a1.85,1.85,0,0,0,1.41-.5l.06-.06a.34.34,0,0,1,.15.06C114.78,220.29,114.49,220.05,114.68,220.23Z"
                fill="#a06f18"
              />
              <path
                d="M114.26,221.1a3,3,0,0,0-1,2.65c0,.1-2.07-.85-1.75-2S114.26,221.1,114.26,221.1Z"
                fill="#ba8419"
              />
              <path
                d="M115.27,221c1.16-.16,1.37.21,2.11.74,0,0-1.53-3.23-3.6-.63Z"
                fill="#ba8419"
              />
              <path
                d="M113.94,221.15l-.11.43a2.58,2.58,0,0,0-.58,2.17A1.86,1.86,0,0,1,113.94,221.15Z"
                fill="#a06f18"
              />
              <path
                d="M111.49,222.19s.62,1.08,1.48.26l.24.48a2.09,2.09,0,0,0,0,.82C113.3,223.84,111.67,223.12,111.49,222.19Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M115.27,221l-1.22.09-.18-.06a2.38,2.38,0,0,1,1.55-.51,4,4,0,0,1,2,1.22C116.64,221.2,116.43,220.83,115.27,221Z"
                fill="#a06f18"
              />
              <path
                d="M113.78,221.1c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.91-1-1.59A6.26,6.26,0,0,1,113.78,221.1Z"
                fill="#ba8419"
              />
              <path
                d="M114.52,221.15a1.39,1.39,0,0,1,1.38,1.17"
                fill="#a06f18"
              />
              <path d="M114.26,221.36a1.4,1.4,0,0,1,.95,1.38" fill="#a06f18" />
              <path
                d="M116.63,222.72a7.43,7.43,0,0,1-1.37,1.88s-.63-.91-1-1.59l-.06-.12A1.88,1.88,0,0,0,116.63,222.72Z"
                fill="#a06f18"
              />
              <path d="M113.46,221.26s-.85,0-1.11.58" fill="#a06f18" />
              <path
                d="M114.35,227.93s0-2.27-2.85-2.38"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M112.19,224.12s1.14.64.65,1.69A1.85,1.85,0,0,1,112.19,224.12Z"
                fill="#396039"
              />
              <path
                d="M114.26,227.37a1.29,1.29,0,0,0-1.28-.81S113.41,227.49,114.26,227.37Z"
                fill="#396039"
              />
              <path
                d="M112,225.59a1.71,1.71,0,0,0-2.1-1A2.28,2.28,0,0,0,112,225.59Z"
                fill="#396039"
              />
              <path
                d="M113.67,226.36s.64-.23.27-1.13C113.94,225.23,113.36,225.8,113.67,226.36Z"
                fill="#396039"
              />
              <path
                d="M113,225.88a.77.77,0,0,0-1,.46A1.09,1.09,0,0,0,113,225.88Z"
                fill="#396039"
              />
              <path
                d="M114.52,226.74a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,114.52,226.74Z"
                fill="#396039"
              />
              <path
                d="M109.91,224.6l.16,0a3.44,3.44,0,0,0,1.74,1.07A2.36,2.36,0,0,1,109.91,224.6Z"
                fill="#204220"
              />
              <path
                d="M113,226.56h.21a1.66,1.66,0,0,0,1,.83,1.34,1.34,0,0,1-1.19-.81Z"
                fill="#204220"
              />
              <g>
                <path d="M112.85,225.79h0Z" fill="#204220" />
                <path
                  d="M112.84,225.78l-.2-.15a2,2,0,0,1-.45-1.51l0,0A3.79,3.79,0,0,0,112.84,225.78Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M113,225.87h0l0,0a1.12,1.12,0,0,1-.93.42,1.2,1.2,0,0,1,.16-.25A1.33,1.33,0,0,0,113,225.87Z"
                fill="#204220"
              />
              <path
                d="M116.27,224.81a2.33,2.33,0,0,1-1.71,1.92h0A2.8,2.8,0,0,0,116,225,1.5,1.5,0,0,1,116.27,224.81Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M126.05,219.88s1.71,5.72-.2,7.89"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M126,219.4c1.48-.74,3.07.32,3,1.22s-1.48,2.28-1.48,2.28a18.54,18.54,0,0,1-1-1.59A6.12,6.12,0,0,1,126,219.4Z"
                fill="#ba8419"
              />
              <path
                d="M126,219.4s1.2-.64,1-.85a1.81,1.81,0,0,0-.23-.21c-.32-.27-2,.32-1.86.79S126,219.4,126,219.4Z"
                fill="#ba8419"
              />
              <path
                d="M125.9,219.66a1.3,1.3,0,0,0-1.48.38c-.59.74.42,1.37.42,1.37"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.05"
              />
              <path
                d="M126.9,218.53l-.09.3a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.27a.3.3,0,0,1,.06-.21l.18-.08a1.82,1.82,0,0,0,1.4-.5l.07-.06a.34.34,0,0,1,.15.06C127,218.6,126.72,218.36,126.9,218.53Z"
                fill="#a06f18"
              />
              <path
                d="M126.48,219.4a3,3,0,0,0-1,2.65c0,.11-2.07-.85-1.75-2S126.48,219.4,126.48,219.4Z"
                fill="#ba8419"
              />
              <path
                d="M127.49,219.29c1.17-.16,1.38.22,2.12.75,0,0-1.54-3.24-3.6-.64Z"
                fill="#ba8419"
              />
              <path
                d="M126.17,219.45l-.12.43a2.58,2.58,0,0,0-.57,2.17A1.86,1.86,0,0,1,126.17,219.45Z"
                fill="#a06f18"
              />
              <path
                d="M123.71,220.49s.63,1.08,1.49.26l.24.48a1.92,1.92,0,0,0,0,.82C125.52,222.14,123.9,221.42,123.71,220.49Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M127.49,219.29l-1.21.09-.18-.06a2.34,2.34,0,0,1,1.55-.5c.9.05,2,1.22,2,1.22C128.87,219.51,128.66,219.13,127.49,219.29Z"
                fill="#a06f18"
              />
              <path
                d="M126,219.4c1.48-.74,3.07.32,3,1.22s-1.48,2.28-1.48,2.28a18.54,18.54,0,0,1-1-1.59A6.12,6.12,0,0,1,126,219.4Z"
                fill="#ba8419"
              />
              <path
                d="M126.75,219.45a1.39,1.39,0,0,1,1.38,1.17"
                fill="#a06f18"
              />
              <path d="M126.48,219.66a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
              <path
                d="M128.86,221a7.43,7.43,0,0,1-1.37,1.88,18.54,18.54,0,0,1-1-1.59,1.17,1.17,0,0,0,0-.11A1.89,1.89,0,0,0,128.86,221Z"
                fill="#a06f18"
              />
              <path d="M125.69,219.56s-.85,0-1.11.58" fill="#a06f18" />
              <path
                d="M126.58,226.24s0-2.28-2.85-2.39"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M124.42,222.42a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,124.42,222.42Z"
                fill="#396039"
              />
              <path
                d="M126.48,225.67a1.29,1.29,0,0,0-1.27-.81S125.63,225.79,126.48,225.67Z"
                fill="#396039"
              />
              <path
                d="M124.24,223.9a1.72,1.72,0,0,0-2.1-1A2.28,2.28,0,0,0,124.24,223.9Z"
                fill="#396039"
              />
              <path
                d="M125.9,224.67s.64-.24.27-1.14C126.17,223.53,125.58,224.1,125.9,224.67Z"
                fill="#396039"
              />
              <path
                d="M125.21,224.18a.77.77,0,0,0-.95.47A1.11,1.11,0,0,0,125.21,224.18Z"
                fill="#396039"
              />
              <path
                d="M126.75,225a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,126.75,225Z"
                fill="#396039"
              />
              <path
                d="M122.14,222.9l.16-.05a3.28,3.28,0,0,0,1.74,1.07A2.36,2.36,0,0,1,122.14,222.9Z"
                fill="#204220"
              />
              <path
                d="M125.22,224.86h.21a1.66,1.66,0,0,0,1,.83,1.32,1.32,0,0,1-1.19-.81Z"
                fill="#204220"
              />
              <g>
                <path d="M125.08,224.09h0Z" fill="#204220" />
                <path
                  d="M125.06,224.08l-.19-.15a2,2,0,0,1-.45-1.51l0,0A3.91,3.91,0,0,0,125.06,224.08Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M125.2,224.18h0l0,0a1.15,1.15,0,0,1-.93.43.83.83,0,0,1,.16-.25A1.51,1.51,0,0,0,125.2,224.18Z"
                fill="#204220"
              />
              <path
                d="M128.5,223.11a2.34,2.34,0,0,1-1.71,1.92h0a2.74,2.74,0,0,0,1.51-1.75Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M69,168.59s1.71,5.72-.2,7.9"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M69,168.11c1.48-.74,3.07.32,3,1.22s-1.48,2.28-1.48,2.28a18.54,18.54,0,0,1-1-1.59A6.12,6.12,0,0,1,69,168.11Z"
                fill="#ba8419"
              />
              <path
                d="M68.89,168.11s1.2-.63,1-.85.09.06-.22-.21-2,.32-1.86.8S68.89,168.11,68.89,168.11Z"
                fill="#ba8419"
              />
              <path
                d="M68.84,168.38a1.3,1.3,0,0,0-1.48.37c-.59.74.42,1.38.42,1.38"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.05"
              />
              <path
                d="M69.84,167.25l-.09.29a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.26a.29.29,0,0,1,.06-.21l.18-.08a1.85,1.85,0,0,0,1.4-.51l.06-.05a.34.34,0,0,1,.16.05C69.94,167.31,69.66,167.07,69.84,167.25Z"
                fill="#a06f18"
              />
              <path
                d="M69.42,168.11a3,3,0,0,0-1,2.65c0,.11-2.07-.85-1.75-2S69.42,168.11,69.42,168.11Z"
                fill="#ba8419"
              />
              <path
                d="M70.43,168c1.17-.15,1.38.22,2.12.75,0,0-1.54-3.23-3.6-.64Z"
                fill="#ba8419"
              />
              <path
                d="M69.11,168.17l-.12.42a2.58,2.58,0,0,0-.57,2.17A1.84,1.84,0,0,1,69.11,168.17Z"
                fill="#a06f18"
              />
              <path
                d="M66.65,169.21s.63,1.08,1.49.25l.24.48a1.91,1.91,0,0,0,0,.82C68.46,170.86,66.84,170.13,66.65,169.21Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M70.43,168l-1.21.09L69,168a2.4,2.4,0,0,1,1.55-.5c.9.05,2,1.22,2,1.22C71.81,168.22,71.6,167.85,70.43,168Z"
                fill="#a06f18"
              />
              <path
                d="M69,168.11c1.48-.74,3.07.32,3,1.22s-1.48,2.28-1.48,2.28a18.54,18.54,0,0,1-1-1.59A6.12,6.12,0,0,1,69,168.11Z"
                fill="#ba8419"
              />
              <path
                d="M69.69,168.17a1.38,1.38,0,0,1,1.38,1.16"
                fill="#a06f18"
              />
              <path d="M69.42,168.38a1.39,1.39,0,0,1,1,1.38" fill="#a06f18" />
              <path
                d="M71.8,169.74a7.51,7.51,0,0,1-1.37,1.87,18.54,18.54,0,0,1-1-1.59,1.17,1.17,0,0,1,0-.11A1.9,1.9,0,0,0,71.8,169.74Z"
                fill="#a06f18"
              />
              <path d="M68.63,168.27s-.85,0-1.11.58" fill="#a06f18" />
              <path
                d="M69.52,175s0-2.28-2.85-2.39"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M67.36,171.13a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,67.36,171.13Z"
                fill="#396039"
              />
              <path
                d="M69.42,174.38a1.3,1.3,0,0,0-1.27-.81S68.57,174.51,69.42,174.38Z"
                fill="#396039"
              />
              <path
                d="M67.18,172.61a1.72,1.72,0,0,0-2.1-1A2.26,2.26,0,0,0,67.18,172.61Z"
                fill="#396039"
              />
              <path
                d="M68.84,173.38s.64-.23.27-1.13C69.11,172.25,68.52,172.82,68.84,173.38Z"
                fill="#396039"
              />
              <path
                d="M68.15,172.89a.77.77,0,0,0-1,.47A1.11,1.11,0,0,0,68.15,172.89Z"
                fill="#396039"
              />
              <path
                d="M69.69,173.76a4.8,4.8,0,0,1,1.75-1.94A2.36,2.36,0,0,1,69.69,173.76Z"
                fill="#396039"
              />
              <path
                d="M65.08,171.61l.16,0A3.4,3.4,0,0,0,67,172.64,2.37,2.37,0,0,1,65.08,171.61Z"
                fill="#204220"
              />
              <path
                d="M68.16,173.57h.2a1.71,1.71,0,0,0,1,.82,1.32,1.32,0,0,1-1.19-.81Z"
                fill="#204220"
              />
              <g>
                <path d="M68,172.81h0Z" fill="#204220" />
                <path
                  d="M68,172.8l-.19-.16a1.94,1.94,0,0,1-.45-1.51l0,0A4,4,0,0,0,68,172.8Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M68.14,172.89h0l0,.05a1.17,1.17,0,0,1-.93.42.89.89,0,0,1,.16-.25A1.51,1.51,0,0,0,68.14,172.89Z"
                fill="#204220"
              />
              <path
                d="M71.44,171.82a2.34,2.34,0,0,1-1.71,1.92h0A2.78,2.78,0,0,0,71.21,172Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M49,191.69s1.71,5.72-.2,7.89"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M48.91,191.21c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6.12,6.12,0,0,1,48.91,191.21Z"
                fill="#ba8419"
              />
              <path
                d="M48.85,191.21s1.2-.64,1-.85a1.81,1.81,0,0,0-.23-.21c-.32-.27-2,.32-1.86.79S48.85,191.21,48.85,191.21Z"
                fill="#ba8419"
              />
              <path
                d="M48.8,191.47a1.3,1.3,0,0,0-1.48.37c-.59.75.42,1.38.42,1.38"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.05"
              />
              <path
                d="M49.8,190.34l-.09.3a4.89,4.89,0,0,1-.86.57s-1,.21-1.11-.27a.29.29,0,0,1,.06-.21l.18-.08a1.82,1.82,0,0,0,1.4-.5l.07-.06a.34.34,0,0,1,.15.06C49.9,190.4,49.62,190.17,49.8,190.34Z"
                fill="#a06f18"
              />
              <path
                d="M49.38,191.21a3,3,0,0,0-1,2.65c0,.1-2.07-.85-1.75-2S49.38,191.21,49.38,191.21Z"
                fill="#ba8419"
              />
              <path
                d="M50.39,191.1c1.17-.16,1.38.21,2.12.74,0,0-1.54-3.23-3.6-.63Z"
                fill="#ba8419"
              />
              <path
                d="M49.07,191.26l-.12.43a2.58,2.58,0,0,0-.57,2.17A1.86,1.86,0,0,1,49.07,191.26Z"
                fill="#a06f18"
              />
              <path
                d="M46.61,192.3s.63,1.08,1.49.26l.24.48a1.92,1.92,0,0,0,0,.82C48.42,194,46.8,193.23,46.61,192.3Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M50.39,191.1l-1.21.09-.18-.06a2.34,2.34,0,0,1,1.55-.5c.9.05,2,1.21,2,1.21C51.77,191.31,51.56,190.94,50.39,191.1Z"
                fill="#a06f18"
              />
              <path
                d="M48.91,191.21c1.48-.74,3.07.32,3,1.22a6,6,0,0,1-1.49,2.28s-.63-.9-1-1.59A6.12,6.12,0,0,1,48.91,191.21Z"
                fill="#ba8419"
              />
              <path
                d="M49.65,191.26A1.39,1.39,0,0,1,51,192.43"
                fill="#a06f18"
              />
              <path d="M49.38,191.47a1.4,1.4,0,0,1,1,1.38" fill="#a06f18" />
              <path
                d="M51.76,192.83a7.43,7.43,0,0,1-1.37,1.88s-.63-.9-1-1.59a.37.37,0,0,0-.05-.11A1.89,1.89,0,0,0,51.76,192.83Z"
                fill="#a06f18"
              />
              <path d="M48.59,191.37s-.85,0-1.11.58" fill="#a06f18" />
              <path
                d="M49.48,198s0-2.27-2.85-2.38"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M47.32,194.23a1.36,1.36,0,0,1,.65,1.7A1.86,1.86,0,0,1,47.32,194.23Z"
                fill="#396039"
              />
              <path
                d="M49.38,197.48a1.29,1.29,0,0,0-1.27-.81S48.53,197.6,49.38,197.48Z"
                fill="#396039"
              />
              <path
                d="M47.14,195.71a1.72,1.72,0,0,0-2.1-1A2.28,2.28,0,0,0,47.14,195.71Z"
                fill="#396039"
              />
              <path
                d="M48.8,196.48s.64-.24.27-1.14C49.07,195.34,48.48,195.91,48.8,196.48Z"
                fill="#396039"
              />
              <path
                d="M48.11,196a.77.77,0,0,0-1,.47A1.11,1.11,0,0,0,48.11,196Z"
                fill="#396039"
              />
              <path
                d="M49.65,196.85a4.8,4.8,0,0,1,1.75-1.93A2.34,2.34,0,0,1,49.65,196.85Z"
                fill="#396039"
              />
              <path
                d="M45,194.71l.16-.05a3.34,3.34,0,0,0,1.74,1.07A2.36,2.36,0,0,1,45,194.71Z"
                fill="#204220"
              />
              <path
                d="M48.12,196.67h.21a1.66,1.66,0,0,0,1,.83,1.34,1.34,0,0,1-1.19-.81Z"
                fill="#204220"
              />
              <g>
                <path d="M48,195.9h0Z" fill="#204220" />
                <path
                  d="M48,195.89l-.19-.15a2,2,0,0,1-.45-1.51l0,0A3.91,3.91,0,0,0,48,195.89Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M48.1,196h0l0,0a1.14,1.14,0,0,1-.93.43.83.83,0,0,1,.16-.25A1.51,1.51,0,0,0,48.1,196Z"
                fill="#204220"
              />
              <path
                d="M51.4,194.92a2.34,2.34,0,0,1-1.71,1.92h0a2.74,2.74,0,0,0,1.51-1.75Z"
                fill="#204220"
              />
            </g>
            <g>
              <path
                d="M58.75,175.44s2.87,9.62-.34,13.27"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M58.68,174.63c2.49-1.25,5.17.54,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.48,10.48,0,0,1,58.68,174.63Z"
                fill="#ba8419"
              />
              <path
                d="M58.59,174.63s2-1.07,1.63-1.42.15.08-.38-.36-3.3.53-3.12,1.34S58.59,174.63,58.59,174.63Z"
                fill="#ba8419"
              />
              <path
                d="M58.5,175.08a2.2,2.2,0,0,0-2.5.62c-1,1.25.72,2.32.72,2.32"
                fill="none"
                stroke="#a06f18"
                strokeMiterlimit="10"
                strokeWidth="0.09"
              />
              <path
                d="M60.19,173.17l-.16.5a8.36,8.36,0,0,1-1.44,1s-1.69.36-1.87-.44a.45.45,0,0,1,.09-.36l.31-.13a3.14,3.14,0,0,0,2.36-.85l.1-.1a.57.57,0,0,1,.26.1C60.35,173.28,59.87,172.88,60.19,173.17Z"
                fill="#a06f18"
              />
              <path
                d="M59.48,174.63s-2.32,2.05-1.69,4.46c.09.18-3.48-1.43-2.94-3.3S59.48,174.63,59.48,174.63Z"
                fill="#ba8419"
              />
              <path
                d="M61.18,174.45c2-.26,2.31.36,3.56,1.25,0,0-2.59-5.44-6.06-1.07Z"
                fill="#ba8419"
              />
              <path
                d="M59,174.72l-.2.72a4.36,4.36,0,0,0-1,3.65A3.11,3.11,0,0,1,59,174.72Z"
                fill="#a06f18"
              />
              <path
                d="M54.82,176.47s1.06,1.82,2.5.43l.4.81a3.42,3.42,0,0,0,.07,1.38C57.86,179.24,55.14,178,54.82,176.47Z"
                fill="#a06f18"
                opacity="0.65"
              />
              <path
                d="M61.18,174.45l-2,.15-.3-.1a4,4,0,0,1,2.61-.85c1.52.09,3.3,2,3.3,2C63.49,174.81,63.13,174.19,61.18,174.45Z"
                fill="#a06f18"
              />
              <path
                d="M58.68,174.63c2.49-1.25,5.17.54,5,2.05s-2.5,3.83-2.5,3.83a31.16,31.16,0,0,1-1.69-2.67A10.48,10.48,0,0,1,58.68,174.63Z"
                fill="#ba8419"
              />
              <path d="M59.93,174.72a2.31,2.31,0,0,1,2.31,2" fill="#a06f18" />
              <path d="M59.48,175.08a2.33,2.33,0,0,1,1.6,2.31" fill="#a06f18" />
              <path
                d="M63.48,177.36a12.74,12.74,0,0,1-2.31,3.15,31.16,31.16,0,0,1-1.69-2.67l-.09-.19C61.45,178.77,62.77,178.06,63.48,177.36Z"
                fill="#a06f18"
              />
              <path d="M58.14,174.9s-1.42,0-1.87,1" fill="#a06f18" />
              <path
                d="M59.63,186.13s0-3.83-4.78-4"
                fill="none"
                stroke="#396039"
                strokeMiterlimit="10"
                strokeWidth="0.14"
              />
              <path
                d="M56,179.71s1.93,1.07,1.1,2.85A3.15,3.15,0,0,1,56,179.71Z"
                fill="#396039"
              />
              <path
                d="M59.48,185.18a2.17,2.17,0,0,0-2.14-1.37S58.05,185.39,59.48,185.18Z"
                fill="#396039"
              />
              <path
                d="M55.7,182.19a2.88,2.88,0,0,0-3.53-1.68S53.61,182.63,55.7,182.19Z"
                fill="#396039"
              />
              <path
                d="M58.5,183.49s1.07-.39.45-1.91C59,181.58,58,182.54,58.5,183.49Z"
                fill="#396039"
              />
              <path
                d="M57.34,182.67a1.3,1.3,0,0,0-1.6.78A1.87,1.87,0,0,0,57.34,182.67Z"
                fill="#396039"
              />
              <path
                d="M59.93,184.12a8.11,8.11,0,0,1,2.94-3.25A3.93,3.93,0,0,1,59.93,184.12Z"
                fill="#396039"
              />
              <path
                d="M52.17,180.51l.27-.07c.55.56,1.86,1.75,2.93,1.8A4,4,0,0,1,52.17,180.51Z"
                fill="#204220"
              />
              <path
                d="M57.36,183.81a2,2,0,0,1,.34,0,2.79,2.79,0,0,0,1.65,1.39,2.24,2.24,0,0,1-2-1.36Z"
                fill="#204220"
              />
              <g>
                <path d="M57.11,182.53l0,0,0,0Z" fill="#204220" />
                <path
                  d="M57.09,182.51l-.32-.26a3.29,3.29,0,0,1-.77-2.54l.06,0A6.44,6.44,0,0,0,57.09,182.51Z"
                  fill="#204220"
                />
              </g>
              <path
                d="M57.32,182.67h0l0,.08a1.93,1.93,0,0,1-1.56.7A1.93,1.93,0,0,1,56,183,2.56,2.56,0,0,0,57.32,182.67Z"
                fill="#204220"
              />
              <path
                d="M62.87,180.87A3.93,3.93,0,0,1,60,184.1l-.05,0h0c1.39-.39,2.19-2,2.54-2.95C62.61,181,62.74,181,62.87,180.87Z"
                fill="#204220"
              />
            </g>
            <path d="M112,230.15c1.36-1,1-1.36,3.06-1" fill="#493b1b" />
            <path d="M124.52,228.45c1.35-1,1-1.36,3-1" fill="#493b1b" />
            <path d="M56.59,189.05c1.36-1.7,3.73-.68,3.73-.68" fill="#35280f" />
            <path d="M68.81,201.62c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
            <path d="M83.08,209.77c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
            <path d="M96.67,211.81c1.35-1.7,3.73-.68,3.73-.68" fill="#35280f" />
            <path
              d="M102.1,215.88c1.36-1.69,3.74-.67,3.74-.67"
              fill="#35280f"
            />
            <path d="M120.1,212.49c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
            <path d="M130,221.32c1.36-1.7,3.74-.68,3.74-.68" fill="#35280f" />
            <path
              d="M155.42,236.94c3.4-6.45-2-11.88-4.41-9.51s0,6.8,0,6.8-7.13-5.78-8.83-2,3.22,6.88,3.22,6.88Z"
              fill="#1f441f"
            />
            <path
              d="M123.5,246.11c5.43-3.39,5.43-13.24,5.43-13.24s-4.75-.34-6.45,3S123.5,246.11,123.5,246.11Z"
              fill="#1f441f"
            />
            <path
              d="M124.86,245.43c-2.72-6.45-7.48-10.53-13.25-10.86,0,0,1.7,9.17,6.45,10.86S124.86,245.43,124.86,245.43Z"
              fill="#1f441f"
            />
            <path
              d="M128.93,232.87s-4.75-.34-6.45,3,1,10.19,1,10.19C121.8,237.62,128.93,232.87,128.93,232.87Z"
              fill="#659965"
            />
            <g>
              <path
                d="M154.45,227.79c-1.14-1-2.52-1.28-3.44-.36-1.58,1.58-1.06,4-.54,5.54C150.32,230.25,153,228.32,154.45,227.79Z"
                fill="#659965"
              />
              <path
                d="M150.41,233.77l-.11-.08C150.34,233.75,150.38,233.78,150.41,233.77Z"
                fill="#659965"
              />
            </g>
            <path
              d="M145.26,231.07c-1.33-.32-2.51-.14-3.08,1.12-.91,2,.07,3.82,1.18,5.09C142,234.72,144.1,232.17,145.26,231.07Z"
              fill="#659965"
            />
          </g>
          <g>
            <ellipse
              cx="19.64"
              cy="178.7"
              rx="16.87"
              ry="2.98"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M10.79,176.14c-2.9,1.47-3.53,1.78-6.14.74s-7.83-7.11-2-11.18,11.8,1.35,11.8,3.76c0,0-10.13-10.56,0-13.27s6.79,7.94,6.06,9.51c0,0,3.66-7.21,7.84-5s1.49,15.76-6.2,12.27c0,0,10.38-5,13.62.37s-17.66,6.38-21.32,4.6S10.79,176.14,10.79,176.14Z"
              fill="#1f441f"
            />
            <path
              d="M10.55,163.55c2.62,1,1.73-4.12,1.73-4.12s1.15-.63,1.17-2.92C9.55,158,9.5,160.87,10.55,163.55Z"
              fill="#659965"
            />
            <path
              d="M19.59,167.37c-7.42-.73-7.52-7-3.45-8.78S19.59,167.37,19.59,167.37Z"
              fill="#245624"
            />
            <path
              d="M16.22,172.86c-12,2-14.35-6.56-8.48-10.62S16.22,172.86,16.22,172.86Z"
              fill="#245624"
            />
            <path
              d="M21.26,172.6c9,5.33,14.37-1.71,11.21-7.11S21.26,172.6,21.26,172.6Z"
              fill="#245624"
            />
            <g>
              <path
                d="M20.53,165.7c3.76,2.5,4.5-2,4.5-2,1.6-.22,2.09-1.82,2.23-3.4C23.56,159.72,20.53,165.7,20.53,165.7Z"
                fill="#659965"
              />
              <path d="M20.53,165.7a7.1,7.1,0,0,0,.29-.75Z" fill="#659965" />
            </g>
            <path
              d="M24.91,174.17c5.16,1.36,8.43-1.74,8.47-5.34-.19.17-.38.32-.56.46a5,5,0,0,1-4.45,1.11s-.31,4.18-3.34,3.08Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M12,177.24s-9.2-3.24-7-8.46,5.33-2.41,7,4.18c0,0-2.2-14,5.85-12.12s2,11.8,0,12.12c0,0,5.85-7.94,9.61-2.2s-6.16,6.9-8.67,6.48A33.87,33.87,0,0,0,12,177.24Z"
                fill="#659965"
              />
              <path
                d="M27.48,170.76a5.16,5.16,0,0,0-1.37-1.47A4.91,4.91,0,0,1,20.85,173s.1,3.87-4.39,3.13l-.45.92a18.65,18.65,0,0,1,2.8.18C21.32,177.66,31.24,176.51,27.48,170.76Z"
                fill="#396039"
              />
              <path
                d="M14.47,171.86s2.72,1.29,6-1.66c1.44-2.51,2.36-6.1,0-8.13-1.62,4-4.45,4-4.45,4S19.07,171.13,14.47,171.86Z"
                fill="#396039"
              />
              <path
                d="M12.28,177.22a8.25,8.25,0,0,1-3.45-3.9c-2.53.33-3.66-2.6-4-3.89-1.22,4.84,7.22,7.81,7.22,7.81Z"
                fill="#396039"
              />
            </g>
            <path
              d="M5.28,175a11.24,11.24,0,0,1-3.58-.54,8.15,8.15,0,0,0,3,2.43c2.43,1,3.14.76,5.56-.45A11.69,11.69,0,0,1,5.28,175Z"
              fill="#172d17"
            />
            <path
              d="M35.73,173.24c-1.33,2.77-4.89,3.07-6.11,2.69,0,0-1.65,2.15-7.65,2.78,7.1-.13,16-1.77,13.82-5.39Z"
              fill="#172d17"
            />
            <path
              d="M12.28,177.19c-3-1.26-2-4.29,0-3.87S12.28,177.19,12.28,177.19Z"
              fill="#245624"
            />
            <path
              d="M12.09,177c4.81,4.67,9.65.25,7.25-3.13S12.09,177,12.09,177Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <ellipse
              cx="31.64"
              cy="152.7"
              rx="16.87"
              ry="2.98"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M22.79,150.14c-2.9,1.47-3.53,1.78-6.14.74s-7.83-7.11-2-11.18,11.8,1.35,11.8,3.76c0,0-10.13-10.56,0-13.27s6.79,7.94,6.06,9.51c0,0,3.66-7.21,7.84-5s1.49,15.76-6.2,12.27c0,0,10.38-5,13.62.37s-17.66,6.38-21.32,4.6S22.79,150.14,22.79,150.14Z"
              fill="#1f441f"
            />
            <path
              d="M22.55,137.55c2.62,1,1.73-4.12,1.73-4.12s1.15-.63,1.17-2.92C21.55,132,21.5,134.87,22.55,137.55Z"
              fill="#659965"
            />
            <path
              d="M31.59,141.37c-7.42-.73-7.52-7-3.45-8.78S31.59,141.37,31.59,141.37Z"
              fill="#245624"
            />
            <path
              d="M28.22,146.86c-12,2-14.35-6.56-8.48-10.62S28.22,146.86,28.22,146.86Z"
              fill="#245624"
            />
            <path
              d="M33.26,146.6c9,5.33,14.37-1.71,11.21-7.11S33.26,146.6,33.26,146.6Z"
              fill="#245624"
            />
            <g>
              <path
                d="M32.53,139.7c3.76,2.5,4.5-2,4.5-2,1.6-.22,2.09-1.82,2.23-3.4C35.56,133.72,32.53,139.7,32.53,139.7Z"
                fill="#659965"
              />
              <path d="M32.53,139.7a7.1,7.1,0,0,0,.29-.75Z" fill="#659965" />
            </g>
            <path
              d="M36.91,148.17c5.16,1.36,8.43-1.74,8.47-5.34-.19.17-.38.32-.56.46a5,5,0,0,1-4.45,1.11s-.31,4.18-3.34,3.08Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M24,151.24s-9.2-3.24-7-8.46,5.33-2.41,7,4.18c0,0-2.2-14,5.85-12.12s2,11.8,0,12.12c0,0,5.85-7.94,9.61-2.2s-6.16,6.9-8.67,6.48A33.87,33.87,0,0,0,24,151.24Z"
                fill="#659965"
              />
              <path
                d="M39.48,144.76a5.16,5.16,0,0,0-1.37-1.47A4.91,4.91,0,0,1,32.85,147s.1,3.87-4.39,3.13l-.45.92a18.65,18.65,0,0,1,2.8.18C33.32,151.66,43.24,150.51,39.48,144.76Z"
                fill="#396039"
              />
              <path
                d="M26.47,145.86s2.72,1.29,6-1.66c1.44-2.51,2.36-6.1,0-8.13-1.62,4-4.45,4-4.45,4S31.07,145.13,26.47,145.86Z"
                fill="#396039"
              />
              <path
                d="M24.28,151.22a8.25,8.25,0,0,1-3.45-3.9c-2.53.33-3.66-2.6-4-3.89-1.22,4.84,7.22,7.81,7.22,7.81Z"
                fill="#396039"
              />
            </g>
            <path
              d="M17.28,149a11.24,11.24,0,0,1-3.58-.54,8.15,8.15,0,0,0,2.95,2.43c2.43,1,3.14.76,5.56-.45A11.69,11.69,0,0,1,17.28,149Z"
              fill="#172d17"
            />
            <path
              d="M47.73,147.24c-1.33,2.77-4.89,3.07-6.11,2.69,0,0-1.65,2.15-7.65,2.78,7.1-.13,16-1.77,13.82-5.39Z"
              fill="#172d17"
            />
            <path
              d="M24.28,151.19c-3-1.26-2-4.29,0-3.87S24.28,151.19,24.28,151.19Z"
              fill="#245624"
            />
            <path
              d="M24.09,151c4.81,4.67,9.65.25,7.25-3.13S24.09,151,24.09,151Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <ellipse
              cx="60.87"
              cy="137.7"
              rx="16.87"
              ry="2.98"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M69.73,135.14c2.9,1.47,3.53,1.78,6.14.74s7.83-7.11,2-11.18-11.8,1.35-11.8,3.76c0,0,10.13-10.56,0-13.27s-6.8,7.94-6.06,9.51c0,0-3.66-7.21-7.84-5s-1.49,15.76,6.2,12.27c0,0-10.38-5-13.62.37s17.66,6.38,21.32,4.6S69.73,135.14,69.73,135.14Z"
              fill="#1f441f"
            />
            <path
              d="M70,122.55c-2.62,1-1.73-4.12-1.73-4.12s-1.15-.63-1.18-2.92C71,117,71,119.87,70,122.55Z"
              fill="#659965"
            />
            <path
              d="M60.93,126.37c7.41-.73,7.52-7,3.44-8.78S60.93,126.37,60.93,126.37Z"
              fill="#245624"
            />
            <path
              d="M64.3,131.86c12,2,14.34-6.56,8.48-10.62S64.3,131.86,64.3,131.86Z"
              fill="#245624"
            />
            <path
              d="M59.26,131.6c-9,5.33-14.37-1.71-11.21-7.11S59.26,131.6,59.26,131.6Z"
              fill="#245624"
            />
            <g>
              <path
                d="M60,124.7c-3.77,2.5-4.5-2-4.5-2-1.6-.22-2.09-1.82-2.23-3.4C57,118.72,60,124.7,60,124.7Z"
                fill="#659965"
              />
              <path d="M60,124.7q-.12-.26-.3-.75Z" fill="#659965" />
            </g>
            <path
              d="M55.61,133.17c-5.16,1.36-8.43-1.74-8.47-5.34.19.17.38.32.56.46a5,5,0,0,0,4.45,1.11s.31,4.18,3.34,3.08Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M68.5,136.24s9.2-3.24,7-8.46-5.33-2.41-7,4.18c0,0,2.2-14-5.85-12.12s-2,11.8,0,12.12c0,0-5.85-7.94-9.61-2.2s6.16,6.9,8.67,6.48A33.87,33.87,0,0,1,68.5,136.24Z"
                fill="#659965"
              />
              <path
                d="M53,129.76a5.16,5.16,0,0,1,1.37-1.47A4.91,4.91,0,0,0,59.67,132s-.1,3.87,4.39,3.13l.45.92a18.56,18.56,0,0,0-2.8.18C59.2,136.66,49.28,135.51,53,129.76Z"
                fill="#396039"
              />
              <path
                d="M66.05,130.86s-2.72,1.29-6-1.66c-1.44-2.51-2.36-6.1,0-8.13,1.62,4,4.45,4,4.45,4S61.45,130.13,66.05,130.86Z"
                fill="#396039"
              />
              <path
                d="M68.24,136.22a8.25,8.25,0,0,0,3.45-3.9c2.53.33,3.66-2.6,4-3.89,1.22,4.84-7.22,7.81-7.22,7.81Z"
                fill="#396039"
              />
            </g>
            <path
              d="M75.24,134a11.24,11.24,0,0,0,3.58-.54,8.15,8.15,0,0,1-2.95,2.43c-2.43,1-3.14.76-5.56-.45A11.69,11.69,0,0,0,75.24,134Z"
              fill="#172d17"
            />
            <path
              d="M44.79,132.24c1.33,2.77,4.89,3.07,6.11,2.69,0,0,1.65,2.15,7.65,2.78-7.11-.13-16-1.77-13.82-5.39Z"
              fill="#172d17"
            />
            <path
              d="M68.24,136.19c3-1.26,2-4.29,0-3.87S68.24,136.19,68.24,136.19Z"
              fill="#245624"
            />
            <path
              d="M68.43,136c-4.81,4.67-9.65.25-7.25-3.13S68.43,136,68.43,136Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <ellipse
              cx="136.25"
              cy="63.23"
              rx="8.25"
              ry="1.46"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M140.58,62c1.42.72,1.72.87,3,.36s3.83-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.84-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
              fill="#1f441f"
            />
            <path
              d="M140.7,55.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C141.19,53.09,141.21,54.5,140.7,55.82Z"
              fill="#659965"
            />
            <path
              d="M136.28,57.68c3.62-.36,3.67-3.42,1.68-4.29S136.28,57.68,136.28,57.68Z"
              fill="#245624"
            />
            <path
              d="M137.92,60.37c5.89,1,7-3.21,4.15-5.19S137.92,60.37,137.92,60.37Z"
              fill="#245624"
            />
            <path
              d="M135.46,60.24c-4.42,2.61-7-.84-5.48-3.48S135.46,60.24,135.46,60.24Z"
              fill="#245624"
            />
            <g>
              <path
                d="M135.82,56.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C134.33,53.94,135.82,56.86,135.82,56.86Z"
                fill="#659965"
              />
              <path d="M135.82,56.86a3,3,0,0,1-.15-.36Z" fill="#659965" />
            </g>
            <path
              d="M133.68,61c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.41,2.41,0,0,0,2.17.54s.16,2.05,1.64,1.51Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M140,62.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2.05c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,140,62.51Z"
                fill="#659965"
              />
              <path
                d="M132.42,59.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C135.43,62.71,130.58,62.15,132.42,59.34Z"
                fill="#396039"
              />
              <path
                d="M138.78,59.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S136.53,59.52,138.78,59.88Z"
                fill="#396039"
              />
              <path
                d="M139.85,62.5a4.09,4.09,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.59,2.37-3.53,3.82-3.53,3.82Z"
                fill="#396039"
              />
            </g>
            <path
              d="M143.28,61.41a5.25,5.25,0,0,0,1.75-.27,3.92,3.92,0,0,1-1.45,1.19,2.51,2.51,0,0,1-2.72-.22A5.77,5.77,0,0,0,143.28,61.41Z"
              fill="#172d17"
            />
            <path
              d="M128.38,60.55a2.78,2.78,0,0,0,3,1.32s.81,1.05,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64A.05.05,0,0,0,128.38,60.55Z"
              fill="#172d17"
            />
            <path
              d="M139.85,62.48c1.48-.61,1-2.09,0-1.89S139.85,62.48,139.85,62.48Z"
              fill="#245624"
            />
            <path
              d="M139.94,62.41c-2.35,2.28-4.71.12-3.54-1.53S139.94,62.41,139.94,62.41Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <ellipse
              cx="155.25"
              cy="49.23"
              rx="8.25"
              ry="1.46"
              fill="#141c66"
              opacity="0.2"
            />
            <path
              d="M159.58,48c1.42.72,1.72.87,3,.36s3.83-3.47,1-5.47-5.77.67-5.77,1.84c0,0,5-5.16,0-6.48s-3.32,3.88-3,4.64c0,0-1.79-3.52-3.84-2.45s-.73,7.71,3,6c0,0-5.08-2.42-6.66.18s8.63,3.12,10.42,2.25Z"
              fill="#1f441f"
            />
            <path
              d="M159.7,41.82c-1.28.51-.85-2-.85-2s-.56-.31-.57-1.43C160.19,39.09,160.21,40.5,159.7,41.82Z"
              fill="#659965"
            />
            <path
              d="M155.28,43.68c3.62-.36,3.67-3.42,1.68-4.29S155.28,43.68,155.28,43.68Z"
              fill="#245624"
            />
            <path
              d="M156.92,46.37c5.89,1,7-3.21,4.15-5.19S156.92,46.37,156.92,46.37Z"
              fill="#245624"
            />
            <path
              d="M154.46,46.24c-4.42,2.61-7-.84-5.48-3.48S154.46,46.24,154.46,46.24Z"
              fill="#245624"
            />
            <g>
              <path
                d="M154.82,42.86c-1.84,1.23-2.2-1-2.2-1-.79-.1-1-.89-1.09-1.66C153.33,39.94,154.82,42.86,154.82,42.86Z"
                fill="#659965"
              />
              <path d="M154.82,42.86a3,3,0,0,1-.15-.36Z" fill="#659965" />
            </g>
            <path
              d="M152.68,47c-2.53.66-4.13-.85-4.15-2.61.1.08.19.16.28.22a2.41,2.41,0,0,0,2.17.54s.16,2.05,1.64,1.51Z"
              fill="#172d17"
            />
            <g>
              <path
                d="M159,48.51s4.5-1.58,3.42-4.14-2.6-1.17-3.42,2.05c0,0,1.07-6.85-2.86-5.93s-1,5.77,0,5.93c0,0-2.86-3.89-4.7-1.08s3,3.37,4.24,3.17A17,17,0,0,1,159,48.51Z"
                fill="#659965"
              />
              <path
                d="M151.42,45.34a2.77,2.77,0,0,1,.67-.72,2.4,2.4,0,0,0,2.57,1.82s0,1.89,2.15,1.53l.22.45a8.37,8.37,0,0,0-1.37.09C154.43,48.71,149.58,48.15,151.42,45.34Z"
                fill="#396039"
              />
              <path
                d="M157.78,45.88a2.77,2.77,0,0,1-2.94-.81c-.7-1.23-1.15-3,0-4,.79,2,2.17,2,2.17,2S155.53,45.52,157.78,45.88Z"
                fill="#396039"
              />
              <path
                d="M158.85,48.5a4.09,4.09,0,0,0,1.69-1.91c1.24.16,1.79-1.27,2-1.9.59,2.37-3.53,3.82-3.53,3.82Z"
                fill="#396039"
              />
            </g>
            <path
              d="M162.28,47.41a5.25,5.25,0,0,0,1.75-.27,3.92,3.92,0,0,1-1.45,1.19,2.51,2.51,0,0,1-2.72-.22A5.77,5.77,0,0,0,162.28,47.41Z"
              fill="#172d17"
            />
            <path
              d="M147.38,46.55a2.78,2.78,0,0,0,3,1.32s.81,1.05,3.74,1.36c-3.47-.06-7.83-.87-6.75-2.64A.05.05,0,0,0,147.38,46.55Z"
              fill="#172d17"
            />
            <path
              d="M158.85,48.48c1.48-.61,1-2.09,0-1.89S158.85,48.48,158.85,48.48Z"
              fill="#245624"
            />
            <path
              d="M158.94,48.41c-2.35,2.28-4.71.12-3.54-1.53S158.94,48.41,158.94,48.41Z"
              fill="#1f441f"
            />
          </g>
          <g>
            <polygon
              points="149.52 147 163.52 154 193.52 137 179.52 126.49 149.52 147"
              fill="#141c66"
              opacity="0.2"
            />
            <g>
              <g>
                <polygon
                  points="179.31 96.5 179.31 131.42 181.34 130.24 181.31 95.35 179.31 96.5"
                  fill="#54392e"
                />
                <polygon
                  points="178.22 130.79 179.31 131.42 179.31 96.5 178.22 95.88 178.22 130.79"
                  fill="#96695c"
                />
                <polygon
                  points="178.22 95.88 179.31 96.5 181.31 95.35 180.22 94.8 178.22 95.88"
                  fill="#704d3c"
                />
              </g>
              <line
                x1="154.1"
                y1="134.31"
                x2="186.44"
                y2="115.73"
                fill="none"
                stroke="#54392e"
                strokeMiterlimit="10"
              />
              <line
                x1="159.13"
                y1="137.21"
                x2="191.47"
                y2="118.64"
                fill="none"
                stroke="#54392e"
                strokeMiterlimit="10"
              />
              <g>
                <polygon
                  points="174.25 134.31 159.13 125.58 159.13 128.61 174.25 137.21 174.25 134.31"
                  fill="#96695c"
                />
                <polygon
                  points="159.13 125.58 161.17 124.41 176.36 133.1 174.25 134.31 159.13 125.58"
                  fill="#704d3c"
                />
                <polygon
                  points="174.25 134.31 176.36 133.1 176.36 135.88 174.25 137.21 174.25 134.31"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="179.29 131.41 164.17 122.68 164.17 125.71 179.29 134.31 179.29 131.41"
                  fill="#96695c"
                />
                <polygon
                  points="164.17 122.68 166.21 121.51 181.4 130.2 179.29 131.41 164.17 122.68"
                  fill="#704d3c"
                />
                <polygon
                  points="179.29 131.41 181.4 130.2 181.4 132.97 179.29 134.31 179.29 131.41"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="184.33 128.49 169.21 119.77 169.21 122.8 184.33 131.4 184.33 128.49"
                  fill="#96695c"
                />
                <polygon
                  points="169.21 119.77 171.25 118.59 186.44 127.29 184.33 128.49 169.21 119.77"
                  fill="#704d3c"
                />
                <polygon
                  points="184.33 128.49 186.44 127.29 186.44 130.06 184.33 131.4 184.33 128.49"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="189.37 125.59 174.25 116.86 174.25 119.89 189.37 128.49 189.37 125.59"
                  fill="#96695c"
                />
                <polygon
                  points="174.25 116.86 176.29 115.69 191.48 124.38 189.37 125.59 174.25 116.86"
                  fill="#704d3c"
                />
                <polygon
                  points="189.37 125.59 191.48 124.38 191.48 127.16 189.37 128.49 189.37 125.59"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="194.41 122.71 179.29 113.98 179.29 117.01 194.41 125.61 194.41 122.71"
                  fill="#96695c"
                />
                <polygon
                  points="179.29 113.98 181.33 112.81 196.52 121.5 194.41 122.71 179.29 113.98"
                  fill="#704d3c"
                />
                <polygon
                  points="194.41 122.71 196.52 121.5 196.52 124.28 194.41 125.61 194.41 122.71"
                  fill="#a06338"
                />
              </g>
              <g>
                <polygon
                  points="169.21 137.22 154.09 128.49 154.09 131.52 169.21 140.12 169.21 137.22"
                  fill="#96695c"
                />
                <polygon
                  points="154.09 128.49 156.13 127.32 171.32 136.01 169.21 137.22 154.09 128.49"
                  fill="#704d3c"
                />
                <polygon
                  points="169.21 137.22 171.32 136.01 171.32 138.79 169.21 140.12 169.21 137.22"
                  fill="#54392e"
                />
              </g>
              <polygon
                points="149.05 113.94 149.05 148.86 151.09 147.68 151.06 112.79 149.05 113.94"
                fill="#54392e"
              />
              <polygon
                points="147.96 148.23 149.05 148.86 149.05 113.94 147.96 113.31 147.96 148.23"
                fill="#96695c"
              />
              <g>
                <polygon
                  points="164.17 140.12 149.05 131.4 149.05 134.43 164.17 143.03 164.17 140.12"
                  fill="#96695c"
                />
                <polygon
                  points="149.05 131.4 151.09 130.22 166.28 138.92 164.17 140.12 149.05 131.4"
                  fill="#704d3c"
                />
                <polygon
                  points="164.17 140.12 166.28 138.92 166.28 141.69 164.17 143.03 164.17 140.12"
                  fill="#a06338"
                />
              </g>
              <polygon
                points="147.96 113.31 149.05 113.94 151.06 112.79 149.97 112.24 147.96 113.31"
                fill="#704d3c"
              />
              <polygon
                points="164.17 157.59 164.17 140.12 162.07 138.92 162.07 156.37 164.17 157.59"
                fill="#96695c"
              />
              <polygon
                points="164.17 157.59 166.28 156.37 166.28 138.92 164.17 140.12 164.17 157.59"
                fill="#54392e"
              />
              <polygon
                points="194.42 140.12 194.41 122.71 196.52 121.5 196.52 138.91 194.42 140.12"
                fill="#54392e"
              />
              <polygon
                points="192.85 121.81 192.85 139.23 194.42 140.12 194.41 122.71 192.85 121.81"
                fill="#96695c"
              />
              <polygon
                points="149.05 119.76 179.29 102.31 179.29 105.54 149.05 122.68 149.05 119.76"
                fill="#54392e"
              />
              <polygon
                points="178.22 101.69 179.29 102.31 151.06 118.6 151.06 116.86 178.22 101.69"
                fill="#704d3c"
              />
            </g>
          </g>
          <g>
            <polygon
              points="217.52 116 231.52 123 261.52 106 247.52 95.49 217.52 116"
              fill="#141c66"
              opacity="0.2"
            />
            <g>
              <g>
                <polygon
                  points="240.31 82.86 240.31 100.42 242.34 99.83 242.31 82.28 240.31 82.86"
                  fill="#54392e"
                />
                <polygon
                  points="239.22 100.1 240.31 100.42 240.31 82.86 239.52 83 239.22 100.1"
                  fill="#96695c"
                />
                <polyline
                  points="240.31 82.86 242.31 82.28 241.22 82"
                  fill="#704d3c"
                />
              </g>
              <line
                x1="215.1"
                y1="103.31"
                x2="247.44"
                y2="84.73"
                fill="none"
                stroke="#54392e"
                strokeMiterlimit="10"
              />
              <line
                x1="220.13"
                y1="106.21"
                x2="252.47"
                y2="87.64"
                fill="none"
                stroke="#54392e"
                strokeMiterlimit="10"
              />
              <g>
                <polygon
                  points="235.25 103.31 220.13 94.58 220.13 97.61 235.25 106.21 235.25 103.31"
                  fill="#96695c"
                />
                <polygon
                  points="220.13 94.58 222.17 93.41 237.36 102.1 235.25 103.31 220.13 94.58"
                  fill="#704d3c"
                />
                <polygon
                  points="235.25 103.31 237.36 102.1 237.36 104.88 235.25 106.21 235.25 103.31"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="240.29 100.41 225.17 91.68 225.17 94.71 240.29 103.31 240.29 100.41"
                  fill="#96695c"
                />
                <polygon
                  points="225.17 91.68 227.21 90.51 242.4 99.2 240.29 100.41 225.17 91.68"
                  fill="#704d3c"
                />
                <polygon
                  points="240.29 100.41 242.4 99.2 242.4 101.97 240.29 103.31 240.29 100.41"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="245.33 97.49 230.21 88.77 230.21 91.8 245.33 100.4 245.33 97.49"
                  fill="#96695c"
                />
                <polygon
                  points="230.21 88.77 232.25 87.59 247.44 96.29 245.33 97.49 230.21 88.77"
                  fill="#704d3c"
                />
                <polygon
                  points="245.33 97.49 247.44 96.29 247.44 99.06 245.33 100.4 245.33 97.49"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="250.37 94.59 235.25 85.86 235.25 88.89 250.37 97.49 250.37 94.59"
                  fill="#96695c"
                />
                <polygon
                  points="235.25 85.86 237.29 84.69 252.48 93.38 250.37 94.59 235.25 85.86"
                  fill="#704d3c"
                />
                <polygon
                  points="250.37 94.59 252.48 93.38 252.48 96.16 250.37 97.49 250.37 94.59"
                  fill="#54392e"
                />
              </g>
              <g>
                <polygon
                  points="255.31 91.52 239.52 82.25 239.52 85.47 255.31 94.61 255.31 91.52"
                  fill="#96695c"
                />
                <polygon
                  points="239.52 82.25 241.65 81 257.52 90.24 255.31 91.52 239.52 82.25"
                  fill="#704d3c"
                />
                <polygon
                  points="255.31 91.52 257.52 90.24 257.52 93.19 255.31 94.61 255.31 91.52"
                  fill="#a06338"
                />
              </g>
              <g>
                <polygon
                  points="230.21 106.22 215.09 97.49 215.09 100.52 230.21 109.12 230.21 106.22"
                  fill="#96695c"
                />
                <polygon
                  points="215.09 97.49 217.13 96.32 232.32 105.01 230.21 106.22 215.09 97.49"
                  fill="#704d3c"
                />
                <polygon
                  points="230.21 106.22 232.32 105.01 232.32 107.79 230.21 109.12 230.21 106.22"
                  fill="#54392e"
                />
              </g>
              <polygon
                points="211.05 100.83 211.05 117.86 213.09 117.28 213.06 100.27 211.05 100.83"
                fill="#54392e"
              />
              <polygon
                points="209.96 117.55 211.05 117.86 211.05 100.83 209.96 100.52 209.96 117.55"
                fill="#96695c"
              />
              <g>
                <polygon
                  points="225.17 109.12 210.05 100.4 210.05 103.43 225.17 112.03 225.17 109.12"
                  fill="#96695c"
                />
                <polygon
                  points="210.05 100.4 212.09 99.22 227.28 107.92 225.17 109.12 210.05 100.4"
                  fill="#704d3c"
                />
                <polygon
                  points="225.17 109.12 227.28 107.92 227.28 110.69 225.17 112.03 225.17 109.12"
                  fill="#a06338"
                />
              </g>
              <polygon
                points="225.17 126.59 225.17 109.12 223.07 107.92 223.07 125.37 225.17 126.59"
                fill="#96695c"
              />
              <polygon
                points="225.17 126.59 227.28 125.37 227.28 107.92 225.17 109.12 225.17 126.59"
                fill="#54392e"
              />
              <polygon
                points="255.42 109.12 255.41 91.71 257.52 90.5 257.52 107.91 255.42 109.12"
                fill="#54392e"
              />
              <polygon
                points="253.85 90.81 253.85 108.23 255.42 109.12 255.41 91.71 253.85 90.81"
                fill="#96695c"
              />
            </g>
          </g>
        </g>
        <g transform="translate(0 40)">
          <g>
            <g>
              <rect
                x="396.91"
                y="429.29"
                width="1.91"
                height="33.71"
                rx="0.95"
                fill="#a39bb2"
              />
              <g>
                <ellipse
                  cx="397.87"
                  cy="420.36"
                  rx="3.91"
                  ry="0.77"
                  fill="url(#bb51daec-2d1c-4186-8ed3-820ddd26374e)"
                />
                <ellipse
                  cx="397.87"
                  cy="421.7"
                  rx="5.39"
                  ry="1.01"
                  fill="url(#af17228d-3ce7-4fd8-98b9-d6ef50cb940c)"
                />
                <ellipse
                  cx="397.87"
                  cy="423.03"
                  rx="6.88"
                  ry="1.25"
                  fill="url(#ff3485ce-0572-4be1-9003-13828d6dc858)"
                />
                <ellipse
                  cx="397.87"
                  cy="424.37"
                  rx="8.36"
                  ry="1.49"
                  fill="url(#ff0b2c7f-4e58-4b5a-a10d-7b5ca9f69024)"
                />
                <ellipse
                  cx="397.87"
                  cy="425.7"
                  rx="9.84"
                  ry="1.72"
                  fill="url(#f86f0c2a-e547-4535-8bd8-0ad58b69fd76)"
                />
                <ellipse
                  cx="397.87"
                  cy="427.04"
                  rx="11.33"
                  ry="1.96"
                  fill="url(#a5cf90d3-ff06-45f0-9de2-4acd6caded88)"
                />
                <ellipse
                  cx="397.87"
                  cy="429"
                  rx="10.21"
                  ry="1.8"
                  fill="url(#b8432aea-8d64-447c-919c-1d6f3349aff5)"
                />
                <ellipse
                  cx="397.87"
                  cy="430.97"
                  rx="9.1"
                  ry="1.63"
                  fill="url(#f505260b-cbaa-4ce0-921b-03f3b01e1585)"
                />
                <ellipse
                  cx="397.87"
                  cy="432.94"
                  rx="7.99"
                  ry="1.46"
                  fill="url(#edf4915a-6e6f-4799-b8f9-448896d4cab2)"
                />
                <ellipse
                  cx="397.87"
                  cy="434.91"
                  rx="6.87"
                  ry="1.3"
                  fill="url(#f3466d8e-5a58-46c2-af02-f186783b7058)"
                />
                <ellipse
                  cx="397.87"
                  cy="436.87"
                  rx="5.76"
                  ry="1.13"
                  fill="url(#ba6d1fa7-51d9-499f-bd73-f2f345abe976)"
                />
              </g>
            </g>
            <circle
              cx="397.67"
              cy="428"
              r="19"
              fill="url(#a866a499-21a3-4cd6-a270-e25945a93385)"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <rect
                x="391.91"
                y="323.29"
                width="1.91"
                height="33.71"
                rx="0.95"
                fill="#a39bb2"
              />
              <g>
                <ellipse
                  cx="392.87"
                  cy="314.36"
                  rx="3.91"
                  ry="0.77"
                  fill="url(#be03678d-295a-4f13-89c6-3a9c3e2b27bd)"
                />
                <ellipse
                  cx="392.87"
                  cy="315.7"
                  rx="5.39"
                  ry="1.01"
                  fill="url(#b3c1a236-8a79-4e04-b640-73353683d346)"
                />
                <ellipse
                  cx="392.87"
                  cy="317.03"
                  rx="6.88"
                  ry="1.25"
                  fill="url(#a5d09026-af44-4849-9891-fa1f5a3e80f4)"
                />
                <ellipse
                  cx="392.87"
                  cy="318.37"
                  rx="8.36"
                  ry="1.49"
                  fill="url(#bffbe26a-01ac-467b-a3f4-bedb7f6a82e5)"
                />
                <ellipse
                  cx="392.87"
                  cy="319.7"
                  rx="9.84"
                  ry="1.72"
                  fill="url(#a1f78bdb-8cce-422e-83c1-9e6711b32ad1)"
                />
                <ellipse
                  cx="392.87"
                  cy="321.04"
                  rx="11.33"
                  ry="1.96"
                  fill="url(#eaccccad-037b-407f-9b10-a2bb0b34629f)"
                />
                <ellipse
                  cx="392.87"
                  cy="323"
                  rx="10.21"
                  ry="1.8"
                  fill="url(#ac97d989-8264-49f9-b1f6-1a57da9534a0)"
                />
                <ellipse
                  cx="392.87"
                  cy="324.97"
                  rx="9.1"
                  ry="1.63"
                  fill="url(#ed4f33a6-7515-485b-a1f5-422a7ae4c71d)"
                />
                <ellipse
                  cx="392.87"
                  cy="326.94"
                  rx="7.99"
                  ry="1.46"
                  fill="url(#f159e18f-a70f-4269-ae4b-183616ca71c1)"
                />
                <ellipse
                  cx="392.87"
                  cy="328.91"
                  rx="6.87"
                  ry="1.3"
                  fill="url(#bf29695c-7c1a-46f6-90cd-c8aba126d7a5)"
                />
                <ellipse
                  cx="392.87"
                  cy="330.87"
                  rx="5.76"
                  ry="1.13"
                  fill="url(#e39a3a15-72f8-441a-9c6a-b7aa979b5e9f)"
                />
              </g>
            </g>
            <circle
              cx="392.67"
              cy="322"
              r="19"
              fill="url(#a8ccf94f-e10f-4ed7-8c49-810d363b466d)"
            />
          </g>
        </g>
        <g>
          <path
            d="M1078.36,0V97.73l63.09-.64V44.18Zm31.58,77.7A21.73,21.73,0,1,1,1131.68,56,21.73,21.73,0,0,1,1109.94,77.7Z"
            fill="#6d4c89"
          />
          <path
            d="M1109.94,33.81a21.12,21.12,0,0,1,16.5,5.67,22.46,22.46,0,0,1,5.28,7.47,22.63,22.63,0,0,1,0,18,22.63,22.63,0,0,1-5.29,7.48,21.11,21.11,0,0,1-16.5,5.66,23.53,23.53,0,0,0,14.84-7.32,21.86,21.86,0,0,0,0-29.69A23.57,23.57,0,0,0,1109.94,33.81Z"
            fill="#e59661"
          />
          <line
            x1="1078.17"
            y1="0.5"
            x2="1078.17"
            y2="97.5"
            fill="none"
            stroke="#e59661"
            strokeMiterlimit="10"
          />
        </g>
        <g transform="translate(8 -30)">
          <rect x="993.67" y="174" width="95" height="4" fill="#422b47" />
          <ellipse
            cx="1041.17"
            cy="178.07"
            rx="47.68"
            ry="10.93"
            fill="#422b47"
          />
          <ellipse
            cx="1041.18"
            cy="174.11"
            rx="47.68"
            ry="10.93"
            fill="#6d4c89"
          />
          <circle cx="1036.21" cy="110.54" r="67.54" fill="#663f6d" />
          <path
            d="M988.54,118.49a67.51,67.51,0,0,1,82.39-65.88,67.54,67.54,0,1,0-49.58,123.81A67.49,67.49,0,0,1,988.54,118.49Z"
            fill="#d0827d"
          />
          <path
            d="M1072.29,53.45a67.54,67.54,0,0,0-54.18,122.16,67.79,67.79,0,0,0,12.07,2.19A67.53,67.53,0,0,1,1074.08,59c2,0,4.05.11,6,.29A68.53,68.53,0,0,0,1072.29,53.45Z"
            fill="#422f5b"
          />
          <path
            d="M1011.67,153c1.74.36,12,24,20,25,43,0,72.08-30.21,72.08-67.46a67.21,67.21,0,0,0-14.08-41.25h0S1091.13,143.07,1011.67,153Z"
            fill="#422b47"
          />
          <path
            d="M1021.35,176.42s-52.31-49.83,0-102.62C1032,62.2,1061.67,53,1078.67,58l1,1s-29-3-60,28-1,86.83,6,90.42Z"
            fill="#291f3a"
          />
          <path
            d="M993.5,174.11c0,5.59,18.36,10.2,42,10.84-36.76-4-37-15.71-37-15.71h0C995.31,170.71,993.5,172.36,993.5,174.11Z"
            fill="#d0827d"
          />
          <polygon
            points="982.67 86 1009.67 113 1011.67 102 1019.67 87 1031.67 75 1046.67 65 1031.67 45 982.67 86"
            fill="#667784"
          />
          <path
            d="M1011.67,102l7.72-14.47.28-1.53c-14,7-14.7,0-14.7,0-11.7,9-22.3,0-22.3,0l27,27Z"
            fill="#4e6472"
          />
          <polygon
            points="982.67 86 986.67 91 1035.67 50 1031.67 45 982.67 86"
            fill="#95aab7"
          />
          <ellipse
            cx="1011.17"
            cy="70.5"
            rx="32"
            ry="9"
            transform="translate(186.69 660.13) rotate(-39.56)"
            fill="#95aab7"
          />
          <ellipse
            cx="1007.17"
            cy="65.5"
            rx="32"
            ry="9"
            transform="translate(188.96 656.44) rotate(-39.56)"
            fill="#3f2b2b"
          />
          <ellipse
            cx="1007.17"
            cy="65.5"
            rx="22.83"
            ry="6.42"
            transform="translate(188.96 656.44) rotate(-39.56)"
            fill="#775252"
          />
          <ellipse
            cx="1007.17"
            cy="65.5"
            rx="16.29"
            ry="4.58"
            transform="translate(188.96 656.44) rotate(-39.56)"
            fill="#542d2d"
          />
          <path
            d="M1030.17,177.5A68.16,68.16,0,0,1,1015.69,162a62,62,0,0,1-8.65-19.56,67.14,67.14,0,0,1,3.64-42.31,68,68,0,0,1,5.08-9.53,63.37,63.37,0,0,1,6.51-8.61,67.3,67.3,0,0,1,16.66-13.55,65.2,65.2,0,0,1,9.71-4.59,62.68,62.68,0,0,1,10.3-2.94,65.17,65.17,0,0,1,10.59-1.2c.88-.06,1.77,0,2.66,0s1.77,0,2.65,0c1.77.1,3.53.28,5.28.51a69.78,69.78,0,0,0-40,10.21,75.23,75.23,0,0,0-8.39,6.11,67.55,67.55,0,0,0-7.34,7.31c-1.14,1.3-2.2,2.67-3.25,4s-2,2.8-2.91,4.28a63.84,63.84,0,0,0-4.81,9.15,71.38,71.38,0,0,0-3.38,9.77,73,73,0,0,0-1.79,10.18l-.22,2.59c-.06.86-.07,1.72-.11,2.58-.08,1.73,0,3.46.06,5.19a67.27,67.27,0,0,0,1.34,10.28C1012.2,155.5,1019.8,167.94,1030.17,177.5Z"
            fill="#d0827d"
          />
          <path
            d="M1088.85,174.11c0-1.75-1.8-3.4-5-4.87,0,0-3.41,11.24-22.64,14.78C1077.54,182.29,1088.85,178.5,1088.85,174.11Z"
            fill="#422b47"
          />
        </g>
        <g>
          <path
            d="M1010.24,188.71c1.79-3,2.4-3.64,1.64-5.64s-1.5-.29-.73-4a3.91,3.91,0,0,0-3.47-5c-1.32-.14-7.57,3.53-6.51,5.52s1.5,7.66.37,8.13S1008.12,192.2,1010.24,188.71Z"
            fill="#396039"
          />
          <path
            d="M1009,181.81c-.06-1.61,2.38-2.26,1.59-3s-1.74-2.64-2.5-1.65-1.35,2.47-1.94,1.65-1.23-.85-1.61,0-.06,1.91-1,1.64-1.32.15-1.2,1,.79.53,1.38,1.58,3.23.91,2.79.33S1009,181.81,1009,181.81Z"
            fill="#447244"
          />
          <path
            d="M1013.58,179c1.32-2.08,3.17-4,5-2.2s-1.23,5,0,6.25,1,4.47,0,4.58-5.58.12-6.78.68-2.76-1.5-2.79-3.49S1013.58,179,1013.58,179Z"
            fill="#6b996b"
          />
          <path
            d="M1006.62,191.38c3.1,2.36,3.32-5.84,0-5.14s-4.4.5-5.45-1-3.7,1.11-3.79,1.84A4.74,4.74,0,0,0,1000,191C1001.78,191.73,1004.78,190,1006.62,191.38Z"
            fill="#447244"
          />
          <path
            d="M1013,193c-3.09,2.36-3.31-5.84,0-5.13s4.41.5,5.46-1,3.7,1.11,3.79,1.85a4.72,4.72,0,0,1-2.58,3.9C1017.86,193.38,1014.86,191.62,1013,193Z"
            fill="#447244"
          />
          <path
            d="M1016.87,190.21c.44-.88,1.73.82,1.73.82s-.09-1.15.62-1.56,1,.65,1,.65c.06-.82,1.74-.06,1.27.92h0a3.92,3.92,0,0,1-1.83,1.63,3.28,3.28,0,0,1-1.31.17l-1.58-.4A3.79,3.79,0,0,1,1016.87,190.21Z"
            fill="#396039"
          />
          <path
            d="M1010.5,191.7c-.62,1.09-1,10.86,0,15.35,0,0-2.82-.49-3.7,0-.09.29-.09,0-.09,0s3.91-13.59.5-17.58-7.1,0-7.1,0,1-2.35,3.2-2.52,5.22,2.67,5.37,3.23c0,0,.12-4.29-1.26-5.79a1.61,1.61,0,0,1,.38-2.58s-1.82.56,1.11,4.38c1.53,2,.44,5.66.44,5.66s.94-2.88,3.29-2.26,3.76,3.35,6,3.17a11.63,11.63,0,0,1-4.64-1.38A2.72,2.72,0,0,0,1010.5,191.7Z"
            fill="#704d3c"
          />
          <path
            d="M1013.71,191.24a2.68,2.68,0,0,0-3.21.46,13.75,13.75,0,0,0-.5,3.65,7.13,7.13,0,0,1,1-5.58,2.18,2.18,0,0,1,1.68-.18,5.27,5.27,0,0,1,1.55.74Z"
            fill="#634b42"
          />
          <path
            d="M1008.31,190.34a7.18,7.18,0,0,1,.28,4h0a8.07,8.07,0,0,0-1.38-4.86,7.33,7.33,0,0,0-.61-.63c-.08-.25-.14-.41-.14-.41A5.16,5.16,0,0,1,1008.31,190.34Z"
            fill="#44322c"
          />
          <path
            d="M1013.06,190.79c.85-.28.9-1.47,1.91-1.4s1.13,1.52,2,2.46,1.52.73,2.19,1.05-1.83,3.91-4.15,2.62-2.1-1.08-2.9-1.61A1.85,1.85,0,0,1,1013.06,190.79Z"
            fill="#6b996b"
          />
          <g>
            <path d="M1008.66,188.94c0,.06,0,.06,0,0v0Z" fill="#7f2c03" />
            <path
              d="M1008.62,188.43c-.11-1.37-.4-3.17-1.2-4a1.77,1.77,0,0,1-.53-1.06l.41-.08a7.91,7.91,0,0,0,1.61,2.94l.07.09C1008.91,187.05,1008.67,187.84,1008.62,188.43Z"
              fill="#634b42"
            />
          </g>
          <path
            d="M1005.44,188.32c-.55-.7.06-1.72-.82-2.22s-1.78.64-3,1-1.68-.22-2.41-.32-.64,4.27,2,4.47,2.34.26,3.3.26A1.85,1.85,0,0,0,1005.44,188.32Z"
            fill="#6b996b"
          />
          <path
            d="M1006.56,180.08c.58-.91,1.39-1.74,2.2-1s-.54,2.18,0,2.73.42,2,0,2a16.57,16.57,0,0,0-3,.29c-.53.25-1.21-.65-1.22-1.52S1006.56,180.08,1006.56,180.08Z"
            fill="#6b996b"
          />
          <path
            d="M1000.78,190.23c.17.26.66.21.94.09s.45-1,.9-.83.68.61,1.19.46.29-.69.94-.7,1.2.23,1.22.57v.08h0a.22.22,0,0,0,0,.08,1.65,1.65,0,0,1-1.42,1.49c-1,0-.65-.06-3.3-.26a2.18,2.18,0,0,1-1-.31C1000,190.7,1000.62,190,1000.78,190.23Z"
            fill="#447244"
          />
          <path
            d="M1012.7,193.9c.65,0,1.94.71,2.11.06s1.47-.79,1.62-.5a1.27,1.27,0,0,0,1.38.44c.44-.23.88.36.68.59-.82.92-2.2,1.77-3.52,1-1.61-.9-2-1.07-2.35-1.27C1012.47,194.14,1012.21,193.9,1012.7,193.9Z"
            fill="#396039"
          />
          <path
            d="M1010.29,186.48c.41-.91,1.41-.73,2.12-.62s.5,1.06,1.05.62,1.79.62,1.33,1.38h0a10.87,10.87,0,0,0-3,.47c-.74.34-1.63-.31-2.19-1.34l-.25-.51h0S1009.88,187.39,1010.29,186.48Z"
            fill="#447244"
          />
          <path
            d="M1017.75,185.92c-.27-.82.91-1.53,0-1.53s-2.41.91-2.26-.41-.26-2-1.26-1.93-1.76-2.06-1.21-2.54-3.11.92-1.49,2.3,2.2.94,2.14,1.59,0,2,1.23,2.2-.35,1.88.58,2.26S1018.45,188.12,1017.75,185.92Z"
            fill="#447244"
          />
          <path
            d="M1006.71,207.05s.25-.84.56-2.17c2.45-1.25,2.62-5.35,2.63-5.47a41,41,0,0,0,.6,7.64s-2.82-.49-3.7,0C1006.71,207.32,1006.71,207.05,1006.71,207.05Z"
            fill="#44322c"
          />
          <path
            d="M1009.64,206.93a17.06,17.06,0,0,0-.36-2.33,15.5,15.5,0,0,1,0-2.36c.09-1.58.24-3.14.31-4.71a6.44,6.44,0,0,0-.1-2.32,3.88,3.88,0,0,1,0-2.36,4.82,4.82,0,0,1,1.33-1.95,3.13,3.13,0,0,1,2.31-.11,3.11,3.11,0,0,0-2.27.19,5,5,0,0,0-1.27,1.92,3.87,3.87,0,0,0,.08,2.28c0,.19.11.37.15.57a4.19,4.19,0,0,1,0,.61c0,.39,0,.79,0,1.18-.1,1.57-.26,3.14-.37,4.7a15.36,15.36,0,0,0,0,2.35A16.79,16.79,0,0,1,1009.64,206.93Z"
            fill="#44322c"
          />
          <path
            d="M1009,199.41a7.83,7.83,0,0,0,0,1,1.2,1.2,0,0,1-.32.92A2.62,2.62,0,0,0,1008,203a3.89,3.89,0,0,0,.25,1.87,7.09,7.09,0,0,1,.22,1.94,10.94,10.94,0,0,0-.33-1.9,4,4,0,0,1-.31-1.93,2.72,2.72,0,0,1,.8-1.77C1009.1,200.77,1008.85,200,1009,199.41Z"
            fill="#44322c"
          />
          <path
            d="M1009,186.93c0,.38.18.72.2,1.11,0,.19-.08.39-.08.55a2.06,2.06,0,0,0,.1.53,5.35,5.35,0,0,1,.32,2.22c0,.39-.2.73-.24,1.09a5.76,5.76,0,0,0-.06,1.1,13.74,13.74,0,0,0,.26,2.21,9.22,9.22,0,0,1-.38-2.2,7.08,7.08,0,0,1,0-1.13c0-.38.19-.74.22-1.09a5.22,5.22,0,0,0-.27-2.17,2.61,2.61,0,0,1-.09-.57,4.18,4.18,0,0,0,.1-.54C1009.14,187.68,1009,187.31,1009,186.93Z"
            fill="#44322c"
          />
        </g>
      </g>
    </g>
  );
};

export default Decor2;
